import { createI18n } from '@/i18n';

const moment = require('moment-timezone');
import axios from 'axios';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import 'jspdf-autotable';

const i18n = createI18n();

export default {
    install(Vue, store) {

        const helpers = new Helpers(store);
        Vue.helpers = helpers;
        Vue.prototype.$helpers = helpers;
    }
}

class Helpers {
    constructor(store) {
        this.store = store;
    }

    log(src, info, obj = null, splitArray = true) {
        console.log((src ? src.$options.name : '$helpers.log()') + ' :: ' + info);
        if (obj) {
            if (splitArray && Array.isArray(obj)) {
                obj.forEach(o => {
                    console.log(o);
                });
            } else {
                console.log(obj);
            }
        }
    }

    supportUrl(url) {
        if(url.includes('youtube')){
            // do not adapt video links
            return url;
        }
        let baseUrl = url;
        let storeName = this.store.state.storeSettings.name;
        if (storeName != undefined && storeName != "") {
            url = this.appendParam("customfield_10072", storeName, url, baseUrl);
        }
        let userEmail = this.store.state.userInfo.email;
        if (userEmail != undefined && userEmail != "") {
            url = this.appendParam("email", userEmail, url, baseUrl);
        }
        return url;
    }

    pad2(n) {
        if (n >= 0) {
            return n < 10 ? '0' + n : n;
        }
        let nAbs = Math.abs(n);
        return nAbs < 10 ? '-0' + nAbs : n;
    }

    logColored(msg, obj, color) {
        console.log('%c ' + msg, 'color: ' + color + '; font-weight: 800; font-size: 12px;');
        if (obj) {
            console.log(obj);
        }
    }

    logSuccess(msg, obj = null) {
        this.logColored(msg, obj, 'green');
    }

    logDebug(msg, obj = null) {
        this.logColored(msg, obj, 'blue');
    }

    logWarn(msg, obj = null) {
        this.logColored(msg, obj, 'yellow');
    }

    logError(msg, obj = null) {
        this.logColored(msg, obj, 'red');
    }

    truncate(str, n) {
        return (str.length > n) ? str.substr(0, n - 1) + '...' : str;
    }

    isSafari() {
        var browserInfo = this.getBrowserInfo();
        return browserInfo[0] == "Safari";
    }

    getBrowserInfo() {
        var nAgt = navigator.userAgent;
        var nameOffset, verOffset, ix;
        var browserName = "";
        var mobile = false;

        if ((verOffset = nAgt.indexOf("Opera")) != -1) {
            browserName = "Opera";
        } else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
            browserName = "Microsoft Internet Explorer";
        } else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
            browserName = "Chrome";
        } else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
            browserName = "Safari";
        } else if ((verOffset = nAgt.indexOf("iPhone")) != -1) {
            browserName = "Safari";
        } else if ((verOffset = nAgt.indexOf("iOS")) != -1) {
            browserName = "Safari";
        } else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
            browserName = "Firefox";
        } else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
            browserName = nAgt.substring(nameOffset, verOffset);
            if (browserName.toLowerCase() == browserName.toUpperCase()) {
                browserName = navigator.appName;
            }
        }
        if (nAgt.indexOf("iPhone") != -1 || nAgt.indexOf("iOS") != -1 || nAgt.indexOf("Android") != -1) {
            mobile = true
        }
        return [browserName, mobile];
    }

    appendParam(name, param, url, baseUrl) {
        if (!this.isBlank(param)) {
            if (url == baseUrl) {
                url += "?" + name + "=" + param;
            } else {
                url += "&" + name + "=" + param;
            }
        }
        return url;
    }

    loadTimeZone(zone) {

    }

    isEmpty(val) {
        if (val == null || val == undefined || val === "") return true;
        return false;
    }

    isFunction(x) {
        return Object.prototype.toString.call(x) == '[object Function]';
    }

    isBlank(str) {
        if (typeof str === 'boolean' || this.isInt(str)) {
            return false;
        } else {
            return (!str || /^\s*$/.test(str))
        }
    }

    isInt(value) {
        var x;
        if (isNaN(value)) {
            return false;
        }
        x = parseFloat(value);
        return (x | 0) === x;
    }



    isUnderage(birthday, checkDate = null, checkCurrent = false) {

        if (birthday) {
            let d = null;
            if (moment.isMoment(birthday)) {

                d = this.getMomentTZ().startOf('day').year(birthday.year()).month(birthday.month()).date(birthday.date());
            } else {
                let td = this.getMomentFromStringTZ(birthday);
                d = this.getMomentTZ().startOf('day').year(td.year()).month(td.month()).date(td.date());
            }
            let td = checkDate;
            if (td == null) {
                td = this.getMomentTZ();
            }
            if(checkCurrent){
                let today = this.getMomentTZ().startOf('day');
                if((td.month() == today.month() && td.year() == today.year())){
                    td = today;
                }
            }
            let diff = td.diff(d, 'years');
            return diff < 18;
        } else {
            return false;
        }
    }

    roundNumber(number, decimals) {
        var mult = Math.pow(10, decimals);
        return (Math.round(number * mult) / mult);
    }

    round2(number) {
        return this.roundNumber(number, 2);
    }

    euroInputToCents(input) {
        let inputFloat = input;

        if (typeof input === 'string') {
            // fix decimal char and parse float value
            input = input.replace(",", ".");
            inputFloat = parseFloat(input);
            if(isNaN(inputFloat)){
                inputFloat = 0;
            }
        }

        var cents = Math.round(inputFloat * 100);
        return cents;
    }

    formatPayment(centValue) {
        if (centValue != null) {
            var euro = centValue / 100;
            var frmtEuro = euro.toFixed(2);
            frmtEuro = frmtEuro.replace('.', ',');
            return '€ ' + frmtEuro;
        }
        return '';
    }

    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {
            type: mime
        });
    }

    setTimeoutAsync(ms) {
        return new Promise((res) => setTimeout(res, ms));
    }

    timeout(title, message) {
        return (title.length * 60 + message.length * 60);
    }

    success(title, message) {
        window.app.popupmessages.push({
            startTime: new Date().getTime(),
            timer: this.timeout(title, message),
            type: 'success',
            header: title,
            description: message
        });
    }

    OpenPopup(state) {
        if (state && state.draggable && this.DragOpenedCheck()) return; //if you're already dragging a popup don't open it, it's better to put this here then on every mousedown function
        state.created = new Date().getTime();
        window.app.genericPopups.push(state);
        return state;
    }

    CheckDatafillKeysForHiddenInverted(...entryKeys) {
        if (!entryKeys.find) {
            let temp = [];
            temp.push(entryKeys);
            entryKeys = temp;
        }
        return (entries, entry) => {
            let value = false;
            if (!entries) {
                return value;
            }
            if (!entries.length) {
                entries = Object.values(entries);
            }
            if (entries.length) {
                value = !entryKeys.every(k => entries.find(e => e.key === k && !e.value));
            }
            return value;
        }
    }

    CheckDatafillKeysForHidden(...entryKeys) {
        if (!entryKeys.find) {
            let temp = [];
            temp.push(entryKeys);
            entryKeys = temp;
        }
        return (entries, entry) => {
            let value = false;
            if (!entries) {
                return value;
            }
            if (!entries.length) {
                entries = Object.values(entries);
            }
            if (entries.length) {
                value = entryKeys.every(k => entries.find(e => e.key === k && !e.value));
            }
            return value;
        }
    }

    warning(title, message) {
        window.app.popupmessages.push({
            startTime: new Date().getTime(),
            timer: this.timeout(title, message),
            type: 'warning',
            header: title,
            description: message
        });
    }

    error(title, message) {
        window.app.popupmessages.push({
            startTime: new Date().getTime(),
            timer: this.timeout(title, message),
            type: 'error',
            header: title,
            description: message
        });
    }

    info(title, message) {
        window.app.popupmessages.push({
            startTime: new Date().getTime(),
            timer: this.timeout(title, message),
            type: i18n.t('shift.plan.info'),
            header: title,
            description: message
        });
    }

    formatDateStringTZ(datestr, format = null) {
        if (format != null) {
            if (this.store.state.storeSettings.timeZone) {
                if (!this.isBlank(datestr)) {
                    return moment.tz(datestr, this.store.state.storeSettings.timeZone).locale(i18n.locale).format(format);
                } else {
                    return moment(datestr).format(format).locale(i18n.locale);
                }
            }
        }
        return this.convertDateStringTZ(datestr);
    }

    convertDateString(datestr) {
        if (!this.isBlank(datestr)) {
            return moment(datestr).format('YYYY-MM-DDTHH:mmZ');
        } else {
            return null;
        }
    }

    convertDateStringUTC(datestr) {
        if (!this.isBlank(datestr)) {
            return moment.utc(datestr).format('YYYY-MM-DDTHH:mmZ');
        } else {
            return null;
        }
    }

    convertDateStringTZ(datestr) {
        if (this.store.state.storeSettings.timeZone) {
            if (!this.isBlank(datestr)) {
                return moment.tz(datestr, this.store.state.storeSettings.timeZone).format('YYYY-MM-DDTHH:mmZ');
            } else {
                return null;
            }
        }
        return this.convertDateString(datestr);

    }

    convertDateTimeString(datestr, timestr) {

        if (!this.isBlank(datestr) && !this.isBlank(timestr)) {
            return moment(datestr + 'T' + timestr).format('YYYY-MM-DDTHH:mmZ');
        } else if (!this.isBlank(datestr)) {
            return moment(datestr + 'T00:00:00').format('YYYY-MM-DDTHH:mmZ');
        } else if (!this.isBlank(timestr)) {
            return moment(timestr, 'HH:mm').format('HH:mmZ');
        } else {
            return null;
        }
    }

    convertDateTimeStringUTC(datestr, timestr) {

        if (!this.isBlank(datestr) && !this.isBlank(timestr)) {
            return moment.utc(datestr + 'T' + timestr).format('YYYY-MM-DDTHH:mmZ');
        } else if (!this.isBlank(datestr)) {
            return moment.utc(datestr + 'T00:00:00').format('YYYY-MM-DDTHH:mmZ');
        } else if (!this.isBlank(timestr)) {
            return moment.utc(timestr, 'HH:mm').format('HH:mmZ');
        } else {
            return null;
        }
    }

    convertDateTimeStringTZ(datestr, timestr) {
        if (this.store.state.storeSettings.timeZone) {
            if (!this.isBlank(datestr) && !this.isBlank(timestr)) {
                return moment.tz(datestr + 'T' + timestr, this.store.state.storeSettings.timeZone).format('YYYY-MM-DDTHH:mmZ');
            } else if (!this.isBlank(datestr)) {
                return moment.tz(datestr + 'T00:00:00', this.store.state.storeSettings.timeZone).format('YYYY-MM-DDTHH:mmZ');
            } else if (!this.isBlank(timestr)) {
                return moment.tz("2019-11-01T" + timestr, this.store.state.storeSettings.timeZone).format('HH:mmZ');
            } else {
                return null;
            }
        }
        return this.convertDateTimeString(datestr, timestr);
    }

    extractDateStringTZ(datestr, format = "YYYY-MM-DD", midnightIsPreviousDay = false) {
        if (this.store.state.storeSettings.timeZone) {
            if (!this.isBlank(datestr)) {
                if (midnightIsPreviousDay) {
                    return moment.tz(datestr, this.store.state.storeSettings.timeZone).add(-1, "minute").format(format);
                }
                return moment.tz(datestr, this.store.state.storeSettings.timeZone).format(format);
            } else {
                return null;
            }
        }
        return this.extractDateString(datestr, format);
    }

    extractLocalizedDateStringTZ(datestr, format, locale = "de") {
        let m;
        if (this.store.state.storeSettings.timeZone) {
            if (!this.isBlank(datestr)) {
                m = moment.tz(datestr, this.store.state.storeSettings.timeZone);
            }
        }
        if (!this.isBlank(datestr)) {
            m = moment.utc(datestr);
        }
        if (m) {
            m.locale(locale);
            return m.format(format);
        }
        return null;
    }

    extractTimeStringTZ(str, format = "HH:mm") {
        if (this.store.state.storeSettings.timeZone) {
            if (!this.isBlank(str)) {
                return moment.tz(str, 'HH:mmZ', this.store.state.storeSettings.timeZone).format(format);
            } else {
                return null;
            }
        }
        return this.extractTimeString(datestr, format);
    }

    extractDateString(datestr, format = "YYYY-MM-DD", midnightIsPreviousDay = false) {
        if (!this.isBlank(datestr)) {
            if (midnightIsPreviousDay) {
                return moment.utc(datestr).add(-1, "minute").format(format);
            }
            return moment.utc(datestr).format(format);
        } else {
            return null;
        }

    }

    extractTimeString(str, format = "HH:mm") {
        if (!this.isBlank(str)) {
            return moment.utc(str, 'HH:mmZ').format(format);
        } else {
            return null;
        }

    }

    getNowDateTimeString(format = "DD.MM.YYYY HH:mm") {
        return this.getMomentTZ().format(format);
    }

    getWeekDays() {
        return moment.weekdays();
    }

    getActualMoment(param = null) {
        if (param) {
            return moment(param).locale('de');
        }
        return moment;
    }

    getMoment() {
        return moment().locale('de');
    }

    getStartOfIsoWeek(isoWeek, isoYear){
        if (this.store.state.storeSettings.timeZone) {
            //console.log("timezone");
            return moment.tz(this.store.state.storeSettings.timeZone).isoWeekYear(isoYear).isoWeek(isoWeek).isoWeekday(1).locale('de');
        } else {
            return moment().isoWeekYear(isoYear).isoWeek(isoWeek).isoWeekday(1);
        }

    }

    getMomentUTC() {
        return moment.utc().locale('de');
    }

    getMomentTZ() {
        if (this.store.state.storeSettings.timeZone) {
            //console.log("timezone");
            return moment.tz(this.store.state.storeSettings.timeZone).locale('de');
        }
        return this.getMoment();
    }

    getMomentTZFromUnix(ts) {
        if (this.store.state.storeSettings.timeZone) {
            return moment.tz(moment.unix(ts),this.store.state.storeSettings.timeZone).locale('de');
        }
        return moment.unix(ts).utc();
    }

    getMomentTZStartOfDay() {
        return this.getMomentTZ().hours(0).minutes(0).seconds(0).milliseconds(0);
    }

    getMomentFromString(str, format = 'YYYY-MM-DDTHH:mmZ') {
        return moment(str, format).locale('de');
    }

    getMomentFromStringUTC(str, format = 'YYYY-MM-DDTHH:mmZ') {
        return moment.utc(str, format).locale('de');
    }

    getMomentFromStringTZ(str, format = 'YYYY-MM-DDTHH:mmZ') {
        if (this.store.state.storeSettings.timeZone) {
            return moment.tz(str, format, this.store.state.storeSettings.timeZone).locale('de');
        }
        return this.getMomentFromString(str, format);
    }

    getNextMonthMoment() {
        return moment().date(1).hours(0).minutes(0).seconds(0).milliseconds(0).add(1, 'M').locale('de');
    }

    getNextMonthMomentUTC() {
        return moment.utc().date(1).hours(0).minutes(0).seconds(0).milliseconds(0).add(1, 'M').locale('de');
    }

    getNextMonthMomentTZ() {
        if (this.store.state.storeSettings.timeZone) {
            return moment.tz(this.store.state.storeSettings.timeZone).date(1).hours(0).minutes(0).seconds(0).milliseconds(0).add(1, 'M').locale('de');
        }
        return this.getNextMonthMoment();
    }

    getCurrentMoment() {
        return moment().locale('de');
    }

    getCurrentMonthMoment() {
        return moment().date(1).hours(0).minutes(0).seconds(0).milliseconds(0).locale('de');
    }

    getCurrentMonthMomentUTC() {
        return moment.utc().date(1).hours(0).minutes(0).seconds(0).milliseconds(0).locale('de');
    }

    getCurrentMonthMomentTZ() {
        if (this.store.state.storeSettings.timeZone) {
            return moment.tz(this.store.state.storeSettings.timeZone).date(1).hours(0).minutes(0).seconds(0).milliseconds(0).locale('de');
        }
        return this.getCurrentMonthMoment();
    }

    getMomentFromUnix(unix = 0) {
        return moment(unix).locale('de');
    }

    getMomentFromUnixTZ(unix = 0) {
        if (this.store.state.storeSettings.timeZone) {
            return moment(unix).tz(this.store.state.storeSettings.timeZone).locale('de');
        }
    }

    getMomentFromUnixUTC(unix = 0) {
        return moment(unix).utc().locale('de');
    }

    getMomentFromValues(year, month, day, hours = 0, minutes = 0, seconds = 0, milliseconds = 0) {
        return moment().year(year).month(month).date(day).hours(hours).minutes(minutes).seconds(seconds).milliseconds(milliseconds).locale('de');
    }

    getMomentFromValuesUTC(year, month, day, hours = 0, minutes = 0, seconds = 0, milliseconds = 0) {
        return moment.utc().year(year).month(month).date(day).hours(hours).minutes(minutes).seconds(seconds).milliseconds(milliseconds).locale('de');
    }

    getMomentFromValuesTZ(year, month, day, hours = 0, minutes = 0, seconds = 0, milliseconds = 0) {
        if (this.store.state.storeSettings.timeZone) {
            return moment.tz(this.store.state.storeSettings.timeZone).year(year).month(month).date(day).hours(hours).minutes(minutes).seconds(seconds).milliseconds(milliseconds).locale('de');
        }
        return this.getMomentFromValues(year, month, day, hours, minutes, seconds, milliseconds);
    }

    getMomentDuration(start, end) {
        return moment.duration(end.diff(start)).locale('de');
    }

    gender(code) {
        switch (code) {
            case 'M':
                return i18n.t('pages.employeeCoreData.male');
            case 'F':
                return i18n.t('pages.employeeCoreData.female');
            default:
                return "";
        }
    }

    salutation(code) {
        switch (code) {
            case 'M':
                return "Herr";
            case 'F':
                return "Frau";
            default:
                return "";
        }
    }

    employeeFieldLabel(key) {
        switch (key) {
            case 'active':
                return i18n.t('global.general.active');
            case 'address':
                return i18n.t('pages.employeeData.address');
            case 'bankAccountHolder':
                return i18n.t('pages.employeeCoreData.bankAccountHolder');
            case 'bic':
                return i18n.t('pages.employeeCoreData.bic');
            case 'citizenType':
                return i18n.t('pages.employeeCoreData.citizenType');
            case 'city':
                return i18n.t('pages.employeeCoreData.city');
            case 'country':
                return i18n.t('pages.employeeCoreData.country');
            case 'disability':
                return i18n.t('pages.employeeCoreData.disability');
            case 'dlExpiry':
                return i18n.t('pages.employeeCoreData.driversLicenseExpiration');
            case 'dob':
                return i18n.t('pages.employeeData.dateOfBirth');
            case 'driverslicense':
                return i18n.t('pages.employeeCoreData.driverslicense');
            case 'email':
                return i18n.t('pages.employeeCoreData.email');
            case 'faExpiry':
                return i18n.t('pages.comp.firstAidCourseExpiration');
            case 'workExperience':
                return i18n.t('pages.comp.preServiceYear');
            case 'firstName':
                return i18n.t('pages.employeeCoreData.firstName');
            case 'lastName':
                return i18n.t('pages.employeeCoreData.lastName');
            case 'firstaidcourse':
                return i18n.t('pages.employeeCoreData.firstaidcourse');
            case 'gender':
                return i18n.t('pages.employeeCoreData.gender');
            case 'guardianAddress':
                return i18n.t('pages.employeeCoreData.emergencyContactAddressShort');
            case 'guardianName':
                return i18n.t('pages.employeeCoreData.emergencyContact');
            case 'guardianPhone':
                return i18n.t('pages.employeeCoreData.emergencyContactPhoneShort');
            case 'guardianRelationship':
                return i18n.t('pages.employeeCoreData.guardianRelationship');
            case 'homephone':
                return i18n.t('pages.employeeCoreData.homephone');
            case 'iban':
                return i18n.t('pages.employeeCoreData.iban');
            case 'maidenName':
                return i18n.t('pages.employeeCoreData.maidenName');
            case 'pob':
                return i18n.t('pages.employeeCoreData.pob');
            case 'miscInfo':
                return i18n.t('pages.employeeCoreData.otherDetails');
            case 'mobilephone':
                return i18n.t('pages.employeeCoreData.mobilephone');
            case 'nationality':
                return i18n.t('pages.employeeCoreData.nationality');
            case 'personnelId':
                return i18n.t('pages.employeeCoreData.personnelNumber');
            case 'postalCode':
                return i18n.t('pages.employeeCoreData.postalCode');
            case 'postfix':
                return i18n.t('pages.employeeCoreData.postfixTitle');
            case 'prefix':
                return i18n.t('pages.employeeCoreData.prefixTitle');
            case 'pregnant':
                return i18n.t('pages.employeeCoreData.pregnant');
            case 'religion':
                return i18n.t('pages.comp.religion');
            case 'socialsecurity':
                return i18n.t('pages.employeeCoreData.socialsecurity');
            case 'spotId':
                return i18n.t('pages.employeeCoreData.mainPosition');
            case 'title':
                return i18n.t('roster.main.title');
            case 'civilStatus':
                return i18n.t('pages.employeeCoreData.civilStatus');
            case 'socialInsuranceRegistered':
                return i18n.t('pages.employeeCoreData.socialInsuranceRegistered');
            default:
                return key;
        }
    }

    contractFieldLabel(key) {
        switch (key) {
            case 'collectiveContractId':
                return i18n.t('store.settings.workingTimeModel');
            case 'jobName':
                return i18n.t('pages.employeeContract.jobName');
            case 'from':
                return i18n.t('pages.employeeContract.validFrom');
            case 'to':
                return i18n.t('pages.employeeContract.validUntil');
            case 'probationTo':
                return i18n.t('pages.employeeContract.probationTo');
            case 'weekTimeRegular':
                return i18n.t('pages.employeeContract.weekTimeRegular');
            case 'weekWorkDaysRegular':
                return i18n.t('store.settings.workingDays');
            case 'paymentType':
                return i18n.t('pages.employeeContract.paymentType');
            case 'wageType':
                return i18n.t('pages.employeeContract.wageType');
            case 'payment':
                return i18n.t('pages.employeeContract.payment');
            case 'contractType':
                return i18n.tc('pages.employeeContract.contractType');
            case 'employmentType':
                return i18n.t('pages.employeeContract.employmentType');
            case 'employeeCategory':
                return i18n.t('pages.employeeContract.category');
            case 'nightWorkerType':
                return i18n.t('pages.employeeContract.dayNight');
            case 'calculateNightWork':
                return i18n.t('pages.employeeContract.nwBonus');
            case 'nightWorkBonusHour':
                return i18n.t('pages.employeeContract.nwHourBonus');
            case 'nightWorkBonusShift':
                return i18n.t('pages.employeeContract.nwFlat');
            case 'overtimeBonusHour':
                return i18n.t('pages.employeeContract.otHourBonus');
            case 'overtimeBonusShift':
                return i18n.t('pages.employeeContract.otFlat');
            case 'nightWorkFrom':
                return i18n.t('pages.employeeContract.nightWorkFrom');
            case 'nightWorkTo':
                return i18n.t('pages.employeeContract.nightWorkUntil');
            case 'assistancePayment':
                return i18n.t('pages.employeeContract.funding');
            case 'exitReason':
                return i18n.t('global.general.contractEndReason');
            case 'overtimeCutoff':
                return i18n.t('pages.employeeContract.otDailyLimit');
            case 'weeklyOvertimeCutoff':
                return i18n.t('pages.employeeContract.otWeeklyLimit');
            case 'additionalMonthWorkTime':
                return i18n.t('pages.employeeContract.additionalMonthWorkTime');
            case 'allowPartialShifts':
                return i18n.t('pages.employeeContract.allowPartialShifts');
            case 'pregnant':
                return i18n.t('pages.employeeContract.pregnancy');
            case 'fullTimeCutoff':
                return i18n.t('pages.employeeContract.ftWeeklyHourLimit');
            case 'dayFullTimeCutoff':
                    return i18n.t('pages.employeeContract.dayFullTimeCutoff');
            case 'vacationTime':
                return i18n.t('pages.employeeContract.vacationDays');
            case 'employmentGroup':
                    return i18n.t('pages.employeeContract.employmentGroup');
            case 'partTimeType':
                    return i18n.t('pages.employeeContract.partTimeType');
            case 'mlWageGroup':
                    return i18n.t('pages.employeeContract.mlWageGroup');
            case 'deadlineTo':
                    return i18n.t('pages.employeeContract.deadlineTo');
            case 'comment':
                return i18n.t('global.general.comment');
            case 'workDays':
                return i18n.t('pages.employeeContract.workDays');
            case 'extraPayment':
                return i18n.t('pages.employeeContract.extraPayment');
            case 'holidayTypes':
                return 'Feiertagszuschlag';
            case 'totalPayment':
                return i18n.t('pages.employeeContract.totalPayment');
            default:
                return key;
        }
    }

    localizedLabel(context, map){
        let key = 'label_' + context.$i18n.locale.toLowerCase();
        if(key in map){
            return map[key];
        }
        return map.label;
    }

    getRandomLightColor() {
        let color = this.hslToHex(Math.random() * 360, 100, 75);
        return color;
    }

    hslToHex(h, s, l) {
        h /= 360;
        s /= 100;
        l /= 100;
        let r, g, b;
        if (s === 0) {
            r = g = b = l; // achromatic
        } else {
            const hue2rgb = (p, q, t) => {
                if (t < 0) t += 1;
                if (t > 1) t -= 1;
                if (t < 1 / 6) return p + (q - p) * 6 * t;
                if (t < 1 / 2) return q;
                if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                return p;
            };
            const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            const p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        const toHex = x => {
            const hex = Math.round(x * 255).toString(16);
            return hex.length === 1 ? '0' + hex : hex;
        };
        return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    }

    hexToHSLObject(H) {
        let r = 0,
            g = 0,
            b = 0;
        if (H.length === 4) {
            r = "0x" + H[1] + H[1];
            g = "0x" + H[2] + H[2];
            b = "0x" + H[3] + H[3];
        } else if (H.length === 7) {
            r = "0x" + H[1] + H[2];
            g = "0x" + H[3] + H[4];
            b = "0x" + H[5] + H[6];
        }
        r /= 255;
        g /= 255;
        b /= 255;
        let cmin = Math.min(r, g, b),
            cmax = Math.max(r, g, b),
            delta = cmax - cmin,
            h = 0,
            s = 0,
            l = 0;

        if (delta === 0) h = 0;
        else if (cmax === r) h = ((g - b) / delta) % 6;
        else if (cmax === g) h = (b - r) / delta + 2;
        else h = (r - g) / delta + 4;

        h = Math.round(h * 60);

        if (h < 0) h += 360;

        l = (cmax + cmin) / 2;
        s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
        s = +(s * 100).toFixed(1);
        l = +(l * 100).toFixed(1);

        return {
            h: h,
            s: s,
            l: l
        };
    }

    hexToRGBObject(H) {
        let r = 0,
            g = 0,
            b = 0;
        if (H.length === 4) {
            r = "0x" + H[1] + H[1];
            g = "0x" + H[2] + H[2];
            b = "0x" + H[3] + H[3];
        } else if (H.length === 7) {
            r = "0x" + H[1] + H[2];
            g = "0x" + H[3] + H[4];
            b = "0x" + H[5] + H[6];
        }
        r /= 1;
        g /= 1;
        b /= 1;

        return {
            r: r,
            g: g,
            b: b
        };
    }

    hexToHSL(H) {
        let hsl = this.hexToHSLObject(H);
        return 'hsl(' + hsl.h + ',' + hsl.s + '%,' + hsl.l + '%)';
    }

    PopupNewEvent($event, date, copyEvents, fromRange = null, toRange = null, createCallback) {
        var view = this;
        let copyEventItems = [];
        copyEventItems.push({
            label: i18n.t('roster.comp.standard'),
            name: "Standard",
            value: null
        });
        copyEvents.forEach(e => {
            if (e.name == null) {
                e.name = e.label;
            }
            copyEventItems.push(e)
        })
        let from = date.clone().hours(0);

        let to = date.clone().hours(0);

        let nameEntry = {
            label: i18n.t('pages.employeeData.name'),
            key: 'name',
            hidden: false,
            type: 'text',
            value: i18n.t('store.events.event'),
            length: 20
        };
        let dataEntries = [


            {
                label: i18n.t('global.general.from'),
                key: 'from',
                hidden: false,
                type: 'timeframe',
                value: from,
                flexGroup: true,
                timeBig: true,
                startTime: true
            },
            {
                label: i18n.t('global.general.to').toLowerCase(),
                key: 'to',
                hidden: false,
                type: 'timeframe',
                value: to,
                flexGroup: true,
                timeBig: true,
                endTime: true
            },
            {
                divider: true
            },
            nameEntry,
            {
                label: i18n.t('store.events.allocation'),
                key: 'copyEventId',
                hidden: false,
                type: 'dropdownsearch',
                value: null,
                selectMultiple: false,
                flexGroup: true,
                dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: copyEventItems,
                    selectMultiple: false,
                    selectFirst: true,
                    selectedItems: [],
                    selectedItem: null,
                    onceSelected: function ($event, item, searchbar) {
                        if (view.isEmpty(nameEntry.value)) {
                            nameEntry.value = item.name;
                        }

                    },
                    styleLight: true,
                },
                styles: {
                    width: '500px'
                }
            },
            {
                label: i18n.t('store.events.color'),
                key: 'color',
                hidden: false,
                type: 'color',
                value: view.getRandomLightColor()
            },
            {
                label: i18n.t('global.general.fromDay'),
                key: 'fromDate',
                hidden: false,
                type: 'date',
                value: from.clone(),
                flexGroup: true,
                styles: {
                    'margin-right': '10px'
                }
            },
            {
                label: i18n.t('global.general.toDay'),
                key: 'toDate',
                hidden: false,
                type: 'date',
                value: to.clone(),
                flexGroup: true
            },
            {
                flexDivider: true
            },
            {
                label: i18n.t('store.events.nationalHoliday'),
                key: 'federalHoliday',
                hidden: false,
                type: 'bool',
                value: false,
                flexGroup: false
            },
            {
                label: i18n.t('store.events.bankHoliday'),
                key: 'bankHoliday',
                hidden: false,
                type: 'bool',
                value: false,
                flexGroup: false
            },
            {
                label: i18n.t('store.events.contractHoliday'),
                key: 'contractHoliday',
                hidden: false,
                type: 'bool',
                value: false,
                flexGroup: false
            },
            {
                label: i18n.t('store.events.allowShiftTemplates'),
                key: 'allowTemplateAssignment',
                hidden: false,
                type: 'bool',
                value: true,
                flexGroup: false
            },
            {
                label: i18n.t('store.events.createWithShiftTemplates'),
                key: 'createWithTemplates',
                hidden: false,
                type: 'bool',
                value: true,
                flexGroup: false,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let allowFlag = datafill.entries.find(i => i.key == 'allowTemplateAssignment').value;
                    if(allowFlag){
                        entryBeforeUpdate.hidden = false;
                    } else {

                        entryBeforeUpdate.value = false;
                        entryBeforeUpdate.hidden = true;
                    }

                    return entryBeforeUpdate;
                }
            },
            {
                label: i18n.t('store.events.description'),
                key: 'description',
                hidden: false,
                type: 'text',
                value: '',
                length: 20
            },
            {
                label: i18n.t('store.events.shiftMode'),
                key: 'shiftCreationMode',
                hidden: false,
                type: 'dropdownsearch',
                value: 0,
                selectMultiple: false,
                dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: [{
                        label: i18n.t('store.events.allocationReplacement'),
                        value: 0
                    },
                        {
                            label: i18n.t('store.events.allocationReinforcement'),
                            value: 1
                        },
                        {
                            label: i18n.t('store.events.noShifts'),
                            value: 2
                        },
                    ],
                    selectMultiple: false,
                    selectFirst: true,
                    selectedItems: [],
                    styleLight: true,
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let allowFlag = datafill.entries.find(i => i.key == 'allowTemplateAssignment').value;
                    if(allowFlag){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.value = 1;
                        entryBeforeUpdate.hidden = true;
                    }

                    return entryBeforeUpdate;
                }
            },
        ];
        let target = $event.currentTarget;

        this.OpenPopup({
            elRelative: target,
            type: 'datafill',
            componentState: {
                entries: dataEntries,
                errorCheck: [
                    (entries) => {
                        if(fromRange != null && entries['fromDate'] < fromRange ){
                            return {key: 'fromDate', type: 'error', label: i18n.t('global.general.from'), text: i18n.t('roster.error.startBeforeSpecific', [fromRange.format('DD.MM.YYYY')])}
                        } else {
                            return null
                        }
                    },
                    (entries) => {
                        if(toRange != null && entries['toDate'] > toRange ){
                            return {key: 'fromDate', type: 'error', label: i18n.t('global.general.to'), text: i18n.t('roster.error.endAfterSpecific', [toRange.format('DD.MM.YYYY')])}
                        } else {
                            return null
                        }
                    },
                    (entries) => {
                        if(entries['toDate'] < entries['fromDate'] ){
                            return {key: 'fromDate', type: 'error', label: i18n.t('store.settings.date'), text: i18n.t('roster.error.startAfterEnd')}
                        } else {
                            return null
                        }
                    },

                ],
                selectCallback: createCallback
            },
            header: i18n.t('store.events.new'),
            expanded: true,
            centered: true
        });
    }

    PopupEditEvent($event, event, editCallback) {

        let view = this;
        let dataEntries = [{
            label: 'Id',
            key: 'id',
            hidden: true,
            type: 'text',
            value: event.id,
            length: 20
        },
            {
                label: i18n.t('pages.employeeData.name'),
                key: 'name',
                hidden: false,
                type: 'text',
                value: '',
                length: 20
            },
            {
                label: i18n.t('store.events.color'),
                key: 'color',
                hidden: false,
                type: 'color',
                value: event.color
            },
            {
                label: i18n.t('global.general.fromDay'),
                key: 'from',
                hidden: false,
                type: 'datetimeframe',
                value: event.from
            },
            /*{
                label: 'Von',
                key: 'from',
                hidden: false,
                type: 'timeframe',
                value: from
            },*/
            {
                label: i18n.t('global.general.toDay'),
                key: 'to',
                hidden: false,
                type: 'datetimeframe',
                value: event.to
            },
            /*{
                label: 'Bis',
                key: 'to',
                hidden: false,
                type: 'timeframe',
                value: to
            },*/
            {
                label: i18n.t('store.events.nationalHoliday'),
                key: 'federalHoliday',
                hidden: false,
                type: 'bool',
                value: event.federalHoliday
            },
            {
                label: i18n.t('store.events.bankHoliday'),
                key: 'bankHoliday',
                hidden: false,
                type: 'bool',
                value: event.bankHoliday
            },
            {
                label: i18n.t('store.events.contractHoliday'),
                key: 'contractHoliday',
                hidden: false,
                type: 'bool',
                value: event.contractHoliday
            },
            {
                label: i18n.t('store.events.description'),
                key: 'description',
                hidden: false,
                type: 'text',
                value: event.description,
                length: 20
            },
            {
                label: i18n.t('global.general.active'),
                key: 'active',
                hidden: true,
                type: 'bool',
                value: event.active,
            },
            {
                label: i18n.t('store.events.shiftMode'),
                key: 'shiftCreationMode',
                hidden: !event.allowTemplateAssignment,
                type: 'dropdownsearch',
                value: event.shiftCreationMode,
                selectMultiple: false,
                dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: [{
                        label: i18n.t('store.events.allocationReplacement'),
                        value: 0
                    },
                        {
                            label: i18n.t('store.events.allocationReinforcement'),
                            value: 1
                        },
                        {
                            label: i18n.t('store.events.noShifts'),
                            value: 2
                        },
                    ],
                    selectMultiple: false,
                    selectFirst: false,
                    selectedItems: [],
                    styleLight: true,
                }
            },
        ];

        if (event) {
            for (let x in event) {
                let entry = dataEntries.find(e => e.key === x);
                if (entry) {
                    if (x === 'from' || x === 'to') {
                        //do nothing cause datafill a shit
                    } else if (x === 'shiftCreationMode') {
                        entry.dropdownSearchState.selectedItem = entry.dropdownSearchState.items.find(i => event[x] === i.value);
                        if (entry.dropdownSearchState.selectedItem) entry.dropdownSearchState.input = entry.dropdownSearchState.selectedItem.label;
                    } else {
                        entry.value = event[x];
                    }
                }
            }
        }
        let target = $event.currentTarget;

        this.OpenPopup({
            elRelative: target,
            type: 'datafill',
            componentState: {
                entries: dataEntries,
                selectCallback: editCallback
            },
            header: i18n.t('store.events.edit'),
            expanded: true,
            centered: true
        });
    }

    TimeDiff(a, b) {
        if (!a || !b || !a.format || !b.format) return NaN;
        return b._d.getTime() - a._d.getTime();
    }

    OpenAlert(state) {
        window.app.popupalerts.push({
            header: state.header,
            description: state.description,
            callbackAccept: state.callbackAccept,
            callbackCancel: state.callbackCancel,
            disableAccept: state.disableAccept ? state.disableAccept : false,
            disableCancel: state.disableCancel ? state.disableCancel : false,
            enableExternal: state.enableExternal ? state.enableExternal : false,
            externalUrl: state.externalUrl,
            externalLabel: state.externalLabel,
            closeOnExternal: state.closeOnExternal == null ? true : state.closeOnExternal,
            acceptLabel: state.acceptLabel ? state.acceptLabel : "Ok",
            cancelLabel: state.cancelLabel ? state.cancelLabel : i18n.t('global.ui.cancel'),
        });
    }

    OpenDatepicker(state) {
        window.app.datepickerState = state;
    }


    /*
        sumArray should look like this if any
        let dataSum = [];
        let dataSumItem = {};
        let keyStart = Object.keys(headerMap)[0];
        dataSumItem[keyStart] = {key: keyStart, label: 'Total'};
        dataSumItem['amount'] = {key: amount, label: data.map(i => i.amount).reduce((total, current) => { return total + current})};
    */
    GetDataTableStateFromObject(dataItem, dataArray, sumArray) {

        let headerMap = {};

        for (let key in dataItem) {

            headerMap[key] = {
                key: key,
                DisplayLabel: (d) => d[key],
                sort: dataItem.sort ? dataItem.sort : null
            };
        }

        return {
            headerMap: headerMap,
            data: dataArray ? dataArray : [],
            dataSum: sumArray ? sumArray : [],
        }
    }

    GetDataTableStateFromKeyLabelObject(dataItem, dataArray, sumArray) {

        let headerMap = {};

        for (let key in dataItem) {

            headerMap[key] = {
                key: key,
                label: dataItem[key] && dataItem !== '' ? dataItem[key] : this.ConvertKeyToName(key),
                DisplayLabel: (d) => d[key],
                sort: dataItem.sort ? dataItem.sort : null
            };
        }

        return {
            headerMap: headerMap,
            data: dataArray ? dataArray : [],
            dataSum: sumArray ? sumArray : [],
        }
    }

    ConvertKeyToName(key) {
        if (key === undefined) return '';
        key = key.toString();
        let label = '';
        let temp = '';
        key.split('_').filter(l => l.length > 0).forEach(l => temp += l[0].toUpperCase() + l.substr(1) + ' ');
        label = temp;
        temp = '';
        label.split('-').filter(l => l.length > 0).forEach(l => temp += l[0].toUpperCase() + l.substr(1) + ' ');
        label = temp;
        temp = '';
        label.split(/(?=[A-Z])/).filter(l => l.length > 0).forEach(l => temp += ' ' + l);
        label = temp;
        label = label.replace(/\s\s+/g, ' ').trimRight();
        return label;
    }

    GetDataFillStateFromObject(object, selectCallback, asArray = false) {

        let dataEntries = {};
        if (asArray) {
            dataEntries = [];
        }
        for (let x in object) {
            let entry = {
                key: x,
                label: this.ConvertKeyToName(x),
                hidden: false,
                value: object[x],
                type: 'text',
            };
            if (asArray) {
                dataEntries.push(entry);
            } else {
                dataEntries[x] = entry;
            }
        }

        return {
            entries: dataEntries,
            selectCallback: selectCallback
        };
    }


    GetDataFillStateFromKeyLabelObject(object, selectCallback) {

        let dataEntries = {};
        for (let x in object) {
            dataEntries[x] = {
                key: x,
                label: object[x],
                hidden: false,
                value: null,
                type: 'text',
            };
        }

        return {
            entries: dataEntries,
            selectCallback: selectCallback
        };
    }

    async* workPromiseQueue(promiseConstructors) {
        const finalResults = [];
        for (let i = 0; i < promiseConstructors.length; i++) {
            try {
                const result = await promiseConstructors[i]();
                finalResults.push([result, null]);
                yield {
                    finished: false,
                    result,
                    progress: i / promiseConstructors.length,
                    index: i,
                };
            } catch (error) {
                finalResults.push([null, error]);
                yield {
                    finished: false,
                    error,
                    progress: i / promiseConstructors.length,
                    index: i,
                }
            }
        }
        yield {
            finished: true,
            results: finalResults,
        }
    }

    async retryPromises(promiseConstructors, maxRetries = 3, delay = 0) {
        promiseConstructors = promiseConstructors.map((p, i) => ([i, p]));
        const results = [];
        const recursiveRetry = async (indizes, retryCount) => {
            const retryPromises = promiseConstructors.filter(([i]) => indizes.includes(i));
            const promiseResults = await Promise.allSettled(retryPromises.map(([, p]) => p()));
            const failedIndizes = [];
            for (let i = 0; i < promiseResults.length; i++) {
                let result = promiseResults[i];
                const originalIndex = retryPromises[i][0];
                if (result.status === 'fulfilled')
                    results[originalIndex] = result;
                else
                    failedIndizes.push(originalIndex);
            }
            if (failedIndizes.length > 0) {
                if (retryCount > 0) {
                    await new Promise(resolve => setTimeout(resolve, delay));
                    await recursiveRetry(failedIndizes, retryCount - 1);
                } else {
                    for (let i = 0; i < promiseResults.length; i++) {
                        const result = promiseResults[i];
                        if (result.status === 'rejected') {
                            const originalIndex = retryPromises[i][0];
                            results[originalIndex] = result;
                        }
                    }
                }
            }
        }
        await recursiveRetry(Array.from(Array(promiseConstructors.length).keys()), maxRetries);
        return results;
    }

    GetCall(url, params) {
        return this.SendCall('get', url, params);
    }

    PostCall(url, payload, params = null) {
        let request = {
            payload: payload,
            params: params,
        }
        return this.SendCall('post2', url, request);
    }

    CreateCall(url, object, successCallback, successMessage, errorCallback, errorMessage) {
        if (!successMessage) {
            successMessage = {
                title: i18n.t('global.ui.create'),
                message: i18n.t('global.ui.createdX', [''])
            };
        }
        if (!errorMessage) {
            errorMessage = {
                title: i18n.t('global.ui.create'),
                message: i18n.t('global.ui.createFailed')
            };
        }
        return this.SendCall('post', url, object, successCallback, successMessage, errorCallback, errorMessage);
    }

    EditCall(url, object, successCallback, successMessage, errorCallback, errorMessage) {
        if (!successMessage) {
            successMessage = {
                title: 'Update',
                message: i18n.t('global.notifications.updateMessage'),
            };
        }
        if (!errorMessage) {
            errorMessage = {
                title: 'Update',
                message: i18n.t('global.notifications.updateFailed')
            };
        }
        return this.SendCall('put', url, object, successCallback, successMessage, errorCallback, errorMessage);
    }

    DeleteCall(url, object, successCallback, successMessage, errorCallback, errorMessage) {
        object = {
            id: object.id
        };
        if (!successMessage) {
            successMessage = {
                title: i18n.t('global.ui.delete'),
                message: i18n.t('global.ui.deletedX', [''])
            };
        }
        if (!errorMessage) {
            errorMessage = {
                title: i18n.t('global.ui.delete'),
                message: i18n.t('global.ui.deleteFailed')
            };
        }
        return this.SendCall('delete', url, object, successCallback, successMessage, errorCallback, errorMessage);
    }

    SendCall(type, url, object, successCallback, successMessage, errorCallback, errorMessage) {
        let view = this;
        if (type === 'put' || type === 'post') {
            url = this.appendParam("storeId", this.store.state.storeId, url, url);
            let payload = {
                storeId: this.store.state.storeId,
            };
            for (let x in object) {
                if (type === 'put' && x !== 'id') {
                    if (!payload.updateFields) payload.updateFields = [];
                    payload.updateFields.push(x);
                }
                payload[x] = object[x];
            }


            return axios({
                method: type,
                headers: {
                    'AUTHORIZATION': "bearer " + this.store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                if (successMessage) view.success(successMessage.title, successMessage.message);
                if (successCallback) successCallback(response);
            }).catch(function (error) {
                if (errorMessage) view.error(errorMessage.title, errorMessage.message);
                if (errorCallback) errorCallback(error);
            })
        } else if (type === 'post2') {
            //url = this.appendParam("storeId", this.store.state.storeId, url, url);
            let payload = {
                storeId: this.store.state.storeId,
            };

            let params = object.params ? object.params : {};
            if (!params.storeId) {
                params.storeId = this.store.state.storeId;
            }
            for (let x in object.payload) {
                if (type === 'put' && x !== 'id') {
                    if (!payload.updateFields) payload.updateFields = [];
                    payload.updateFields.push(x);
                }
                payload[x] = object.payload[x];
            }
            return axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.store.state.jwt
                },
                url: url,
                data: payload
            });
        } else if (type === 'delete') {
            let urlTemp = '';
            urlTemp = this.appendParam("id", object.id, url, url);
            urlTemp = this.appendParam("storeId", this.store.state.storeId, urlTemp, url);
            let axiosData = {
                method: type,
                headers: {
                    'AUTHORIZATION': "bearer " + this.store.state.jwt
                },
                url: urlTemp,
            };
            return axios(axiosData).then(response => {
                if (successMessage) view.success(successMessage.title, successMessage.message);
                if (successCallback) successCallback(response);
            }).catch(function (error) {

                if (errorMessage) view.error(errorMessage.title, errorMessage.message);
                if (errorCallback) errorCallback(error);
            });
        } else {
            url = this.appendParam("storeId", this.store.state.storeId, url, url);
            let axiosData = {
                method: type,
                headers: {
                    'AUTHORIZATION': "bearer " + this.store.state.jwt
                },
                url: url,
            };
            if (object) axiosData.params = object;
            return axios(axiosData);
        }
    }

    DownloadFileFromFileServer(url, filename, fileending = null){
        let finalUrl = url+"&dl=true"+"&filename="+filename;
        if(fileending != null){
            finalUrl += "."+fileending;
        }
        window.open(finalUrl);
    }


    DateSelectionPopup($event, time, selectCallback, disableDate, disableTime) {
        let view = this;
        let state = this.GetDataFillStateFromObject({
            date: time,
            timeframe: time
        }, (newTime) => {
            let date = view.getMomentFromStringTZ(newTime.date);
            let timeframe = view.getMomentFromStringTZ(newTime.timeframe);
            let time = date.hours(timeframe.hours).minutes(timeframe.minutes());
            selectCallback(view.convertDateStringTZ(time), time);
        });

        state.entries.date.label = '';
        state.entries.date.type = 'date';
        state.entries.date.dataStyles = disableTime ? {
            'justify-content': 'center'
        } : {
            'justify-content': 'flex-end'
        };
        state.entries.date.styles = {
            'margin-top': '-15px'
        };
        state.entries.date.hidden = disableDate;

        state.entries.timeframe.label = 'Time';
        state.entries.timeframe.type = 'timeframe';
        state.entries.timeframe.timeBig = true;
        state.entries.timeframe.flexGroup = true;
        state.entries.timeframe.hidden = disableTime;

        state.entries.divider = {
            divider: true,
            styles: {
                opacity: 0,
                margin: 0
            }
        };

        let target = $event.currentTarget;

        this.OpenPopup({
            elRelative: target,
            type: 'datafill',
            componentState: state,
            header: i18n.t('store.events.pickDateTime'),
            expanded: true,
        });
    }

    returnObj(map, asArray) {
        /* this.log(null, 'returnObj', [map, asArray], false);
        this.log(null, 'returnObj', asArray? Object.values(map) : map, false); */
        return asArray ? Object.values(map) : map;
    }

    idObjectsArrayToMap(responseData) {
        var map = {};
        if(responseData != null){
            responseData.forEach(item => {
                map[item.id] = item;
            });
        }

        return map;
    }

    LoadMaps() {
        let view = this;
        let maps = {};
        view.GetCall('/api/sec/employee').then((response) => {
            maps.employeeDataMap = response.data;
            return view.GetCall('/api/sec/spot')
        }).then((response) => {
            maps.spotMap = response.data;
            return view.GetCall('/api/sec/skill')
        }).then((response) => {
            maps.skillMap = response.data;
            return view.GetCall('/api/sec/employeeskill')
        }).then((response) => {
            maps.employeeSkillMap = response.data;
            return view.GetCall('/api/sec/employeeavailability')
        }).then((response) => {
            maps.employeeAvailabilityMap = response.data;
            return view.GetCall('/api/sec/employeecontract')
        }).then((response) => {
            maps.employeeContractMap = response.data;
            return view.GetCall('/api/sec/employeetype')
        }).then((response) => {
            maps.employeeTypeMap = response.data;
            return view.GetCall('/api/sec/employeerules')
        }).then((response) => {
            maps.employeeRulesMap = response.data;
            return view.GetCall('/api/semi/uidata')
        }).then((response) => {
            maps.employeeAvailabilityStateMap = response.data;
            for (let x in maps) {
                if (maps[x].forEach) {
                    let temp = {};
                    maps[x].forEach(e => temp[e.id] = e);
                    maps[x] = temp;
                }
            }
            window.maps = maps;
        }).catch((e) => {
            view.error('Failed to load maps', e)
        });
    }


    GetStoreSettings(force = false, asArray = false) {
        if (this.store.state.storeSettings && this.store.state.storeSettings.id == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.storeSettings, asArray));
            });
        } else {
            let params = {
                id: this.store.state.storeId,
            };
            return this.GetCall('/api/sec/storesettings', params).then((response) => {
                let map = response.data;
                let validMpLicense = false;
                let validMzLicense = false;
                let validAsLicense = false;
                let validStatsLicense = false;
                let dateNow = this.getMomentTZ()
                if (response.data.mpLicExpiry != null && this.getMomentFromStringTZ(response.data.mpLicExpiry).add(1, 'weeks') > dateNow &&
                    response.data.usageStartDate != null && dateNow > this.getMomentFromStringTZ(response.data.usageStartDate).add(-8, 'weeks')) {
                    validMpLicense = true;
                }
                if (response.data.mzLicExpiry != null && this.getMomentFromStringTZ(response.data.mzLicExpiry).add(1, 'weeks') > dateNow &&
                    response.data.usageStartDate != null && dateNow > this.getMomentFromStringTZ(response.data.usageStartDate).add(-8, 'weeks')) {
                    validMzLicense = true;
                }
                if (response.data.asLicExpiry != null && this.getMomentFromStringTZ(response.data.asLicExpiry).add(1, 'weeks') > dateNow &&
                    response.data.usageStartDate != null && dateNow > this.getMomentFromStringTZ(response.data.usageStartDate).add(-8, 'weeks')) {
                    validAsLicense = true;
                }
                if (response.data.statsLicExpiry != null && this.getMomentFromStringTZ(response.data.statsLicExpiry).add(1, 'weeks') > dateNow &&
                    response.data.usageStartDate != null && dateNow > this.getMomentFromStringTZ(response.data.usageStartDate).add(-8, 'weeks')) {
                    validStatsLicense = true;
                }




                this.store.commit("setValidMpLicense", {
                    validMpLicense: validMpLicense
                });
                this.store.commit("setValidMzLicense", {
                    validMzLicense: validMzLicense
                });
                this.store.commit("setValidAsLicense", {
                    validAsLicense: validAsLicense
                });
                this.store.commit("setValidStatsLicense", {
                    validStatsLicense: validStatsLicense
                });
                this.store.commit('setStoreSettings', {
                    storeSettings: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });

            });
        }
    }

    GetUserUnitSort(force = false, asArray = false) {
        let view = this;
        if (this.store.state.userUnitSortMap && this.store.state.userUnitSortMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.userUnitSortMap, asArray));
            });
        } else {
            let params = {
                id: this.store.state.storeId,
            };
            return this.GetCall('/api/sec/userunitsort', params).then((response) => {
                let map = {};
                response.data.forEach(unit => {
                    map[unit.id] = unit;
                })
                this.store.commit('setUserUnitSortMap', {
                    userUnitSortMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });

            });
        }
    }

    CreateDefaultHolidays(year){


        let url = '/api/sec/storeevent/holidays/default';

        let params = {
            storeId: this.store.state.storeId,
            years: year
        };

        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.store.state.jwt
                },
                url: url,
            }).then(response => {
                resolve();

            }).catch(function (error) {
                console.log(error);
                resolve();
            })
        })


    }

    GetDefaultHolidays(year, asArray){
        let params = {
            storeId: this.store.state.storeId,
            years: year + ',' + (year + 1) + ',' + (year - 1)
        };
        return this.GetCall('/api/sec/storeevent/holidays/default', params).then((response) => {
            let map = {};
            response.data.forEach(holiday => {
                map[holiday.id] = holiday;
            })
            this.store.commit('setHolidayMap', {
                holidayMap: map,
                year: year
            });
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(map, asArray));
            })
        }).catch((e) => {
            return new Promise((resolve, reject) => {
                reject(e);
            });
        });
    }

    GetHolidayMap(force = false, asArray = false, tyear = null) {
        let year = tyear ? tyear : this.store.state.rosterFromTo.year;
        let view = this;
        if (this.store.state.holidayMap && this.store.state.holidayMapState.storeId == this.store.state.storeId && this.store.state.holidayMapState.year == year && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.holidayMap, asArray));
            });
        } else {
            let startOfYear = this.getMomentFromValuesTZ(year, 0, 1);
            let params = {
                storeId: this.store.state.storeId,
                from: startOfYear.clone().date(15).month(11).subtract(1, 'year').format(),
                to: startOfYear.clone().date(15).month(0).add(1, 'year').format(),
                holiday: true,
                active: true,
            };
            return this.GetCall('/api/sec/storeevent', params).then((response) => {
                if (response.status == 200) {
                    let holidaysInYear = response.data.map(event =>view.getMomentFromStringTZ(event.from).year()).filter(y => y == year);
                    if(holidaysInYear.length > 0){
                        let map = {};
                        response.data.forEach(holiday => {
                            map[holiday.id] = holiday;
                        })
                        this.store.commit('setHolidayMap', {
                            holidayMap: map,
                            year: year
                        });
                        return new Promise((resolve, reject) => {
                            resolve(this.returnObj(map, asArray));
                        })
                    } else {
                        return this.CreateDefaultHolidays(year)
                            .then(res => {
                                return this.GetCall('/api/sec/storeevent', params);
                            }).then(res => {
                                if (response.status == 200) {
                                    let map = {};
                                    res.data.forEach(holiday => {
                                        map[holiday.id] = holiday;
                                    })
                                    this.store.commit('setHolidayMap', {
                                        holidayMap: map,
                                        year: year
                                    });
                                    return new Promise((resolve, reject) => {
                                        resolve(this.returnObj(map, asArray));
                                    })
                                } else {
                                    return new Promise((resolve, reject) => {
                                        reject('Invalid return code');
                                    });
                                }
                            })
                    }
                } else {
                    return new Promise((resolve, reject) => {
                        reject('Invalid return code');
                    });
                }

            })
                .catch((e) => {
                    return new Promise((resolve, reject) => {
                        reject(e);
                    });

                });
        }
    }


    GetStoreSettingsArray(force = false) {
        return this.GetStoreSettings(force, true);
    }

    GetBusinessUnitMap(force = false, asArray = false) {
        if (this.store.state.businessUnitMap && this.store.state.businessUnitMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.businessUnitMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/businessunit').then((response) => {
                let map = {};
                response.data.forEach(unit => {
                    map[unit.id] = unit;
                })
                this.store.commit('setBusinessUnitMap', {
                    businessUnitMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetBusinessUnitArray(force = false) {
        return this.GetBusinessUnitMap(force, true);
    }

    GetSkillMap(force = false, asArray = false) {
        if (this.store.state.skillMap && this.store.state.skillMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.skillMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/skill').then((response) => {
                let map = {};
                response.data.forEach(skill => {
                    map[skill.id] = skill;
                })
                this.store.commit('setSkillMap', {
                    skillMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetSkillArray(force = false) {
        return this.GetSkillMap(force, true);
    }

    GetSpotMap(force = false, asArray = false) {

        if (this.store.state.spotMap && this.store.state.spotMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.spotMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/spot').then((response) => {
                let map = {};
                response.data.forEach(spot => {
                    map[spot.id] = spot;
                })
                this.store.commit('setSpotMap', {
                    spotMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetSpotArray(force = false) {
        return this.GetSpotMap(force, true);
    }

    GetCompanySpotMap(companyId, asArray = false) {
        let params = {
            companyId: companyId,
        }
        return this.RecursiveGETPaged('/api/sec/spot/company', [], params, 1)
            .then((result) => {
                let map = {};
                result.forEach(spot => {
                    map[spot.id] = spot;
                })

                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });

            });
    }



    GetEmployeeMap(force = false, asArray = false) {
        /* this.log(null, 'GetEmployeeMap', [force, asArray], false); */
        if (this.store.state.employeeMap && this.store.state.employeeMapState.storeId == this.store.state.storeId && this.store.state.employeeMapState.type == 'all' && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/employee').then((response) => {
                let map = {};
                response.data.forEach(employee => {
                    map[employee.id] = employee;
                })
                this.store.commit('setEmployeeMap', {
                    employeeMap: map,
                    type: "all"
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });

            });
        }
    }

    GetEmployeeArray(force = false) {
        /* this.log(null, 'GetEmployeeArray', force); */
        return this.GetEmployeeMap(force, true);
    }

    GetActiveEmployeeMap(force = false, asArray = false, activeOnly = true) {
        if (this.store.state.employeeMap && this.store.state.employeeMapState.storeId == this.store.state.storeId && this.store.state.employeeMapState.type == 'active' && this.store.state.employeeMapState.rosterFromToKey == this.store.getters.rosterFromToKey && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeMap, asArray));
            });
        } else {
            let params = {
                activeAtFrom: this.store.state.rosterFromTo.from,
                activeAtTo: this.store.state.rosterFromTo.to,
            }
            if(activeOnly){
                params.active = true;
            }

            return this.GetCall('/api/sec/employee', params).then((response) => {
                let map = {};
                response.data.forEach(employee => {
                    map[employee.id] = employee;
                })
                this.store.commit('setEmployeeMap', {
                    employeeMap: map,
                    type: "active"
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });

            });
        }
    }



    GetEmployeeMissingExternalIdMap(force = false, asArray = false) {
        /* this.log(null, 'GetEmployeeMap', [force, asArray], false); */
        if (this.store.state.employeeMissingExternalIdMap && this.store.state.employeeMissingExternalIdMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeMissingExternalIdMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/externalapiaccess/missingemployees').then((response) => {
                let map = {};
                response.data.forEach(employee => {
                    map[employee.id] = employee;
                })
                this.store.commit('setEmployeeMissingExternalIdMap', {
                    employeeMissingExternalIdMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });

            });
        }
    }

    GetEmployeeMissingExternalIdArray(force = false) {
        /* this.log(null, 'GetEmployeeArray', force); */
        return this.GetEmployeeMissingExternalIdMap(force, true);
    }

    GetEmploymentModelMap(force = false, asArray = false){
        if (this.store.state.employmentModelMap && this.store.state.employmentModelMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employmentModelMap, false));
            });
        } else {
            let params = {
                companyId: this.store.state.storeSettings.companyId
            }
            return this.GetCall('/api/sec/employmentmodel', params).then((response) => {
                let map = {};
                response.data.forEach(model => {
                    map[''+model.id] = model;
                })
                this.store.commit('setEmploymentModelMap', {
                    employmentModelMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });

            });
        }

    }

    GetEmployeeEmploymentModelMap(remoteIds, force = false, asArray = false){
        if (this.store.state.employeeEmploymentModelMap && this.store.state.employeeEmploymentModelMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeEmploymentModelMap, false));
            });
        } else {
            let params = {
                companyId: this.store.state.storeSettings.companyId
            }
            let payload = {
                ids: remoteIds,
            }
            return this.PostCall('/api/sec/employmentmodel/employee', payload, params).then((response) => {
                let map = {};
                response.data.forEach(data => {
                    if(data.employmentModelId != null){
                        map[''+data.id] = data;
                    }

                })
                this.store.commit('setEmployeeEmploymentModelMap', {
                    employeeEmploymentModelMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });

            });
        }

    }

    GetEmployeeSpareWeekDaysStats(from, to, weekDays, checkDayBeforeMinutes, checkDayAfterMinutes){
        let payload = {
            from: from,
            to: to,
            weekDays: weekDays,
            checkDayBeforeMinutes: checkDayBeforeMinutes,
            checkDayAfterMinutes: checkDayAfterMinutes
        }
        return this.PostCall('/api/sec/statistics/peremployee/spareweekdays', payload, {}).then((response) => {

            return new Promise((resolve, reject) => {
                resolve(response.data);
            })
        }).catch((e) => {
            return new Promise((resolve, reject) => {
                reject(e);
            });

        });

    }


    GetRosterBackupMap(force = false) {
        if (this.store.state.rosterBackupMap && this.store.state.rosterBackupMapState.storeId == this.store.state.storeId && this.store.state.rosterBackupMapState.rosterFromToKey == this.store.getters.rosterFromToKey && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.rosterBackupMap, false));
            });
        } else {
            let params = {
                month: this.store.state.rosterFromTo.month + 1,
                year: this.store.state.rosterFromTo.year,
            }
            return this.GetCall('/api/sec/rosterbackup', params).then((response) => {
                let map = {};
                response.data.forEach(item => {
                    map[item.id] = item;
                })
                this.store.commit('setRosterBackupMap', {
                    rosterBackupMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, false));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });

            });
        }
    }

    GetShiftTemplateMap(groupId = null, force = false, asArray = false) {
        if ((groupId == this.store.state.shiftTemplateMapState.groupId || (groupId == null && this.store.state.shiftTemplateMapState.groupId == null))
            && this.store.state.shiftTemplateMap
            && this.store.state.shiftTemplateMapState.storeId == this.store.state.storeId
            && this.store.state.shiftTemplateMapState.rosterFromToKey == this.store.getters.rosterFromToKey
            && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.shiftTemplateMap, asArray));
            });
        } else {
            let params = {
                validFrom: this.store.state.rosterFromTo.from,
                validTo: this.store.state.rosterFromTo.to,
            }
            if(groupId != null){
                params.groupId = groupId;
            }
            return this.RecursiveGETPaged('/api/sec/shifttemplate', [], params, 1, 3)
                .then((result) => {
                    let map = {};
                    result.forEach(shift => {
                        map[shift.id] = shift;
                    })
                    this.store.commit('setShiftTemplateMap', {
                        shiftTemplateMap: map,
                        groupId: groupId
                    });
                    return new Promise((resolve, reject) => {
                        resolve(this.returnObj(map, asArray));
                    })
                }).catch((e) => {
                    return new Promise((resolve, reject) => {
                        reject(e);
                    });

                });
        }
    }

    GetShiftTemplateGroupMap(force = false, asArray = false) {
        if (this.store.state.shiftTemplateGroupMap && this.store.state.shiftTemplateGroupMapState.storeId == this.store.state.storeId
            && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.shiftTemplateGroupMap, asArray));
            });
        } else {

            return this.GetCall('/api/sec/shifttemplategroup').then((response) => {
                let map = {};
                response.data.forEach(group => {
                    map[group.id] = group;
                })
                this.store.commit('setShiftTemplateGroupMap', {
                    shiftTemplateGroupMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetShiftTemplateGroupFrameMap(force = false, asArray = false, tyear = null) {
        let year = tyear ? tyear : this.store.state.rosterFromTo.year;
        let view = this;
        if (this.store.state.shiftTemplateGroupFrameMap && this.store.state.shiftTemplateGroupFrameMapState.storeId == this.store.state.storeId
            && this.store.state.shiftTemplateGroupFrameMapState.year == year && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.shiftTemplateGroupFrameMap, asArray));
            });
        } else {
            let startOfYear = this.getMomentFromValuesTZ(year, 0, 1);
            let params = {
                storeId: this.store.state.storeId,
                from: startOfYear.clone().date(15).month(11).subtract(1, 'year').format(),
                to: startOfYear.clone().date(15).month(0).add(1, 'year').format(),

            };
            return this.GetCall('/api/sec/shifttemplategroupframe', params).then((response) => {
                if (response.status == 200) {
                    let map = {};
                    response.data.forEach(frame => {
                        map[frame.id] = frame;
                    })
                    this.store.commit('setShiftTemplateGroupFrameMap', {
                        shiftTemplateGroupFrameMap: map,
                        year: year
                    });
                    return new Promise((resolve, reject) => {
                        resolve(this.returnObj(map, asArray));
                    })
                } else {
                    return new Promise((resolve, reject) => {
                        reject('Invalid return code');
                    });
                }

            })
                .catch((e) => {
                    return new Promise((resolve, reject) => {
                        reject(e);
                    });

                });
        }
    }

    GetPlanShiftMap(force = false, asArray = false) {
        if (this.store.state.planShiftMap && this.store.state.planShiftMapState.storeId == this.store.state.storeId && this.store.state.planShiftMapState.rosterFromToKey == this.store.getters.rosterFromToKey && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.planShiftMap, asArray));
            });
        } else {
            let params = {
                from: this.getMomentFromStringTZ(this.store.state.rosterFromTo.from).add(-1, 'days').format(),
                to: this.getMomentFromStringTZ(this.store.state.rosterFromTo.to).add(1, 'days').format(),
            }
            return this.RecursiveGETPaged('/api/sec/planshift', [], params, 1, 3)
                .then((result) => {
                    let map = {};
                    result.forEach(shift => {
                        map[shift.id] = shift;
                    })
                    this.store.commit('setPlanShiftMap', {
                        planShiftMap: map
                    });
                    return new Promise((resolve, reject) => {
                        resolve(this.returnObj(map, asArray));
                    })
                }).catch((e) => {
                    return new Promise((resolve, reject) => {
                        reject(e);
                    });

                });
        }
    }

    GetPlanShiftArray(force = false) {
        return this.GetPlanShiftMap(force, true);
    }

    GetCompanyPlanshiftMap(companyId, spotIds, asArray = false) {
        let params = {
            companyId: companyId,
            from: this.store.state.rosterFromTo.from,
            to: this.store.state.rosterFromTo.to,
        }
        let payload =  {
            ids: spotIds
        }
        return this.RecursivePOSTPaged('/api/sec/planshift/company', [], params, payload, 1)
            .then((result) => {
                let map = {};
                result.forEach(shift => {
                    map[shift.id] = shift;
                })

                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });

            });
    }

    GetExternalShiftMap(force = false, asArray = false) {
        if (this.store.state.externalShiftMap && this.store.state.externalShiftMapState.storeId == this.store.state.storeId && this.store.state.externalShiftMapState.rosterFromToKey == this.store.getters.rosterFromToKey && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.externalShiftMap, asArray));
            });
        } else {
            let params = {
                from: this.store.state.rosterFromTo.from,
                to: this.store.state.rosterFromTo.to,
            }
            return this.RecursiveGETPaged('/api/sec/planshift/external', [], params, 1, 3)
                .then((result) => {
                    let map = {};
                    result.forEach(shift => {
                        map[shift.id] = shift;
                    })
                    this.store.commit('setExternalShiftMap', {
                        externalShiftMap: map
                    });
                    return new Promise((resolve, reject) => {
                        resolve(this.returnObj(map, asArray));
                    })
                }).catch((e) => {
                    return new Promise((resolve, reject) => {
                        reject(e);
                    });

                });
        }
    }

    GetExternalShiftArray(force = false) {
        return this.GetExternalShiftMap(force, true);
    }

    UpdateActualShiftComment(actualShift, comment, employeeComment){
        let view = this;
        let url = '/api/sec/actualshift/comment';

        let params = {
            storeId: this.store.state.storeId,

        };

        let payload = {
            id: actualShift.id,
            comment: comment,
            employeeComment: employeeComment
        }
        return new Promise((resolve, reject) => {
            axios({
                method: 'put',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                actualShift.comment = comment;
                actualShift.employeeComment = employeeComment;
                view.store.commit('setActualShiftMapEntry', actualShift);
                view.success(i18n.t('global.notifications.updateMessage'), i18n.t('global.ui.editedX', [i18n.t('shift.plan.punchTimes')]));

                resolve();

            }).catch(function (error) {
                console.log(error);
                view.error(i18n.t('global.notifications.updateFailed'), i18n.t('global.ui.editedErrorX', [i18n.t('shift.plan.punchTimes')]));
                resolve();
            })
        });

    }

    GetActualShiftMap(force = false, asArray = false) {
        if (this.store.state.actualShiftMap && this.store.state.actualShiftMapState.storeId == this.store.state.storeId && this.store.state.actualShiftMapState.rosterFromToKey == this.store.getters.rosterFromToKey && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.actualShiftMap, asArray));
            });
        } else {
            let params = {
                from: this.getMomentFromStringTZ(this.store.state.rosterFromTo.from).add(-1, 'days').format(), //this.store.state.rosterFromTo.from,
                to: this.getMomentFromStringTZ(this.store.state.rosterFromTo.to).add(1, 'days').format(),
            }
            return this.RecursiveGETPaged('/api/sec/actualshift', [], params, 1, 3)
                .then((result) => {
                    let map = {};
                    result.forEach(shift => {
                        map[shift.id] = shift;
                    })
                    this.store.commit('setActualShiftMap', {
                        actualShiftMap: map
                    });
                    return new Promise((resolve, reject) => {
                        resolve(this.returnObj(map, asArray));
                    })
                }).catch((e) => {
                    return new Promise((resolve, reject) => {
                        reject(e);
                    });

                });
        }
    }

    GetActualShiftArray(force = false) {
        return this.GetActualShiftMap(force, true);
    }


    GetActualShiftMax(force = false) {
        if (this.store.state.actualShiftMax && this.store.state.actualShiftMaxState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.store.state.actualShiftMax);
            });
        } else {
            let params = {
                from: this.store.state.rosterFromTo.from,
                to: this.store.state.rosterFromTo.to,
                limit: 1,
                confirmed: true,
            }
            return this.GetCall('/api/sec/actualshift', params).then((response) => {
                let timestamp = 0;
                response.data.forEach(shift => {
                    timestamp = this.getMomentFromString(shift.from).unix();
                })
                this.store.commit('setActualShiftMax', {
                    actualShiftMax: timestamp
                });
                return new Promise((resolve, reject) => {
                    resolve(timestamp);
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });

            });
        }
    }

    GetActualBreakMap(force = false, asArray = false) {
        if (this.store.state.actualBreakMap && this.store.state.actualBreakMapState.storeId == this.store.state.storeId && this.store.state.actualBreakMapState.rosterFromToKey == this.store.getters.rosterFromToKey && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.actualBreakMap, asArray));
            });
        } else {
            let params = {
                from: this.store.state.rosterFromTo.from,
                to: this.store.state.rosterFromTo.to,
            }
            return this.RecursiveGETPaged('/api/sec/actualbreak', [], params, 1, 3)
                .then((result) => {
                    let map = {};
                    result.forEach(abreak => {
                        map[abreak.id] = abreak;
                    })
                    this.store.commit('setActualBreakMap', {
                        actualBreakMap: map
                    });
                    return new Promise((resolve, reject) => {
                        resolve(this.returnObj(map, asArray));
                    })
                }).catch((e) => {
                    return new Promise((resolve, reject) => {
                        reject(e);
                    });

                });
        }
    }

    GetActualBreakArray(force = false) {
        return this.GetActualBreakMap(force, true);
    }

    GetEmployeeTypeMap(force = false, asArray = false) {
        if (this.store.state.employeeTypeMap && this.store.state.employeeTypeMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeTypeMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/employeetype').then((response) => {
                let map = {};
                response.data.forEach(employeeType => {
                    map[employeeType.id] = employeeType;
                })
                this.store.commit('setEmployeeTypeMap', {
                    employeeTypeMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetEmployeeTypeArray(force = false) {
        return this.GetEmployeeTypeMap(force, true);
    }

    GetEmployeeFilesMap(force = false, asArray = false) {
        if (this.store.state.employeeFilesMap && this.store.state.employeeFilesMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeFilesMap, asArray));
            });
        } else {
            let params = {

            }
            return this.RecursiveGETPaged('/api/sec/employeefile', [], params, 1, 3)
                .then((result) => {
                    let map = {};
                    result.forEach(employeeFile => {
                        map[employeeFile.id] = employeeFile;
                    })
                    this.store.commit('setEmployeeFilesMap', {
                        employeeFilesMap: map
                    });
                    return new Promise((resolve, reject) => {
                        resolve(this.returnObj(map, asArray));
                    })
                }).catch((e) => {
                    return new Promise((resolve, reject) => {
                        reject(e);
                    });

                });
        }
    }

    GetEmployeeFilesArray(force = false) {
        return this.GetEmployeeFilesMap(force, true);
    }

    GetEmployeeWeeklyParametersMap(force = false, asArray = false) {
        if (this.store.state.employeeWeeklyParametersMap && this.store.state.employeeWeeklyParametersMapState.storeId == this.store.state.storeId && this.store.state.employeeWeeklyParametersMapState.rosterFromToKey == this.store.getters.rosterFromToKey && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeWeeklyParametersMap, asArray));
            });
        } else {
            let params = {
                from: this.store.state.rosterFromTo.from,
                to: this.store.state.rosterFromTo.to,
            }
            return this.GetCall('/api/sec/employeeweeklyparameter', params).then((response) => {
                let map = {};
                response.data.forEach(entity => {
                    map[entity.id] = entity;
                })
                this.store.commit('setEmployeeWeeklyParametersMap', {
                    employeeWeeklyParametersMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });

            });
        }
    }

    GetEmployeeWeeklyParametersArray(force = false) {
        return this.GetEmployeeWeeklyParametersMap(force, true);
    }

    GetEmployeeTypeTemplateMap(force = false, asArray = false) {
        if (this.store.state.employeeTypeTemplateMap && this.store.state.employeeTypeTemplateMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeTypeTemplateMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/employeetypetemplate').then((response) => {
                let map = {};
                response.data.forEach(employeeTypeTemplate => {
                    map[employeeTypeTemplate.id] = employeeTypeTemplate;
                })
                this.store.commit('setEmployeeTypeTemplateMap', {
                    employeeTypeTemplateMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetEmployeeRulesTemplateMap(force = false, asArray = false) {
        if (this.store.state.employeeRulesTemplateMap && this.store.state.employeeRulesTemplateMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeRulesTemplateMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/ruletemplate').then((response) => {
                let map = {};
                response.data.forEach(employeeRuleTemplate => {
                    map[employeeRuleTemplate.id] = employeeRuleTemplate;
                });
                this.store.commit('setEmployeeRulesTemplateMap', {
                    employeeRulesTemplateMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetEmployeeRulesTemplateArray(force = false) {
        return this.GetEmployeeRulesTemplateMap(force, true);
    }

    GetEmployeeRulesMap(force = false, asArray = false) {
        if (this.store.state.employeeRulesMap && this.store.state.employeeRulesMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeRulesMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/employeerules').then((response) => {
                let map = {};
                response.data.forEach(employeeRule => {
                    map[employeeRule.id] = employeeRule;
                });
                this.store.commit('setEmployeeRulesMap', {
                    employeeRulesMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetEmployeeRulesArray(force = false) {
        return this.GetEmployeeRulesMap(force, true);
    }

    GetCollectiveContractMap(force = false, asArray = false) {
        if (this.store.state.collectiveContractMap && this.store.state.collectiveContractMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, rejedt) => {
                resolve(this.returnObj(this.store.state.collectiveContractMap, asArray));
            });
        } else {
            return this.GetCall('/api/semi/collectivecontract').then((response) => {
                let map = {};
                response.data.forEach(collectiveContract => {
                    map[collectiveContract.id] = collectiveContract;
                });
                this.store.commit('setCollectiveContractMap', {
                    collectiveContractMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }


    GetMlCollectiveAgreementMap(force = false, asArray = false) {
        if (this.store.state.mlCollectiveAgreementMap && this.store.state.mlCollectiveAgreementMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, rejedt) => {
                resolve(this.returnObj(this.store.state.mlCollectiveAgreementMap, asArray));
            });
        } else {
            let params = {
                companyId: this.store.state.storeSettings.companyId
            }
            return this.GetCall('/api/sec/mlcollectiveagreement', params).then((response) => {
                let map = {};
                response.data.forEach(ca => {
                    map[ca.id] = ca;
                });
                this.store.commit('setMlCollectiveAgreementMap', {
                    mlCollectiveAgreementMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetMlCostCenterMap(force = false, asArray = false) {
        if (this.store.state.mlCostCenterMap && this.store.state.mlCostCenterMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, rejedt) => {
                resolve(this.returnObj(this.store.state.mlCostCenterMap, asArray));
            });
        } else {
            let params = {
                companyId: this.store.state.storeSettings.companyId
            }
            return this.GetCall('/api/sec/mlcostcenter', params).then((response) => {
                let map = {};
                response.data.forEach(ca => {
                    map[ca.id] = ca;
                });
                this.store.commit('setMlCostCenterMap', {
                    mlCostCenterMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetYouthWorkConfigMap(force = false, asArray = false) {
        if (this.store.state.youthWorkConfigMap && this.store.state.youthWorkConfigMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, rejedt) => {
                resolve(this.returnObj(this.store.state.youthWorkConfigMap, asArray));
            });
        } else {
            return this.GetCall('/api/semi/youthworkconfig').then((response) => {
                let map = {};
                response.data.forEach(youthWorkConfig => {
                    map[youthWorkConfig.id] = youthWorkConfig;
                });
                this.store.commit('setYouthWorkConfigMap', {
                    youthWorkConfigMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetYouthWorkConfigArray(force = false) {
        return this.GetYouthWorkConfigMap(force, true);
    }

    GetShiftStatusLogMap(force = false, merge = true, asArray = false) {
        if (this.store.state.shiftStatusLogMap && this.store.state.shiftStatusLogMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.shiftStatusLogMap, asArray));
            });
        } else {
            let url = '/api/sec/shiftstatuslog';

            let from = this.getMomentFromStringTZ(this.store.state.rosterFromTo.from);
            let to = this.getMomentFromStringTZ(this.store.state.rosterFromTo.to);

            url = this.appendParam("storeId", this.store.state.storeId, url, '/api/sec/shiftstatuslog');
            url = this.appendParam("from", from.toISOString(), url, '/api/sec/shiftstatuslog');
            url = this.appendParam("to", to.add(1, 'M').toISOString(), url, '/api/sec/shiftstatuslog');
            return axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.store.state.jwt
                },
                url: url,
            }).then((response) => {
                let map = {};
                response.data.forEach(shiftStatusLog => {
                    map[shiftStatusLog.id] = shiftStatusLog;
                });

                if (this.store.state.shiftStatusLogMap && this.store.state.shiftStatusLogMapState.storeId == this.store.state.storeId && merge) {
                    let oldMap = this.store.state.shiftStatusLogMap;
                    Object.values(map).forEach(log => {
                        oldMap[log.id] = log;
                    });
                    map = oldMap;
                }

                this.store.commit("setShiftStatusLogMap", {shiftStatusLogMap: map});
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetShiftStatusLogArray(force = false, merge = true) {
        return this.GetShiftStatusLogMap(force, merge, true);
    }

    GetVlhTimeFrameMap(force = false, asArray = false) {
        if (this.store.state.vlhTimeFrameMap && this.store.state.vlhTimeFrameMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.vlhTimeFrameMap, asArray));
            });
        } else {
            let url = '/api/sec/vlhtimeframe';



            url = this.appendParam("storeId", this.store.state.storeId, url, '/api/sec/vlhtimeframe');

            return axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.store.state.jwt
                },
                url: url,
            }).then((response) => {
                let map = {};
                response.data.forEach(vlhTimeFrame => {
                    map[vlhTimeFrame.id] = vlhTimeFrame;
                });



                this.store.commit("setVlhTimeFrameMap", {vlhTimeFrameMap: map});
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetVlhConversionMap(force = false, asArray = false) {
        if (this.store.state.vlhConversionMap && this.store.state.vlhConversionMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.vlhConversionMap, asArray));
            });
        } else {
            let url = '/api/sec/vlhconversion';



            url = this.appendParam("storeId", this.store.state.storeId, url, '/api/sec/vlhconversion');

            return axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.store.state.jwt
                },
                url: url,
            }).then((response) => {
                let map = {};
                response.data.forEach(vlhConversion => {
                    map[vlhConversion.id] = vlhConversion;
                });



                this.store.commit("setVlhConversionMap", {vlhConversionMap: map});
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetVlhConfigMap(force = false, asArray = false) {
        if (this.store.state.vlhConfigMap && this.store.state.vlhConfigMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.vlhConfigMap, asArray));
            });
        } else {
            let url = '/api/sec/vlhconfig';



            url = this.appendParam("storeId", this.store.state.storeId, url, '/api/sec/vlhconfig');

            return axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.store.state.jwt
                },
                url: url,
            }).then((response) => {
                let map = {};
                response.data.forEach(vlhConfig => {
                    map[vlhConfig.id] = vlhConfig;
                });



                this.store.commit("setVlhConfigMap", {vlhConfigMap: map});
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetVlhEmployeeThresholdMap(force = false, asArray = false) {
        if (this.store.state.vlhEmployeeThresholdMap && this.store.state.vlhEmployeeThresholdMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.vlhEmployeeThresholdMap, asArray));
            });
        } else {
            let url = '/api/sec/vlhemployeethreshold';



            url = this.appendParam("storeId", this.store.state.storeId, url, '/api/sec/vlhemployeethreshold');

            return axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.store.state.jwt
                },
                url: url,
            }).then((response) => {
                let map = {};
                response.data.forEach(vlhEmployeeThreshold => {
                    map[vlhEmployeeThreshold.id] = vlhEmployeeThreshold;
                });



                this.store.commit("setVlhEmployeeThresholdMap", {vlhEmployeeThresholdMap: map});
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetVlhThresholdCurve(from, to, typeId, planned = true, mode) {
        let params = {
            storeId: this.store.state.storeId,
        }
        let url = '/api/sec/vlhemployeethreshold/curve/'+mode;
        let payload = {
            from: from.format(),
            to: to.format(),
            planned: planned,
            typeId: typeId,
        }

        return this.PostCall(url, payload, params);
    }

    GetVlhThresholdCurvePaged(from, to, typeId, planned = true, mode) {
        let params = {
            storeId: this.store.state.storeId,
        }
        let url = '/api/sec/vlhemployeethreshold/curve/'+mode;
        let payload = {
            from: from.format(),
            to: to.format(),
            planned: planned,
            typeId: typeId,
        }

        return this.RecursivePOSTPaged(url, [], params, payload, 1)
            .then((result) => {
                return new Promise((resolve, reject) => {
                    resolve(result);
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });

            });
    }

    GetPlanningEmployeeThresholdCurve(from, to, typeId, planned = true, mode) {
        let params = {
            storeId: this.store.state.storeId,
        }
        let url = '/api/sec/planningemployeethreshold/curve/'+mode;
        let payload = {
            from: from.format(),
            to: to.format(),
            planned: planned,
            typeId: typeId,
        }

        return this.PostCall(url, payload, params);
    }

    GetPlanningEmployeeThresholdCurvePaged(from, to, typeId, planned = true, mode) {
        let params = {
            storeId: this.store.state.storeId,
        }
        let url = '/api/sec/planningemployeethreshold/curve/'+mode;
        let payload = {
            from: from.format(),
            to: to.format(),
            planned: planned,
            typeId: typeId,
        }

        return this.RecursivePOSTPaged(url, [], params, payload, 1)
            .then((result) => {
                return new Promise((resolve, reject) => {
                    resolve(result);
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });

            });
    }



    GetAllowedContractMap(force = false, asArray = false) {
        if (this.store.state.allowedContractMap && this.store.state.allowedContractMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, rejedt) => {
                resolve(this.returnObj(this.store.state.allowedContractMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/allowedcontract').then((response) => {
                let map = {};
                response.data.forEach(allowedContract => {
                    map[allowedContract.id] = allowedContract;
                });
                this.store.commit('setAllowedContractMap', {
                    allowedContractMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetAllowedContractArray(force = false) {
        return this.GetAllowedContractMap(force, true);
    }


    GetShiftSkillMap(payload, force = false, asArray = false) {
        if (this.store.state.shiftSkillMap && this.store.state.shiftSkillMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.shiftSkillMap, asArray));
            });
        } else {

            return this.RecursivePOSTAny('/api/sec/shiftskillrequirement/any/shift', payload, []).then((data) => {
                let map = {};
                data.forEach(item => {
                    map[item.id] = item;
                });
                this.store.commit('setShiftSkillMap', {
                    shiftSkillMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    RecursivePOSTAny(url, payload, result = [], params = null, max = 3000, payloadKey = 'ids', resultKey = null) {
        let remaining = [];
        if (payload[payloadKey].length >= max) {
            remaining = payload[payloadKey].slice(max-1, payload[payloadKey].length - 1);
            payload[payloadKey] = payload[payloadKey].slice(0, max-1);
        }
        return this.PostCall(url, payload, params).then((response) => {
            if(resultKey != null){
                response.data[resultKey].forEach(item => {
                    result.push(item);
                });
            } else {
                response.data.forEach(item => {
                    result.push(item);
                });
            }

            if (remaining.length > 0) {
                payload[payloadKey] = remaining;
                return this.RecursivePOSTAny(url, payload, result, params, max, payloadKey, resultKey);
            } else {
                return new Promise((resolve, reject) => {
                    resolve(result);
                });
            }

        }).catch((e) => {
            return new Promise((resolve, reject) => {
                reject(e);
            });
        });
    }

    RecursiveGETPaged(url, result = [], params = null, page = 1, max = null) {
        let p = params;
        if (p == null) {
            p = {};
        }
        p.page = page;
        return this.GetCall(url, p).then((response) => {
            response.data.forEach(item => {
                result.push(item);
            });
            if (response.data.length > 0 && (max == null || (max != null && page + 1 <= max))) {
                return this.RecursiveGETPaged(url, result, params, page + 1);
            } else {
                return new Promise((resolve, reject) => {
                    resolve(result);
                });
            }
        }).catch((e) => {
            return new Promise((resolve, reject) => {
                reject(e);
            });

        });
    }

    RecursivePOSTPaged(url, result = [], params = null, payload = {}, page = 1, max = null) {
        let p = params;
        if (p == null) {
            p = {};
        }
        p.page = page;
        return this.PostCall(url, payload, p).then((response) => {
            response.data.forEach(item => {
                result.push(item);
            });
            if (response.data.length > 0 && (max == null || (max != null && page + 1 <= max))) {
                return this.RecursivePOSTPaged(url, result, params, payload, page + 1);
            } else {
                return new Promise((resolve, reject) => {
                    resolve(result);
                });
            }
        }).catch((e) => {
            return new Promise((resolve, reject) => {
                reject(e);
            });

        });
    }

    GetShiftSkillArray(force = false) {
        return this.GetShiftSkillMap(force, true);
    }


    GetEmployeeContractMap(force = false, asArray = false) {
        if (this.store.state.employeeContractMap && this.store.state.employeeContractMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeContractMap, asArray));
            });
        } else {

            return this.GetCall('/api/sec/employeecontract').then((response) => {
                let map = {};
                response.data.forEach(employeeContract => {
                    map[employeeContract.id] = employeeContract;
                });
                this.store.commit('setEmployeeContractMap', {
                    employeeContractMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetEmployeeContractArray(force = false) {
        return this.GetEmployeeContractMap(force, true);
    }

    GetCurrentMonthEmployeeContractMap(force = false, asArray = false, activeOnly = true) {
        if (this.store.state.currentMonthEmployeeContractMap && this.store.state.currentMonthEmployeeContractMapState.storeId == this.store.state.storeId && this.store.state.currentMonthEmployeeContractMapState.rosterFromToKey == this.store.getters.rosterFromToKey && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.currentMonthEmployeeContractMap, asArray));
            });
        } else {
            let params = {
                from: this.store.state.rosterFromTo.from,
                to: this.store.state.rosterFromTo.to,
                overlapping: true,
            };
            if(activeOnly){
                params.active = true;
            }
            return this.GetCall('/api/sec/employeecontract', params).then((response) => {
                let map = {};
                response.data.forEach(employeeContract => {
                    map[employeeContract.id] = employeeContract;
                });
                this.store.commit('setCurrentMonthEmployeeContractMap', {
                    currentMonthEmployeeContractMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetCurrentMonthEmployeeContractArray(force = false) {
        return this.GetCurrentMonthEmployeeContractMap(force, true);
    }


    GetAvgEmployeeWorktimeMap(ids, force = false, asArray = false) {
        if (this.store.state.employeeAvgWorktimeMap && this.store.state.employeeAvgWorktimeMapState.storeId == this.store.state.storeId && this.store.state.employeeAvgWorktimeMapState.rosterFromToKey == this.store.getters.rosterFromToKey && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeAvgWorktimeMap, asArray));
            });
        } else {
            let params = {
                companyId: this.store.state.storeSettings.companyId
            }
            let payload = {
                year: this.store.state.rosterFromTo.year,
                month: this.store.state.rosterFromTo.month+1,
                ids: ids
            }
            return this.PostCall('/api/sec/mlaveragerecords/get', payload, params)
                .then((result) => {

                    let map = {};
                    result.data.forEach(a => {
                        map[""+a.employeeId] = {averageMinutes: Math.round(parseFloat(a.averageHours)*60), averagePayment: Math.round(a.averagePayment*100)};
                    })
                    this.store.commit('setEmployeeAvgWorktimeMap', {
                        employeeAvgWorktimeMap: map
                    });
                    return new Promise((resolve, reject) => {
                        resolve(this.returnObj(map, asArray));
                    })
                }).catch((e) => {

                    return new Promise((resolve, reject) => {
                        reject(e);
                    });

                });
        }
    }

    GetAvgEmployeeWorktimeMapForMonth(ids, year, month, asArray = false) {
        let params = {
            companyId: this.store.state.storeSettings.companyId
        }
        let payload = {
            year: year,
            month: month,
            ids: ids
        }
        return this.PostCall('/api/sec/mlaveragerecords/get', payload, params)
            .then((result) => {

                let map = {};
                result.data.forEach(a => {
                    map[""+a.employeeId] = {averageMinutes: Math.round(parseFloat(a.averageHours)*60), averagePayment: Math.round(a.averagePayment*100)};
                })

                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {

                return new Promise((resolve, reject) => {
                    reject(e);
                });

            });
    }

    SaveAvgEmployeeWorktimeForMonth(employeeId, year, month, averageMinutes, averagePayment) {
        let params = {
            companyId: this.store.state.storeSettings.companyId
        }
        let payload = {
            year: year,
            month: month,
            employeeId: employeeId,
            averageHours: averageMinutes/60.0,
            averagePayment: averagePayment != null ? averagePayment/100.0 : null
        }
        return this.PostCall('/api/sec/mlaveragerecords/save', payload, params)
            .then((result) => {
                return new Promise((resolve, reject) => {
                    resolve(result);
                });


            }).catch((e) => {

                return new Promise((resolve, reject) => {
                    reject(e);
                });

            });
    }

    updateEmployeeContractCall(changedKeys, newContract, contractToEditId, employeeId){
        let url = '/api/sec/employeecontract';
        url = this.appendParam("storeId", this.store.state.storeId, url, '/api/sec/employeecontract');
        url = this.appendParam("employeeId", employeeId, url, '/api/sec/employeecontract');

        let payload = {
            id: contractToEditId,
            updateFields: changedKeys
        };
        changedKeys.forEach((key) => {
            payload[key] = newContract[key];
        });

        return axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer " + this.store.state.jwt
            },
            url: url,
            data: payload
        })
    }

    checkContractForCollectiveContractChanges(contract, cc, contractFrom){
        let changedKeys = [];
        if(contract.weekTimeRegular < contract.fullTimeCutoff && (contract.contractType == 2 || contract.contractType == 3)){

            if(cc.changes != null){
                let lastChange = null;
                let lastChangeDate = null;
                cc.changes.forEach(change => {
                    let changeDate = this.getMomentFromStringTZ(change.date);
                    if(changeDate <= contractFrom){
                        if(lastChangeDate == null || changeDate > lastChangeDate){
                            lastChange = change;
                            lastChangeDate = changeDate;
                        }
                    }

                });
                if(lastChange){

                    contract.overtimeCutoff = lastChange.partTimeOvertimeCutoff;
                    contract.weeklyOvertimeCutoff = lastChange.partTimeWeeklyOvertimeCutoff;

                    if(lastChange.partTimeWeeklyOvertimeAddition != null){
                        contract.weeklyOvertimeCutoff = contract.weekTimeRegular + lastChange.partTimeWeeklyOvertimeAddition;
                    }
                    changedKeys = ["overtimeCutoff", "weeklyOvertimeCutoff"];
                }
            }
        }
        return changedKeys;
    }

    copyOnWriteEmployeeContract(newContract, contractToEditId, employeeId, from) {

        let url = '/api/sec/employeecontract/cow';
        url = this.appendParam("storeId", this.store.state.storeId, url, '/api/sec/employeecontract/cow');

        let payload = {
            storeId: this.store.state.storeId,
            employeeId: employeeId,
            id: contractToEditId
        }
        if (!this.isBlank(newContract.jobName)) {
            payload.jobName = newContract.jobName;
        }
        if (!this.isBlank(newContract.employmentGroup)) {
            payload.employmentGroup = newContract.employmentGroup;
        }

        payload.from = from.format();

        payload.to = newContract.to? newContract.to : null;
        payload.deadlineTo = newContract.deadlineTo ? newContract.deadlineTo : null;
        payload.probationTo = null;
        payload.paymentType =newContract.paymentType;
        payload.wageType = newContract.wageType;
        payload.payment = newContract.payment;
        payload.extraPayment = newContract.extraPayment;
        payload.assistancePayment = newContract.assistancePayment;
        payload.weekWorkDaysRegular = newContract.weekWorkDaysRegular;
        payload.weekTimeRegular = newContract.weekTimeRegular;
        payload.additionalMonthWorkTime = newContract.additionalMonthWorkTime;
        payload.overtimeCutoff = newContract.overtimeCutoff;
        payload.weeklyOvertimeCutoff = newContract.weeklyOvertimeCutoff;
        payload.fullTimeCutoff = newContract.fullTimeCutoff;
        payload.dayFullTimeCutoff = newContract.dayFullTimeCutoff;
        payload.vacationTime = newContract.vacationTime;
        payload.employeeCategory = newContract.employeeCategory;
        payload.employmentType = newContract.employmentType;
        payload.contractType = newContract.contractType;
        payload.partTimeType = newContract.partTimeType;
        if(payload.contractType == 1){
            payload.partTimeType = null;
        }
        payload.nightWorkerType = newContract.nightWorkerType;
        payload.nightWorkFrom = newContract.nightWorkFrom;
        payload.nightWorkTo = newContract.nightWorkTo;
        payload.nightWorkMode = newContract.nightWorkMode;
        payload.nightWorkCutoff = newContract.nightWorkCutoff;
        payload.nightWorkBonusHour = newContract.nightWorkBonusHour;
        payload.nightWorkBonusShift = newContract.nightWorkBonusShift;
        payload.overtimeBonusHour = newContract.overtimeBonusHour;
        payload.overtimeBonusShift = newContract.overtimeBonusShift;
        payload.calculateNightWork = newContract.calculateNightWork ? newContract.calculateNightWork : false;
        payload.allowPartialShifts = newContract.allowPartialShifts ? newContract.allowPartialShifts : false;
        payload.pregnant = newContract.pregnant ? newContract.pregnant : false;
        payload.minNightWorkTime = newContract.minNightWorkTime;
        payload.collectiveContractId = newContract.collectiveContractId;
        payload.workDays = newContract.workDays;
        payload.mlWageGroup = newContract.mlWageGroup;
        payload.accPeriodExclusion = newContract.accPeriodExclusion;
        payload.accPeriodPriority = newContract.accPeriodPriority;

        if(newContract.vacationEntitlementBase != null && newContract.vacationEntitlementBase > 0 && newContract.vacationEntitlementBase < 12){
            payload.vacationEntitlementBase = newContract.vacationEntitlementBase;
        } else {
            payload.vacationEntitlementBase = null;
        }

        if (!this.isBlank(newContract.comment)) {
            payload.comment = newContract.comment;
        }
        if (!this.isBlank(newContract.exitReason)) {
            payload.exitReason = newContract.exitReason;
        }

        payload.holidayTypes = newContract.holidayTypes;
        payload.nightWorkBonusPercentage = newContract.nightWorkBonusPercentage;


        let specificData = {};
        payload.specificData = specificData;

        return axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer " + this.store.state.jwt
            },
            url: url,
            data: payload
        })
    }

    findWageAmountForEmploymentGroup(contract, mlWageGroupMap, from = null){
        let view = this;
        let validMlWageAmounts = [];
        let selectedWageAmount = null;
        if(contract.mlWageGroup != null){
            let wage_amount = null;

            let latest = null;
            let wa = mlWageGroupMap[contract.mlWageGroup] ? mlWageGroupMap[contract.mlWageGroup].wage_amounts : null;
            let contractFrom = from ? from : view.getMomentFromStringTZ(contract.from);
            if(wa){
                wa.forEach(w => {
                    let validFrom = view.getMomentFromStringTZ(w.validFrom);
                    if(!latest || validFrom > latest){
                        if(validFrom <= contractFrom){
                            latest = validFrom;
                            wage_amount = w;
                        }

                    }
                })
                if(wage_amount){
                    let validFrom = view.getMomentFromStringTZ(wage_amount.validFrom);
                    wa.forEach(w => {
                        let vFrom = view.getMomentFromStringTZ(w.validFrom);
                        if(validFrom.format("YYYY-MM-DD") == vFrom.format("YYYY-MM-DD")){
                            validMlWageAmounts.push(w);
                        }
                    })
                }

            }

            if(validMlWageAmounts.length > 0){
                selectedWageAmount = validMlWageAmounts.find(i => i.paymentType == contract.paymentType && i.wageType == contract.wageType);
                if(!selectedWageAmount){
                    selectedWageAmount = validMlWageAmounts[0];
                }



            }
        }
        return {validMlWageAmounts, selectedWageAmount};

    }

    GetFixedCostMap(force = false, asArray = false) {
        if (this.store.state.fixedCostMap && this.store.state.fixedCostMapState.storeId == this.store.state.storeId && this.store.state.fixedCostMapState.rosterFromToKey == this.store.getters.rosterFromToKey && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.fixedCostMap, asArray));
            });
        } else {

            let currentMonthStart = this.getMomentFromValuesTZ(this.store.state.rosterFromTo.year, this.store.state.rosterFromTo.month, 1);
            let currentMonthEnd = currentMonthStart.clone().add(1, 'month');
            let params = {
                from: currentMonthStart.format(),
                to:  currentMonthEnd.format(),
            };
            return this.GetCall('/api/sec/fixedcost', params).then((response) => {
                let map = {};
                response.data.forEach(fixedCost => {
                    map[fixedCost.id] = fixedCost;
                });
                this.store.commit('setFixedCostMap', {
                    fixedCostMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetRosterNoticeMap(force = false, asArray = false) {
        if (this.store.state.rosterNoticeMap && this.store.state.rosterNoticeMapState.storeId == this.store.state.storeId && this.store.state.rosterNoticeMapState.rosterFromToKey == this.store.getters.rosterFromToKey && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.rosterNoticeMap, asArray));
            });
        } else {
            let params = {
                from: this.getMomentFromStringTZ(this.store.state.rosterFromTo.from).format(),
                to:  this.getMomentFromStringTZ(this.store.state.rosterFromTo.to).add(1,'days').format(),
            };
            return this.GetCall('/api/sec/rosternotice', params).then((response) => {
                let map = {};
                response.data.forEach(rosternotice => {
                    map[rosternotice.id] = rosternotice;
                });
                this.store.commit('setRosterNoticeMap', {
                    rosterNoticeMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetPositioningTaskMap(force = false, asArray = false) {
        if (this.store.state.positioningTaskMap && this.store.state.positioningTaskMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.positioningTaskMap, asArray));
            });
        } else {
            let params = {

            };
            return this.GetCall('/api/sec/positioningtask', params).then((response) => {
                let map = {};
                response.data.forEach(e => {
                    map[e.id] = e;
                });
                this.store.commit('setPositioningTaskMap', {
                    positioningTaskMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetPositioningTaskAssignmentMap(force = false, asArray = false) {
        if (this.store.state.positioningTaskAssignmentMap && this.store.state.positioningTaskAssignmentMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.positioningTaskAssignmentMap, asArray));
            });
        } else {
            let params = {

            };
            return this.GetCall('/api/sec/positioningtaskassignment', params).then((response) => {
                let map = {};
                response.data.forEach(e => {
                    map[e.id] = e;
                });
                this.store.commit('setPositioningTaskAssignmentMap', {
                    positioningTaskAssignmentMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetPositioningEntryMap(force = false, asArray = false) {
        if (this.store.state.positioningEntryMap && this.store.state.positioningEntryMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.positioningEntryMap, asArray));
            });
        } else {
            let params = {

            };
            return this.GetCall('/api/sec/positioningentry', params).then((response) => {
                let map = {};
                response.data.forEach(e => {
                    map[e.id] = e;
                });
                this.store.commit('setPositioningEntryMap', {
                    positioningEntryMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }


    GetEmployeeExtraPaymentMap(force = false, asArray = false) {
        if (this.store.state.employeeExtraPaymentMap && this.store.state.employeeExtraPaymentMapState.storeId == this.store.state.storeId && this.store.state.employeeExtraPaymentMapState.rosterFromToKey == this.store.getters.rosterFromToKey && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeExtraPaymentMap, asArray));
            });
        } else {
            let params = {
                from: this.getMomentFromStringTZ(this.store.state.rosterFromTo.from).format("YYYY-MM-DD"),
                to:  this.getMomentFromStringTZ(this.store.state.rosterFromTo.to).add(1,'days').format("YYYY-MM-DD"),
            };
            return this.GetCall('/api/sec/employeeextrapayment', params).then((response) => {
                let map = {};
                response.data.forEach(employeeextrapayment => {
                    map[employeeextrapayment.id] = employeeextrapayment;
                });
                this.store.commit('setEmployeeExtraPaymentMap', {
                    employeeExtraPaymentMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetEmployeeExtraPaymentArray(force = false) {
        return this.GetEmployeeExtraPaymentMap(force, true);
    }

    PopupEditEmployeeExtraPayment($event, entry, editCallback, deleteCallback) {
        let view = this;

        let dataEntries = [
            {
                label: 'EmployeeId',
                key: 'employeeId',
                hidden: true,
                type: 'text',
                value: entry.employeeId,
                length: 20
            },
            {
                label: 'Id',
                key: 'id',
                hidden: true,
                type: 'text',
                value: entry.id,
                length: 20
            },
            {
                label: i18n.t('store.events.description'),
                key: 'description',
                hidden: false,
                type: 'text',
                length: 50,
                disabled: false,
                value: entry.description != null ? entry.description : ''
            },
            {
                label: i18n.t('workBalance.extraPay.value'),
                key: 'amount',
                hidden: false,
                type: 'numeric',
                disabled: false,
                value: entry.amount != null ? parseFloat(entry.amount/100.0) : 0
            },

        ];


        let target = $event.currentTarget;

        this.OpenPopup({
            elRelative: target,
            type: 'datafill',
            componentState: {
                entries: dataEntries,
                selectCallback: editCallback,
                deleteCallback: deleteCallback
            },
            header: i18n.t('global.ui.editX', [i18n.t('workBalance.extraPay.employeeExtraPay')]),
            expanded: true,
            centered: true
        });
      }

      NewEmployeeExtraPaymentBackendCall(employeeextrapayment, callback) {
        let view = this;
        let url = '/api/sec/employeeextrapayment';

        let params = {
          storeId: this.store.state.storeId
        };

        let payload = {
            employeeId: employeeextrapayment.employeeId,
            type: employeeextrapayment.type,
            amount: Math.floor(Math.round(employeeextrapayment.amount *100)),
            date: employeeextrapayment.date,
            description: employeeextrapayment.description,
            isBonus: employeeextrapayment.isBonus
        };

        axios({
            method: 'post',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer " + this.store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
          view.store.commit("setEmployeeExtraPaymentMapEntry", response.data.data);
          view.success(i18n.t('store.events.creationSuccessful'), i18n.t('global.ui.createdX', [i18n.t('workBalance.extraPay.employeeExtraPay')]))
          if(callback){
            callback(true);
          }
        }).catch(function (error) {
          view.error(i18n.t('global.notifications.error'), i18n.t('global.ui.createFailed'));
          console.log(error)
          if(callback){
            callback(false);
          }
        })

    }
    MultiNewEmployeeExtraPaymentBackendCall(employeeextrapayments, callback) {
        let view = this;
        let url = '/api/sec/employeeextrapayment/multiple';

        let params = {
            storeId: this.store.state.storeId
        };

        let payload = {
            requests: []
        };
        employeeextrapayments.forEach(employeeextrapayment => {
            payload.requests.push({
                employeeId: employeeextrapayment.employeeId,
                type: employeeextrapayment.type,
                amount: Math.floor(Math.round(employeeextrapayment.amount *100)),
                date: employeeextrapayment.date,
                description: employeeextrapayment.description,
                isBonus: employeeextrapayment.isBonus
            });
        })


        axios({
            method: 'post',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer " + this.store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            response.data.data.forEach(entry => {
                view.store.commit("setEmployeeExtraPaymentMapEntry", response.data.data);
            })

            view.success('Erstellen erfolgreich', 'Mitarbeiter Extra-Zahlungen wurden erfolgreich erstellt')
            if(callback){
                callback(true);
            }
        }).catch(function (error) {
            view.error('Fehler', 'Fehler beim Erstellen!');
            console.log(error)
            if(callback){
                callback(false);
            }
        })

    }
    EditEmployeeExtraPaymentBackendCall(employeeextrapayment, callback) {
        let view = this;
        let url = '/api/sec/employeeextrapayment';

        let params = {
            storeId: this.store.state.storeId
        };

        let payload = {
            id: employeeextrapayment.id,
            amount: Math.floor(Math.round(employeeextrapayment.amount *100)),
            description: employeeextrapayment.description,
            updateFields: ["amount", "description"]
        };

        axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer " + this.store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {

            let entry = view.store.state.employeeExtraPaymentMap[payload.id];
            entry.amount = payload.amount;
            entry.description = payload.description;

            view.store.commit("setEmployeeExtraPaymentMapEntry", entry);
            view.success('Erfolg', 'Eintrag wurde erfolgreich geändert');
            if(callback){
                callback(true);
            }
        }).catch(function (error) {
            view.error('Fehler', 'Fehler beim Ändern der Daten!');
            console.log(error)
            if(callback){
                callback(false);
            }
        })

    }

    DeleteEmployeeExtraPaymentBackendCall(employeeextrapayment, callback) {
        let view = this;
        let url = '/api/sec/employeeextrapayment';

        let params = {
            id: employeeextrapayment.id,
            storeId: this.store.state.storeId
        }


        axios({
            method: 'delete',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer " + this.store.state.jwt
            },
            url: url
        }).then(response => {
            view.store.commit("deleteEmployeeExtraPaymentMapEntry", {id: employeeextrapayment.id});
            view.success('Erfolg', 'Eintrag wurde erfolgreich gelöscht')
            if(callback){
                callback(true);
            }
        }).catch(function (error) {
            view.error('Fehler', 'Fehler beim Löschen!');
            console.log(error)
            if(callback){
                callback(false);
            }
        })
    }

    GetEmployeeSkillMap(force = false, asArray = false) {
        if (this.store.state.employeeSkillMap && this.store.state.employeeSkillMapState.storeId == this.store.state.storeId && this.store.state.employeeSkillMapState.type == 'all' && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeSkillMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/employeeskill').then((response) => {
                let map = {};
                response.data.forEach(emplSkill => {
                    map[emplSkill.id] = emplSkill;
                });
                this.store.commit('setEmployeeSkillMap', {
                    employeeSkillMap: map,
                    type: 'all',
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetEmployeeSkillMapForEmployees(payload, force = false, asArray = false) {

        if (this.store.state.employeeSkillMap
            && this.store.state.employeeSkillMapState.storeId == this.store.state.storeId
            && this.store.state.employeeSkillMapState.type == 'employees'
            && this.store.state.employeeSkillMapState.rosterFromToKey == this.store.getters.rosterFromToKey
            && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeSkillMap, asArray));
            });
        } else {
            return this.RecursivePOSTAny('/api/sec/employeeskill/any/employee', payload, []).then((data) => {
                let map = {};
                data.forEach(emplSkill => {
                    map[emplSkill.id] = emplSkill;
                });
                this.store.commit('setEmployeeSkillMap', {
                    employeeSkillMap: map,
                    type: 'employees',
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetEmployeeSkillArray(force = false) {
        return this.GetEmployeeSkillMap(force, true);
    }

    GetEmployeeAllUnapprovedPreferenceMap(force = false, asArray = false) {
        if (this.store.state.employeeAllUnapprovedPreferenceMap && this.store.state.employeeAllUnapprovedPreferenceMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeAllUnapprovedPreferenceMap, asArray));
            });
        } else {
            let params = {
                approved: false,
                denied: false
            };
            return this.GetCall('/api/sec/employeepreference', params).then((response) => {
                let map = {};
                response.data.forEach(item => {
                    map[item.id] = item;
                });
                this.store.commit('setEmployeeAllUnapprovedPreferenceMap', {
                    employeeAllUnapprovedPreferenceMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetExportSettingsMap(force = false, asArray = false) {
        if (this.store.state.exportSettingsMap && this.store.state.exportSettingsMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.exportSettingsMap, asArray));
            });
        } else {
            let params = {

            };
            return this.GetCall('/api/sec/exportsettings', params).then((response) => {
                let map = {};
                response.data.forEach(item => {
                    map[item.id] = item;
                });

                this.store.commit('setExportSettingsMap', {
                    exportSettingsMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    CreateExportSetting(exportSetting, type){
        let view = this;
        let url = '/api/sec/exportsettings';
        url = this.appendParam("storeId", this.store.state.storeId, url, '/api/sec/exportsettings');

        let payload = {
            storeId: this.store.state.storeId,
            type: type,
            name: exportSetting.name,
            setting: exportSetting.setting
        };

        axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            let exportSetting = response.data.data;
            view.store.commit("setExportSettingsMapEntry", exportSetting);

            view.success(i18n.t('store.events.creationSuccessful'), i18n.t('global.ui.createdX', [i18n.t('global.ui.exportConfig')]));

        }).catch(function (error) {

            view.error(i18n.t('global.ui.creationFailed'), i18n.t('global.ui.createdErrorX', [i18n.t('global.ui.exportConfig')]));
        })
    }

    UpdateExportSetting(exportSetting){
        let view = this;
        let url = '/api/sec/exportsettings';
        url = this.appendParam("storeId", this.store.state.storeId, url, '/api/sec/exportsettings');

        let payload = {
            id: exportSetting.id,
            storeId: this.store.state.storeId,
            name: exportSetting.name,
            setting: exportSetting.setting,
            updateFields: ["name", "setting"]
        };

        axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            let texportSetting = view.store.state.exportSettingsMap ? view.store.state.exportSettingsMap[exportSetting.id] : null;
            if(texportSetting){
                texportSetting.name = exportSetting.name;
                texportSetting.setting = exportSetting.setting;
                view.store.commit("setExportSettingsMapEntry", texportSetting);
            }


            view.success(i18n.t('shift.template.edited'), i18n.t('global.ui.editedX', [i18n.t('global.ui.exportConfig')]));
        }).catch(function (error) {
            view.error(i18n.t('workBalance.payroll.editError'), i18n.t('global.ui.editedErrorX', [i18n.t('global.ui.exportConfig')]));
        })
    }

    DeleteExportSetting(exportSetting){
        let view = this;
        let url = '/api/sec/exportsettings';


        let params = {
            id: exportSetting.id,
            storeId: this.store.state.storeId,
        };

        axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.store.state.jwt
            },
            url: url,
            params: params
        }).then(response => {

            view.store.commit("deleteExportSettingsMapEntry", {id: exportSetting.id});
            view.success(i18n.t('shift.template.deleted'), i18n.t('global.ui.deletedX', [i18n.t('global.ui.exportConfig')]));

        }).catch(function (error) {
            view.error(i18n.t('global.ui.deleteFailed'), i18n.t('global.ui.deletedErrorX', [i18n.t('global.ui.exportConfig')]));
        })
    }

    GetEmployeePreferenceMap(force = false, asArray = false) {
        if (this.store.state.employeePreferenceMap && this.store.state.employeePreferenceMapState.storeId == this.store.state.storeId && this.store.state.employeePreferenceMapState.type == 'all' && this.store.state.employeePreferenceMapState.rosterFromToKey == this.store.getters.rosterFromToKey && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeePreferenceMap, asArray));
            });
        } else {
            let params = {
                from: this.store.state.rosterFromTo.from,
                to: this.store.state.rosterFromTo.to,
            };
            return this.GetCall('/api/sec/employeepreference', params).then((response) => {
                let map = {};
                response.data.forEach(item => {
                    map[item.id] = item;
                });

                this.store.commit('setEmployeePreferenceMap', {
                    employeePreferenceMap: map,
                    type: 'all',
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetEmployeePreferenceMapForEmployees(payload, force = false, asArray = false) {
        if (this.store.state.employeePreferenceMap && this.store.state.employeePreferenceMapState.storeId == this.store.state.storeId && this.store.state.employeePreferenceMapState.type == 'employees' && this.store.state.employeePreferenceMapState.rosterFromToKey == this.store.getters.rosterFromToKey && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeePreferenceMap, asArray));
            });
        } else {
            let params = {
                approved: true,
                from: this.store.state.rosterFromTo.from,
                to: this.store.state.rosterFromTo.to,
            };

            return this.RecursivePOSTAny('/api/sec/employeepreference/any/employee', payload, []).then((data) => {
                let map = {};
                data.forEach(item => {
                    map[item.id] = item;
                });
                this.store.commit('setEmployeePreferenceMap', {
                    employeePreferenceMap: map,
                    type: 'employees',
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetPreviousMonthEmployeeWorkbalanceMapForEmployees(payload, force = false, asArray = false, month = null, year = null, commit = true) {
        //console.log("LOADING NEW EWB")


        if (this.store.state.employeeWorkbalanceMap && this.store.state.employeeWorkbalanceMapState.storeId == this.store.state.storeId && this.store.state.employeeWorkbalanceMapState.type == 'employees-prevm' && this.store.state.employeeWorkbalanceMapState.rosterFromToKey == this.store.getters.rosterFromToKey && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeWorkbalanceMap, asArray));
            });
        } else {
            //console.log("LOADING NEW EWB FR")
            let storeId = this.store.state.employeeWorkbalanceMapState.storeId;
            let mapStateType = this.store.state.employeeWorkbalanceMapState.type;
            let mapStateKey = this.store.state.employeeWorkbalanceMapState.rosterFromToKey;

            if (year === null)
                year = this.store.state.rosterFromTo.year;
            if (month === null)
                month = this.store.state.rosterFromTo.month;
            let currentMonthStart = this.getMomentFromValuesUTC(year, month, 1);
            let pastMonthDateStart = currentMonthStart.clone().subtract(1, 'month');
            let pastMonthDateEnd = pastMonthDateStart.clone().date(2);
            let params = {
                from: pastMonthDateStart.format(),
                to: pastMonthDateEnd.format()
            };

            return this.RecursivePOSTAny('/api/sec/employeeworkbalance/any/employee', payload, [], params).then((data) => {
                let map = {};
                data.forEach(item => {
                    map[item.id] = item;
                });
                let newStoreId = this.store.state.employeeWorkbalanceMapState.storeId;
                let newMapStateType = this.store.state.employeeWorkbalanceMapState.type;
                let newMapStateKey = this.store.state.employeeWorkbalanceMapState.rosterFromToKey;
                if (commit && newMapStateType == mapStateType && newMapStateKey == mapStateKey && newStoreId == storeId) {
                    //console.log("STORING PREV MONTH EWB")
                    this.store.commit('setEmployeeWorkbalanceMap', {
                        employeeWorkbalanceMap: map,
                        type: 'employees-prevm',
                    });
                }

                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetCurrentMonthEmployeeWorkbalanceMapForEmployees(payload, force = false, asArray = false, month = null) {
        //console.log("LOADING NEW EWB")


        if (this.store.state.employeeWorkbalanceMap && this.store.state.employeeWorkbalanceMapState.storeId == this.store.state.storeId && this.store.state.employeeWorkbalanceMapState.type == 'employees-currentm' && this.store.state.employeeWorkbalanceMapState.rosterFromToKey == this.store.getters.rosterFromToKey && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeWorkbalanceMap, asArray));
            });
        } else {
            //console.log("LOADING NEW EWB FR")
            let storeId = this.store.state.employeeWorkbalanceMapState.storeId;
            let mapStateType = this.store.state.employeeWorkbalanceMapState.type;
            let mapStateKey = this.store.state.employeeWorkbalanceMapState.rosterFromToKey;

            let currentMonthStart = this.getMomentFromValuesUTC(this.store.state.rosterFromTo.year, month == null ? this.store.state.rosterFromTo.month : month, 1);

            let currentMonthEnd = currentMonthStart.clone().date(2);
            let params = {
                from: currentMonthStart.format(),
                to: currentMonthEnd.format()
            };

            return this.RecursivePOSTAny('/api/sec/employeeworkbalance/any/employee', payload, [], params).then((data) => {
                let map = {};
                data.forEach(item => {
                    map[item.id] = item;
                });
                let newStoreId = this.store.state.employeeWorkbalanceMapState.storeId;
                let newMapStateType = this.store.state.employeeWorkbalanceMapState.type;
                let newMapStateKey = this.store.state.employeeWorkbalanceMapState.rosterFromToKey;
                if (newMapStateType == mapStateType && newMapStateKey == mapStateKey && newStoreId == storeId) {
                    //console.log("STORING PREV MONTH EWB")
                    this.store.commit('setEmployeeWorkbalanceMap', {
                        employeeWorkbalanceMap: map,
                        type: 'employees-currentm',
                    });
                }

                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetPreviousYearDecemberEmployeeWorkbalanceMapForEmployees(currentYear, payload, force = false, asArray = false) {
        if (this.store.state.employeeWorkbalanceMap && this.store.state.employeeWorkbalanceMapState.storeId == this.store.state.storeId && this.store.state.employeeWorkbalanceMapState.type == 'employees-prevy' && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeWorkbalanceMap, asArray));
            });
        } else {
            let currentMonthStart = this.getMomentFromValuesUTC(currentYear, 0, 1);
            let pastMonthDateStart = currentMonthStart.clone().subtract(1, 'month');
            let pastMonthDateEnd = pastMonthDateStart.clone().date(2);
            let params = {
                from: pastMonthDateStart.format(),
                to: pastMonthDateEnd.format()
            };

            return this.RecursivePOSTAny('/api/sec/employeeworkbalance/any/employee', payload, [], params).then((data) => {
                let map = {};
                data.forEach(item => {
                    map[item.id] = item;
                });
                this.store.commit('setEmployeeWorkbalanceMap', {
                    employeeWorkbalanceMap: map,
                    type: 'employees-prevy',
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetAllEmployeeWorkbalancesMapForEmployees(payload, params, force = false, asArray = false) {
        console.log(params);

        return this.RecursivePOSTAny('/api/sec/employeeworkbalance/any/employee', payload, [], params).then((data) => {
            let map = {};
            data.forEach(item => {
                map[item.id] = item;
            });
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(map, asArray));
            });
        }).catch((e) => {
            return new Promise((resolve, reject) => {
                reject(e);
            });
        });
    }

    GetEmployeeAvailabilityMap(force = false, asArray = false) {
        if (this.store.state.employeeAvailabilityMap && this.store.state.employeeAvailabilityMapState.storeId == this.store.state.storeId && this.store.state.employeeAvailabilityMapState.type == 'all' && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeAvailabilityMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/employeeavailability').then((response) => {
                let map = {};
                response.data.forEach(emplAvailability => {
                    map[emplAvailability.id] = emplAvailability;
                });
                this.store.commit('setEmployeeAvailabilityMap', {
                    employeeAvailabilityMap: map,
                    type: 'all',
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetEmployeeAvailabilityMapForEmployees(payload, force = false, asArray = false) {
        if (this.store.state.employeeAvailabilityMap && this.store.state.employeeAvailabilityMapState.storeId == this.store.state.storeId && this.store.state.employeeAvailabilityMapState.type == 'employees' && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeAvailabilityMap, asArray));
            });
        } else {

            return this.RecursivePOSTAny('/api/sec/employeeavailability/any/employee', payload, []).then((data) => {
                let map = {};
                data.forEach(emplAvailability => {
                    map[emplAvailability.id] = emplAvailability;
                });
                this.store.commit('setEmployeeAvailabilityMap', {
                    employeeAvailabilityMap: map,
                    type: 'employees',
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetEmployeeAvailabilityArray(force = false) {
        return this.GetEmployeeAvailabilityMap(force, true);
    }

    GetProjectGroupMap(force = false, asArray = false) {
        if (this.store.state.projectGroupMap && this.store.state.projectGroupMapState && this.store.state.projectGroupMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.projectGroupMap, asArray));
            });
        } else {

            return this.RecursiveGETPaged('/api/sec/projectgroup', [], null, 1, 3)
                .then((result) => {
                    let map = {};
                    result.forEach(es => {
                        map[es.id] = es;
                    });
                    this.store.commit('setProjectGroupMap', {
                        projectGroupMap: map,
                    });
                    return new Promise((resolve, reject) => {
                        resolve(this.returnObj(map, asArray));
                    });
                }).catch((e) => {
                    return new Promise((resolve, reject) => {
                        reject(e);
                    });

                });

        }
    }

    GetProjectGroupArray(force = false) {
        return this.GetProjectGroupMap(force, true);
    }

    GetProjectMap(force = false, asArray = false) {
        if (this.store.state.projectMap && this.store.state.projectMapState && this.store.state.projectMapState.year == this.store.state.rosterFromTo.year && this.store.state.projectMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.projectMap, asArray));
            });
        } else {
            let from = this.getMomentFromValuesTZ(this.store.state.rosterFromTo.year, 0, 1, 0, 0, 0, 0);
            let to = from.clone().add(1, 'years');
            let params = {
                from: from.format(),
                to: to.format(),
                overlappingshift: true,
                overlappingtemplate: true,
            }
            return this.RecursiveGETPaged('/api/sec/project', [], params, 1, 3)
                .then((result) => {
                    let map = {};
                    result.forEach(es => {
                        map[es.id] = es;
                    });
                    this.store.commit('setProjectMap', {
                        projectMap: map,
                        year: from.year(),
                    });
                    return new Promise((resolve, reject) => {
                        resolve(this.returnObj(map, asArray));
                    });
                }).catch((e) => {
                    return new Promise((resolve, reject) => {
                        reject(e);
                    });

                });

        }
    }

    GetProjectArray(force = false) {
        return this.GetProjectMap(force, true);
    }

    GetLocationMap(force = false, asArray = false) {
        if (this.store.state.locationMap && this.store.state.locationMapState && this.store.state.locationMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.locationMap, asArray));
            });
        } else {

            return this.GetCall('/api/sec/location').then((response) => {
                let map = {};
                response.data.forEach(location => {
                    map[location.id] = location;
                });
                this.store.commit('setLocationMap', {
                    locationMap: map,
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });

        }
    }

    GetApiIntegrationDataMap(force = false, asArray = false) {
        if (this.store.state.apiIntegrationDataMap && this.store.state.apiIntegrationDataMapState && this.store.state.apiIntegrationDataMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.apiIntegrationDataMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/apiintegrationdata').then((response) => {
                let map = {};
                response.data.forEach(es => {
                    map[es.id] = es;
                });
                this.store.commit('setApiIntegrationDataMap', {
                    apiIntegrationDataMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetApiIntegrationDataArray(force = false) {
        return this.GetApiIntegrationDataMap(force, true);
    }



    GetExternalServicesMap(force = false, asArray = false) {
        if (this.store.state.externalServicesMap && this.store.state.externalServicesMapState && this.store.state.externalServicesMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.externalServicesMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/externalservice').then((response) => {
                let map = {};
                response.data.forEach(es => {
                    map[es.id] = es;
                });
                this.store.commit('setExternalServicesMap', {
                    externalServicesMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetExternalServicesArray(force = false) {
        return this.GetExternalServicesMap(force, true);
    }

    GetEmployeeExternalDataMap(force = false, asArray = false) {
        if (this.store.state.employeeExternalDataMap && this.store.state.employeeExternalDataMapState && this.store.state.employeeExternalDataMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.employeeExternalDataMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/employeeexternaldata').then((response) => {
                let map = {};
                response.data.forEach(ed => {
                    map[ed.id] = ed;
                });
                this.store.commit('setEmployeeExternalDataMap', {
                    employeeExternalDataMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetEmployeeExternalDataArray(force = false) {
        return this.GetEmployeeExternalDataMap(force, true);
    }

    GetAccountingPeriodSettingsMap(force = false, asArray = false) {
        if (this.store.state.accountingPeriodSettingsMap && this.store.state.accountingPeriodSettingsMapState && this.store.state.accountingPeriodSettingsMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.accountingPeriodSettingsMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/accountingperiodsetting').then((response) => {
                let map = {};
                response.data.forEach(ed => {
                    map[ed.id] = ed;
                });

                this.store.commit('setAccountingPeriodSettingsMap', {
                    accountingPeriodSettingsMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetContractExitSettingMap(force = false, asArray = false) {
        if (this.store.state.contractExitSettingMap && this.store.state.contractExitSettingMapState && this.store.state.contractExitSettingMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.contractExitSettingMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/contractexitsetting').then((response) => {
                let map = {};
                response.data.forEach(ed => {
                    map[ed.id] = ed;
                });

                this.store.commit('setContractExitSettingMap', {
                    contractExitSettingMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetBonusPaymentSettingsMap(force = false, asArray = false) {
        if (this.store.state.bonusPaymentSettingsMap && this.store.state.bonusPaymentSettingsMapState && this.store.state.bonusPaymentSettingsMapState.storeId == this.store.state.storeId && this.store.state.bonusPaymentSettingsMapState.rosterFromToKey == this.store.getters.rosterFromToKey && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.bonusPaymentSettingsMap, asArray));
            });
        } else {
            let mfrom = this.getMomentFromValuesTZ(this.store.state.rosterFromTo.year, this.store.state.rosterFromTo.month, 1, 0, 0, 0, 0);
            let mto = mfrom.clone().add(1, 'months').startOf('day');
            let params = {
                from: mfrom.format(),
                to: mto.format(),
            };
            return this.GetCall('/api/sec/bonuspaymentsetting', params).then((response) => {
                let map = {};
                response.data.forEach(ed => {
                    map[ed.id] = ed;
                });

                this.store.commit('setBonusPaymentSettingsMap', {
                    bonusPaymentSettingsMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetEventLogMap(force = false, asArray = false) {
        let nowTS = new Date().getTime();
        let mapTS = this.store.state.eventLogMapState.timestamp ? this.store.state.eventLogMapState.timestamp : Infinity;
        let validity = this.store.state.eventLogMapState.validity;
        /* this.log(null, 'EventLogMap validity check', [mapTS, nowTS, nowTS-mapTS, validity], false); */
        if (this.store.state.eventLogMap && this.store.state.eventLogMapState.storeId == this.store.state.storeId && (nowTS - mapTS) < validity && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.eventLogMap, asArray));
            });
        } else {
            let params = {
                from: this.store.state.rosterFromTo ? this.store.state.rosterFromTo.from : this.getMomentTZ().startOf('month').format(),
                to: this.store.state.rosterFromTo ? this.store.state.rosterFromTo.to : this.getMomentTZ().endOf('month').format(),
            };
            return this.GetCall('/api/sec/eventlog', params).then((response) => {
                let map = this.idObjectsArrayToMap(response.data);
                this.store.commit('setEventLogMap', {
                    eventLogMap: map,
                    validity: 30000
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                });


            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetEventLogArray(force = false) {
        return this.GetEventLogMap(force, true);
    }

    GetUiDataMap(force = false) {
        if (this.store.state.uiDataMap && this.store.state.uiDataMapState && this.store.state.uiDataMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.store.state.uiDataMap);
            });
        } else {

            return this.GetCall('/api/semi/uidata').then((response) => {
                var map = response.data;
                this.store.commit('setUiDataMap', {
                    uiDataMap: map,
                });
                return new Promise((resolve, reject) => {
                    resolve(map);
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetCrewlaborPlanningMap(force = false, groupId, year) {
        if (this.store.state.crewLaborPlanningMap &&
            this.store.state.crewlaborPlanningMapState.storeId == this.store.state.storeId &&
            this.store.state.crewlaborPlanningMapState.groupid == groupId &&
            this.store.state.crewlaborPlanningMapState.year == year &&
            !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.crewLaborPlanningMap, false));
            });
        } else {
            let params = {
                groupId: groupId,
                year: year
            }
            return this.GetCall('/api/sec/crewlaborplanning', params).then((response) => {
                let map = {};
                response.data.forEach(crewlaborPlanning => {
                    map[crewlaborPlanning.id] = crewlaborPlanning;
                })
                this.store.commit('setCrewlaborPlanningMap', {
                    crewlaborPlanningMap: map,
                    groupId: groupId,
                    year: year
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, false));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetPlanningEmployeeMap(force = false, groupId, year, payload) {
        if (this.store.state.planningEmployeeMap &&
            this.store.state.planningEmployeeMapState.storeId == this.store.state.storeId &&
            this.store.state.planningEmployeeMapState.groupid == groupId &&
            this.store.state.planningEmployeeMapState.year == year &&
            !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.planningEmployeeMap, false));
            });
        } else {
            return this.RecursivePOSTAny('/api/sec/planningemployee/any/planning', payload, []).then((data) => {
                let map = {};
                data.forEach(planningEmployee => {
                    map[planningEmployee.id] = planningEmployee;
                });
                this.store.commit('setPlanningEmployeeMap', {
                    planningEmployeeMap: map,
                    groupId: groupId,
                    year: year
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, false));
                });
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetPlanningIndicatorTypeMap(force = false, asArray = false) {

        if (this.store.state.planningIndicatorTypeMap && this.store.state.planningIndicatorTypeMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.planningIndicatorTypeMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/planningindicatortype').then((response) => {
                let map = {};
                response.data.forEach(item => {
                    map[item.id] = item;
                })
                this.store.commit('setPlanningIndicatorTypeMap', {
                    planningIndicatorTypeMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetPlanningEmployeeThresholdMap(force = false, asArray = false) {

        if (this.store.state.planningEmployeeThresholdMap && this.store.state.planningEmployeeThresholdMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.planningEmployeeThresholdMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/planningemployeethreshold').then((response) => {
                let map = {};
                response.data.forEach(item => {
                    map[item.id] = item;
                })
                this.store.commit('setPlanningEmployeeThresholdMap', {
                    planningEmployeeThresholdMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetContactPersonMap(force = false, asArray = false) {

        if (this.store.state.contactPersonMap && this.store.state.contactPersonMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.contactPersonMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/contactperson').then((response) => {
                let map = {};
                response.data.forEach(item => {
                    map[item.id] = item;
                })
                this.store.commit('setContactPersonMap', {
                    contactPersonMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetEmailNotificationMap(force = false, asArray = false) {

        if (this.store.state.emailNotificationMap && this.store.state.emailNotificationMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.emailNotificationMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/emailnotification').then((response) => {
                let map = {};
                response.data.forEach(item => {
                    map[item.id] = item;
                })
                this.store.commit('setEmailNotificationMap', {
                    emailNotificationMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetMlEmailNotificationMap(force = false, asArray = false) {

        if (this.store.state.mlEmailNotificationMap && this.store.state.mlEmailNotificationMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.mlEmailNotificationMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/ml/emailnotification').then((response) => {
                let map = {};
                response.data.forEach(item => {
                    map[item.id] = item;
                })
                this.store.commit('setMlEmailNotificationMap', {
                    mlEmailNotificationMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetOpeningHoursMap(force = false, asArray = false) {

        if (this.store.state.storeOpeningHoursMap && this.store.state.storeOpeningHoursMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.storeOpeningHoursMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/storeopeninghours').then((response) => {
                let map = {};
                response.data.forEach(item => {
                    map[item.id] = item;
                })
                this.store.commit('setOpeningHoursMap', {
                    storeOpeningHoursMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetExternalApiAccessMap(force = false, asArray = false) {

        if (this.store.state.externalApiAccessMap && this.store.state.externalApiAccessMapState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.externalApiAccessMap, asArray));
            });
        } else {
            return this.GetCall('/api/sec/externalapiaccess').then((response) => {
                let map = {};
                response.data.forEach(item => {
                    map[item.id] = item;
                })
                this.store.commit('setExternalApiAccessMap', {
                    externalApiAccessMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetForecastTargetMap(force = false, asArray = false) {

        if (this.store.state.forecastTargetMap && this.store.state.forecastTargetMapState.storeId == this.store.state.storeId && this.store.state.forecastTargetMapState.year == this.store.state.rosterFromTo.year && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(this.store.state.externalApiAccessMap, asArray));
            });
        } else {
            let params = {
                year: this.store.state.rosterFromTo.year
            }
            return this.GetCall('/api/sec/forecasttarget', params).then((response) => {
                let map = {};
                response.data.forEach(item => {
                    map[item.id] = item;
                })
                this.store.commit('setForecastTargetMap', {
                    forecastTargetMap: map
                });
                return new Promise((resolve, reject) => {
                    resolve(this.returnObj(map, asArray));
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }
    }

    GetRosterFromLogs(cutoffDate) {
        let params = {
            from: this.store.state.rosterFromTo.from,
            to: this.store.state.rosterFromTo.to,
            cutoff: cutoffDate.format()
        };
        return this.GetCall('/api/sec/rosterlog/timeframe', params).then((response) => {

            return new Promise((resolve, reject) => {
                resolve(response.data);
            });
        }).catch((e) => {
            return new Promise((resolve, reject) => {
                reject(e);
            });
        });
    }
    GetRosterLogs(cutoffDateFrom, cutoffDateTo) {
        let params = {
            changeDateFrom: cutoffDateFrom.format(),
            changeDateTo: cutoffDateTo.format(),

        };
        return this.RecursiveGETPaged('/api/sec/rosterlog', [], params, 1)
            .then((result) => {

                return new Promise((resolve, reject) => {
                    resolve(result);
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });

            });
    }

    DoSotecLiveDataImport(){
        let params = {

        }
        let payload = {

        }
        return this.PostCall('/api/sec/sotecactualdata/currentday/import', payload, params).then((response) => {

            return new Promise((resolve, reject) => {
                resolve();
            })
        }).catch((e) => {
            return new Promise((resolve, reject) => {
                reject(e);
            });

        });



    }
    GetSotecWebcockpitConfig(force = false){
        if (this.store.state.sotecWebcockpitConfig && this.store.state.sotecWebcockpitConfigState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.store.state.sotecWebcockpitConfig);
            });
        } else {
            return this.GetCall('/api/sec/sotecapidata').then((response) => {
                let config = this.store.state.sotecWebcockpitConfig;
                if(response.data.length > 0){
                    config = response.data[0];
                } else {
                    config = null;
                }
                this.store.commit('setSotecWebcockpitConfig', {
                    sotecWebcockpitConfig: config
                });

                return new Promise((resolve, reject) => {
                    resolve(config);
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }

    }
    GetStatisticsSetting(force = false){
        if (this.store.state.crewLaborConfig && this.store.state.crewLaborConfigState.storeId == this.store.state.storeId && !force) {
            return new Promise((resolve, reject) => {
                resolve(this.store.state.crewLaborConfig);
            });
        } else {
            return this.GetCall('/api/sec/statisticssetting').then((response) => {
                let config = this.store.state.crewLaborConfig;
                if(response.data.length > 0){
                    config = response.data[0];
                    this.store.commit('setCrewLaborConfig', {
                        crewLaborConfig: config
                    });

                }

                return new Promise((resolve, reject) => {
                    resolve(config);
                })
            }).catch((e) => {
                return new Promise((resolve, reject) => {
                    reject(e);
                });
            });
        }

    }
    loadHourStatisticsFully(from, to, spotIds, unassigned, typeId, employeeLevels, data = []){
        let view = this;
        if(from < to){

            let fromDate = from.clone();
            let toDate = fromDate.clone().add(23, 'hours');
            return view.loadHourlyStatistics(fromDate, toDate, spotIds, unassigned, typeId, employeeLevels)
                .then(rdata => {
                    data = data.concat(rdata);
                    return view.loadHourStatisticsFully(fromDate.add(24, 'hours'), to,  spotIds, unassigned, typeId, employeeLevels, data);
                }).catch(error => {
                    return new Promise((resolve, reject) => {
                        reject(error);
                    })
                })

        } else {
            return new Promise((resolve, reject) => {
                resolve(data);
            });

        }


    }
    loadHourlyStatistics(from, to, spotIds, unassigned, typeId, employeeLevels){
        if((spotIds.length == 0 && !unassigned) || typeId == null){
            return new Promise((resolve, reject) => {
                resolve([]);
            });
        } else {

            let params = {
                storeId: this.store.state.storeId,
            }

            let payload = {
                from: from.format(),
                to: to.format(),
                typeId: typeId,
                spotIds: spotIds,
                unassigned: unassigned,
                employeeLevels: employeeLevels
            };

            return this.PostCall('/api/sec/statistics/hourly', payload, params)
                .then((response) => {
                    return new Promise((resolve, reject) => {
                        resolve(response.data);
                    });
                })
                .catch((e) => {
                    return new Promise((resolve, reject) => {
                        reject(e);
                    });
                });

        }


    }

    loadDailyStatistics(from, to, spotIds, unassigned, typeId, employeeLevels){
        if((spotIds.length == 0 && !unassigned) || typeId == null){
            return new Promise((resolve, reject) => {
                resolve([]);
            });
        } else {

            let params = {
                storeId: this.store.state.storeId,
            }

            let payload = {
                from: from.format(),
                to: to.format(),
                typeId: typeId,
                spotIds: spotIds,
                unassigned: unassigned,
                employeeLevels: employeeLevels,
            };

            return this.PostCall('/api/sec/statistics/daily', payload, params)
                .then((response) => {
                    return new Promise((resolve, reject) => {
                        resolve(response.data);
                    });
                })
                .catch((e) => {
                    return new Promise((resolve, reject) => {
                        reject(e);
                    });
                });

        }
    }

    calculateCLWorkTimeSum(item, config, planned = false){
        let sum = 0;
        if(planned){
            sum += (config.workValue ? item.productivePlannedWorkTime : 0)

                + (config.openWorkValue ? item.productivePlannedOpenWorkTime: 0)
        } else {
            sum += (config.workValue ? item.productiveActualWorkTime : 0)

                + (config.openWorkValue ? item.productiveActualOpenWorkTime: 0)
        }
        return sum;
    }

    calculateCLProductiveWorkValueSum(item, config, planned = false){
        let sum = 0;
        if(planned){
            sum += (config.workValue ? item.productivePlannedWorkValue : 0)

                + (config.openWorkValue ? item.productivePlannedOpenWorkValue: 0)
        } else {
            sum += (config.workValue ? item.productiveActualWorkValue : 0)

                + (config.openWorkValue ? item.productiveActualOpenWorkValue: 0)
        }
        return sum;
    }

    calculateCLWorkValueSum(item, config, planned = false){
        let sum = 0;
        if(planned){
            sum += (config.workValue ? item.productivePlannedWorkValue : 0)

                + (config.openWorkValue ? item.productivePlannedOpenWorkValue: 0)
                + (config.nightWorkShiftFlatValue ? item.plannedNightWorkShiftFlatValue : 0)
                + (config.nightWorkValue ? item.plannedNightWorkValue : 0)
                + (config.overtimeShiftFlatValue ? item.plannedOvertimeShiftFlatValue : 0)
                + (config.overtimeValue ? item.plannedOvertimeValue : 0)
                + (config.holidayWorkValue ? item.plannedHolidayWorkValue : 0)
        } else {
            sum += (config.workValue ? item.productiveActualWorkValue : 0)

                + (config.openWorkValue ? item.productiveActualOpenWorkValue: 0)
                + (config.nightWorkShiftFlatValue ? item.actualNightWorkShiftFlatValue : 0)
                + (config.nightWorkValue ? item.actualNightWorkValue : 0)
                + (config.overtimeShiftFlatValue ? item.actualOvertimeShiftFlatValue : 0)
                + (config.overtimeValue ? item.actualOvertimeValue : 0)
                + (config.holidayWorkValue ? item.actualHolidayWorkValue : 0)
        }
        return sum;
    }

    calculateCLUnproductiveWorkTimeSum(item, config, planned = false){
        let sum = 0;
        if(planned){
            sum += (config.workValue ? (item.plannedWorkTime - item.productivePlannedWorkTime) : 0)
                + (config.openWorkValue ? (item.plannedOpenWorkTime - item.productivePlannedOpenWorkTime) : 0)

        } else {
            sum += (config.workValue ? (item.actualWorkTime - item.productiveActualWorkTime) : 0)
                + (config.openWorkValue ? (item.actualOpenWorkTime - item.productiveActualOpenWorkTime) : 0)

        }

        sum += (config.vacationWorkValue ? item.vacationWorkTime : 0)
            + (config.sickWorkValue ? item.sickWorkTime: 0)
            + (config.holidayAdjustWorkValue ? item.holidayAdjustWorkTime : 0)
            + (config.miscWorkValue ? item.miscWorkTime : 0)
            + (config.nursingVacationWorkValue ? item.nursingVacationWorkTime : 0)
            + (config.eduWorkValue ? item.eduWorkTime : 0)
            + (config.wageContinuationWorkValue ? item.wageContinuationWorkTime : 0)

        return sum;
    }

    calculateCLUnproductiveWorkValueSum(item, config, planned = false){
        let sum = 0;

        if(planned){
            sum += (config.workValue ? (item.plannedWorkValue - item.productivePlannedWorkValue) : 0)
                + (config.openWorkValue ? (item.plannedOpenWorkValue - item.productivePlannedOpenWorkValue) : 0)

        } else {
            sum += (config.workValue ? (item.actualWorkValue - item.productiveActualWorkValue) : 0)
                + (config.openWorkValue ? (item.actualOpenWorkValue - item.productiveActualOpenWorkValue) : 0)

        }

        sum += (config.vacationWorkValue ? item.vacationWorkValue : 0)
            + (config.sickWorkValue ? item.sickWorkValue : 0)
            + (config.holidayAdjustWorkValue ? item.holidayAdjustWorkValue : 0)
            + (config.miscWorkValue ? item.miscWorkValue : 0)
            + (config.nursingVacationWorkValue ? item.nursingVacationWorkValue : 0)
            + (config.eduWorkValue ? item.eduWorkValue : 0)
            + (config.wageContinuationWorkValue ? item.wageContinuationWorkValue : 0)
            + (item.fixedCostValue != null ? item.fixedCostValue : 0);

        return sum;
    }

    calculateCLOnlyUnproductiveWorkTimeSum(item, config, planned = false){
        let sum = 0;
        if(planned){
            sum += (config.workValue ? (item.plannedWorkTime - item.productivePlannedWorkTime) : 0)
                + (config.openWorkValue ? (item.plannedOpenWorkTime - item.productivePlannedOpenWorkTime) : 0)

        } else {
            sum += (config.workValue ? (item.actualWorkTime - item.productiveActualWorkTime) : 0)
                + (config.openWorkValue ? (item.actualOpenWorkTime - item.productiveActualOpenWorkTime) : 0)

        }



        return sum;
    }

    calculateCLOnlyUnproductiveWorkValueSum(item, config, planned = false){
        let sum = 0;

        if(planned){
            sum += (config.workValue ? (item.plannedWorkValue - item.productivePlannedWorkValue) : 0)
                + (config.openWorkValue ? (item.plannedOpenWorkValue - item.productivePlannedOpenWorkValue) : 0)

        } else {
            sum += (config.workValue ? (item.actualWorkValue - item.productiveActualWorkValue) : 0)
                + (config.openWorkValue ? (item.actualOpenWorkValue - item.productiveActualOpenWorkValue) : 0)

        }



        return sum;
    }

    calculateCLCrewLaborSum(item, config, planned = false){
        let sum = 0;
        sum += this.calculateCLWorkValueSum(item, config, planned);
        sum += this.calculateCLUnproductiveWorkValueSum(item, config, planned);


        return sum;
    }


    CalculateDaysCount(date) {

        let start = date.clone().startOf('month');
        let end = start.clone().endOf('month').add(1, 'days').startOf('day');
        let result = end.diff(start, 'days');

        //console.log("CalcDays: "+result);
        return result;
    }

    CalculateBusinessDaysCount(s, end, holidays = [], contractWorkDays = null) {
        let storeSettings = this.store.state.storeSettings;
        let workDays = contractWorkDays != null ? contractWorkDays : (storeSettings != null ? storeSettings.workDays : [1, 2, 3, 4, 5]);

        let start = s.clone();
        let result = 0;
        while (end > start) {
            if (workDays.includes(start.isoWeekday())) {
                if(holidays.length > 0){
                    let matchingHoliday = holidays.find(h => h.year() == start.year() && h.month() == start.month() && h.date() == start.date());

                    if(!matchingHoliday){
                        result += 1;
                    }
                } else {
                    result += 1;
                }

            }
            start = start.add(1, 'days');
        }
        //console.log("CalcWorkDays: "+result);
        return result;
    }

    formatWeekDayArray(array){
        let result = "";
        if(array){
            array.forEach(e => {
                if(e == 1){result+=i18n.t('store.openingHours.weekDay1Short') + " "}
                else if(e == 2){result+=i18n.t('store.openingHours.weekDay2Short') + " "}
                else if(e == 3){result+=i18n.t('store.openingHours.weekDay3Short') + " "}
                else if(e == 4){result+=i18n.t('store.openingHours.weekDay4Short') + " "}
                else if(e == 5){result+=i18n.t('store.openingHours.weekDay5Short') + " "}
                else if(e == 6){result+=i18n.t('store.openingHours.weekDay6Short') + " "}
                else if(e == 7){result+=i18n.t('store.openingHours.weekDay7Short') + " "}
            })
        }

        return result;
    }
    documentTypes(inclContract = true) {
        let types = [{
            key: '2',
            value: 'ID',
            label: i18n.t('global.ui.id')
        },
            {
                key: '3',
                value: 'PASSPORT',
                label: i18n.t('pages.employeeContext.passport')
            },
            {
                key: '4',
                value: 'DRIVERSLICENSE',
                label: i18n.t('pages.employeeCoreData.driverslicense')
            },
            {
                key: '5',
                value: 'REGISTRATION',
                label: i18n.t('global.ui.registrationForm')
            },
            {
                key: '6',
                value: 'RESIDENCEPERMIT',
                label: i18n.t('pages.employeeContext.residencePermit')
            },
            {
                key: '7',
                value: 'WORKPERMIT',
                label: i18n.t('pages.employeeContext.workPermit')
            },
            {
                key: '8',
                value: 'NOTICEOFPREGNANCY',
                label: i18n.t('pages.employeeContext.pregnancyNotice')
            },
            {
                key: '9',
                value: 'NOTICEOFSICKNESS',
                label: i18n.t('pages.employeeContext.sickNote')
            },
            {
                key: '10',
                value: 'NOTICEOFRESIGNATION',
                label: i18n.t('pages.employeeContext.resignationNote')
            },
            {
                key: '11',
                value: 'ACCIDENTPREVENTION',
                label: i18n.t('pages.employeeContext.accidentPrevention')
            },
            {
                key: '12',
                value: 'OPERATINGRULES',
                label: i18n.t('pages.employeeContext.workRules')
            },
            {
                key: '13',
                value: 'BANKACCOUNTINFO',
                label: i18n.t('pages.employeeCoreData.bankConnection')
            },
            {
                key: '14',
                value: 'SOCIALSECURITYCARD',
                label: i18n.t('pages.employeeCoreData.sscAlt')
            },
            {
                key: '15',
                value: 'OFFICIALNOTICE',
                label: i18n.t('pages.employeeCoreData.officialNote')
            },
            {
                key: '16',
                value: 'SOCIALSECURITYREGISTRATION',
                label: i18n.t('pages.employeeCoreData.svRegistration')
            },
            {
                key: '17',
                value: 'SOCIALSECURITYDEREGISTRATION',
                label: i18n.t('pages.employeeCoreData.svDeRegistration')
            },
            {
                key: '18',
                value: 'NOTICEOFCHANGE',
                label: i18n.t('pages.employeeContext.changeReport')
            },
            {
                key: '19',
                value: 'VACCINATIONCERTIFICATE',
                label: i18n.t('pages.employeeContext.vaccinationCertificate')
            },
            {
                key: '20',
                value: 'CUSTOMCERTIFICATE',
                label: i18n.t('pages.employeeContext.certificate')
            },
            {
                key: '21',
                value: 'VACATIONREQUEST',
                label: i18n.t('pages.employeeContext.vacationRequest')
            },
            {
                key: '22',
                value: 'CONSENTFORM',
                label: i18n.t('pages.employeeContext.consentForm')
            },
            {
                key: '23',
                value: 'WORKTIMEPROTOCOL',
                label: i18n.t('pages.employeeContext.timeLog')
            },
            {
                key: '24',
                value: 'EDUCATIONCERTIFICATE',
                label: i18n.t('pages.employeeContext.educationCertification')
            },
            {
                key: '25',
                value: 'RESIDENCEWORKPERMIT',
                label: i18n.t('pages.employeeContext.laborFreelyResidencePermit')
            },
            {
                key: '26',
                value: 'ASYLUMPASS',
                label: i18n.t('pages.employeeContext.conventionForeignPassport')
            },
            {
                key: '27',
                value: 'HEALTHRULES',
                label: i18n.t('pages.employeeContext.healthProtection')
            },
            {
                key: '28',
                value: 'UNIFORMFORM',
                label: i18n.t('pages.employeeContext.uniformForm')
            },
            {
                key: '29',
                value: 'FIREPREVENTIONPASS',
                label: i18n.t('pages.employeeContext.firePreventionPass')
            },
            {
                key: '30',
                value: 'MISC',
                label: i18n.t('roster.main.other'),
            },
        ];
        if (inclContract) types.push({
            key: '1',
            value: 'CONTRACT',
            label: i18n.tc('pages.employeeData.contract')
        });
        return types.sort((a, b) => a.value == 'MISC' ? 1 : (b.value == 'MISC' ? -1 :a.label.localeCompare(b.label)));
    }

    documentTypeLabel(type) {
        let label = "";
        this.documentTypes().forEach((t) => {
            if (t.value == type) label = t.label;
        });
        return label;
    }


    // HELPERS FOR REPORTS

    reportDoc(title, subtitle = null, subtitle2 = null, userFullname = null, orientation = 'p', headerImgData = null) {
        var doc = new jsPDF({
            orientation: orientation
        });
        var tmpFill = doc.getFillColor();
        var tmpFontSize = doc.getFontSize();
        var tmpTextColor = doc.getTextColor();

        var y = 20;
        var headerRightOffset = orientation == 'l' ? 265 : 178;
        var titleX = 14;
        if (headerImgData != null) {
            titleX = 33;
            doc.setFillColor(109, 141, 33);
            doc.rect(14, 16, 16, 16, 'F');
            doc.addImage(headerImgData, 'png', 14.5, 16.5, 15, 15);
        }

        doc.text(title, titleX, y);
        y += 5;
        doc.setFontSize(10);
        if (subtitle != null) {
            doc.text(subtitle, titleX, y);
            y += 4;
        }
        if (subtitle2 != null) {
            doc.text(subtitle2, titleX, y);
            y += 6;
        }
        doc.setFontSize(8);
        var img = 'data:image/png;base64,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';
        var created = this.getNowDateTimeString();
        doc.addImage(img, 'png', headerRightOffset + 3, 17, 15, 15);
        doc.text(i18n.t('roster.main.createdAt') + ': ' + created, headerRightOffset, 20, {
            align: 'right'
        });
        if (userFullname != null) doc.text(i18n.t('pref.main.createdBy') + ': ' + userFullname, headerRightOffset, 24, {
            align: 'right'
        });

        // reapply previous settings
        doc.setFillColor(tmpFill);
        doc.setFontSize(tmpFontSize);
        doc.setTextColor(tmpTextColor);
        doc.setFont(undefined, 'normal');
        return {
            doc: doc,
            contentOffsetY: 35
        }
    }

    employeeDataReportDoc(name, employeePictureData, storeName) {
        return this.reportDoc(name, i18n.t('pages.employeeContext.personnelDataSheet'), null, storeName, 'p', employeePictureData);
    }

    tableReportDoc(headers, title, subtitle = null, subtitle2 = null, userFullname = null, orientationBreakpoint = 8) {
        var orientation = headers.length >= orientationBreakpoint ? 'l' : 'p';
        return this.reportDoc(title, subtitle, subtitle2, userFullname, orientation);
    }

    reportHeaderColorBlock(doc, title, offsetY) {
        var tmpFill = doc.getFillColor();
        var tmpFontSize = doc.getFontSize();
        var tmpTextColor = doc.getTextColor();

        doc.setFillColor(109, 141, 33);
        doc.setFontSize(14);
        doc.setTextColor(255, 255, 255);
        doc.setFont(undefined, 'bold');
        doc.rect(14, offsetY, 182, 10, 'F');
        offsetY += 7;
        doc.text(title, 16, offsetY);
        offsetY += 8;

        // reapply previous settings
        doc.setFillColor(tmpFill);
        doc.setFontSize(tmpFontSize);
        doc.setTextColor(tmpTextColor);
        doc.setFont(undefined, 'normal');

        return doc, offsetY;
    }

    reportColorBlockDivider(doc, offsetY) {
        var tmpFill = doc.getFillColor();

        doc.setFillColor(200, 200, 200);
        doc.rect(14, offsetY, 182, 5, 'F');
        offsetY += 10;

        // reapply previous settings
        doc.setFillColor(tmpFill);

        return doc, offsetY;
    }

    reportSubHeaderColorBlock(doc, title, offsetY) {
        var tmpFill = doc.getFillColor();
        var tmpFontSize = doc.getFontSize();
        var tmpTextColor = doc.getTextColor();

        doc.setFillColor(109, 141, 33);
        doc.setFontSize(14);
        doc.setTextColor(255, 255, 255);
        doc.setFont(undefined, 'bold');
        doc.rect(14, offsetY, 182, 10, 'F');
        offsetY += 7;
        doc.text(title, 16, offsetY);
        offsetY += 8;

        // reapply previous settings
        doc.setFillColor(tmpFill);
        doc.setFontSize(tmpFontSize);
        doc.setTextColor(tmpTextColor);
        doc.setFont(undefined, 'normal');

        return doc, offsetY;
    }

    dataBlock(doc, data, offsetX, offsetY, page) {
        var tmpFill = doc.getFillColor();
        var tmpFontSize = doc.getFontSize();
        var tmpTextColor = doc.getTextColor();
        var offset = {
            offsetY: offsetY,
            page: page
        };
        var lineHeight = 4;
        var left = 50 + offsetX;
        doc.setFontSize(8);
        doc.setTextColor(0, 0, 0);
        data.forEach((d) => {
            var key = d.key;
            var value = d.value;
            var keyOnly = d.keyOnly != undefined && d.keyOnly;
            doc.setFont(undefined, 'normal');
            doc.text(key + (key != "" && !keyOnly ? ":" : ""), left, offsetY, {
                align: 'right'
            });
            doc.setFont(undefined, 'bold')
            doc.text(value != null ? value : '', left + 3, offsetY);
            offsetY += lineHeight;
            doc, offset = this.checkOffsetForNewPage(doc, offsetY, page);
            offsetY = offset.offsetY;
            page = offset.page;
        });

        // reapply previous settings
        doc.setFillColor(tmpFill);
        doc.setFontSize(tmpFontSize);
        doc.setTextColor(tmpTextColor);
        doc.setFont(undefined, 'normal');
        return doc, {
            offsetY: offsetY,
            page: page
        };
    }

    checkOffsetForNewPage(doc, offsetY, page) {
        // doc.rect(13.9, curY-0.2, 182.2, 297 - curY - 15);
        if (offsetY > 297 - 20) {
            var pageCount = doc.internal.getNumberOfPages();
            if (page == pageCount) {
                doc.addPage();
                page++;
            } else {
                page++;
                doc.setPage(page);
            }
            offsetY = 15;
            doc.rect(13.9, offsetY, 182.2, 297 - offsetY - 15);
            offsetY = 25;
        }

        return doc, {
            offsetY: offsetY,
            page: page
        };
    }

    insertPageNumbers(doc, landscape = false) {
        var tmpFontSize = doc.getFontSize();
        var tmpTextColor = doc.getTextColor();

        var offsetX = 105;
        var offsetY = 287;
        if (landscape) {
            offsetX = 148.5;
            offsetY = 200;
        }

        doc.setFont(undefined, 'normal');
        doc.setFontSize(6);
        doc.setTextColor(60, 60, 60);

        var pageCount = doc.internal.getNumberOfPages();
        for (var i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.text(i18n.t('report.main.pageOf', [i, pageCount]), offsetX, offsetY, {
                align: 'center'
            });
        }
        doc.setFontSize(tmpFontSize);
        doc.setTextColor(tmpTextColor);
        return doc;
    }

    getImageDataUri(url, cb) {
        var image = new Image();
        image.setAttribute('crossOrigin', 'anonymous'); //getting images from external domain

        image.onload = function () {
            var canvas = document.createElement('canvas');
            canvas.width = this.naturalWidth;
            canvas.height = this.naturalHeight;

            //next three lines for white background in case png has a transparent background
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = '#fff'; /// set white fill style
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            canvas.getContext('2d').drawImage(this, 0, 0);

            cb(canvas.toDataURL('image/jpeg'));
        };

        image.src = url;
    }


    ProcessNumericLabel(label, decimals = 2, divider = ',', plusSign = true, ceil = false) {
        let number = parseFloat(label);
        if (!isNaN(number)) {
            number = (Math.round((ceil ? Math.ceil(number) : number) * 100) / 100).toFixed(decimals);
            if (plusSign) {
                number = (number < 0 ? '' : '+') + number;
            }
            label = (number.toString()).replace('.', divider);
        }
        return label;
    }

    GetSnapShot(el, options, callbackSnapTaken) {
        console.log(html2canvas);
        let helpers = this;
        let box = el.getBoundingClientRect();
        html2canvas(el, options ? options : {}).then((canvas) => {
            console.log('success on promise');
            let image = canvas.toDataURL("image/png");
            let imageDownloadElement = document.createElement('a');
            imageDownloadElement.href = image;
            let name = i18n.t('global.md') + 'Snapshot ' + helpers.getMomentTZ().locale(i18n.locale()).format('YYYY-MM-DD');
            if (options && options.name) name = options.name;
            imageDownloadElement.download = name + '.png';
            document.body.appendChild(imageDownloadElement);
            imageDownloadElement.click();
            document.body.removeChild(imageDownloadElement);
            if (callbackSnapTaken) callbackSnapTaken();
        }).catch((error) => {
            console.log(error)
        });
    }

    DragOpenedCheck() {
        return window.app.genericPopups.find(p => p.draggable);
    }

    OpenListLabel(labels, options) {
        let defaultState = {
            components: [{
                type: 'listlabel',
                state: {
                    labels: labels,
                },
            }],
            listStyle: true,
            noScroll: true,
            pointerDirection: 3,
            elRelative: null,
            pointerOffset: 0,
            pointerHide: true,
            pinTopRight: true,
        };
        if (options)
            for (let x in options) defaultState[x] = options[x];
        /*if(defaultState.elRelative) {
            defaultState.offsety = defaultState.elRelative.getBoundingClientRect().height / 2;
        }*/

        this.OpenPopup(defaultState);
    }

    TimeBarDragCheck(shift) {
        var shiftDragged = shift;
        return (elementOnMouseCursor) => {
            let timebar = $(elementOnMouseCursor).closest('.time-bar-new')[0];

            if (timebar) {
                console.log('timebar dragged unto');
                timebar = timebar.__vue__;
                timebar.AddTimeFrameDrag(shiftDragged);
            }
        }
    }

    EndShiftDrag(rosterView, dropdowncontainer) {
        $('.dragged-shift').removeClass('dragged-shift');
        $('.shift-drag-overlay').css('display', '');
        rosterView.dragging = false;
        rosterView.ClearEmployeeFilter();
        dropdowncontainer.Close();
        window.app.MouseMoveUnsubscribe('TimeBarShiftDragCheck');
        if (window.timebars) {
            window.timebars.filter(t => t).forEach(t => t.timeFrameDrag = null);
        }

    }

    DragShift(shifts, rosterView, shiftDraggedElement) {
        if (shifts && !shifts.length) {
            let array = [];
            array.push(shifts);
            shifts = array;
        }
        if (!shifts || shifts.length === 0 || shifts[0].length === 0 || !shifts.find(s => !s.published)) return;
        let view = this;
        setTimeout(function () {
            if (!window.mouse.click) return;
            window.app.MouseMoveSubscribe('TimeBarShiftDragCheck', view.TimeBarDragCheck(shifts[0]));
            rosterView.dragging = true;
            shifts.forEach(s => rosterView.FilterSpot(s.spotId, true));
            rosterView.filterEmployees();
            if (shiftDraggedElement && !shifts.find(s => !s.templateId)) {

                let draggedBox = shiftDraggedElement.getBoundingClientRect();
                $(shiftDraggedElement).addClass('dragged-shift');
                requestAnimationFrame(function () {
                    if (!view.DragOpenedCheck()) return;
                    let scrollValue = $('#rosterscrollcontainer').scrollLeft();
                    $('.shift-drag-overlay').css('display', 'inline-block');
                    let firstWeek = $('.entry > .week:first-child')[0].getBoundingClientRect();
                    let lastWeek = $('.entry > .week:last-child')[0].getBoundingClientRect();
                    $('.shift-drag-overlay.left').css({
                        width: (draggedBox.left - firstWeek.left) + 'px',
                        left: firstWeek.left + scrollValue + 'px'
                    });
                    $('.shift-drag-overlay.right').css({
                        left: (draggedBox.right) + scrollValue + 'px',
                        width: (lastWeek.right - draggedBox.right) + 'px'
                    });
                });
            }
            let components = [];
            let draggedUntoSelection = {
                shifts: []
            };
            let elementDraggedOn = {};
            let dropdowncontainerFromDrag = {};
            for (let x in shifts) {
                let shiftMomentItem = rosterView.planShiftMap[shifts[x].id] ? rosterView.planShiftMap[shifts[x].id] : rosterView.actualShiftMap[shifts[x].id];
                let dayClasses = shifts[x].employeeId ? rosterView.GetDayClasses(shifts[x].employeeId, shiftMomentItem.fromDate.format('YYYY-MM-DD')) : 'Greem';
                components.push({
                    type: 'rosterday',
                    state: {
                        shifts: shifts[x],
                        spotMap: rosterView.spotMap,
                        relative: true,
                        shiftClasses: dayClasses,
                    },
                    /*propContainer: {
                        eventProp: rosterView.GetTimeBarShiftProp(rosterView.planShiftMomentMap[shifts[x].id].fromDate, shifts[x]),
                        class: shifts[x].published ? 'published' : '',
                    },*/
                    customEvents: {
                        'click': (rosterdayComponent) => {

                            view.ShiftDragEnd(elementDraggedOn, dropdowncontainerFromDrag, rosterdayComponent.shifts, draggedUntoSelection, rosterView);

                        },
                    },

                });
            }


            rosterView.$helpers.OpenPopup({
                components: components,
                listStyle: true,
                noScroll: true,
                draggable: true,
                remainAfterSelect: !(shifts[0] && !shifts[0].employeeId),
                allowOverflow: true,
                toggleCallback: (dropdowncontainer) => {
                    view.EndShiftDrag(rosterView, dropdowncontainer);
                },
                callbackDrag: (element, dropdowncontainer) => {
                    elementDraggedOn = element;
                    dropdowncontainerFromDrag = dropdowncontainer;
                    if (shifts.length > 1) {
                        let day = $(element).closest('.entry:not(.header) .day')[0];
                        if (day) {
                            let date = rosterView.$helpers.getMomentFromStringTZ(day.attributes.date.value);
                            dropdowncontainer.$children.filter(c => c.shifts).forEach(c => {
                                c.disabled = (c.shifts[0].templateId && c.shifts[0].fromDate.dayOfYear() !== date.dayOfYear())
                            });
                        } else {
                            view.EndShiftDrag(rosterView, dropdowncontainer);
                        }
                        return;
                    }
                    view.ShiftDragEnd(element, dropdowncontainer, shifts, draggedUntoSelection, rosterView);
                }
            });
        }, 200);
    }

    ShiftDragEnd(element, dropdowncontainer, shifts, draggedUntoSelection, rosterView) {
        let view = this;
        if ($(element).closest('.shifts')[0]) {
            rosterView.UpdateShift(shifts[0], {
                employeeId: null
            }, () => {
                view.EndShiftDrag(rosterView, dropdowncontainer);
            }, () => {
                view.EndShiftDrag(rosterView, dropdowncontainer);
            }, null, true);
            return;
        }
        let day = $(element).closest('.entry:not(.header) .day')[0];
        if (day) {
            draggedUntoSelection.employee = rosterView.employeeMap[day.attributes.employeeid.value];

            if(draggedUntoSelection.employee){
                draggedUntoSelection.shifts = rosterView.rosterContentMap[day.attributes.employeeid.value][day.attributes.date.value].planShifts;
                draggedUntoSelection.date = rosterView.$helpers.getMomentFromStringTZ(day.attributes.date.value);
                if (draggedUntoSelection.shifts.length === 0 && shifts.length === 1) {
                    if (!shifts[0].templateId && draggedUntoSelection.date.month() !== shifts[0].fromDate.month()) {
                        view.EndShiftDrag(rosterView, dropdowncontainer);
                    } else {
                        let shiftPayload = {
                            employeeId: draggedUntoSelection.employee.id
                        };
                        if (!shifts[0].templateId) {
                            let dateDifference = draggedUntoSelection.date.dayOfYear() - shifts[0].fromDate.dayOfYear();
                            shiftPayload.from = rosterView.$helpers.convertDateStringTZ(shifts[0].fromDate.clone().add(dateDifference, 'days'));
                            shiftPayload.to = rosterView.$helpers.convertDateStringTZ(shifts[0].toDate.clone().add(dateDifference, 'days'));
                            shiftPayload.breakFrom = shifts[0].breakFrom;
                        }
                        rosterView.UpdateShift(shifts[0], shiftPayload,
                            () => {
                                view.EndShiftDrag(rosterView, dropdowncontainer);
                            }, () => {
                                view.EndShiftDrag(rosterView, dropdowncontainer);
                            }, null, true);
                    }
                }
                if (draggedUntoSelection.shifts.length === 1 && shifts.length === 1) {
                    if ((shifts[0].templateId && draggedUntoSelection.employee.id === shifts[0].employeeId || (!shifts[0].templateId && draggedUntoSelection.date.month() !== shifts[0].fromDate.month()))) {
                        view.EndShiftDrag(rosterView, dropdowncontainer);
                    } else {
                        rosterView.$helpers.OpenShiftDragSubMenu(shifts[0], draggedUntoSelection, day, dropdowncontainer, rosterView);
                        requestAnimationFrame(function () {
                            view.EndShiftDrag(rosterView, dropdowncontainer);
                        });
                    }
                }
            } else {
                view.EndShiftDrag(rosterView, dropdowncontainer);
            }

        } else {
            let timebar = $(element).closest('.time-bar-new')[0];

            if (timebar) {
                timebar = timebar.__vue__;
                draggedUntoSelection.employee = timebar.eventProp.employee;
                if(draggedUntoSelection.employee && rosterView.employeeMap[draggedUntoSelection.employee.id]){
                    draggedUntoSelection.shifts = timebar.timeFrames.filter(t => t.type == "shift").map(t => t.shift);
                    let array = [];

                    draggedUntoSelection.shifts.forEach(s => {
                        if (!array.find(a => a.id === s.id)) {
                            if (rosterView.planShiftMomentMap[s.id] && rosterView.planShiftMomentMap[s.id].fromDate.date() === timebar.eventProp.day.date()) array.push(s);
                            if (rosterView.actualShiftMomentMap[s.id] && rosterView.actualShiftMomentMap[s.id].fromDate.date() === timebar.eventProp.day.date()) array.push(s);
                        }
                    });
                    draggedUntoSelection.shifts = array;
                    draggedUntoSelection.date = timebar.eventProp.day.clone();
                    if (draggedUntoSelection.shifts.length === 0 && shifts.length === 1) {
                        rosterView.UpdateShift(shifts[0], {
                            employeeId: draggedUntoSelection.employee.id
                        }, () => {
                            view.EndShiftDrag(rosterView, dropdowncontainer);
                        }, () => {
                            view.EndShiftDrag(rosterView, dropdowncontainer);
                        }, null, true);
                    }
                    if (draggedUntoSelection.shifts.length === 1 && shifts.length === 1) {
                        if (draggedUntoSelection.employee.id === shifts[0].employeeId) {
                            view.EndShiftDrag(rosterView, dropdowncontainer);
                        } else {
                            rosterView.$helpers.OpenShiftDragSubMenu(shifts[0], draggedUntoSelection, null, dropdowncontainer, rosterView);
                            requestAnimationFrame(function () {
                                view.EndShiftDrag(rosterView, dropdowncontainer);
                            });
                        }
                    }
                } else {
                    view.EndShiftDrag(rosterView, dropdowncontainer);
                }


            } else {
                view.EndShiftDrag(rosterView, dropdowncontainer);
            }
        }
    }

    OpenShiftDragSubMenu(shift, draggedUntoSelection, element, dropdowncontainer, rosterView) {
        let labelOptions = [];
        let helpers = this;
        let view = this;

        let overlap = draggedUntoSelection.shifts.find(s =>
            helpers.CheckTimeFrameIntersect(rosterView.planShiftMomentMap[shift.id].fromDate, rosterView.planShiftMomentMap[shift.id].toDate,
                rosterView.planShiftMomentMap[s.id].fromDate, rosterView.planShiftMomentMap[s.id].toDate));

        let addOption = {
            text: i18n.t('global.ui.add'),
            type: 'block',
            click: () => {
                let shiftPayload = {
                    employeeId: draggedUntoSelection.employee.id
                };
                if (!shift.templateId) {
                    let dateDifference = draggedUntoSelection.date.dayOfYear() - shift.fromDate.dayOfYear();
                    shiftPayload.from = rosterView.$helpers.convertDateStringTZ(shift.fromDate.clone().add(dateDifference, 'days'));
                    shiftPayload.to = rosterView.$helpers.convertDateStringTZ(shift.toDate.clone().add(dateDifference, 'days'));
                    shiftPayload.breakFrom = shift.breakFrom;
                }
                rosterView.UpdateShift(shift, shiftPayload, () => {
                    view.EndShiftDrag(rosterView, dropdowncontainer);
                }, () => {
                    view.EndShiftDrag(rosterView, dropdowncontainer);
                }, null, true);
            }
        };

        if (overlap) {
            addOption.disabled = true;
            addOption.tooltip = i18n.t('shift.groups.overlap');
        }

        labelOptions.push(addOption);
        let draggedUntoShift = draggedUntoSelection.shifts[0];
        if (draggedUntoShift) {
            labelOptions.push({
                text: i18n.t('roster.comp.swap'),
                type: 'block',
                click: () => {
                    let draggedEmployeeId = shift.employeeId;
                    let shiftUpdateRequests = [];
                    shiftUpdateRequests.push({
                        shift: shift,
                        fields: {
                            employeeId: draggedUntoSelection.employee.id
                        }
                    });
                    shiftUpdateRequests.push({
                        shift: draggedUntoShift,
                        fields: {
                            employeeId: draggedEmployeeId
                        }
                    });
                    rosterView.UpdateShiftMulti(shiftUpdateRequests, () => {
                        view.EndShiftDrag(rosterView, dropdowncontainer);
                    }, () => {
                        view.EndShiftDrag(rosterView, dropdowncontainer);
                    }, true);

                    console.log('Tauschen ' + draggedUntoSelection.employee.firstName);
                },
                disabled: draggedUntoShift.published || (!shift.templateId && draggedUntoShift.templateId),
                tooltip: draggedUntoShift.published ? i18n.t('roster.view.alreadyPublished') : (!shift.templateId && draggedUntoShift.templateId) ? i18n.t('roster.view.cantSwapWithTemplate') : null
            });
            labelOptions.push({
                text: i18n.t('roster.view.replace'),
                type: 'block',
                click: () => {
                    rosterView.UpdateShift(draggedUntoShift, {
                        employeeId: null
                    }, () => {
                        let shiftPayload = {
                            employeeId: draggedUntoSelection.employee.id
                        };
                        if (!shift.templateId) {
                            let dateDifference = draggedUntoSelection.date.dayOfYear() - shift.fromDate.dayOfYear();
                            shiftPayload.from = rosterView.$helpers.convertDateStringTZ(shift.fromDate.clone().add(dateDifference, 'days'));
                            shiftPayload.to = rosterView.$helpers.convertDateStringTZ(shift.toDate.clone().add(dateDifference, 'days'));
                            shiftPayload.breakFrom = shift.breakFrom;
                        }
                        rosterView.UpdateShift(shift, shiftPayload, () => {
                            view.EndShiftDrag(rosterView, dropdowncontainer);
                        }, () => {
                            view.EndShiftDrag(rosterView, dropdowncontainer);
                        }, null, true);
                    }, () => {
                        view.EndShiftDrag(rosterView, dropdowncontainer);
                    }, null, true);
                    console.log('Ersetzen ' + draggedUntoSelection.employee.firstName);
                },
                disabled: draggedUntoShift.published,
                tooltip: draggedUntoShift.published ? i18n.t('roster.view.alreadyPublished') : null
            });
        }

        rosterView.$helpers.OpenListLabel(labelOptions, {
            elRelative: element,
            pointerHide: true,
            pointerDirection: 3,
            noScroll: true
        });
    }

    CheckTimeFrameIntersect(startA, endA, startB, endB) {
        return startA < endB && startB < endA;
    }

    IsKeyNameNavigationType(keyName) {
        return (keyName === 'Home' || keyName === 'End' || keyName === 'PageUp' || keyName === 'PageDown' || keyName === 'ArrowLeft' || keyName === 'ArrowRight' || keyName === 'Backspace' || keyName === 'Delete' || keyName === 'Tab' || keyName === 'Shift')
    }

    OpenDatepickerPopup(dateOptions, dateEvents, popupOptions) {
        /* example datepicker
            dateOptions = {viewsEnabled: ['W','M','Y','C'], date: dateMoment}
            dateEvents = {
                OnDateSelect: (date) => {...}, //always called to avoid having to define it x5 for a generic date pick
                OnWeekSelect: (date) => {...}, //you don't have to define these or OnDateSelect if you're not using them
                OnDaySelect: (date) => {...},
                OnMonthSelect: (date) => {...},
                OnYearSelect: (date) => {...},
                OnCalendarSelect: (date) => {...},
            };
            popupOptions: {elRelative: $event.currentTarget} // if elRelative isn't defined the popup will open on the cursor so no big deal
        */
        let defaultState = {
            components: [{
                type: 'datepicker',
                state: dateOptions,
                customEvents: dateEvents,
            }],
            noScroll: false,
            pointerDirection: 3,
            elRelative: null,
            pointerOffset: 0,
            pointerHide: true,
            pinTopRight: true,
            expanded: true,
        };
        if (popupOptions)
            for (let x in popupOptions) defaultState[x] = popupOptions[x];

        this.OpenPopup(defaultState);

    }


    GetContrastingColor(hex, lightcolor = 'white', darkcolor = '#444444', contrastLimit = 80) {
        if (!hex) return darkcolor;
        let hsl = this.hexToHSLObject(hex);
        if (hsl.l < contrastLimit){
            return lightcolor;
        }
        return darkcolor;
    }

    OpenDragPopup(popupOptions, dragEndCallback = (elementOnMouse, dropdowncontainer) => {}) {
        let defaultState = {
            components: [],
            listStyle: true,
            noScroll: true,
            draggable: true,
            remainAfterSelect: true,
            callbackDrag: dragEndCallback
        };
        if (popupOptions)
            for (let x in popupOptions) defaultState[x] = popupOptions[x];
        this.OpenPopup(defaultState);
    }

    SetMomentTimeFromMoment(momentExisting, momentToCopy) {
        momentExisting.year(momentToCopy.year());
        momentExisting.month(momentToCopy.month());
        momentExisting.date(momentToCopy.date());
        momentExisting.hours(momentToCopy.hours());
        momentExisting.minutes(momentToCopy.minutes());
        momentExisting.seconds(momentToCopy.seconds());
        momentExisting.milliseconds(momentToCopy.milliseconds());
        return momentExisting;
    }

    GetHourMinuteFormatFromTotal(total) {
        if (!total) return '--:--';
        if (!total.totalActual) return this.GetHourMinuteFormatFromMilliseconds(total.total + total.totalPreviousDay);
        return this.GetHourMinuteFormatFromMilliseconds(total.totalActual + total.totalActualPreviousDay);
    }


    GetHourMinuteFormatFromMap(map, format) {
        if (!map || !map[format]) return '--:--';
        return this.GetHourMinuteFormatFromTotal(map[format]);
    }

    GetHourMinuteFormatFromMilliseconds(milliseconds, float = false) {
        if(float){
            if(milliseconds !== 0 && !milliseconds) return '';

            return (milliseconds/1000/60/60).toFixed(2) + "h";
        }
        if (!milliseconds) return '--:--';
        let seconds = milliseconds / 1000;
        let minutes = seconds / 60;

        let hours = (minutes - (minutes % 60)) / 60;
        minutes = Math.ceil(minutes % 60);
        if (minutes === 60) {
            hours++;
            minutes = 0;
        }
        if (minutes < 10) minutes = '0' + minutes;
        if (hours < 10) hours = '0' + hours;

        return hours + 'h:' + minutes + 'm';
    }


    GetMillisecondTotalObjectFromMoments(from, to, timeBorderMoment) {
        let difference = 0;
        let remaining = 0;
        if (!timeBorderMoment) {
            difference += Math.max(0, to._d.getTime() - from._d.getTime());
        } else {
            if (to._d.getTime() < timeBorderMoment._d.getTime()) {
                difference += Math.max(0, to._d.getTime() - from._d.getTime());
            } else if (from._d.getTime() < timeBorderMoment._d.getTime()) {
                difference += Math.max(0, timeBorderMoment._d.getTime() - from._d.getTime());
                remaining += Math.max(0, to._d.getTime() - timeBorderMoment._d.getTime());
            } else {

                remaining += Math.max(0, to._d.getTime() - from._d.getTime());
            }
        }
        return {
            total: difference,
            totalOutOfRange: remaining
        };
    }


    MountViewOnDropdownContainer(view, options) {

        let state = {
            show: true,
            toggled: true,
            centered: true,
            expanded: true,
        };

        for (let o in options) {
            state[o] = options[o];
        }
        let containerState = this.OpenPopup(state);
        requestAnimationFrame(function () {
            let container = window.app.$children.find(c => c.state === containerState);
            if (container) {
                container.$el.querySelector('.tab-body').appendChild(view.$el);
                container.toggled = true;
                container.show = true;

                view.$once('hook:beforeDestroy', () => {
                    container.locked = false;
                    container.$emit('on-close', container);
                    view.$destroy();
                })
            }
        })
    }

    dateIsBefore(dateA, dateB) {
        if (dateA == null) {
            return false;
        } else if (dateB == null && dateA != null) {
            return true;
        } else if (dateA == null && dateB == null) {
            return false
        } else {
            return dateA.year() < dateB.year() || (dateA.year() == dateB.year() && dateA.month() < dateB.month()) || (dateA.year() == dateB.year() && dateA.month() == dateB.month() && dateA.date() < dateB.date())

        }

    }

    calculateEmployeeWorkBalance(employee, previousMonthWorkBalanceMap, employeeContractMap, nextMonthEmployeeContractMap, allowedContractMap, collectiveContractMap,
                                 employeePlanShiftMap, employeeDateActualShiftMap, employeeDateActualShiftMarkedMap, holidayMap, actualShiftBreakMap,
                                 employeePreferenceMap, workBalanceMap, spotMap, storeSettings, currentMonthFrom, currentMonthTo, currentMonthFromTZ, currentMonthToTZ,
                                 workTimeBalanceCreationMode = 1, erasePayment = false, accountingPeriodSettings = null,
                                 contractExitSettings = [], disableAccountingPeriodSetting = false,
                                 exitReasonReverseIdMap = {}, bonusPaymentSettingsMap = {}, employeeAvgWorktimeMap = {}) {

        let employeeId = employee.id;
        let employeeWorkBalance = {
            employeeId: employeeId,
            year: currentMonthFrom.year(),
            month: currentMonthFrom.month() + 1,
            workTimeBalance: 0,
            vacationTimeBalance: 0,
            holidayTimeBalance: 0,
            workTimeRegular: 0,
            workTime: 0,
            unproductiveWorkTime: 0,
            vacationTime: 0,
            paidVacationTime: 0,
            vacationWorkTime: 0,
            nursingVacationTime: 0,
            nursingVacationWorkTime: 0,
            holidayTime: 0,
            holidayAdjustmentTime: 0,
            holidayAdjustmentWorkTime: 0,
            sickTime: 0,
            sickWorkTime: 0,
            educationTime: 0,
            educationWorkTime: 0,
            wageContinuationTime: 0,
            wageContinuationWorkTime: 0,
            miscTime: 0,
            paidWorkTime: 0,
            paidHolidayTime: 0,
            nightWorkTime: 0,
            nightWorkCount: 0,
            overTime: 0,
            overTimeCount: 0,
            moreTime: 0,
            moreTimeCount: 0,
            prevMonthTime: 0,
            multiplier: 100,
            comment: null,
            autoCalc: true,
            autoEqualize: false,
            prevMonthNightWorkTime: 0,
            nightWorkTimeBalance: 0,
            paidNightWorkTime: 0,
            prevMonthOverTime: 0,
            overTimeBalance: 0,
            paidOverTime: 0,
            dailyOverTime: 0,
            weeklyOverTime: 0,
            workDayOverTime: 0,
            prevMonthMoreTime: 0,
            moreTimeBalance: 0,
            paidMoreTime: 0,
            miscWorkTime: 0,
            accountingPeriodBalance: 0,
            appliedAccountingPeriod: false,
            bonusTime: 0,
            bonusTimeCount: 0,
            paidBonusTime: 0,
            prevMonthBonusTime: 0,
            bonusTimeBalance: 0,
            holidayCount: 0,
            workCount: 0,
            educationCount: 0,
            vacationCount: 0,
            wageContinuationCount: 0,
            nursingVacationCount: 0,
            miscCount: 0,
            sickCount: 0,
            holidayAdjustmentCount: 0,
            workTimeMod: 0,
            overTimeToWorkTime: 0,
            holidayTimeToWorkTime: 0,
            moreTimeMod: 0

        };

        let prevMonthBalance = previousMonthWorkBalanceMap[employeeId];
        let prevMonthNightWorkTime = 0;
        let prevMonthOverTime = 0;
        let prevMonthMoreTime = 0;
        let prevMonthBonusTime = 0;
        let prevMonthAccountingPeriodBalance = 0;
        let workTimeRegular = 0;
        let fullTimeRegular = 0;
        let prevMonthTime = 0;
        let mainContract;
        let useContractExitSetting = false;
        let contractExitSetting = null;
        let isUnderage = false;
        if(employee.dob){
            isUnderage = this.isUnderage(employee.dob, currentMonthToTZ);
        }

        let overlappingContracts = [];
        let contractFromToMap =  {};
        if (employeeContractMap[employeeId]) {
            let contracts = employeeContractMap[employeeId];

            let federalHolidayMoments = Object.values(holidayMap).filter(h => h.federalHoliday).map(h => h.fromMoment);
            let includingContractHolidayMoments = Object.values(holidayMap).filter(h => h.federalHoliday || h.contractHoliday).map(h => h.fromMoment);
            workTimeRegular = this.GetWorktimeForRangeWithinMonthFromContracts(currentMonthFromTZ, currentMonthFromTZ, currentMonthToTZ, contracts, allowedContractMap, storeSettings, storeSettings.workTimeMode, storeSettings.exitFactoring, null, federalHolidayMoments, includingContractHolidayMoments)
            fullTimeRegular = this.GetFulltimeForRangeWithinMonthFromContracts(currentMonthFromTZ, currentMonthFromTZ, currentMonthToTZ, contracts, allowedContractMap, storeSettings, storeSettings.workTimeMode, storeSettings.exitFactoring, null, federalHolidayMoments, includingContractHolidayMoments)

            overlappingContracts = this.GetContractsOverlappingMonth(contracts, currentMonthFromTZ.clone().startOf('week').subtract(1,'days'), currentMonthToTZ);
            overlappingContracts.forEach(contract => {

                let contractFrom = this.getMomentFromStringTZ(contract.from);
                let contractTo = contract.to ? this.getMomentFromStringTZ(contract.to).add(-1, 'minutes') : null; //subtract 1 minute so when contract ends at end of month (= beginnining of next month) we are still in current month
                contractFromToMap[contract.id] = {from: contractFrom, to: contractTo};
                if (contractTo != null &&
                    contractExitSettings != null && contractExitSettings.length > 0 &&
                    contractTo.year() == currentMonthFromTZ.year() &&
                    contractTo.month() == currentMonthFromTZ.month() &&
                    contract.exitReason != null) {
                    contractExitSettings.forEach(exitSetting => {
                        let reverseId = exitReasonReverseIdMap["" + exitSetting.reason];
                        if (reverseId == contract.exitReason) {
                            useContractExitSetting = true;
                            contractExitSetting = exitSetting;
                        }
                    })

                }

                if (!mainContract) {
                    mainContract = contract;
                } else {
                    let mainContractFrom = this.getMomentFromStringTZ(mainContract.from);
                    if (contractFrom > mainContractFrom) {
                        mainContract = contract;
                    }
                }
            });

        }

        if (prevMonthBalance) {
            prevMonthTime = prevMonthBalance.workTimeBalance;
            prevMonthNightWorkTime = prevMonthBalance.nightWorkTimeBalance;
            prevMonthOverTime = prevMonthBalance.overTimeBalance;
            prevMonthMoreTime = prevMonthBalance.moreTimeBalance;
            prevMonthBonusTime = prevMonthBalance.bonusTimeBalance;
            prevMonthAccountingPeriodBalance = prevMonthBalance.accountingPeriodBalance;
        }
        employeeWorkBalance.workTimeRegular = workTimeRegular / 60;


        let workTime = 0;
        let holidayTime = 0;
        let nightWorkTime = 0;
        let overTime = 0;
        let moreTime = 0;
        let bonusTime = 0;
        let overtimeMap = {};
        let bonusPaymentResultMap = {};
        let weekWorkDayMap = {};

        if (employeePlanShiftMap[employeeId] && (workTimeBalanceCreationMode == 1 || workTimeBalanceCreationMode == 3)) {
            let planShifts = employeePlanShiftMap[employeeId];
            planShifts.forEach(shift => {
                let workValue = shift.workValue;
                let totalWorkValue = shift.workValue;
                let shiftFrom = this.getMomentFromStringTZ(shift.from);
                let shiftTo = this.getMomentFromStringTZ(shift.to);
                let currentContract = overlappingContracts.find(contract => {
                    if(shiftFrom >= contractFromToMap[contract.id].from && (contractFromToMap[contract.id].to == null || shiftFrom < contractFromToMap[contract.id].to)){
                        return true;
                    } else {
                        return false;
                    }
                })

                let dateKey = shiftFrom.format("YYYY-MM-DD");
                let actualShiftMarked = employeeDateActualShiftMarkedMap[employeeId] && employeeDateActualShiftMarkedMap[employeeId][dateKey];
                let hasActualShifts = employeeDateActualShiftMap[employeeId] && employeeDateActualShiftMap[employeeId][dateKey] /*&& employeeDateActualShiftMap[employeeId][dateKey].filter(a => !a.endMissing).length > 0*/;
                if ((!(hasActualShifts || actualShiftMarked) || workTimeBalanceCreationMode == 3)) {
                    if(shiftTo > currentMonthFromTZ && shiftFrom < currentMonthToTZ){
                        let ratioFrom = shiftFrom < currentMonthFromTZ ? currentMonthFromTZ : (shiftFrom > currentMonthToTZ ? currentMonthToTZ : shiftFrom);
                        let ratioTo = shiftTo > currentMonthToTZ ? currentMonthToTZ : (shiftTo < currentMonthFromTZ ? currentMonthFromTZ : shiftTo);

                        if (workValue == null || workValue <= -1) {
                            let breakValue = this.CalculateBreakValueForPlanShift(shift, currentMonthFromTZ, currentMonthToTZ)
                            workValue = ((this.CalculateWorktime(shiftFrom, shiftTo, currentMonthFromTZ, currentMonthToTZ, breakValue) / 60) / 1000);

                            let totalBreakValue = this.CalculateBreakValueForPlanShift(shift, shiftFrom, shiftTo)
                            totalWorkValue = Math.max(0, shiftTo.diff(shiftFrom, 'minutes') - totalBreakValue / (60 * 1000));

                        } else {

                            if (ratioFrom.utcOffset() != ratioTo.utcOffset()) {
                                //ratioTo = ratioTo.clone().utcOffset(ratioFrom.utcOffset(), true);
                            }
                            let ratio = ratioTo.diff(ratioFrom) / shiftTo.diff(shiftFrom);

                            workValue = Math.round(workValue * ratio);
                        }

                        workTime += workValue;
                        employeeWorkBalance.workCount +=1;


                        if (currentContract) {
                            //check how much of the shift was worked on a holiday
                            //keep track of holidays in case there's 2 on same day, in that case shift should only be counted once
                            let seenHolidays = [];
                            Object.values(holidayMap).filter(holiday => {
                                let holidayTypes = this.getHolidayTypesForStoreEvent(holiday);
                                let matchingTypes = currentContract.holidayTypes.filter(type => holidayTypes.includes(type));
                                return matchingTypes.length > 0 && shiftFrom < holiday.toMoment && shiftTo > holiday.fromMoment
                            }).forEach(holiday => {
                                let holidayKey = holiday.fromMoment.format("YYYY-MM-DD");

                                let pHolidayFrom = holiday.fromMoment >= currentMonthFromTZ ? holiday.fromMoment : currentMonthFromTZ;
                                let pHolidayTo = holiday.toMoment <= currentMonthToTZ ? holiday.toMoment : currentMonthToTZ;

                                if (!seenHolidays.includes(holidayKey)) {
                                    if(storeSettings.useShiftStartForHolidayTime){
                                        if(shiftFrom >= pHolidayFrom && shiftFrom < pHolidayTo){
                                            holidayTime += this.caclulateHolidayTimeForPlanShift(shiftFrom, shiftTo, shiftFrom, shiftTo, shift, workValue);
                                        }

                                    } else {
                                        holidayTime += this.caclulateHolidayTimeForPlanShift(shiftFrom, shiftTo, pHolidayFrom, pHolidayTo, shift, workValue);
                                    }

                                    seenHolidays.push(holidayKey);
                                }
                                if(pHolidayFrom.format("YYYY-MM-DD") == shiftFrom.format("YYYY-MM-DD")){
                                    employeeWorkBalance.holidayCount +=1;
                                }

                            });
                            //check how much of the shift was worked during the night if night work applies and calculate overtime
                            this.CalculateOvertimeForShift(shiftFrom, totalWorkValue, currentContract, overtimeMap, currentMonthFromTZ.month(), currentMonthFromTZ.year());
                            this.CalculateBonusPaymentSettingValues(bonusPaymentResultMap, shift, shift.fromLocationId, shift.spotId, false, shiftFrom, shiftTo, ratioFrom, ratioTo, employee,
                                currentContract, bonusPaymentSettingsMap, spotMap, actualShiftBreakMap,
                                isUnderage, allowedContractMap, currentMonthToTZ, holidayMap)


                            let overMidnight = false;
                            let nightWorkFrom = this.getMomentFromStringUTC(currentContract.nightWorkFrom, 'HH:mm');
                            let nightWorkTo = this.getMomentFromStringUTC(currentContract.nightWorkTo, 'HH:mm');
                            if (nightWorkTo <= nightWorkFrom) {
                                overMidnight = true;
                            }
                            nightWorkFrom = shiftFrom.clone().hours(nightWorkFrom.hours()).minutes(nightWorkFrom.minutes());
                            nightWorkTo = shiftFrom.clone().hours(nightWorkTo.hours()).minutes(nightWorkTo.minutes());
                            if (nightWorkTo <= nightWorkFrom) {
                                nightWorkTo.add(1, 'days');
                            }

                            if (shiftFrom < currentMonthToTZ) {

                                let nwResult = this.CalculateNightWorkForShift(shift, false, shiftFrom, shiftTo, ratioFrom, ratioTo, nightWorkFrom, nightWorkTo, currentContract, actualShiftBreakMap);

                                employeeWorkBalance.nightWorkCount += nwResult.count;

                                nightWorkTime += nwResult.time;
                                if (overMidnight) {
                                    //nightwork goes over midnight => WE NEED TO CHECK IF THE SHIFT MATCHES WITH NIGHTWORK OF 'PREVIOUS' DAY
                                    let nwfrom = nightWorkFrom.clone().add(-1, 'days');
                                    let nwto = nightWorkTo.clone().add(-1, 'days');
                                    nwResult = this.CalculateNightWorkForShift(shift, false, shiftFrom, shiftTo, ratioFrom, ratioTo, nwfrom, nwto, currentContract, actualShiftBreakMap);

                                    employeeWorkBalance.nightWorkCount += nwResult.count;
                                    nightWorkTime += nwResult.time;
                                }
                                if (shiftTo.date() != shiftFrom.date() && shiftTo < currentMonthToTZ) {
                                    //shift goes over midnight => WE NEED TO CHECK IF SHIFT MATCHES WITH NIGHTWORK OF NEXT DAY
                                    let nwfrom = nightWorkFrom.clone().add(1, 'days');
                                    let nwto = nightWorkTo.clone().add(1, 'days');
                                    nwResult = this.CalculateNightWorkForShift(shift, false, shiftFrom, shiftTo, ratioFrom, ratioTo, nwfrom, nwto, currentContract, actualShiftBreakMap);

                                    employeeWorkBalance.nightWorkCount += nwResult.count;
                                    nightWorkTime += nwResult.time;
                                }
                            }
                        }
                    } else {
                        //still need to calculate overtime for it
                        if (currentContract) {
                            if (workValue == null || workValue <= -1) {
                                let totalBreakValue = this.CalculateBreakValueForPlanShift(shift, shiftFrom, shiftTo)
                                totalWorkValue = Math.max(0, shiftTo.diff(shiftFrom, 'minutes') - totalBreakValue / (60 * 1000));

                            }
                            this.CalculateOvertimeForShift(shiftFrom, totalWorkValue, currentContract, overtimeMap, currentMonthFromTZ.month(), currentMonthFromTZ.year());
                        }
                    }
                    //add it to weekWorkDayMap
                    this.addToWeekWorkDayMap(weekWorkDayMap, shiftFrom, totalWorkValue);



                }
            });
        }

        if (employeeDateActualShiftMap[employeeId] && (workTimeBalanceCreationMode == 1 || workTimeBalanceCreationMode == 2)) {
            let dateStart = currentMonthFrom.clone().startOf('week').subtract(1,'days');
            let dateEnd = currentMonthTo.clone().endOf('week').add(1,'days').startOf('day');
            while (dateEnd.diff(dateStart) > 0) {
                let dateKey = dateStart.format("YYYY-MM-DD");

                let actualShifts = employeeDateActualShiftMap[employeeId][dateKey];
                /*if(actualShifts != null){
                    actualShifts = actualShifts.filter(a => !a.endMissing);
                } */
                if (actualShifts != null && actualShifts.length > 0) {

                    actualShifts.forEach(shift => {

                        let shiftFrom = this.getMomentFromStringTZ(shift.from);
                        let shiftTo = this.getMomentFromStringTZ(shift.to);
                        let totalWorkValue = 0;
                        let currentContract = overlappingContracts.find(contract => {
                            if(shiftFrom >= contractFromToMap[contract.id].from && (contractFromToMap[contract.id].to == null || shiftFrom < contractFromToMap[contract.id].to)){
                                return true;
                            } else {
                                return false;
                            }
                        })
                        if (shiftTo > currentMonthFromTZ && shiftFrom < currentMonthToTZ) {

                            let breakValue = 0;
                            let totalBreakValue = 0;
                            if (actualShiftBreakMap[shift.id] && actualShiftBreakMap[shift.id].length > 0) {
                                let breaks = actualShiftBreakMap[shift.id];
                                breaks.forEach(abreak => {
                                    let check = this.CheckActualBreakFromToInActualShift(abreak, shiftFrom, shiftTo);
                                    if (check.isNonZeroDiff) {
                                        let breakFrom = check.from;
                                        let breakTo = check.to;
                                        let breakRatioFrom = breakFrom < currentMonthFromTZ ? currentMonthFromTZ : (breakFrom > currentMonthToTZ ? currentMonthToTZ : breakFrom);
                                        let breakRatioTo = breakTo > currentMonthToTZ ? currentMonthToTZ : (breakTo < currentMonthFromTZ ? currentMonthFromTZ : breakTo);
                                        if (breakRatioFrom.utcOffset() != breakRatioTo.utcOffset()) {
                                            //breakRatioTo = breakRatioTo.clone().utcOffset(breakRatioFrom.utcOffset(), true);
                                        }
                                        totalBreakValue += Math.max(0, breakTo.diff(breakFrom, 'minutes'));
                                        breakValue += Math.max(0, breakRatioTo.diff(breakRatioFrom, 'minutes'));
                                    }


                                });
                            }


                            let ratioFrom = shiftFrom < currentMonthFromTZ ? currentMonthFromTZ : (shiftFrom > currentMonthToTZ ? currentMonthToTZ : shiftFrom);
                            let ratioTo = shiftTo > currentMonthToTZ ? currentMonthToTZ : (shiftTo < currentMonthFromTZ ? currentMonthFromTZ : shiftTo);
                            if (ratioFrom.utcOffset() != ratioTo.utcOffset()) {
                                //ratioTo = ratioTo.clone().utcOffset(ratioFrom.utcOffset(), true);
                            }
                            let workValue = Math.max(0, ratioTo.diff(ratioFrom, 'minutes') - breakValue);



                            totalWorkValue = Math.max(0, shiftTo.diff(shiftFrom, 'minutes') - totalBreakValue);
                            workTime += workValue;
                            employeeWorkBalance.workCount +=1;


                            if (currentContract) {
                                //check how much of the shift was worked on a holiday
                                //keep track of holidays in case there's 2 on same day, in that case shift should only be counted once
                                let seenHolidays = [];
                                Object.values(holidayMap)
                                    .filter(holiday => {
                                        let holidayTypes = this.getHolidayTypesForStoreEvent(holiday);
                                        let matchingTypes = currentContract.holidayTypes.filter(type => holidayTypes.includes(type));
                                        return matchingTypes.length > 0 && shiftFrom < holiday.toMoment && shiftTo > holiday.fromMoment
                                    }).forEach(holiday => {
                                    let holidayKey = holiday.fromMoment.format("YYYY-MM-DD");
                                    let pHolidayFrom = holiday.fromMoment >= currentMonthFromTZ ? holiday.fromMoment : currentMonthFromTZ;
                                    let pHolidayTo = holiday.toMoment <= currentMonthToTZ ? holiday.toMoment : currentMonthToTZ;
                                    if (!seenHolidays.includes(holidayKey)) {
                                        if(storeSettings.useShiftStartForHolidayTime){
                                            if(shiftFrom >= pHolidayFrom && shiftFrom < pHolidayTo){
                                                holidayTime += this.calculateHolidayTimeForActualShift(shiftFrom, shiftTo, shiftFrom, shiftTo, actualShiftBreakMap, shift)
                                            }
                                        } else {
                                            holidayTime += this.calculateHolidayTimeForActualShift(shiftFrom, shiftTo, pHolidayFrom, pHolidayTo, actualShiftBreakMap, shift)
                                        }
                                        seenHolidays.push(holidayKey);
                                        if(pHolidayFrom.format("YYYY-MM-DD") == shiftFrom.format("YYYY-MM-DD")){
                                            employeeWorkBalance.holidayCount +=1;
                                        }

                                    }
                                });

                                //check how much of the shift was worked during the night if night work applies and calculateOvertime
                                this.CalculateOvertimeForShift(shiftFrom, totalWorkValue, currentContract, overtimeMap, currentMonthFromTZ.month(), currentMonthFromTZ.year());

                                let planShift = employeePlanShiftMap[employeeId] ? (employeePlanShiftMap[employeeId].find(s => s.id == shift.planshiftId)) : null;
                                this.CalculateBonusPaymentSettingValues(bonusPaymentResultMap, shift, planShift ? planShift.fromLocationId : null, planShift ? planShift.spotId : null,
                                    true, shiftFrom, shiftTo, ratioFrom, ratioTo, employee,
                                    currentContract, bonusPaymentSettingsMap, spotMap, actualShiftBreakMap,
                                    isUnderage, allowedContractMap, currentMonthToTZ, holidayMap)

                                let overMidnight = false;
                                let nightWorkFrom = this.getMomentFromStringUTC(currentContract.nightWorkFrom, 'HH:mm');
                                let nightWorkTo = this.getMomentFromStringUTC(currentContract.nightWorkTo, 'HH:mm');
                                if (nightWorkTo <= nightWorkFrom) {
                                    overMidnight = true;
                                }
                                nightWorkFrom = shiftFrom.clone().hours(nightWorkFrom.hours()).minutes(nightWorkFrom.minutes());
                                nightWorkTo = shiftFrom.clone().hours(nightWorkTo.hours()).minutes(nightWorkTo.minutes());
                                if (nightWorkTo <= nightWorkFrom) {
                                    nightWorkTo.add(1, 'days');
                                }

                                if (shiftFrom < currentMonthToTZ && shiftTo > currentMonthFromTZ) {
                                    let nwResult = this.CalculateNightWorkForShift(shift, true, shiftFrom, shiftTo, ratioFrom, ratioTo, nightWorkFrom, nightWorkTo, currentContract, actualShiftBreakMap);
                                    employeeWorkBalance.nightWorkCount += nwResult.count;
                                    nightWorkTime += nwResult.time;
                                    if (overMidnight) {
                                        //nightwork goes over midnight => WE NEED TO CHECK IF THE SHIFT MATCHES WITH NIGHTWORK OF 'PREVIOUS' DAY
                                        let nwfrom = nightWorkFrom.clone().add(-1, 'days');
                                        let nwto = nightWorkTo.clone().add(-1, 'days');

                                        nwResult = this.CalculateNightWorkForShift(shift, true, shiftFrom, shiftTo, ratioFrom, ratioTo, nwfrom, nwto, currentContract, actualShiftBreakMap);
                                        employeeWorkBalance.nightWorkCount += nwResult.count;
                                        nightWorkTime += nwResult.time;
                                    }
                                    if (shiftTo.date() != shiftFrom.date() && shiftTo < currentMonthToTZ) {
                                        //shift goes over midnight => WE NEED TO CHECK IF SHIFT MATCHES WITH NIGHTWORK OF NEXT DAY
                                        let nwfrom = nightWorkFrom.clone().add(1, 'days');
                                        let nwto = nightWorkTo.clone().add(1, 'days');

                                        nwResult = this.CalculateNightWorkForShift(shift, true, shiftFrom, shiftTo, ratioFrom, ratioTo, nwfrom, nwto, currentContract, actualShiftBreakMap);
                                        employeeWorkBalance.nightWorkCount += nwResult.count;
                                        nightWorkTime += nwResult.time;
                                    }
                                }
                            }
                        } else {
                            //still need to calculate overtime for it
                            if (currentContract) {

                                let totalBreakValue = 0;
                                if (actualShiftBreakMap[shift.id] && actualShiftBreakMap[shift.id].length > 0) {
                                    let breaks = actualShiftBreakMap[shift.id];
                                    breaks.forEach(abreak => {
                                        let check = this.CheckActualBreakFromToInActualShift(abreak, shiftFrom, shiftTo);
                                        if (check.isNonZeroDiff) {
                                            let breakFrom = check.from;
                                            let breakTo = check.to;
                                            totalBreakValue += Math.max(0, breakTo.diff(breakFrom, 'minutes'));

                                        }
                                    });
                                }

                                totalWorkValue = Math.max(0, shiftTo.diff(shiftFrom, 'minutes') - totalBreakValue);
                                this.CalculateOvertimeForShift(shiftFrom, totalWorkValue, currentContract, overtimeMap, currentMonthFromTZ.month(), currentMonthFromTZ.year());
                            }
                        }

                        //add it to weekWorkDayMap
                        this.addToWeekWorkDayMap(weekWorkDayMap, shiftFrom, totalWorkValue);

                    });
                }
                dateStart = dateStart.add(1, 'days');
            }
        }



        let vacationTime = 0;
        let vacationWorkTime = 0;
        let nursingVacationTime = 0;
        let nursingVacationWorkTime = 0;
        let sickTime = 0;
        let sickWorkTime = 0;
        let miscTime = 0;
        let holidayAdjustmentTime = 0;
        let holidayAdjustmentWorkTime = 0;
        let educationTime = 0;
        let educationWorkTime = 0;
        let wageContinuationTime = 0;
        let wageContinuationWorkTime = 0;
        let unproductiveWorkTime = 0;
        let miscWorkTime = 0;

        if (employeePreferenceMap[employeeId]) {
            let preferences = employeePreferenceMap[employeeId];
            preferences.filter(pref => pref.approved).forEach(pref => {
                if (pref.state == 1) {
                    let baseWorkValue = pref.workValue;
                    let prefFrom = this.getMomentFromStringTZ(pref.from);
                    let prefTo = this.getMomentFromStringTZ(pref.to);

                    let workValue = 0;
                    let prefStart = prefFrom.clone();

                    let alwaysWork = pref.alwaysWork;

                    while (prefStart < prefTo) {
                        //step through day, and check interval
                        let endOfDay = prefStart.clone().add(1, 'days').startOf('day');
                        let checkEnd = endOfDay < prefTo ? endOfDay : prefTo;

                        if (checkEnd.utcOffset() != prefStart.utcOffset()) {
                            //checkEnd = checkEnd.clone().utcOffset(prefStart.utcOffset(), true);
                        }
                        let currentContract = overlappingContracts.find(contract => {
                            if(prefStart >= contractFromToMap[contract.id].from && (contractFromToMap[contract.id].to == null || prefStart < contractFromToMap[contract.id].to)){
                                return true;
                            } else {
                                return false;
                            }
                        })
                        let workDays = currentContract ? currentContract.workDays : storeSettings.workDays;
                        let dayTimeRegular = currentContract != null ? Math.round((currentContract.weekTimeRegular / currentContract.weekWorkDaysRegular)) : 9 * 60;

                        if (employee.remoteId && employeeAvgWorktimeMap[employee.remoteId] && storeSettings.useAvgWorkTimeForPrefs) {
                            dayTimeRegular = employeeAvgWorktimeMap[employee.remoteId].averageMinutes;
                        }

                        if (checkEnd > currentMonthFromTZ && prefStart < currentMonthToTZ) {
                            let diff = checkEnd.diff(prefStart, 'minutes');

                            let ratioFrom = prefStart < currentMonthFromTZ ? currentMonthFromTZ : (prefStart > currentMonthToTZ ? currentMonthToTZ : prefStart);
                            let ratioTo = checkEnd > currentMonthToTZ ? currentMonthToTZ : (checkEnd < currentMonthFromTZ ? currentMonthFromTZ : checkEnd);
                            if (ratioFrom.utcOffset() != ratioTo.utcOffset()) {
                                //ratioTo = ratioTo.clone().utcOffset(ratioFrom.utcOffset(), true);
                            }

                            let ratio = ratioTo.diff(ratioFrom) / checkEnd.diff(prefStart);


                            let prefTime = Math.round(diff * ratio);
                            if (prefTime > 0) {
                                let isWeekend = !workDays.includes(prefStart.isoWeekday());



                                let tWorkValue = 0;
                                if (baseWorkValue > -1) {
                                    //use preference.workValue instead of preference duration to determine workValue
                                    //first determine the ratio that the current day interval has compared to entire preference length
                                    let workValueRatio = ratioTo.diff(ratioFrom) / prefTo.diff(prefFrom);
                                    tWorkValue = Math.round(baseWorkValue * workValueRatio);
                                } else {
                                    if (prefTime > dayTimeRegular) {
                                        tWorkValue += dayTimeRegular;
                                    } else {
                                        tWorkValue += prefTime;
                                    }
                                }

                                let prefHolidayTime = 0
                                let seenHolidays = [];
                                if(currentContract){
                                    Object.values(holidayMap)
                                        .filter(holiday => {
                                            let holidayTypes = this.getHolidayTypesForStoreEvent(holiday);
                                            let matchingTypes = holidayTypes.filter(type => type == 1 || currentContract.holidayTypes.includes(type));
                                            return matchingTypes.length > 0 && prefStart < holiday.toMoment && checkEnd > holiday.fromMoment
                                        })
                                        .forEach(holiday => {
                                            let holidayKey = holiday.fromMoment.format("YYYY-MM-DD");
                                            if (!seenHolidays.includes(holidayKey)) {
                                                let holidayRatioFrom = prefStart < holiday.fromMoment ? holiday.fromMoment : (prefStart > holiday.toMoment ? holiday.toMoment : prefStart);
                                                let holidayRatioTo = checkEnd > holiday.toMoment ? holiday.toMoment : (checkEnd < holiday.fromMoment ? holiday.fromMoment : checkEnd);
                                                if (holidayRatioFrom.utcOffset() != holidayRatioTo.utcOffset()) {
                                                    //holidayRatioTo = holidayRatioTo.clone().utcOffset(holidayRatioFrom.utcOffset(), true);
                                                }

                                                let holidayRatio = holidayRatioTo.diff(holidayRatioFrom) / checkEnd.diff(prefStart);

                                                prefHolidayTime += Math.round(prefTime * holidayRatio);
                                                seenHolidays.push(holidayKey);
                                                if(pref.countsAsHoliday){
                                                    holidayTime += Math.round(tWorkValue * holidayRatio);
                                                }
                                            }
                                        });
                                }



                                if (pref.type == 1 || pref.type == 2 || pref.type == 3 || pref.type == 6 || pref.type == 7 || pref.type == 8) {
                                    if (!isWeekend || alwaysWork) {
                                        workValue += tWorkValue;
                                        if (pref.type == 1) {
                                            vacationWorkTime += tWorkValue;
                                        }
                                        if (pref.type == 2) {
                                            sickWorkTime += tWorkValue;
                                        }
                                        if (pref.type == 3) {
                                            holidayAdjustmentWorkTime += tWorkValue;
                                        }
                                        if (pref.type == 6) {
                                            nursingVacationWorkTime += tWorkValue;
                                        }
                                        if (pref.type == 7) {
                                            educationWorkTime += tWorkValue;
                                        }
                                        if (pref.type == 8) {
                                            wageContinuationWorkTime += tWorkValue;
                                        }
                                        if (currentContract && pref.type != 3) {
                                            this.CalculateOvertimeForShift(ratioFrom, tWorkValue, currentContract, overtimeMap, currentMonthFromTZ.month(), currentMonthFromTZ.year());
                                        }

                                    }
                                } else if (pref.type == 4 && alwaysWork) {
                                    workValue += tWorkValue;
                                    miscWorkTime += tWorkValue;
                                }
                                if (pref.type == 1) {
                                    if (!isWeekend || alwaysWork) {
                                        if (alwaysWork) {
                                            vacationTime += (prefTime);
                                        } else {
                                            vacationTime += (prefTime - prefHolidayTime);
                                        }


                                    }
                                    employeeWorkBalance.vacationCount +=1;
                                }
                                if (pref.type == 2) {
                                    sickTime += prefTime;
                                    employeeWorkBalance.sickCount +=1;
                                }

                                if (pref.type == 3) {
                                    holidayAdjustmentTime += prefTime;
                                    employeeWorkBalance.holidayAdjustmentCount +=1;
                                }

                                if (pref.type == 4) {
                                    miscTime += prefTime;
                                    employeeWorkBalance.miscCount +=1;
                                }
                                if (pref.type == 6) {
                                    if (!isWeekend || alwaysWork) {
                                        if (alwaysWork) {
                                            nursingVacationTime += (prefTime);
                                        } else {
                                            nursingVacationTime += (prefTime - prefHolidayTime);
                                        }

                                    }
                                    employeeWorkBalance.nursingVacationCount +=1;

                                }
                                if (pref.type == 7) {
                                    educationTime += prefTime;
                                    employeeWorkBalance.educationCount +=1;
                                }
                                if (pref.type == 8) {
                                    wageContinuationTime += prefTime;
                                    employeeWorkBalance.wageContinuationCount +=1;
                                }
                            }
                        } else {
                            //still need to calculate overtime for it
                            if (pref.type == 1 || pref.type == 2 || pref.type == 3 || pref.type == 6 || pref.type == 7 || pref.type == 8) {
                                let isWeekend = !workDays.includes(prefStart.isoWeekday());
                                if (!isWeekend || alwaysWork) {
                                    if (currentContract && pref.type != 3) {
                                        let tWorkValue = 0;
                                        let prefTime = checkEnd.diff(prefStart, 'minutes');
                                        if (baseWorkValue > -1) {
                                            //use preference.workValue instead of preference duration to determine workValue
                                            //first determine the ratio that the current day interval has compared to entire preference length
                                            let workValueRatio = checkEnd.diff(prefStart) / prefTo.diff(prefFrom);
                                            tWorkValue = Math.round(baseWorkValue * workValueRatio);
                                        } else {
                                            if (prefTime > dayTimeRegular) {
                                                tWorkValue += dayTimeRegular;
                                            } else {
                                                tWorkValue += prefTime;
                                            }
                                        }
                                        this.CalculateOvertimeForShift(prefStart, tWorkValue, currentContract, overtimeMap, currentMonthFromTZ.month(), currentMonthFromTZ.year());
                                    }

                                }
                            }

                        }


                        prefStart = prefStart.add(1, 'days').startOf('day');
                    }

                    unproductiveWorkTime += workValue;




                }

            });
        }

        let prevMonthHolidayTimeBalance = 0;

        if (prevMonthBalance) prevMonthHolidayTimeBalance = prevMonthBalance.holidayTimeBalance;


        let currentEwb = Object.values(workBalanceMap).find(e => e.employeeId == employeeWorkBalance.employeeId);
        if(currentEwb){
            currentEwb = Object.assign({}, currentEwb);
        }

        //first calculate balances with  0 paid time

        employeeWorkBalance.paidWorkTime = 0;
        employeeWorkBalance.paidHolidayTime = 0;
        employeeWorkBalance.paidVacationTime = 0;
        employeeWorkBalance.paidMoreTime = 0;
        employeeWorkBalance.paidNightWorkTime = 0;
        employeeWorkBalance.paidOverTime = 0;


        employeeWorkBalance.holidayAdjustmentTime = holidayAdjustmentTime / 60;
        employeeWorkBalance.holidayAdjustmentWorkTime = holidayAdjustmentWorkTime / 60;
        employeeWorkBalance.holidayTime = holidayTime / 60;
        employeeWorkBalance.holidayTimeBalance = (prevMonthHolidayTimeBalance + holidayTime - holidayAdjustmentWorkTime - (employeeWorkBalance.paidHolidayTime * 60)) / 60;

        employeeWorkBalance.workTime = workTime / 60;
        employeeWorkBalance.unproductiveWorkTime = unproductiveWorkTime / 60;
        employeeWorkBalance.prevMonthTime = prevMonthTime / 60;
        employeeWorkBalance.workTimeBalance = ((workTime + unproductiveWorkTime) - (workTimeRegular - prevMonthTime)) / 60 - employeeWorkBalance.paidWorkTime;

        employeeWorkBalance.vacationTime = vacationTime / (24 * 60);
        employeeWorkBalance.vacationWorkTime = vacationWorkTime / 60;
        employeeWorkBalance.sickTime = sickTime / 60;
        employeeWorkBalance.sickWorkTime = sickWorkTime / 60;
        employeeWorkBalance.miscTime = miscTime / 60;
        employeeWorkBalance.educationTime = educationTime / 60;
        employeeWorkBalance.educationWorkTime = educationWorkTime / 60;
        employeeWorkBalance.wageContinuationTime = wageContinuationTime / 60;
        employeeWorkBalance.wageContinuationWorkTime = wageContinuationWorkTime / 60;
        employeeWorkBalance.nursingVacationTime = nursingVacationTime / (24 * 60);
        employeeWorkBalance.nursingVacationWorkTime = nursingVacationWorkTime / 60;
        employeeWorkBalance.miscWorkTime = miscWorkTime / 60;

        employeeWorkBalance.nightWorkTime = nightWorkTime / 60;
        employeeWorkBalance.prevMonthNightWorkTime = prevMonthNightWorkTime / 60;
        employeeWorkBalance.nightWorkTimeBalance = (prevMonthNightWorkTime + nightWorkTime - employeeWorkBalance.paidNightWorkTime * 60) / 60



        if (mainContract) {
            if(storeSettings.enableWorkdayOvertime){
                this.addToOvertimeMap(weekWorkDayMap, overtimeMap, mainContract, allowedContractMap, collectiveContractMap, currentMonthFromTZ, currentMonthToTZ);
            }

            let overtimeResult = this.CalculateOvertimeForMap(overtimeMap, mainContract);

            overTime = overtimeResult.overTime;
            employeeWorkBalance.overTime = overtimeResult.overTime / 60;
            employeeWorkBalance.overTimeCount = overtimeResult.overTimeCount;
            employeeWorkBalance.dailyOverTime = overtimeResult.dailyOverTimeSum / 60;
            employeeWorkBalance.weeklyOverTime = overtimeResult.weeklyOverTimeSum / 60;
            employeeWorkBalance.workDayOverTime = overtimeResult.workDayOverTimeSum / 60;



        }
        if(storeSettings.country == 1 ){
            let prodBal = ((workTime + unproductiveWorkTime) - (workTimeRegular))
            if(prodBal > 0 && workTimeRegular < fullTimeRegular && mainContract && (mainContract.contractType == 2 || mainContract.contractType == 3)){
                let ftBal = ((workTime + unproductiveWorkTime) - (fullTimeRegular))

                moreTime = Math.max(0, prodBal - Math.max(0, ftBal));
                employeeWorkBalance.moreTime = moreTime / 60;

            } else if (prodBal < 0){
                moreTime = prodBal;
                employeeWorkBalance.moreTime = prodBal / 60;
            }

        }


        employeeWorkBalance.prevMonthOverTime = prevMonthOverTime / 60;
        employeeWorkBalance.overTimeBalance = (prevMonthOverTime + overTime - employeeWorkBalance.paidOverTime * 60) / 60;


        //auto equalize moretime balance
        let moreTimeBalance = prevMonthMoreTime + moreTime - employeeWorkBalance.paidMoreTime * 60;


        employeeWorkBalance.prevMonthMoreTime = prevMonthMoreTime / 60;
        employeeWorkBalance.moreTimeBalance = moreTimeBalance / 60;


        let equalizableBonusTime = 0;
        let workTimeFromBonusSetting = 0;
        Object.values(bonusPaymentResultMap).forEach(item => {
            bonusTime += item.time;
            employeeWorkBalance.bonusTimeCount = item.count;
            if(item.equalizeMonthly){
                equalizableBonusTime += item.time;
            }
            if(item.ewbWorkTime && item.ewbWorkTime > 0){
                workTimeFromBonusSetting += item.ewbWorkTime;
            }
        })

        employeeWorkBalance.paidBonusTime = Math.max(employeeWorkBalance.paidBonusTime, equalizableBonusTime/60);

        employeeWorkBalance.bonusTime = bonusTime / 60;
        employeeWorkBalance.prevMonthBonusTime = prevMonthBonusTime / 60;
        employeeWorkBalance.bonusTimeBalance = (prevMonthBonusTime + bonusTime - employeeWorkBalance.paidBonusTime * 60) / 60;

        let vacationTimeBalance = this.CalculateVacationTimeBalance(employee, previousMonthWorkBalanceMap, workBalanceMap, employeeContractMap, nextMonthEmployeeContractMap, currentMonthFromTZ, currentMonthToTZ, currentMonthFrom, storeSettings, allowedContractMap);



        vacationTimeBalance = vacationTimeBalance - vacationTime; // - nursingVacationTime;
        employeeWorkBalance.vacationTimeBalance = vacationTimeBalance / (24 * 60) - employeeWorkBalance.paidVacationTime;

        let periodSetting = this.findAccPeriodSetting(accountingPeriodSettings, contractExitSetting, employee, mainContract, isUnderage, spotMap, useContractExitSetting)
        let skipAccPeriod = disableAccountingPeriodSetting || (mainContract != null && mainContract.accPeriodExclusion);
        let alwaysFullRecalc = !skipAccPeriod && periodSetting != null && (periodSetting.useWorkTimeFactor || periodSetting.useHolidayFactor || periodSetting.overTimeMode != 0);
        let vacationRecalc = !skipAccPeriod && periodSetting != null && (periodSetting.roundUpVacationTime || periodSetting.compensateVacationTime);

        //then check if paid should be kept
        if (!erasePayment && currentEwb && !alwaysFullRecalc) {
            let currentWorkTimeBalance = currentEwb.workTimeBalance;
            let paidWorkTime = currentEwb.paidWorkTime ? currentEwb.paidWorkTime : 0;
            if(paidWorkTime != 0){
                let newWorkTimeBalance = employeeWorkBalance.workTimeBalance * 60;
                let diff = newWorkTimeBalance - currentWorkTimeBalance;

                employeeWorkBalance.paidWorkTime = diff/60;
                employeeWorkBalance.workTimeBalance = employeeWorkBalance.workTimeBalance - diff/60;
            }

            let currentHolidayTimeBalance = currentEwb.holidayTimeBalance;
            let paidHolidayTime = currentEwb.paidHolidayTime ? currentEwb.paidHolidayTime : 0;
            if(paidHolidayTime != 0){
                let newHolidayTimeBalance = employeeWorkBalance.holidayTimeBalance * 60;
                let diff = newHolidayTimeBalance - currentHolidayTimeBalance;

                employeeWorkBalance.paidHolidayTime = diff/60;
                employeeWorkBalance.holidayTimeBalance = employeeWorkBalance.holidayTimeBalance - diff/60;
            }

            let currentMoreTimeBalance = currentEwb.moreTimeBalance;
            let paidMoreTime = currentEwb.paidMoreTime ? currentEwb.paidMoreTime : 0;
            if(paidMoreTime != 0){
                let newMoreTimeBalance = employeeWorkBalance.moreTimeBalance * 60;
                let diff = newMoreTimeBalance - currentMoreTimeBalance;

                employeeWorkBalance.paidMoreTime = diff/60;
                employeeWorkBalance.moreTimeBalance = employeeWorkBalance.moreTimeBalance - diff/60;
            }

            let currentNightWorkTimeBalance = currentEwb.nightWorkTimeBalance;
            let paidNightWorkTime = currentEwb.paidNightWorkTime ? currentEwb.paidNightWorkTime : 0;
            if(paidNightWorkTime != 0){
                let newNightWorkTimeBalance = employeeWorkBalance.nightWorkTimeBalance * 60;
                let diff = newNightWorkTimeBalance - currentNightWorkTimeBalance;

                employeeWorkBalance.paidNightWorkTime = diff/60;
                employeeWorkBalance.nightWorkTimeBalance = employeeWorkBalance.nightWorkTimeBalance - diff/60;
            }

            let currentOverTimeBalance = currentEwb.overTimeBalance;
            let paidOverTime = currentEwb.paidOverTime ? currentEwb.paidOverTime : 0;
            if(paidOverTime != 0){
                let newOverTimeBalance = employeeWorkBalance.overTimeBalance * 60;
                let diff = newOverTimeBalance - currentOverTimeBalance;

                employeeWorkBalance.paidOverTime = diff/60;
                employeeWorkBalance.overTimeBalance = employeeWorkBalance.overTimeBalance - diff/60;
            }

        }

        //separately check to keep changed vacation modification
        if (!erasePayment && currentEwb && !vacationRecalc) {
            let currentVacationTimeBalance = currentEwb.vacationTimeBalance;
            let paidVacationTime = currentEwb.paidVacationTime ? currentEwb.paidVacationTime : 0;
            if(paidVacationTime != 0){
                /*
                let newVacationTimeBalance = employeeWorkBalance.vacationTimeBalance * 24 * 60;
                let diff = newVacationTimeBalance - currentVacationTimeBalance;

                employeeWorkBalance.paidVacationTime = diff/(24*60);
                employeeWorkBalance.vacationTimeBalance = employeeWorkBalance.vacationTimeBalance - diff/(24*60); */
                employeeWorkBalance.paidVacationTime = paidVacationTime /(24*60);
                employeeWorkBalance.vacationTimeBalance = employeeWorkBalance.vacationTimeBalance - paidVacationTime/(24*60);

            }
        }


        if (currentEwb) {

            employeeWorkBalance.autoEqualize = currentEwb.autoEqualize;
            employeeWorkBalance.comment = currentEwb.comment;
        } else {
            let preUsageStartDate = this.getMomentFromStringUTC(storeSettings.usageStartDate).add(-1, 'month');
            if (preUsageStartDate.month() == currentMonthFrom.month() && preUsageStartDate.year() == currentMonthFrom.year()) {
                //autoequalize fist ewb
                employeeWorkBalance.paidWorkTime = ((workTime + unproductiveWorkTime) - (workTimeRegular - prevMonthTime)) / 60;
                employeeWorkBalance.workTimeBalance = 0;
                employeeWorkBalance.paidHolidayTime = (prevMonthHolidayTimeBalance + holidayTime - holidayAdjustmentWorkTime) / 60;
                employeeWorkBalance.holidayTimeBalance = 0;
                employeeWorkBalance.paidOverTime = (prevMonthOverTime + overTime) / 60
                employeeWorkBalance.overTimeBalance = 0;
                employeeWorkBalance.paidONightWorkTime = (prevMonthNightWorkTime + nightWorkTime) / 60
                employeeWorkBalance.nightWorkTimeBalance = 0;
                employeeWorkBalance.paidMoreTime = (prevMonthMoreTime + moreTime) / 60
                employeeWorkBalance.moreTimeBalance = 0;
                employeeWorkBalance.paidBonusTime = (prevMonthBonusTime + bonusTime) / 60
                employeeWorkBalance.bonusTimeBalance = 0;
            }
        }
        //order matters below. first do auto acc period then auto equalize if turned on
        employeeWorkBalance.accountingPeriodBalance = prevMonthAccountingPeriodBalance / 60;
        //first check if store does not keep overtime and holidaytime separate from worktime
        let htBonus = 0;
        let otBonus = 0;
        if(!storeSettings.separateOvertimeHolidayTime){
            //handle holiday compensation
            let htBalance = prevMonthHolidayTimeBalance + holidayTime - holidayAdjustmentWorkTime;
            htBonus = Math.max(0, Math.round(htBalance));

            employeeWorkBalance.workTimeBalance += htBonus / 60
            employeeWorkBalance.holidayTimeBalance = 0;
            employeeWorkBalance.paidHolidayTime = htBalance /60;
            employeeWorkBalance.holidayTimeToWorkTime = htBonus / 60;
            employeeWorkBalance.workTimeMod += htBonus / 60

            //handle overtime compensation
            let otBalance = prevMonthOverTime + overTime
            otBonus = Math.max(0, Math.round(otBalance / 2));

            employeeWorkBalance.workTimeBalance += otBonus / 60
            employeeWorkBalance.overTimeBalance = 0;
            employeeWorkBalance.paidOverTime = otBalance / 60;
            employeeWorkBalance.overTimeToWorkTime = (otBonus*2) / 60;
            employeeWorkBalance.workTimeMod += otBonus / 60
        }
        //also check if there is worktime from bonuspayment settings
        if(workTimeFromBonusSetting > 0){
            employeeWorkBalance.workTimeBalance += (workTimeFromBonusSetting/60.0);
        }

        //secondly apply periodsettings




        if (periodSetting != null && !skipAccPeriod) {
            let multiplier = periodSetting.workTimeFactor;
            let mtMultiplier = periodSetting.moreTimeFactor;
            //wtBalance is worktimebalance without paidWorkTime + overtime/holidaybonus (which is 0 when overtime and holidaytime is separate from worktime s.a.)
            //wtBalance also includes worktime from bonuspaymentsettings

            let wtBalance = ((workTime + unproductiveWorkTime + htBonus + otBonus + workTimeFromBonusSetting) - (workTimeRegular - prevMonthTime));
            let currentMonthWtBalance = ((workTime + unproductiveWorkTime) - workTimeRegular);

            //otBalance is prev month overtime + current overtime

            let otBalance = prevMonthOverTime + overTime

            //htBalance is prev month holidaytime + current holidaytime - holidayAdjustmentWorkTime
            let htBalance = prevMonthHolidayTimeBalance + holidayTime - holidayAdjustmentWorkTime;

            //moreTimeBalance is prev month moreTime + current moreTime
            let mtBalance = prevMonthMoreTime + moreTime;

            //first apply modifiction of worktime balance if worktime factor is used
            let effectiveWorkBalance = wtBalance - prevMonthAccountingPeriodBalance;
            let effectiveMtBalance = Math.max(0, mtBalance);
            if (periodSetting.useWorkTimeFactor && storeSettings.enableWorkBalanceMultiplier) {
                let mtBonus = 0;
                let newEffectiveWorkBalance = effectiveWorkBalance;

                let wtExemption = 0;
                if(mainContract && mainContract.contractType == 1){
                    wtExemption = Math.max(0, periodSetting.contractTypeFactorExemption1);
                } else if(mainContract && mainContract.contractType == 2){
                    wtExemption = Math.max(0, periodSetting.contractTypeFactorExemption2);
                } else if(mainContract && mainContract.contractType == 3){
                    wtExemption = Math.max(0, periodSetting.contractTypeFactorExemption3);
                }


                if(mtMultiplier > 0 && effectiveMtBalance > 0){

                    //how much of moretime should be upgraded
                    if(periodSetting.overTimeMode == 3 || periodSetting.overTimeMode == 2){
                        effectiveMtBalance = Math.min(Math.max(0, effectiveWorkBalance -  otBalance), effectiveMtBalance);
                    }

                    if(effectiveMtBalance > 0){
                        effectiveMtBalance = Math.max(0, effectiveMtBalance - wtExemption);
                        mtBonus = Math.round(effectiveMtBalance * ((mtMultiplier) / 100));
                        //signify that moreTime was applied to worktime balance
                        let remainingEqualize = Math.max(0, mtBalance);
                        mtBalance = 0;
                        employeeWorkBalance.moreTimeBalance = 0;
                        employeeWorkBalance.paidMoreTime = remainingEqualize / 60



                        //reduce effective ewb by more time balance to ensure it is not upgraded twice
                        newEffectiveWorkBalance -= effectiveMtBalance;
                        employeeWorkBalance.workTimeMod += ((newEffectiveWorkBalance + prevMonthAccountingPeriodBalance + mtBonus) - wtBalance)/60;



                    }
                }
                if (newEffectiveWorkBalance >= 0 ) {
                    //do accounting period by multiypling effective work balance ( = workbalance without balance from prev period) => set paidWorkTime to 0

                    let appliedExemption = Math.min(newEffectiveWorkBalance, wtExemption);
                    let afterExemption = Math.max(0, newEffectiveWorkBalance - appliedExemption)
                    newEffectiveWorkBalance = Math.round( afterExemption* (multiplier / 100))

                    newEffectiveWorkBalance += appliedExemption;
                    employeeWorkBalance.paidWorkTime = 0;
                    if(afterExemption > 0){
                        employeeWorkBalance.multiplier = multiplier;
                    }

                }

                wtBalance = newEffectiveWorkBalance + prevMonthAccountingPeriodBalance + mtBonus;
                employeeWorkBalance.workTimeBalance = (newEffectiveWorkBalance + prevMonthAccountingPeriodBalance  + mtBonus) / 60;


            }

            //then handle modification of worktime balance through overtime application
            if(storeSettings.separateOvertimeHolidayTime){
                if(periodSetting.overTimeMode == 3){
                    if(wtBalance >= 0){
                        let bonus150 = Math.min(wtBalance, otBalance);
                        let bonus50 = Math.max(0, otBalance - bonus150);
                        //wtBalance -= bonus150;

                        employeeWorkBalance.workTimeBalance -= bonus150 / 60;
                        employeeWorkBalance.overTimeBalance = 0;
                        employeeWorkBalance.paidOverTime = otBalance / 60;

                        //employeeWorkBalance.workTimeMod += bonus150 / 60;
                        employeeWorkBalance.paidWorkTime = bonus150/60;

                        //if more time balance is positive, reduce it too
                        if(mtBalance > 0){
                            let mtBonus = Math.min(mtBalance, bonus150);
                            mtBalance -= mtBonus
                            employeeWorkBalance.moreTimeBalance -= mtBonus / 60;
                            employeeWorkBalance.moreTimeMod = (-1*mtBonus) / 60;
                        }

                        //console.log("ÜS Bonus 150%: "+(bonus150/60))
                        //console.log("ÜS Bonus 50%: "+(bonus50/60))
                    } else {
                        let bonusEq = Math.min(wtBalance * -1, otBalance/2);
                        let bonus50 = Math.max(0, otBalance - (bonusEq*2));
                        wtBalance += bonusEq;
                        employeeWorkBalance.workTimeBalance += bonusEq / 60;
                        employeeWorkBalance.overTimeBalance = 0;
                        employeeWorkBalance.paidOverTime = otBalance / 60;


                        employeeWorkBalance.overTimeToWorkTime = (bonusEq*2) / 60;
                        employeeWorkBalance.workTimeMod += bonusEq / 60;

                        if(mtBalance < 0){
                            let mtBonus = Math.min(mtBalance * -1, bonusEq);

                            mtBalance += mtBonus;
                            employeeWorkBalance.moreTimeBalance += mtBonus / 60;
                            employeeWorkBalance.moreTimeMod = (mtBonus) / 60;
                        }

                        //console.log("ÜS Ausgleich: "+((bonusEq*2)/60))
                        //console.log("ÜS Bonus 50%: "+(bonus50/60))
                    }
                } else if (periodSetting.overTimeMode == 2) {
                    let wtCheckBalance = periodSetting.useWorkTimeFactor ? effectiveWorkBalance : wtBalance;
                    if ((periodSetting.useOvertimeFactorForPositive && wtCheckBalance >= 0) || (periodSetting.useOvertimeFactorForNegative && wtCheckBalance <= 0)) {
                        let otBonus = 0;
                        if(periodSetting.useDeltaOvertimeFactor){
                            //only apply delta ot bonus
                            otBonus = Math.max(0, Math.round((otBalance - Math.max(0, wtCheckBalance))/2));
                        } else {
                            otBonus = Math.max(0, Math.round(otBalance / 2));
                        }


                        wtBalance += otBonus
                        employeeWorkBalance.workTimeBalance += otBonus / 60
                        employeeWorkBalance.overTimeBalance = 0;
                        employeeWorkBalance.paidOverTime = otBalance / 60;

                        employeeWorkBalance.overTimeToWorkTime = (otBonus*2) / 60
                        employeeWorkBalance.workTimeMod += otBonus / 60;

                    }
                }
            }

            //then handle modification of worktime balance through holidaytime application
            if(storeSettings.separateOvertimeHolidayTime){
                if (periodSetting.useHolidayFactor) {
                    if (((periodSetting.useHolidayFactorForPositive && wtBalance >= 0) || (periodSetting.useHolidayFactorForNegative && wtBalance <= 0)) && htBalance >= 0) {
                        let htBonus = Math.max(0, Math.round(htBalance));

                        wtBalance += htBonus
                        employeeWorkBalance.workTimeBalance += htBonus / 60
                        employeeWorkBalance.holidayTimeBalance = 0;
                        employeeWorkBalance.paidHolidayTime = htBalance /60;

                        employeeWorkBalance.holidayTimeToWorkTime = htBonus / 60
                        employeeWorkBalance.workTimeMod += htBonus / 60;

                    }
                }
            }

            //auto equalize worktime if worktime factor is not used
            if(!periodSetting.useWorkTimeFactor) {
                if ((periodSetting.compensatePositiveWorkTime && wtBalance >= 0) || (periodSetting.compensateNegativeWorkTime && wtBalance <= 0)) {
                    //auto equalize worktime
                    employeeWorkBalance.paidWorkTime = wtBalance / 60;
                    employeeWorkBalance.workTimeBalance = 0;
                }

            }
            //handle holiday compensation
            if(storeSettings.separateOvertimeHolidayTime){
                if (!periodSetting.useHolidayFactor) {
                    if ((periodSetting.compensatePositiveHolidays && htBalance >= 0) || (periodSetting.compensateNegativeHolidays && htBalance <= 0)) {
                        //equalize holiday balance
                        employeeWorkBalance.paidHolidayTime = htBalance / 60;
                        employeeWorkBalance.holidayTimeBalance = 0;
                    }
                }
            }


            //handle nightwork time compensation
            if (periodSetting.compensateNightWorkTime) {
                //equalize nightworktime
                employeeWorkBalance.paidNightWorkTime = (prevMonthNightWorkTime + nightWorkTime) / 60
                employeeWorkBalance.nightWorkTimeBalance = 0;
            }




            //handle more time compensation
            if (periodSetting.compensateMoreTime) {
                //equalize moretime
                let remainingEqualize = Math.max(0, mtBalance);
                employeeWorkBalance.paidMoreTime = remainingEqualize / 60
                employeeWorkBalance.moreTimeBalance = 0;
            }

            //handle overtime compensation
            if(storeSettings.separateOvertimeHolidayTime){
                if (periodSetting.overTimeMode == 1) {
                    //equalize overtime
                    employeeWorkBalance.paidOverTime = otBalance / 60
                    employeeWorkBalance.overTimeBalance = 0;
                    if (periodSetting.compensateWorkTimeWithOvertime && periodSetting.compensateNegativeWorkTimeWithOvertime && overTime > 0) {
                        let currentCompensation = employeeWorkBalance.paidWorkTime * 60;
                        let maxCompensation = Math.max(employeeWorkBalance.paidWorkTime *60, overTime);

                        let compensationDiff = maxCompensation - currentCompensation;

                        if (compensationDiff > 0) {
                            employeeWorkBalance.paidWorkTime += compensationDiff / 60;
                            employeeWorkBalance.workTimeBalance -= compensationDiff / 60;
                        }

                    } else if(periodSetting.compensateNegativeWorkTimeWithOvertime && overTime > 0 && currentMonthWtBalance <= 0){
                        let currentCompensation = employeeWorkBalance.paidWorkTime * 60;
                        let maxCompensation = Math.max(employeeWorkBalance.paidWorkTime *60, overTime);

                        let compensationDiff = maxCompensation - currentCompensation;

                        if (compensationDiff > 0) {
                            employeeWorkBalance.paidWorkTime += compensationDiff / 60;
                            employeeWorkBalance.workTimeBalance -= compensationDiff / 60;
                        }
                    } else if (periodSetting.compensateWorkTimeWithOvertime && overTime > 0 && currentMonthWtBalance > 0) {
                        let currentCompensation = employeeWorkBalance.paidWorkTime * 60;
                        let maxCompensation = Math.min(currentMonthWtBalance, overTime);

                        let compensationDiff = maxCompensation - currentCompensation;
                        if (compensationDiff > 0) {
                            employeeWorkBalance.paidWorkTime += compensationDiff / 60;
                            employeeWorkBalance.workTimeBalance -= compensationDiff / 60;
                        }

                    }
                }
            }

            //handle bonus time compensation
            if (periodSetting.compensateBonusTime) {
                //equalize bonustime
                employeeWorkBalance.paidBonusTime = (prevMonthBonusTime + bonusTime) / 60
                employeeWorkBalance.bonusTimeBalance = 0;
            }

            //after all boni are applied from workTimeFactor multiplier, check again if negative balance should be equalized
            if (periodSetting.useWorkTimeFactor && employeeWorkBalance.workTimeBalance < 0 && periodSetting.compensateNegativeWorkTime) {
                employeeWorkBalance.paidWorkTime = employeeWorkBalance.workTimeBalance;
                employeeWorkBalance.workTimeBalance = 0;
            }
            if(periodSetting.endsAccountingPeriod){
                employeeWorkBalance.accountingPeriodBalance = employeeWorkBalance.workTimeBalance;
            }

            //check vaction settings from contract exit
            if(periodSetting.roundUpVacationTime){
                let unmodifiedVacationTimeBalance = employeeWorkBalance.vacationTimeBalance + employeeWorkBalance.paidVacationTime;
                unmodifiedVacationTimeBalance = Math.ceil(unmodifiedVacationTimeBalance)
                employeeWorkBalance.vacationTimeBalance = unmodifiedVacationTimeBalance - employeeWorkBalance.paidVacationTime;

            }
            if(periodSetting.compensateVacationTime){
                let unmodifiedVacationTimeBalance = employeeWorkBalance.vacationTimeBalance + employeeWorkBalance.paidVacationTime;
                employeeWorkBalance.vacationTimeBalance = 0;
                employeeWorkBalance.paidVacationTime = unmodifiedVacationTimeBalance;
            }

            employeeWorkBalance.appliedAccountingPeriod = periodSetting.endsAccountingPeriod;

        } else if (employeeWorkBalance.autoEqualize) {
            employeeWorkBalance.paidWorkTime = ((workTime + unproductiveWorkTime + htBonus + otBonus + workTimeFromBonusSetting) - (workTimeRegular - prevMonthTime)) / 60;
            employeeWorkBalance.workTimeBalance = 0;
            employeeWorkBalance.paidHolidayTime = (prevMonthHolidayTimeBalance + holidayTime - holidayAdjustmentWorkTime) / 60;
            employeeWorkBalance.holidayTimeBalance = 0;
            employeeWorkBalance.paidOverTime = (prevMonthOverTime + overTime) / 60
            employeeWorkBalance.overTimeBalance = 0;
            employeeWorkBalance.paidONightWorkTime = (prevMonthNightWorkTime + nightWorkTime) / 60
            employeeWorkBalance.nightWorkTimeBalance = 0;
            employeeWorkBalance.paidMoreTime = (prevMonthMoreTime + moreTime) / 60
            employeeWorkBalance.moreTimeBalance = 0;
            employeeWorkBalance.paidBonusTime = (prevMonthBonusTime + bonusTime) / 60
            employeeWorkBalance.bonusTimeBalance = 0;

        }

        return employeeWorkBalance;

    }

    calculateHolidayTimeForActualShift(shiftFrom, shiftTo, pHolidayFrom, pHolidayTo, actualShiftBreakMap, shift) {
        let holidayFrom = shiftFrom < pHolidayFrom ? pHolidayFrom : (shiftFrom > pHolidayTo ? pHolidayTo : shiftFrom);
        let holidayTo = shiftTo > pHolidayTo ? pHolidayTo : (shiftTo < pHolidayFrom ? pHolidayFrom : shiftTo);

        let shiftHolidayTime = Math.max(0, holidayTo.diff(holidayFrom, 'minutes'));
        if (actualShiftBreakMap[shift.id] && actualShiftBreakMap[shift.id].length > 0) {
            let breaks = actualShiftBreakMap[shift.id];
            breaks.forEach(abreak => {
                let check = this.CheckActualBreakFromToInActualShift(abreak, shiftFrom, shiftTo);
                if (check.isNonZeroDiff) {
                    let breakFrom = check.from;
                    let breakTo = check.to;
                    if (breakFrom < pHolidayTo && breakTo > pHolidayFrom) {
                        let holidayBreakFrom = breakFrom < pHolidayFrom ? pHolidayFrom : (breakFrom > pHolidayTo ? pHolidayTo : breakFrom);
                        let holidayBreakTo = breakTo > pHolidayTo ? pHolidayTo : (breakTo < pHolidayFrom ? pHolidayFrom : breakTo);

                        shiftHolidayTime -= Math.max(0, holidayBreakTo.diff(holidayBreakFrom, 'minutes'));
                    }
                }


            });
        }
        return shiftHolidayTime;
    }

    caclulateHolidayTimeForPlanShift(shiftFrom, shiftTo, pHolidayFrom, pHolidayTo, shift, workValue) {
        let holidayTime = 0;
        if (!shift.workValue || shift.workValue == -1) {
            let holidayBreakValue = this.CalculateBreakValueForPlanShift(shift, pHolidayFrom, pHolidayTo);
            let holidayWorkValue = ((this.CalculateWorktime(shiftFrom, shiftTo, pHolidayFrom, pHolidayTo, holidayBreakValue) / 60) / 1000);
            holidayTime += Math.round(holidayWorkValue);

        } else {
            let holidayRatioFrom = shiftFrom < pHolidayFrom ? pHolidayFrom : shiftFrom;
            let holidayRatioTo = shiftTo > pHolidayTo ? pHolidayTo : shiftTo;

            let holidayRatio = holidayRatioTo.diff(holidayRatioFrom) / shiftTo.diff(shiftFrom);
            holidayTime += Math.round(workValue * holidayRatio);
        }
        return holidayTime;
    }

    findAccPeriodSetting(accountingPeriodSettings, contractExitSetting, employee, mainContract, isUnderage, spotMap, useContractExitSetting) {
        let periodSetting = null;
        let periodSettingCandidates = [];

        if (accountingPeriodSettings != null && accountingPeriodSettings.length > 0) {
            accountingPeriodSettings.forEach(ps => {
                let applySettings = false;

                if(ps.employeeFlag && ps.employees != null && ps.employees.includes(employee.id)){
                    applySettings = true;
                } else {
                    let contractTypeFlag = false;
                    let useContractTypeFlag = (ps.useContractTypes && ps.contractTypes && ps.contractTypes.length > 0) || !ps.useContractTypes;
                    let employeeCategoryFlag = false;
                    let useEmployeeCategoryFlag = ps.employeeCategories && ps.employeeCategories.length > 0;
                    let employeeLevelFlag = false;
                    let useEmployeeLevelFlag =   ps.employeeLevels && ps.employeeLevels.length > 0;
                    let employmentTypeFlag = false;
                    let useEmploymentTypeFlag = ps.employmentTypes && ps.employmentTypes.length > 0;

                    if (ps.useContractTypes) {
                        if (mainContract && ps.contractTypes.includes(mainContract.contractType)) {
                            contractTypeFlag = true;
                        }
                    } else {
                        if (mainContract &&
                            ps.minWeekTimeRegular != null &&
                            ps.maxWeekTimeRegular != null &&
                            ps.minWeekTimeRegular <= mainContract.weekTimeRegular &&
                            mainContract.weekTimeRegular <= ps.maxWeekTimeRegular) {
                            contractTypeFlag = true;
                        }
                    }

                    if (mainContract && ps.employeeCategories && ps.employeeCategories.includes(mainContract.employeeCategory)) {
                        employeeCategoryFlag = true;
                    }

                    let employeeLevel = spotMap[employee.spotId] ? spotMap[employee.spotId].employeeLevel : null;
                    if (employeeLevel && ps.employeeLevels && ps.employeeLevels.includes(employeeLevel)) {
                        employeeLevelFlag = true;
                    }

                    if(mainContract && ps.employmentTypes && ps.employmentTypes.includes(mainContract.employmentType)){
                        employmentTypeFlag = true;
                    }
                    //check whether to use logical and or logical OR for application check
                    if(ps.conditionJoin && (useContractTypeFlag || useEmployeeCategoryFlag || useEmployeeLevelFlag || useEmploymentTypeFlag)){
                        let flag = true;
                        if(useContractTypeFlag){
                            flag = flag && contractTypeFlag;
                        }
                        if(useEmployeeCategoryFlag){
                            flag = flag && employeeCategoryFlag;
                        }
                        if(useEmployeeLevelFlag){
                            flag = flag && employeeLevelFlag;
                        }
                        if(useEmploymentTypeFlag){
                            flag = flag && employmentTypeFlag;
                        }
                        applySettings = flag;
                    } else {
                        applySettings = contractTypeFlag || employeeCategoryFlag || employeeLevelFlag || employmentTypeFlag;
                    }

                    if(ps.applyToUnderage != null && (ps.applyToUnderage == false && isUnderage)){
                        applySettings = false;
                    }
                }

                if(applySettings || (mainContract != null && mainContract.accPeriodPriority != null && mainContract.accPeriodPriority == ps.priority)){
                    periodSettingCandidates.push(ps);
                }
            })

        }


        if(periodSettingCandidates.length > 0){
            if(mainContract != null && mainContract.accPeriodPriority != null){
                periodSetting = periodSettingCandidates.find(ps => ps.priority == mainContract.accPeriodPriority);

            } else {
                periodSetting = periodSettingCandidates.reduce((prev, current) => prev.priority < current.priority ? prev : current, periodSettingCandidates[0])
            }

        }


        if (useContractExitSetting && contractExitSetting != null) {
            periodSetting = contractExitSetting;

        }
        return periodSetting;
    }

    addToWeekWorkDayMap(weekWorkDayMap, shiftFrom, totalWorkValue){
        let isoWeekKey = shiftFrom.clone().endOf('week').format("DD-MM-YYYY");
        let dayKey = shiftFrom.isoWeekday();
        if(weekWorkDayMap[isoWeekKey] == null){
            weekWorkDayMap[isoWeekKey] = {};
        }
        let weekEntry = weekWorkDayMap[isoWeekKey];
        if(weekEntry[''+dayKey] == null){
            weekEntry[''+dayKey] = {index: dayKey, day: shiftFrom.clone().startOf('day'), workValue: 0}
        }
        weekEntry[''+dayKey].workValue += totalWorkValue;
    }

    addToOvertimeMap(weekWorkDayMap, overtimeMap, mainContract, allowedContractMap, collectiveContractMap, currentMonthFromTZ, currentMonthToTZ){
        let weekWorkDaysRegular = mainContract.weekWorkDaysRegular;
        if(mainContract.collectiveContractId && allowedContractMap[mainContract.collectiveContractId]){
            let ccId = allowedContractMap[mainContract.collectiveContractId].collectiveContractId;
            if(ccId && collectiveContractMap[ccId]){
                weekWorkDaysRegular = collectiveContractMap[ccId].weekWorkDaysRegular;
            }
        }
        Object.keys(weekWorkDayMap).forEach(weekKey => {
            let overtimeEntry = overtimeMap[weekKey];
            if(overtimeEntry != null){
                let week = weekWorkDayMap[weekKey];
                let weekEntries = Object.values(week).sort((a, b) => a.index - b.index);
                for(let i = 0; i < weekEntries.length; i++){
                    if(i+1 > weekWorkDaysRegular){
                        let entry = weekEntries[i];
                        let dayKey = entry.day.format("DD-MM-YYYY");
                        let dailyOverTime = overtimeEntry.dayMap[dayKey] ? overtimeEntry.dayMap[dayKey].dailyOverTime: 0;
                        let nimDailyOverTime = overtimeEntry.dayMap[dayKey] ? overtimeEntry.dayMap[dayKey].nimDailyOverTime: 0;

                        //Don't count daily overtime twice => subtract it from workDayOvertime
                        if(entry.day >= currentMonthFromTZ && entry.day < currentMonthToTZ){
                            overtimeEntry.workDayOvertimeSum += Math.max(0, entry.workValue - dailyOverTime);

                        } else {
                            overtimeEntry.nimWorkDayOvertimeSum += Math.max(0, entry.workValue - nimDailyOverTime);
                        }
                    }
                }
            }

        })


    }

    getRatiodWorkValue(limitDateFrom, limitDateTo, shiftFrom, shiftTo, totalWorkValue) {

        let ratioFrom = shiftFrom < limitDateFrom ? limitDateFrom : (shiftFrom > limitDateTo ? limitDateTo : shiftFrom);
        let ratioTo = shiftTo > limitDateTo ? limitDateTo : (shiftTo < limitDateFrom ? limitDateFrom : shiftTo);
        let ratio = ratioTo.diff(ratioFrom) / shiftTo.diff(shiftFrom);
        return Math.round(totalWorkValue * ratio);
    }

    calculateWeekEndWorkValue(currentMonthFromTZ, currentMonthToTZ, shiftFrom, shiftTo, totalWorkValue) {
        let ratioFrom = shiftFrom < currentMonthFromTZ ? currentMonthFromTZ : (shiftFrom > currentMonthToTZ ? currentMonthToTZ : shiftFrom);
        let ratioTo = shiftTo > currentMonthToTZ ? currentMonthToTZ : (shiftTo < currentMonthFromTZ ? currentMonthFromTZ : shiftTo);
        let rwv = this.getRatiodWorkValue(currentMonthFromTZ, currentMonthToTZ, shiftFrom, shiftTo, totalWorkValue);

        let weekendWorkTime = 0;
        if (shiftFrom.isoWeekday() == 5) {
            //shift starts on friday, check if it overlaps with saturday
            let dayFrom = shiftFrom.clone().add(1, 'days').startOf('day');
            let dayTo = dayFrom.clone().add(1, 'days');
            weekendWorkTime += this.getRatiodWorkValue(dayFrom, dayTo, ratioFrom, ratioTo, rwv);
        } else if (shiftFrom.isoWeekday() == 6 || shiftFrom.isoWeekday() == 7) {
            //shift starts on saturday or sunday
            let dayFrom = shiftFrom.clone().startOf('day');
            let dayTo = dayFrom.clone().add(1, 'days');
            weekendWorkTime += this.getRatiodWorkValue(dayFrom, dayTo, ratioFrom, ratioTo, rwv);
            //shift starts on saturday, check sunday too
            if (shiftFrom.isoWeekday() == 6) {
                dayFrom = shiftFrom.clone().add(1, 'days').startOf('day');
                dayTo = dayFrom.clone().add(1, 'days');
                weekendWorkTime += this.getRatiodWorkValue(dayFrom, dayTo, ratioFrom, ratioTo, rwv);
            }

        }
        return weekendWorkTime;
    }

    calculateSundayWorkValue(currentMonthFromTZ, currentMonthToTZ, shiftFrom, shiftTo, totalWorkValue) {
        let ratioFrom = shiftFrom < currentMonthFromTZ ? currentMonthFromTZ : (shiftFrom > currentMonthToTZ ? currentMonthToTZ : shiftFrom);
        let ratioTo = shiftTo > currentMonthToTZ ? currentMonthToTZ : (shiftTo < currentMonthFromTZ ? currentMonthFromTZ : shiftTo);
        let rwv = this.getRatiodWorkValue(currentMonthFromTZ, currentMonthToTZ, shiftFrom, shiftTo, totalWorkValue);

        let weekendWorkTime = 0;
        if (shiftFrom.isoWeekday() == 6) {
            //shift starts on saturday, check if it overlaps with saturday
            let dayFrom = shiftFrom.clone().add(1, 'days').startOf('day');
            let dayTo = dayFrom.clone().add(1, 'days');
            weekendWorkTime += this.getRatiodWorkValue(dayFrom, dayTo, ratioFrom, ratioTo, rwv);
        } else if (shiftFrom.isoWeekday() == 7) {
            //shift starts on sunday
            let dayFrom = shiftFrom.clone().startOf('day');
            let dayTo = dayFrom.clone().add(1, 'days');
            weekendWorkTime += this.getRatiodWorkValue(dayFrom, dayTo, ratioFrom, ratioTo, rwv);


        }
        return weekendWorkTime;
    }

    calculateRegularBonusPayments(employeeId, employeeContractMap, allowedContractMap, collectiveContractMap,
                                  employeePlanShiftMap, employeeDateActualShiftMap, employeeDateActualShiftMarkedMap, actualShiftBreakMap,
                                  currentMonthFrom, currentMonthTo, currentMonthFromTZ, currentMonthToTZ, storeSettings, mode = 1) {

        let bonusStats = {
            employeeId: employeeId,
            year: currentMonthFrom.year(),
            month: currentMonthFrom.month() + 1,

            nightWorkTime: 0,
            nightWorkCount: 0,
            nightWorkTimePayment: 0,
            nightWorkCountPayment: 0,
            overTime: 0,
            overTimePayment: 0,
            overTimeCount: 0,
            overTimeCountPayment: 0,
            moreTime: 0,
            moreTimePayment: 0,
            moreTimeCount: 0,
            moreTimeCountPayment: 0,

            weekendWorkTime: 0,
            weekendWorkCount: 0,
            sundayWorkTime: 0,
            sundayWorkCount: 0,

        };

        let mainContract = null;
        let overlappingContracts = [];
        let contractFromToMap =  {};
        if (employeeContractMap[employeeId]) {
            let contracts = employeeContractMap[employeeId];


            overlappingContracts = this.GetContractsOverlappingMonth(contracts, currentMonthFromTZ.clone().startOf('week').subtract(1,'days'), currentMonthToTZ);
            overlappingContracts.forEach(contract => {

                let contractFrom = this.getMomentFromStringTZ(contract.from);
                let contractTo = contract.to ? this.getMomentFromStringTZ(contract.to).add(-1, 'minutes') : null; //subtract 1 minute so when contract ends at end of month (= beginnining of next month) we are still in current month
                contractFromToMap[contract.id] = {from: contractFrom, to: contractTo};
                if (!mainContract) {
                    mainContract = contract;
                } else {
                    let mainContractFrom = this.getMomentFromStringTZ(mainContract.from);
                    if (contractFrom > mainContractFrom) {
                        mainContract = contract;
                    }
                }
            });


        }


        let nightWorkTime = 0;
        let overtimeMap = {};
        let weekWorkDayMap = {};
        if (employeePlanShiftMap[employeeId] && (mode == 1 || mode == 3)) {
            let planShifts = employeePlanShiftMap[employeeId];
            planShifts.forEach(shift => {
                let workValue = shift.workValue;
                let totalWorkValue = shift.workValue;
                let shiftFrom = this.getMomentFromStringTZ(shift.from);
                let shiftTo = this.getMomentFromStringTZ(shift.to);
                let currentContract = overlappingContracts.find(contract => {
                    if(shiftFrom >= contractFromToMap[contract.id].from && (contractFromToMap[contract.id].to == null || shiftFrom < contractFromToMap[contract.id].to)){
                        return true;
                    } else {
                        return false;
                    }
                })

                let dateKey = shiftFrom.format("YYYY-MM-DD");
                let actualShiftMarked = employeeDateActualShiftMarkedMap[employeeId] && employeeDateActualShiftMarkedMap[employeeId][dateKey];
                let hasActualShifts = employeeDateActualShiftMap[employeeId] && employeeDateActualShiftMap[employeeId][dateKey] && employeeDateActualShiftMap[employeeId][dateKey].length > 0;
                if ((!(hasActualShifts || actualShiftMarked)) && shiftTo > currentMonthFromTZ && shiftFrom < currentMonthToTZ) {
                    if(shiftTo > currentMonthFromTZ && shiftFrom < currentMonthToTZ){
                        let ratioFrom = shiftFrom < currentMonthFromTZ ? currentMonthFromTZ : (shiftFrom > currentMonthToTZ ? currentMonthToTZ : shiftFrom);
                        let ratioTo = shiftTo > currentMonthToTZ ? currentMonthToTZ : (shiftTo < currentMonthFromTZ ? currentMonthFromTZ : shiftTo);

                        if (workValue == null || workValue <= -1) {
                            let breakValue = this.CalculateBreakValueForPlanShift(shift, currentMonthFromTZ, currentMonthToTZ)
                            workValue = ((this.CalculateWorktime(shiftFrom, shiftTo, currentMonthFromTZ, currentMonthToTZ, breakValue) / 60) / 1000);
                            totalWorkValue = Math.max(0, shiftTo.diff(shiftFrom, 'minutes') - breakValue / (60 * 1000));
                        } else {

                            if (ratioFrom.utcOffset() != ratioTo.utcOffset()) {
                                //ratioTo = ratioTo.clone().utcOffset(ratioFrom.utcOffset(), true);
                            }
                            let ratio = ratioTo.diff(ratioFrom) / shiftTo.diff(shiftFrom);

                            workValue = Math.round(workValue * ratio);
                        }

                        //check how much time was worked on weekend
                        let weekendWorkTime = this.calculateWeekEndWorkValue(currentMonthFromTZ, currentMonthToTZ, shiftFrom, shiftTo, totalWorkValue);
                        if (weekendWorkTime > 0) {
                            bonusStats.weekendWorkCount += 1;
                            bonusStats.weekendWorkTime += weekendWorkTime;
                        }
                        let sundayWorkTime = this.calculateSundayWorkValue(currentMonthFromTZ, currentMonthToTZ, shiftFrom, shiftTo, totalWorkValue);
                        if (sundayWorkTime > 0) {
                            bonusStats.sundayWorkCount += 1;
                            bonusStats.sundayWorkTime += sundayWorkTime;
                        }


                        //check how much of the shift was worked during the night if night work applies and calculate overtime
                        if (currentContract) {
                            this.CalculateOvertimeForShift(shiftFrom, totalWorkValue, currentContract, overtimeMap, currentMonthFromTZ.month(), currentMonthFromTZ.year());
                            let nwOverMidnight = false;
                            let nightWorkFrom = this.getMomentFromStringUTC(currentContract.nightWorkFrom, 'HH:mm');
                            let nightWorkTo = this.getMomentFromStringUTC(currentContract.nightWorkTo, 'HH:mm');
                            if (nightWorkTo <= nightWorkFrom) {
                                nwOverMidnight = true;
                            }
                            nightWorkFrom = shiftFrom.clone().hours(nightWorkFrom.hours()).minutes(nightWorkFrom.minutes());
                            nightWorkTo = shiftFrom.clone().hours(nightWorkTo.hours()).minutes(nightWorkTo.minutes());
                            if (nightWorkTo <= nightWorkFrom) {
                                nightWorkTo.add(1, 'days');
                            }

                            if (shiftFrom < currentMonthToTZ && shiftTo > currentMonthFromTZ) {

                                let nwResult = this.CalculateNightWorkForShift(shift, false, shiftFrom, shiftTo, ratioFrom, ratioTo, nightWorkFrom, nightWorkTo, currentContract, actualShiftBreakMap);

                                bonusStats.nightWorkCount += nwResult.count;
                                bonusStats.nightWorkCountPayment += nwResult.countBonus;
                                bonusStats.nightWorkTimePayment += nwResult.timeBonus;
                                nightWorkTime += nwResult.time;
                                if (nwOverMidnight) {
                                    //nightwork goes over midnight => WE NEED TO CHECK IF THE SHIFT MATCHES WITH NIGHTWORK OF 'PREVIOUS' DAY
                                    let nwfrom = nightWorkFrom.clone().add(-1, 'days');
                                    let nwto = nightWorkTo.clone().add(-1, 'days');
                                    nwResult = this.CalculateNightWorkForShift(shift, false, shiftFrom, shiftTo, ratioFrom, ratioTo, nwfrom, nwto, currentContract, actualShiftBreakMap);

                                    bonusStats.nightWorkCount += nwResult.count;
                                    bonusStats.nightWorkCountPayment += nwResult.countBonus;
                                    bonusStats.nightWorkTimePayment += nwResult.timeBonus;
                                    nightWorkTime += nwResult.time;
                                }
                                if (shiftTo.date() != shiftFrom.date() && shiftTo < currentMonthToTZ) {
                                    //shift goes over midnight => WE NEED TO CHECK IF SHIFT MATCHES WITH NIGHTWORK OF NEXT DAY
                                    let nwfrom = nightWorkFrom.clone().add(1, 'days');
                                    let nwto = nightWorkTo.clone().add(1, 'days');
                                    nwResult = this.CalculateNightWorkForShift(shift, false, shiftFrom, shiftTo, ratioFrom, ratioTo, nwfrom, nwto, currentContract, actualShiftBreakMap);

                                    bonusStats.nightWorkCount += nwResult.count;
                                    bonusStats.nightWorkCountPayment += nwResult.countBonus;
                                    bonusStats.nightWorkTimePayment += nwResult.timeBonus;
                                    nightWorkTime += nwResult.time;
                                }

                            }
                        }
                    }    else {
                        //still need to calculate overtime for it
                        if (currentContract) {
                            if (workValue == null || workValue <= -1) {
                                let totalBreakValue = this.CalculateBreakValueForPlanShift(shift, shiftFrom, shiftTo)
                                totalWorkValue = Math.max(0, shiftTo.diff(shiftFrom, 'minutes') - totalBreakValue / (60 * 1000));

                            }
                            this.CalculateOvertimeForShift(shiftFrom, totalWorkValue, currentContract, overtimeMap, currentMonthFromTZ.month(), currentMonthFromTZ.year());
                        }
                    }

                    this.addToWeekWorkDayMap(weekWorkDayMap, shiftFrom, totalWorkValue);
                }
            });
        }

        if (employeeDateActualShiftMap[employeeId] && (mode == 1 || mode == 2)) {
            let dateStart = currentMonthFrom.clone().subtract(1, 'days');
            let dateEnd = currentMonthTo.clone().add(1, 'days');
            while (dateEnd.diff(dateStart) > 0) {
                let dateKey = dateStart.format("YYYY-MM-DD");
                if (employeeDateActualShiftMap[employeeId][dateKey] && employeeDateActualShiftMap[employeeId][dateKey].length > 0) {
                    let actualShifts = employeeDateActualShiftMap[employeeId][dateKey];
                    actualShifts.forEach(shift => {

                        let shiftFrom = this.getMomentFromStringTZ(shift.from);
                        let shiftTo = this.getMomentFromStringTZ(shift.to);
                        let totalWorkValue = 0;
                        let currentContract = overlappingContracts.find(contract => {
                            if(shiftFrom >= contractFromToMap[contract.id].from && (contractFromToMap[contract.id].to == null || shiftFrom < contractFromToMap[contract.id].to)){
                                return true;
                            } else {
                                return false;
                            }
                        })
                        if (shiftTo > currentMonthFromTZ && shiftFrom < currentMonthToTZ) {
                            let breakValue = 0;
                            let totalBreakValue = 0;
                            if (actualShiftBreakMap[shift.id] && actualShiftBreakMap[shift.id].length > 0) {
                                let breaks = actualShiftBreakMap[shift.id];
                                breaks.forEach(abreak => {
                                    let check = this.CheckActualBreakFromToInActualShift(abreak, shiftFrom, shiftTo);
                                    if (check.isNonZeroDiff) {
                                        let breakFrom = check.from;
                                        let breakTo = check.to;
                                        let breakRatioFrom = breakFrom < currentMonthFromTZ ? currentMonthFromTZ : (breakFrom > currentMonthToTZ ? currentMonthToTZ : breakFrom);
                                        let breakRatioTo = breakTo > currentMonthToTZ ? currentMonthToTZ : (breakTo < currentMonthFromTZ ? currentMonthFromTZ : breakTo);
                                        if (breakRatioFrom.utcOffset() != breakRatioTo.utcOffset()) {
                                            //breakRatioTo = breakRatioTo.clone().utcOffset(breakRatioFrom.utcOffset(), true);
                                        }
                                        totalBreakValue += Math.max(0, breakTo.diff(breakFrom, 'minutes'));
                                        breakValue += Math.max(0, breakRatioTo.diff(breakRatioFrom, 'minutes'));
                                    }


                                });
                            }


                            let ratioFrom = shiftFrom < currentMonthFromTZ ? currentMonthFromTZ : (shiftFrom > currentMonthToTZ ? currentMonthToTZ : shiftFrom);
                            let ratioTo = shiftTo > currentMonthToTZ ? currentMonthToTZ : (shiftTo < currentMonthFromTZ ? currentMonthFromTZ : shiftTo);
                            if (ratioFrom.utcOffset() != ratioTo.utcOffset()) {
                                //ratioTo = ratioTo.clone().utcOffset(ratioFrom.utcOffset(), true);
                            }
                            let workValue = Math.max(0, ratioTo.diff(ratioFrom, 'minutes') - breakValue);

                            totalWorkValue = Math.max(0, shiftTo.diff(shiftFrom, 'minutes') - totalBreakValue);

                            //check how much time was worked on weekends
                            let shiftWorkValue = shiftTo.diff(shiftFrom, 'minutes');
                            let weekendWorkTime = this.calculateWeekEndWorkValue(currentMonthFromTZ, currentMonthToTZ, shiftFrom, shiftTo, shiftWorkValue);
                            let weekendBreakTime = 0;

                            let sundayWorkTime = this.calculateSundayWorkValue(currentMonthFromTZ, currentMonthToTZ, shiftFrom, shiftTo, shiftWorkValue);
                            let sundayBreakTime = 0;



                            if (weekendWorkTime > 0 && actualShiftBreakMap[shift.id] && actualShiftBreakMap[shift.id].length > 0) {
                                let breaks = actualShiftBreakMap[shift.id];
                                breaks.forEach(abreak => {
                                    let check = this.CheckActualBreakFromToInActualShift(abreak, shiftFrom, shiftTo);
                                    if (check.isNonZeroDiff) {
                                        let breakFrom = check.from;
                                        let breakTo = check.to;
                                        let breakWorkValue = breakTo.diff(breakFrom, 'minutes');
                                        weekendBreakTime += this.calculateWeekEndWorkValue(currentMonthFromTZ, currentMonthToTZ, breakFrom, breakTo, breakWorkValue);
                                        sundayBreakTime += this.calculateSundayWorkValue(currentMonthFromTZ, currentMonthToTZ, breakFrom, breakTo, breakWorkValue);
                                    }

                                });
                                weekendWorkTime = Math.max(0, weekendWorkTime - weekendBreakTime);
                                sundayWorkTime = Math.max(0, sundayWorkTime - sundayBreakTime);
                            }


                            if (weekendWorkTime > 0) {

                                bonusStats.weekendWorkCount += 1;
                                bonusStats.weekendWorkTime += weekendWorkTime;
                            }
                            if (sundayWorkTime > 0) {

                                bonusStats.sundayWorkCount += 1;
                                bonusStats.sundayWorkTime += sundayWorkTime;
                            }


                            //check how much of the shift was worked during the night if night work applies and calculateOvertime
                            if (currentContract) {
                                this.CalculateOvertimeForShift(shiftFrom, totalWorkValue, currentContract, overtimeMap, currentMonthFromTZ.month(), currentMonthFromTZ.year());
                                let overMidnight = false;
                                let nightWorkFrom = this.getMomentFromStringUTC(currentContract.nightWorkFrom, 'HH:mm');
                                let nightWorkTo = this.getMomentFromStringUTC(currentContract.nightWorkTo, 'HH:mm');
                                if (nightWorkTo <= nightWorkFrom) {
                                    overMidnight = true;
                                }
                                nightWorkFrom = shiftFrom.clone().hours(nightWorkFrom.hours()).minutes(nightWorkFrom.minutes());
                                nightWorkTo = shiftFrom.clone().hours(nightWorkTo.hours()).minutes(nightWorkTo.minutes());
                                if (nightWorkTo <= nightWorkFrom) {
                                    nightWorkTo.add(1, 'days');
                                }

                                if (shiftFrom < currentMonthToTZ && shiftTo > currentMonthFromTZ) {
                                    let nwResult = this.CalculateNightWorkForShift(shift, true, shiftFrom, shiftTo, ratioFrom, ratioTo, nightWorkFrom, nightWorkTo, currentContract, actualShiftBreakMap);

                                    bonusStats.nightWorkCount += nwResult.count;
                                    bonusStats.nightWorkCountPayment += nwResult.countBonus;
                                    bonusStats.nightWorkTimePayment += nwResult.timeBonus;
                                    nightWorkTime += nwResult.time;
                                    if (overMidnight) {
                                        //nightwork goes over midnight => WE NEED TO CHECK IF THE SHIFT MATCHES WITH NIGHTWORK OF 'PREVIOUS' DAY
                                        let nwfrom = nightWorkFrom.clone().add(-1, 'days');
                                        let nwto = nightWorkTo.clone().add(-1, 'days');

                                        nwResult = this.CalculateNightWorkForShift(shift, true, shiftFrom, shiftTo, ratioFrom, ratioTo, nwfrom, nwto, currentContract, actualShiftBreakMap);
                                        bonusStats.nightWorkCount += nwResult.count;
                                        bonusStats.nightWorkCountPayment += nwResult.countBonus;
                                        bonusStats.nightWorkTimePayment += nwResult.timeBonus;
                                        nightWorkTime += nwResult.time;
                                    }
                                    if (shiftTo.date() != shiftFrom.date() && shiftTo < currentMonthToTZ) {
                                        //shift goes over midnight => WE NEED TO CHECK IF SHIFT MATCHES WITH NIGHTWORK OF NEXT DAY
                                        let nwfrom = nightWorkFrom.clone().add(1, 'days');
                                        let nwto = nightWorkTo.clone().add(1, 'days');

                                        nwResult = this.CalculateNightWorkForShift(shift, true, shiftFrom, shiftTo, ratioFrom, ratioTo, nwfrom, nwto, currentContract, actualShiftBreakMap);
                                        bonusStats.nightWorkCount += nwResult.count;
                                        bonusStats.nightWorkCountPayment += nwResult.countBonus;
                                        bonusStats.nightWorkTimePayment += nwResult.timeBonus;
                                        nightWorkTime += nwResult.time;
                                    }
                                }
                            }
                        } else {
                            //still need to calculate overtime for it
                            if (currentContract) {

                                let totalBreakValue = 0;
                                if (actualShiftBreakMap[shift.id] && actualShiftBreakMap[shift.id].length > 0) {
                                    let breaks = actualShiftBreakMap[shift.id];
                                    breaks.forEach(abreak => {
                                        let check = this.CheckActualBreakFromToInActualShift(abreak, shiftFrom, shiftTo);
                                        if (check.isNonZeroDiff) {
                                            let breakFrom = check.from;
                                            let breakTo = check.to;
                                            totalBreakValue += Math.max(0, breakTo.diff(breakFrom, 'minutes'));

                                        }
                                    });
                                }

                                totalWorkValue = Math.max(0, shiftTo.diff(shiftFrom, 'minutes') - totalBreakValue);
                                this.CalculateOvertimeForShift(shiftFrom, totalWorkValue, currentContract, overtimeMap, currentMonthFromTZ.month(), currentMonthFromTZ.year());
                            }
                        }
                        this.addToWeekWorkDayMap(weekWorkDayMap, shiftFrom, totalWorkValue);

                    });
                }
                dateStart = dateStart.add(1, 'days');
            }
        }




        bonusStats.nightWorkTime = nightWorkTime;
        bonusStats.nightWorkTimePayment = Math.round(bonusStats.nightWorkTimePayment);
        bonusStats.nightWorkCountPayment = Math.round(bonusStats.nightWorkCountPayment);

        if (mainContract) {
            if(storeSettings.enableWorkdayOvertime){
                this.addToOvertimeMap(weekWorkDayMap, overtimeMap, mainContract, allowedContractMap, collectiveContractMap, currentMonthFromTZ, currentMonthToTZ);

            }
            let overtimeResult = this.CalculateOvertimeForMap(overtimeMap, mainContract);
            bonusStats.overTime = overtimeResult.overTime;
            bonusStats.overTimePayment = overtimeResult.overTimeBonus;
            bonusStats.overTimeCount = overtimeResult.overTimeCount;
            bonusStats.overTimeCountPayment = overtimeResult.overTimeCountBonus;
            bonusStats.dailyOverTime = overtimeResult.dailyOverTimeSum;
            bonusStats.weeklyOverTime = overtimeResult.weeklyOverTimeSum;
            bonusStats.workDayOverTime = overtimeResult.workDayOverTimeSum;
            bonusStats.moreTime = overtimeResult.moreTime;
            bonusStats.moreTimeCount = overtimeResult.moreTimeCount;
        }




        return bonusStats;

    }

    calculateCustomBonusPayments(employee, employeeContractMap,
                                 employeePlanShiftMap, employeeDateActualShiftMap, employeeDateActualShiftMarkedMap, actualShiftBreakMap,
                                 currentMonthFrom, currentMonthTo, currentMonthFromTZ, currentMonthToTZ, allowedContractMap, spotMap, bonusPaymentSettingsMap, holidayMap = {}, mode = 1) {

        let bonusPaymentResultMap = {};

        let employeeId = employee.id;
        let isUnderage = false;
        if(employee.dob){
            isUnderage = this.isUnderage(employee.dob, currentMonthToTZ);
        }
        let mainContract;
        let overlappingContracts = [];
        let contractFromToMap =  {};
        if (employeeContractMap[employeeId]) {

            overlappingContracts = this.GetContractsOverlappingMonth(employeeContractMap[employeeId], currentMonthFromTZ.clone().startOf('week').subtract(1,'days'), currentMonthToTZ);

            overlappingContracts.forEach(contract => {
                let contractFrom = this.getMomentFromStringTZ(contract.from);
                let contractTo = contract.to ? this.getMomentFromStringTZ(contract.to).add(-1, 'minutes') : null; //subtract 1 minute so when contract ends at end of month (= beginnining of next month) we are still in current month
                contractFromToMap[contract.id] = {from: contractFrom, to: contractTo};
                if (!mainContract) {
                    mainContract = contract;
                } else {
                    let mainContractFrom = this.getMomentFromStringTZ(mainContract.from);
                    let contractFrom = this.getMomentFromStringTZ(contract.from);
                    if (contractFrom > mainContractFrom) {
                        mainContract = contract;
                    }
                }
            });

        }


        if (employeePlanShiftMap[employeeId] && (mode == 1 || mode == 3)) {
            let planShifts = employeePlanShiftMap[employeeId];
            planShifts.forEach(shift => {

                let shiftFrom = this.getMomentFromStringTZ(shift.from);
                let shiftTo = this.getMomentFromStringTZ(shift.to);
                let dateKey = shiftFrom.format("YYYY-MM-DD");
                let actualShiftMarked = employeeDateActualShiftMarkedMap[employeeId] && employeeDateActualShiftMarkedMap[employeeId][dateKey];
                let hasActualShifts = employeeDateActualShiftMap[employeeId] && employeeDateActualShiftMap[employeeId][dateKey] && employeeDateActualShiftMap[employeeId][dateKey].length > 0;
                if ((!(hasActualShifts || actualShiftMarked)) && shiftTo > currentMonthFromTZ && shiftFrom < currentMonthToTZ) {

                    let currentContract = overlappingContracts.find(contract => {
                        if(shiftFrom >= contractFromToMap[contract.id].from && (contractFromToMap[contract.id].to == null || shiftFrom < contractFromToMap[contract.id].to)){
                            return true;
                        } else {
                            return false;
                        }
                    })
                    let ratioFrom = shiftFrom < currentMonthFromTZ ? currentMonthFromTZ : (shiftFrom > currentMonthToTZ ? currentMonthToTZ : shiftFrom);
                    let ratioTo = shiftTo > currentMonthToTZ ? currentMonthToTZ : (shiftTo < currentMonthFromTZ ? currentMonthFromTZ : shiftTo);


                    if (currentContract) {
                        this.CalculateBonusPaymentSettingValues(bonusPaymentResultMap, shift, shift.fromLocationId, shift.spotId, false, shiftFrom, shiftTo, ratioFrom, ratioTo,
                            employee, currentContract, bonusPaymentSettingsMap, spotMap, actualShiftBreakMap,
                            isUnderage, allowedContractMap, currentMonthToTZ, holidayMap)
                    }
                }
            });
        }

        if (employeeDateActualShiftMap[employeeId] && (mode == 1 || mode == 2)) {
            let dateStart = currentMonthFrom.clone().subtract(1, 'days');
            let dateEnd = currentMonthTo.clone().add(1, 'days');


            while (dateEnd.diff(dateStart) > 0) {
                let dateKey = dateStart.format("YYYY-MM-DD");
                if (employeeDateActualShiftMap[employeeId][dateKey] && employeeDateActualShiftMap[employeeId][dateKey].length > 0) {
                    let actualShifts = employeeDateActualShiftMap[employeeId][dateKey];
                    actualShifts.forEach(shift => {

                        let shiftFrom = this.getMomentFromStringTZ(shift.from);
                        let shiftTo = this.getMomentFromStringTZ(shift.to);


                        if (shiftTo > currentMonthFromTZ && shiftFrom < currentMonthToTZ) {

                            let currentContract = overlappingContracts.find(contract => {
                                if(shiftFrom >= contractFromToMap[contract.id].from && (contractFromToMap[contract.id].to == null || shiftFrom < contractFromToMap[contract.id].to)){
                                    return true;
                                } else {
                                    return false;
                                }
                            })
                            let ratioFrom = shiftFrom < currentMonthFromTZ ? currentMonthFromTZ : (shiftFrom > currentMonthToTZ ? currentMonthToTZ : shiftFrom);
                            let ratioTo = shiftTo > currentMonthToTZ ? currentMonthToTZ : (shiftTo < currentMonthFromTZ ? currentMonthFromTZ : shiftTo);

                            if (currentContract) {

                                let planShift = employeePlanShiftMap[employeeId] ? (employeePlanShiftMap[employeeId].find(s => s.id == shift.planshiftId)) : null;
                                this.CalculateBonusPaymentSettingValues(bonusPaymentResultMap, shift,
                                    planShift ? planShift.fromLocationId : null,
                                    planShift ? planShift.spotId : null, true, shiftFrom, shiftTo, ratioFrom, ratioTo,
                                    employee, currentContract, bonusPaymentSettingsMap, spotMap, actualShiftBreakMap,
                                    isUnderage, allowedContractMap, currentMonthToTZ, holidayMap)
                            }
                        }

                    });
                }
                dateStart = dateStart.add(1, 'days');
            }
        }

        return bonusPaymentResultMap;

    }

    CheckActualBreakFromToInActualShift(actualBreak, lower, upper) {
        let from = this.getMomentFromStringTZ(actualBreak.from);
        let to = this.getMomentFromStringTZ(actualBreak.to);
        return this.GetFromToCheckObject(from, to, lower, upper);
    }

    GetFromToCheckObject(from, to, lower, upper) {
        let resultFrom = from < lower ? lower : (from > upper ? upper : from);
        let resultTo = to > upper ? upper : (to < lower ? lower : to);
        let result = {
            isNonZeroDiff: (Math.max(0, resultTo.diff(resultFrom))) > 0,
            from: resultFrom,
            to: resultTo
        };

        return result;
    }

    CalculateBreakValueForActualShift(breaks, lower, upper) {
        let breakTime = 0;
        breaks.forEach(b => {
            let check = this.CheckActualBreakFromToInActualShift(b, lower, upper);
            if (check.isNonZeroDiff) {
                breakTime += (Math.max(0, check.to.diff(check.from)));
            }
        });
        return breakTime;
    }
    CalculateBreakValueForPlanShift(shift, lower, upper) {
        if (!shift) return 0;

        let breakFrom = null;
        if (!shift.breakFrom) {
            let pShiftFrom = this.getMomentFromStringTZ(shift.from);
            let pShiftTo = this.getMomentFromStringTZ(shift.to);
            breakFrom = pShiftFrom.clone().add(Math.round(pShiftTo.diff(pShiftFrom, 'minutes') / 2), 'minutes');
        } else {
            breakFrom = this.getMomentFromStringTZ(shift.breakFrom);
        }
        let breakTo = breakFrom.clone().add(shift.breakValue, 'minutes');
        let ratioFrom = breakFrom < lower ? lower : (breakFrom > upper ? upper : breakFrom);
        let ratioTo = breakTo > upper ? upper : (breakTo < lower ? lower : breakTo);
        if (ratioFrom.utcOffset() != ratioTo.utcOffset()) {
            //ratioTo = ratioTo.clone().utcOffset(ratioFrom.utcOffset(), true);
        }
        let breakTime = Math.max(0, ratioTo.diff(ratioFrom));

        return breakTime;
    }

    CalculateAutoBreakValueForPlanShift(isUnderage, from, to, storeSettings){
        if(storeSettings.noBreaks){
            return 0;
        } else {
            let diff = to.diff(from, 'minutes');
            if(storeSettings.country == 2){
                if(isUnderage){
                    if(diff > 6*60){
                        return 60;
                    } else if(diff > 4.5*60){
                        return 30;
                    }
                } else {
                    if(diff > 9.5*60){
                        return 45;
                    } else if(diff > 6*60){
                        return 30;
                    }
                }
            } else if(storeSettings.country == 8){
                if(isUnderage){
                    if(diff > 6*60){
                        return 30;
                    } else if(diff > 4.0*60){
                        return 30;
                    }
                } else {
                    if(diff > 6*60){
                        return 30;
                    }
                }
            } else {
                if(isUnderage){
                    if(diff > 4.5*60){
                        return 30;
                    }
                } else {
                    if(diff >= 12*60){
                        return 60;
                    } else if(diff > 6*60){
                        return 30;
                    }
                }
            }
            return 0;
        }


    }

    CalculateWorktime(shiftFrom, shiftTo, lower, upper, breakValue) {

        let ratioFrom = shiftFrom < lower ? lower : (shiftFrom > upper ? upper : shiftFrom);
        let ratioTo = shiftTo > upper ? upper : (shiftTo < lower ? lower : shiftTo);
        if (ratioFrom.utcOffset() != ratioTo.utcOffset()) {
            //ratioTo = ratioTo.clone().utcOffset(ratioFrom.utcOffset(), true);
        }
        let workValue = Math.max(0, ratioTo.diff(ratioFrom) - ((breakValue ? breakValue : 0)));

        return workValue;

    }

    CalculateEmployeePreferenceWorkTime(preference, preferenceMomentMap, employeeIdContractMap, employeeContractMomentMap, allowedContractMap, lowerBound, upperBound, storeSettings){
        let workValue = 0;
        let view = this;
        if (preference.state == 1 &&
            (preference.type == 1 ||
                preference.type == 2 ||
                preference.type == 3 ||
                (preference.type == 4 && preference.alwaysWork) ||
                preference.type == 6 ||
                preference.type == 7 ||
                preference.type == 8)) { // 1 = Urlaub , 2 = Krankenstand , 3 = FTA , 4 = Sonstiges, 6 = Pflegeurlaub , 7 = Ausbildung , 8 = LFZ

            let prefFrom = preferenceMomentMap[preference.id].fromDate;
            let prefTo = preferenceMomentMap[preference.id].toDate;

            let baseWorkValue = preference.workValue;


            let prefStart = prefFrom.clone();

            while (prefStart < prefTo) {

                //step through day, and check interval
                let endOfDay = prefStart.clone().add(1, 'days').startOf('day');
                let checkEnd = endOfDay < prefTo ? endOfDay : prefTo; //get tatsächliches Ende


                let dayWorktime = view.CalculateDayWorktimeFromContracts(preference.employeeId, employeeIdContractMap, employeeContractMomentMap, allowedContractMap, prefStart, checkEnd);

                let diff = checkEnd.diff(prefStart, 'minutes');

                let ratioFrom = (prefStart < lowerBound) ? lowerBound : ((prefStart > upperBound) ? upperBound : prefStart); // Liegt die Abwesenheit innerhalb des Monats, oder teilweise außerhalb?
                let ratioTo = (checkEnd > upperBound) ? upperBound : ((checkEnd < lowerBound) ? lowerBound : checkEnd);
                let ratio = ratioTo.diff(ratioFrom) / checkEnd.diff(prefStart); //Was ist der Anteil der Abwesenheit an diesem Monat

                let prefTime = Math.round(diff * ratio);
                if (prefTime > 0) {
                    let currentContract = employeeIdContractMap[preference.employeeId] ? Object.values(employeeIdContractMap[preference.employeeId]).find(contract => {
                        if(prefStart >= employeeContractMomentMap[contract.id].fromDate && (employeeContractMomentMap[contract.id].toDate == null || prefStart < employeeContractMomentMap[contract.id].toDate)){
                            return true;
                        } else {
                            return false;
                        }
                    }) : null;

                    let workDays = currentContract ? currentContract.workDays : storeSettings.workDays;
                    let countTowardsWorkTime = workDays.includes(prefStart.isoWeekday()); // IS WORKDAY CHECK

                    let tWorkValue = 0; //Calculation, how much time is this non availability worth
                    if (baseWorkValue > -1) {
                        //use preference.workValue instead of preference duration to determine workValue
                        //first determine the ratio that the current day interval has compared to entire preference length
                        let workValueRatio = ratioTo.diff(ratioFrom) / prefTo.diff(prefFrom);
                        tWorkValue = Math.round(baseWorkValue * workValueRatio);
                    } else {
                        if (prefTime > dayWorktime) {
                            tWorkValue += dayWorktime;
                        } else {
                            tWorkValue += prefTime;
                        }
                    }
                    if (countTowardsWorkTime || preference.alwaysWork) {
                        workValue += Math.max(0, tWorkValue);
                    }
                }
                prefStart = prefStart.add(1, 'days').startOf('day');
            }

        }
        return workValue;
    }

    CalculateDayWorktimeFromContracts(employeeId, employeeIdContractMap, employeeContractMomentMap, allowedContractMap, lower, upper) {
        //find contract
        let contracts = employeeIdContractMap[employeeId] ? employeeIdContractMap[employeeId] : [];
        let workTimeRegular = 0;
        let mainContract = null;
        let mainRatio = 0;
        contracts.forEach(contract => {
            let collectiveContract = null;
            if (contract.collectiveContractId) {
                collectiveContract = allowedContractMap[contract.collectiveContractId];
            }

            let contractFrom = employeeContractMomentMap[contract.id].fromDate;
            if (contractFrom < lower) contractFrom = lower;
            let contractTo = contract.to == null ? upper : employeeContractMomentMap[contract.id].toDate;
            if (contractTo > upper) contractTo = upper;
            let ratio = Math.max(0, contractTo.diff(contractFrom) / upper.diff(lower));

            if (ratio > mainRatio) {
                mainContract = contract;
            }
        });
        if (mainContract) {
            workTimeRegular = Math.round(mainContract.weekTimeRegular / mainContract.weekWorkDaysRegular);
        }

        return workTimeRegular;
    }

    GetHourlyWageFromContract(contract, allowedContractMap) {
        let wage = 0;
        if (contract != undefined) {
            wage = contract.payment ? (contract.payment + contract.extraPayment) : 0;
            let allowedContract = allowedContractMap[contract.collectiveContractId] ? allowedContractMap[contract.collectiveContractId] : null;
            let daysRegular = contract.weekWorkDaysRegular ? contract.weekWorkDaysRegular : 5;
            let weekWorkTime = contract.weekTimeRegular ? contract.weekTimeRegular : 40 * 60;
            let dayWorkTime = Math.round(weekWorkTime / daysRegular);
            let factor = allowedContract ? allowedContract.workTimeFactor / Math.pow(10, 7) : 4.325

            let monthWorkTime = Math.round(weekWorkTime * factor);


            if (contract.paymentType == 2) {
                if (contract.wageType == 4) { // Monatslohn

                    wage = Math.round((contract.payment + contract.extraPayment) / (monthWorkTime / 60.0));
                } else if (contract.wageType == 3) { //Wochenlohn
                    wage = Math.round((contract.payment + contract.extraPayment) / (weekWorkTime / 60.0));
                } else if (contract.wageType == 2) { //Tageslohn
                    wage = Math.round((contract.payment + contract.extraPayment) / (dayWorkTime / 60.0));
                }

            } else if (contract.paymentType == 1) {
                wage = Math.round((contract.payment + contract.extraPayment) / (monthWorkTime / 60.0));
            }

        }
        return wage;
    }

    GetAvgHourlyWageFromContractsForMonth(monthFrom, monthTo, contracts, allowedContractMap) {
        let overlappingContracts = this.GetContractsOverlappingMonth(contracts, monthFrom, monthTo);

        let wageSum = 0;
        overlappingContracts.forEach(contract => {
            wageSum += this.GetHourlyWageFromContract(contract, allowedContractMap);
        });

        return overlappingContracts.length > 0 ? Math.round(wageSum / overlappingContracts.length) : 0;
    }



    GetContractsOverlappingMonth(contracts, monthFrom, monthTo) {
        let result = [];
        contracts.forEach(contract => {
            let contractFrom = this.getMomentFromStringTZ(contract.from);
            if (contractFrom < monthFrom) contractFrom = monthFrom.clone();

            let contractTo = contract.to == null ? monthTo : this.getMomentFromStringTZ(contract.to);
            if (contractTo > monthTo) contractTo = monthTo.clone();

            if (contractFrom < monthTo && contractTo > monthFrom) {
                result.push(contract);
            }

        })
        return result;
    }

    GetPregnantFlagMapFromContracts(from, to, contracts) {
        let map = {};
        if(contracts && contracts.length > 0){
            let overlappingContracts = this.GetContractsOverlappingMonth(contracts, from, to);
            overlappingContracts.forEach(contract => {
                let contractFrom = this.getMomentFromStringTZ(contract.from);
                if(contractFrom < from){
                    contractFrom = from.clone();
                }
                let contractTo = contract.to == null ? to : this.getMomentFromStringTZ(contract.to);
                if (contractTo > to) contractTo = to.clone();

                let pregnant = contract.pregnant != null ? contract.pregnant : false;
                while(contractFrom < contractTo){
                    let key = contractFrom.format("YYYY-MM-DD");
                    map[key] = pregnant;
                    contractFrom.add(1, 'days');
                }
            });
        }


        return map;

    }


    GetWorktimeForRangeWithinMonthFromContracts(monthFrom, rangeFrom, rangeTo, contracts, allowedContractMap, storeSettings, workTimeMode, exitFactoring, enforcedMonthAvgFactor = null, holidays = [], includingContractHolidays = []) {

        let monthTo = monthFrom.clone().endOf('month').add(1,'days').startOf('month');
        let trueRangeFrom = rangeFrom < monthFrom ? monthFrom : rangeFrom;
        let trueRangeTo = rangeTo > monthTo ? monthTo : rangeTo;

        let workTimeRegular = 0;
        let aliquoteBase = this.GetAliquoteBase(monthFrom, monthTo, contracts, exitFactoring);

        let overlappingContracts = this.GetContractsOverlappingMonth(contracts, trueRangeFrom, trueRangeTo);

        overlappingContracts.forEach(contract => {
            let holidaysToUse = holidays;
            if(contract.holidayTypes.includes(2)){
                holidaysToUse = includingContractHolidays;
            }
            if(storeSettings.aliquoteWorkTime){
                workTimeRegular += this.GetWorktimeForRangeWithinMonthFromContract(aliquoteBase, trueRangeFrom, trueRangeTo, contract, allowedContractMap, storeSettings, workTimeMode, false, enforcedMonthAvgFactor, holidaysToUse)
            } else {
                workTimeRegular = Math.max(workTimeRegular, this.GetWorktimeForRangeWithinMonthFromContract(aliquoteBase, trueRangeFrom, trueRangeTo, contract, allowedContractMap, storeSettings, workTimeMode, false, enforcedMonthAvgFactor, holidaysToUse));

            }
        });


        return Math.round(workTimeRegular);

    }

    GetFulltimeForRangeWithinMonthFromContracts(monthFrom, rangeFrom, rangeTo, contracts, allowedContractMap, storeSettings, workTimeMode, exitFactoring, enforcedMonthAvgFactor = null, holidays = [], includingContractHolidays = []) {

        let monthTo = monthFrom.clone().endOf('month').add(1,'days').startOf('month');
        let trueRangeFrom = rangeFrom < monthFrom ? monthFrom : rangeFrom;
        let trueRangeTo = rangeTo > monthTo ? monthTo : rangeTo;

        let workTimeRegular = 0;
        let aliquoteBase = this.GetAliquoteBase(monthFrom, monthTo, contracts, exitFactoring);

        let overlappingContracts = this.GetContractsOverlappingMonth(contracts, trueRangeFrom, trueRangeTo);

        let weekMap = {};
        let contractDays = 0;
        let empId = null;
        overlappingContracts.forEach(contract => {
            let holidaysToUse = holidays;
            if(contract.holidayTypes.includes(2)){
                holidaysToUse = includingContractHolidays;
            }
            empId = contract.employeeId;
            if(storeSettings.aliquoteWorkTime){
                let res = this.GetFulltimeForRangeWithinMonthFromContract(aliquoteBase, trueRangeFrom, trueRangeTo, contract, allowedContractMap, storeSettings, workTimeMode, enforcedMonthAvgFactor, holidaysToUse)
                Object.keys(res.weekMap).forEach(key => {
                    if(!weekMap[key]){
                        weekMap[key] = res.weekMap[key];
                    } else {
                        let entry = weekMap[key];
                        entry.ratio = Math.max(entry.ratio, res.weekMap[key].ratio);
                        entry.fullTimeCutoff = Math.max(entry.fullTimeCutoff, res.weekMap[key].fullTimeCutoff);
                    }
                });
                contractDays += res.contractDays;
                workTimeRegular += res.workTimeRegular;
            } else {
                let res = this.GetFulltimeForRangeWithinMonthFromContract(aliquoteBase, trueRangeFrom, trueRangeTo, contract, allowedContractMap, storeSettings, workTimeMode, enforcedMonthAvgFactor, holidaysToUse)
                workTimeRegular = Math.max(workTimeRegular, res.workTimeRegular);
            }
        });
        if(storeSettings.aliquoteWorkTime && contractDays < monthTo.diff(monthFrom, 'days')){
            let wt = 0;
            Object.values(weekMap).forEach(entry => {
                wt += entry.ratio * entry.fullTimeCutoff;
            })

            workTimeRegular = Math.max(wt, workTimeRegular);
        }

        return Math.round(workTimeRegular);

    }

    GetAliquoteBase(monthFrom, monthTo, contracts, exitFactoring){
        let base = monthTo.diff(monthFrom, 'days');
        if(exitFactoring == 1){
            //if aliquote mode is 1 then we need to determine if the contracts overlap whole month or not
            //if yes we cannot use 30 as a base like expected because e.g. 16/30 days contract and 15/30 days contract in a month with 31 days would add up > 1
            //we only need to do this if the days in month different than 30
            if(base != 30){
                let cDays = 0
                let overlappingContracts = this.GetContractsOverlappingMonth(contracts, monthFrom, monthTo);
                overlappingContracts.forEach(contract => {
                    let contractFrom = this.getMomentFromStringTZ(contract.from);
                    if (contractFrom < monthFrom) contractFrom = monthFrom.clone();

                    let contractTo = contract.to == null ? monthTo : this.getMomentFromStringTZ(contract.to);
                    if (contractTo > monthTo) contractTo = monthTo.clone();



                    cDays += contractTo.diff(contractFrom, 'days');
                });
                if(cDays != base){
                    base = 30;
                }
                return base;
            } else {
                return base;
            }
        } else {
            return base;
        }
    }

    GetWorktimeForRangeWithinMonthFromContract(aliquoteBase, rangeFrom, rangeTo, contract, allowedContractMap, storeSettings, workTimeMode, detailed = false, enforcedMonthAvgFactor = null, holidays = []) {
        let workTimeRegular = 0;
        let collectiveContract = null;
        if (contract.collectiveContractId) {
            collectiveContract = allowedContractMap[contract.collectiveContractId];
        }
        let monthAvgFactor = enforcedMonthAvgFactor ? enforcedMonthAvgFactor : (collectiveContract ? collectiveContract.workTimeFactor : null);
        let contractWorkTime = 0;


        let contractFrom = this.getMomentFromStringTZ(contract.from);
        if (contractFrom < rangeFrom) contractFrom = rangeFrom;

        let contractTo = contract.to == null ? rangeTo : this.getMomentFromStringTZ(contract.to);
        if (contractTo > rangeTo) contractTo = rangeTo;

        if(!storeSettings.aliquoteWorkTime){
            contractFrom = rangeFrom;
            contractTo = rangeTo;
        }


        let contractDays = contractTo.diff(contractFrom, 'days');
        let workDaysCount = contract.workDays.length > 0 ? contract.workDays.length : Math.max(1, storeSettings.workDays.length);

        if(workTimeMode == 0) {
            //average worktime, dont need workdays or weekdays
            contractWorkTime = this.CalculateMonthWorkTime(0, 0, contract.weekTimeRegular, workDaysCount, monthAvgFactor, workTimeMode, storeSettings);

            let ratio = Math.max(0, contractDays / aliquoteBase)


            contractWorkTime = (contractWorkTime * ratio)

        } else if (workTimeMode == 1) {
            //use businessdays
            let contractWorkDays = this.CalculateBusinessDaysCount(contractFrom, contractTo, [], contract.workDays);
            contractWorkTime = this.CalculateMonthWorkTime(contractWorkDays, 0, contract.weekTimeRegular, workDaysCount, monthAvgFactor, workTimeMode, storeSettings);

        } else if (workTimeMode == 2){
            //use days
            contractWorkTime = this.CalculateMonthWorkTime(0, contractDays, contract.weekTimeRegular, workDaysCount, monthAvgFactor, workTimeMode, storeSettings);

        } else {
            //use businessdays w/o holidays
            let contractWorkDays = this.CalculateBusinessDaysCount(contractFrom, contractTo, holidays, contract.workDays);
            contractWorkTime = this.CalculateMonthWorkTime(contractWorkDays, 0, contract.weekTimeRegular, workDaysCount, monthAvgFactor, workTimeMode, storeSettings);

        }
        if (contract.additionalMonthWorkTime > 0) {
            let ratio = Math.max(0, contractDays / aliquoteBase)
            contractWorkTime = contractWorkTime + (contract.additionalMonthWorkTime * ratio)
        }


        workTimeRegular += contractWorkTime;
        if (detailed) {

            return {
                'workTimeRegular': workTimeRegular,
                'contractDays': contractDays,
                'contractFrom': contractFrom,
                'contractTo': contractTo,
                'aliquoteBase': aliquoteBase,
                'monthAvgFactor': monthAvgFactor
            }
        }
        return workTimeRegular;
    }

    GetFulltimeForRangeWithinMonthFromContract(aliquoteBase, rangeFrom, rangeTo, contract, allowedContractMap, storeSettings, workTimeMode, enforcedMonthAvgFactor = null, holidays = []) {
        let workTimeRegular = 0;
        let collectiveContract = null;
        if (contract.collectiveContractId) {
            collectiveContract = allowedContractMap[contract.collectiveContractId];
        }
        let monthAvgFactor = enforcedMonthAvgFactor ? enforcedMonthAvgFactor : (collectiveContract ? collectiveContract.workTimeFactor : null);
        let contractWorkTime = 0;


        let contractFrom = this.getMomentFromStringTZ(contract.from);
        if (contractFrom < rangeFrom) contractFrom = rangeFrom;

        let contractTo = contract.to == null ? rangeTo : this.getMomentFromStringTZ(contract.to);
        if (contractTo > rangeTo) contractTo = rangeTo;

        if(!storeSettings.aliquoteWorkTime){
            contractFrom = rangeFrom;
            contractTo = rangeTo;
        }
        let weekMap = {};
        let weekStart = contractFrom.clone().startOf('week');
        while(weekStart < contractTo){
            let weekEnd = weekStart.clone().endOf('week').add(1, 'days').startOf('day');

            let weekAliquoteBaseFrom = weekStart < rangeFrom ? rangeFrom : weekStart;
            let weekAliquoteBaseTo = weekEnd > rangeTo ? rangeTo : weekEnd;

            let ratio = Math.max(0, weekAliquoteBaseTo.diff(weekAliquoteBaseFrom) / weekEnd.diff(weekStart));
            weekMap[weekStart.format("YYYY-MM-DD")] = {ratio: ratio, fullTimeCutoff: contract.fullTimeCutoff};
            weekStart = weekEnd;
        }


        let contractDays = contractTo.diff(contractFrom, 'days');
        let workDaysCount = Math.round(contract.fullTimeCutoff / contract.dayFullTimeCutoff);
        let workDays = [];
        for(let i = 0; i < workDaysCount; i++){
            workDays.push(i+1);
        }

        if(workTimeMode == 0) {
            //average worktime, dont need workdays or weekdays
            contractWorkTime = this.CalculateMonthWorkTime(0, 0, contract.fullTimeCutoff, workDaysCount, monthAvgFactor, workTimeMode, storeSettings);

            let ratio = Math.max(0, contractDays / aliquoteBase)
            contractWorkTime = (contractWorkTime * ratio)

        } else if (workTimeMode == 1) {
            //use businessdays
            let contractWorkDays = this.CalculateBusinessDaysCount(contractFrom, contractTo,  [], workDays);
            contractWorkTime = this.CalculateMonthWorkTime(contractWorkDays, 0, contract.fullTimeCutoff, workDaysCount, monthAvgFactor, workTimeMode, storeSettings);

        } else if (workTimeMode == 2){
            //use days
            contractWorkTime = this.CalculateMonthWorkTime(0, contractDays, contract.fullTimeCutoff, workDaysCount, monthAvgFactor, workTimeMode, storeSettings);

        }  else  {
            //use businessdays w/o holidays
            let contractWorkDays = this.CalculateBusinessDaysCount(contractFrom, contractTo, holidays, workDays);
            contractWorkTime = this.CalculateMonthWorkTime(contractWorkDays, 0, contract.fullTimeCutoff, workDaysCount, monthAvgFactor, workTimeMode, storeSettings);

        }



        workTimeRegular += contractWorkTime;


        return {
            'workTimeRegular': workTimeRegular,
            'contractDays': contractDays,
            'contractFrom': contractFrom,
            'contractTo': contractTo,
            'weekMap': weekMap,
        }


    }

    CalculateMonthWorkTime(workDays, days, weekTime, weekDays, monthAvgFactor, workTimeMode = 0, storeSettings) {

        let factor = monthAvgFactor ? (monthAvgFactor / Math.pow(10, 7)) : (storeSettings ? storeSettings.workTimeFactor / Math.pow(10, 7) : 4.325);
        if (workTimeMode == 3) {
            let dayWorkTime = weekTime /weekDays;
            return Math.round(dayWorkTime * workDays);
        } else if (workTimeMode == 2) {
            let dayWorkTime = weekTime / 7;
            return Math.round(dayWorkTime * days);
        } else if (workTimeMode == 1) {
            let dayWorkTime = weekTime / weekDays;
            return Math.round(dayWorkTime * workDays);
        } else {
            return Math.round(weekTime * factor);
        }


    }

    CalculateVacationTimeBalance(employee, previousMonthWorkBalanceMap, workBalanceMap, employeeContractMap, nextMonthEmployeeContractMap, currentMonthFromTZ, currentMonthToTZ, currentMonthFrom, storeSettings, allowedContractMap) {
        let employeeId = employee.id;
        if (currentMonthFromTZ.year() < 2021) {
            return this.CalculateVacationTimeBalanceBefore2021(employeeId, previousMonthWorkBalanceMap, workBalanceMap, employeeContractMap, nextMonthEmployeeContractMap, currentMonthFromTZ, currentMonthToTZ, currentMonthFrom);

        } else {
            let vacationTimeBalance = 0;

            let prevMonthBalance = previousMonthWorkBalanceMap[employeeId]
            if (prevMonthBalance) {
                vacationTimeBalance = prevMonthBalance.vacationTimeBalance;
            }
            let contractEntitlement = this.CalculateVacationEntitlementSum(employee, employeeContractMap, currentMonthFromTZ, storeSettings, allowedContractMap);
            
            vacationTimeBalance += Math.round(contractEntitlement * 24 * 60);
            return vacationTimeBalance;
        }

    }

    CalculateVacationEntitlementSum(employee, employeeContractMap, currentMonthFromTZ, storeSettings, allowedContractMap){
        let employeeId = employee.id;
        let contractEntitlement = 0;
        if (employeeContractMap[employeeId]) {
            let contracts = employeeContractMap[employeeId];
            let entitlement = 0
            let contractCount = 0;
            let workDays = 0;

            let firstOverlappingContractFrom = null;
            let lastOverlappingContractTo = false;
            contracts.forEach(contract => {

                let contractFrom = this.getMomentFromStringTZ(contract.from);

                let contractTo = contract.to == null ? null : this.getMomentFromStringTZ(contract.to);
                let monthEnd = currentMonthFromTZ.clone().endOf('month').add(1, 'days').startOf('day');
                let entitlementForMonth = 0;
                if(contractFrom < monthEnd && (contractTo == null || contractTo > currentMonthFromTZ)){
                    if(this.hasAutomaticVacationEntitlement(storeSettings) && employee.workEntryDate && contract.vacationEntitlementBase == null){
                        let workExperienceYears = (employee.workExperience != null ? employee.workExperience/12.0 : 0);
                        let nonEmploymentYears = (employee.nonEmploymentTime != null ? employee.nonEmploymentTime/12.0 : 0);
                        let ccId = contract.collectiveContractId ? (allowedContractMap[contract.collectiveContractId] ? allowedContractMap[contract.collectiveContractId].collectiveContractId : null) : null;
                
                        let workEntryDate = this.getMomentFromStringTZ(employee.workEntryDate);
                        let vt = Math.round(this.calculateContractVacationEntitlement(storeSettings, workEntryDate, currentMonthFromTZ, workExperienceYears, nonEmploymentYears, contract.weekWorkDaysRegular, ccId) * 24 *60);
                            
                            
                        if(storeSettings.aliquoteVac){
                            entitlementForMonth = this.CalculateVacationEntitlement(contractFrom, contractTo, currentMonthFromTZ, monthEnd, vt, storeSettings.vacationFactoring, storeSettings.exitFactoring, contract.vacationEntitlementBase);

                        } else {
                            entitlementForMonth = this.CalculateVacationEntitlement(currentMonthFromTZ, monthEnd, currentMonthFromTZ, monthEnd, vt, storeSettings.vacationFactoring, storeSettings.exitFactoring, contract.vacationEntitlementBase);

                        }
                            
                    } else if(storeSettings.aliquoteVac && storeSettings.country != 8){
                        entitlementForMonth = this.CalculateVacationEntitlement(contractFrom, contractTo, currentMonthFromTZ, monthEnd, contract.vacationTime, storeSettings.vacationFactoring, storeSettings.exitFactoring, contract.vacationEntitlementBase);

                    } else {
                        entitlementForMonth = this.CalculateVacationEntitlement(currentMonthFromTZ, monthEnd, currentMonthFromTZ, monthEnd, contract.vacationTime, storeSettings.vacationFactoring, storeSettings.exitFactoring, contract.vacationEntitlementBase);

                    }
                    if(entitlementForMonth > 0){
                        contractCount++;
                        entitlement += entitlementForMonth;
                    }

                    let f = contractFrom < currentMonthFromTZ ? currentMonthFromTZ : contractFrom;
                    let t = contractTo > monthEnd || contractTo == null ? monthEnd : contractTo;
                    workDays += t.diff(f, 'days');

                    if(contractFrom < monthEnd && (contractTo == null || contractTo > currentMonthFromTZ)){
                        if(firstOverlappingContractFrom == null || contractFrom < firstOverlappingContractFrom){
                            firstOverlappingContractFrom = contractFrom;
                        }
                        if(lastOverlappingContractTo == false || (contractTo != null && contractTo > lastOverlappingContractTo) || contractTo == null){
                            lastOverlappingContractTo = contractTo;
                        }
                    }
                }
                    

            });

            if(!storeSettings.aliquoteVac || storeSettings.country == 8){
                entitlement = entitlement / ( contractCount > 0 ?  contractCount : 1);
            }
            if(workDays >= storeSettings.minVacEmploymentDays && storeSettings.country != 8){
                contractEntitlement += entitlement;
            }
            //special handling for luxembourg. If contract starts before the 15th of the month, they get full, else half.
            //If contract ends after the 15th of the month, they get full, else half.
            if(storeSettings.country == 8){
                let monthMiddle = currentMonthFromTZ.clone().startOf('month').add(14, 'days');

                let firstHalf = firstOverlappingContractFrom < monthMiddle;
                let secondHalf = lastOverlappingContractTo == false || (lastOverlappingContractTo != null && lastOverlappingContractTo > monthMiddle) || lastOverlappingContractTo == null;
                if(firstHalf && secondHalf){
                    contractEntitlement += entitlement;
                } else {
                    contractEntitlement += entitlement / 2.0;

                }
            }

        }
        return contractEntitlement
    }

    CalculateVacationTimeBalanceBefore2021(employee, previousMonthWorkBalanceMap, workBalanceMap, employeeContractMap, nextMonthEmployeeContractMap, currentMonthFromTZ, currentMonthToTZ, currentMonthFrom) {
        let employeeId = employee.id;
        let firstContract = null
        let vacationContract;

        if (employeeContractMap[employeeId]) {
            let contracts = employeeContractMap[employeeId];
            contracts.forEach(contract => {

                let contractFrom = this.getMomentFromStringTZ(contract.from);

                let contractTo = contract.to == null ? null : this.getMomentFromStringTZ(contract.to);
                if (contractFrom <= currentMonthFromTZ && (contractTo == null || contractTo > currentMonthFromTZ) || (contractFrom.month() == currentMonthFromTZ.month() && contractFrom.year() == currentMonthFromTZ.year())) {
                    vacationContract = contract;
                }
                if (firstContract == null || contractFrom < this.getMomentFromStringTZ(firstContract.from)) {
                    firstContract = contract;
                }
            });
        }
        if (!vacationContract && nextMonthEmployeeContractMap[employeeId]) {
            vacationContract = nextMonthEmployeeContractMap[employeeId];
        }
        let vacationTimeBalance = 0;

        let prevMonthBalance = previousMonthWorkBalanceMap[employeeId]
        if (prevMonthBalance == null && vacationContract) {
            if (currentMonthFrom.month() != 11) {
                //no previous month balance and it isn't december => new employee, dertermine balance aliquote from vacationContract

                let cFrom = this.getMomentFromStringTZ(vacationContract.from);
                let cTo = vacationContract.to != null ? this.getMomentFromStringTZ(vacationContract.to) : null;

                if (cFrom < currentMonthToTZ) {
                    //contract should overlap with current month, determine how much
                    let entitlementForMonth = this.CalculateVacationEntitlement(cFrom, cTo, currentMonthFromTZ, currentMonthFromTZ.clone().endOf('month'), vacationContract.vacationTime, 0, 0, vacationContract.vacationEntitlementBase);

                    if (cTo == null || cTo > currentMonthToTZ || nextMonthEmployeeContractMap[employeeId]) {
                        //contract goes past current month or new contract continues next month => determine how much vacation is left after current month
                        let months = 12 - (currentMonthFrom.month() + 1);
                        entitlementForMonth = entitlementForMonth + (vacationContract.vacationTime / (24 * 60 * 12)) * months;
                    }

                    vacationTimeBalance = Math.round(entitlementForMonth * 24 * 60);
                } else {

                    //contract starts next month
                    let checkFrom = cFrom.clone().startOf('month');
                    let checkTo = checkFrom.clone().endOf('month');
                    let entitlementForMonth = this.CalculateVacationEntitlement(cFrom, cTo, checkFrom, checkTo, vacationContract.vacationTime, 0, 0, vacationContract.vacationEntitlementBase);
                    //console.log(entitlementForMonth);
                    if (cTo == null || cTo > checkTo) {
                        //contract goes past contract month => determine how much vacation is left after contract month
                        let months = 12 - (checkFrom.month() + 1);
                        entitlementForMonth = entitlementForMonth + (vacationContract.vacationTime / (24 * 60 * 12)) * months;
                    }
                    vacationTimeBalance = Math.round(entitlementForMonth * 24 * 60);

                }

            } else {
                vacationTimeBalance = 0;
            }

        } else if (vacationContract) {
            vacationTimeBalance = prevMonthBalance.vacationTimeBalance;
        } else {
            vacationTimeBalance = 0;
        }

        let ending = false;

        if (vacationContract && !nextMonthEmployeeContractMap[employeeId]) {
            ending = true;
            //contract ends and doesn't continue -> subtract remaining aliquote vacationtime
            //dont subtract if it is the first contract and first contract starts and ends in same month because then the value is already aliquote
            let firstContractCheck = true;
            if (firstContract.id == vacationContract.id) {
                let from = this.getMomentFromStringTZ(firstContract.from);
                let to = firstContract.to ? this.getMomentFromStringTZ(firstContract.to) : null;

                if (to != null && to <= currentMonthToTZ && from >= currentMonthFromTZ) {
                    firstContractCheck = false;
                }
            }
            if (firstContractCheck) {
                let cFrom = this.getMomentFromStringTZ(vacationContract.from);
                let cTo = vacationContract.to != null ? this.getMomentFromStringTZ(vacationContract.to) : null;

                let entitlementForMonth = this.CalculateVacationEntitlement(cFrom, cTo, currentMonthFromTZ, currentMonthFromTZ.clone().endOf('month'), vacationContract.vacationTime, 0, 0, vacationContract.vacationEntitlementBase);
                let fullEntitlementForMonth = this.CalculateVacationEntitlement(currentMonthFromTZ, currentMonthFromTZ.clone().endOf('month'), currentMonthFromTZ, currentMonthFromTZ.clone().endOf('month'), vacationContract.vacationTime, 0, 0, vacationContract.vacationEntitlementBase);

                /*
                console.log(employeeId)
                console.log(vacationContract)
                console.log(firstContract)
                console.log(entitlementForMonth)
                console.log(fullEntitlementForMonth)
                */


                let entitlementDiff = Math.max(0, fullEntitlementForMonth - entitlementForMonth);
                let months = 12 - (currentMonthFrom.month() + 1);
                let remainingEntitlement = entitlementDiff + (vacationContract.vacationTime / (24 * 60 * 12)) * months;

                vacationTimeBalance = vacationTimeBalance - Math.round(remainingEntitlement * 24 * 60);
            }

        }

        if (currentMonthFromTZ.month() == 0 && vacationContract) {

            //add full year
            let entitlementForYear = (vacationContract.vacationTime / (24 * 60 * 12)) * 12;
            vacationTimeBalance = vacationTimeBalance + Math.round(entitlementForYear * 24 * 60);
        }


        return vacationTimeBalance;
    }

    CalculateVacationEntitlement(cStart, cEnd, checkDate, checkDateEnd, vacationTime, mode = 0, exitMode = 0, vacationEntitlementBase = null) {

        let baseEntitlement = 0;
        if (mode == 1) {
            let daysInYear = (checkDate.year() % 4) == 0 ? 366 : 365;
            if(vacationEntitlementBase != null && vacationEntitlementBase > 0){
                let daysInYear = vacationEntitlementBase * 30;
            }
            baseEntitlement = (vacationTime / daysInYear * checkDate.daysInMonth())
        } else {
            if(vacationEntitlementBase != null && vacationEntitlementBase > 0){
                baseEntitlement = vacationTime / vacationEntitlementBase;
            } else {
                baseEntitlement = vacationTime / 12 //mode 0, aliquote per month
            }

        }
        let daysInMonth = checkDate.daysInMonth();

        let contractEnds = this.dateIsBefore(cEnd, checkDateEnd);

        if (exitMode == 1 && contractEnds) {
            daysInMonth = 30;
        }
        let vacationEntitled = 0;
        if (cStart < checkDateEnd && (cEnd == null || cEnd > checkDate)) {
            let contractFrom = cStart;
            let contractTo = cEnd;
            if (contractFrom < checkDate) {
                contractFrom = checkDate;
            }
            if (contractTo > checkDateEnd || contractTo == null) {
                contractTo = checkDateEnd;
            }
            let contractDays = Math.max(0, contractTo.diff(contractFrom, 'days'));
            if (contractDays > daysInMonth) {
                contractDays = daysInMonth;
            }

            let dailyEntitlement = baseEntitlement / daysInMonth;

            vacationEntitled = (dailyEntitlement * contractDays) / (60 * 24);
        }
        return vacationEntitled;
    }

    CalculateNightWorkForShift(shift, actualShiftFlag, actualShiftFrom, actualShiftTo, shiftFrom, shiftTo, nightWorkFrom, nightWorkTo, mainContract, actualShiftBreakMap) {
        let result = {
            count: 0,
            countBonus: 0,
            time: 0,
            timeBonus: 0
        };

        //check full shift
        let checkRatioFrom = actualShiftFrom < nightWorkFrom ? nightWorkFrom : (actualShiftFrom > nightWorkTo ? nightWorkTo : actualShiftFrom);
        let checkRatioTo = actualShiftTo > nightWorkTo ? nightWorkTo : (actualShiftTo < nightWorkFrom ? nightWorkFrom : actualShiftTo);
        /*if (checkRatioFrom.utcOffset() != checkRatioTo.utcOffset()) {
            checkRatioTo = checkRatioTo.clone().utcOffset(checkRatioFrom.utcOffset(), true);
        } */
        let checkRatio = checkRatioTo.diff(checkRatioFrom) / actualShiftTo.diff(actualShiftFrom);
        let checkNwTime = checkRatioTo.diff(checkRatioFrom, 'minutes');
        let minNightWorkTime = mainContract != null ? mainContract.minNightWorkTime : 0;
        let applyNw = checkNwTime >= minNightWorkTime && mainContract.calculateNightWork && checkRatio >= 0.00001;


        //values for shift in month
        let ratioFrom = shiftFrom < nightWorkFrom ? nightWorkFrom : (shiftFrom > nightWorkTo ? nightWorkTo : shiftFrom);
        let ratioTo = shiftTo > nightWorkTo ? nightWorkTo : (shiftTo < nightWorkFrom ? nightWorkFrom : shiftTo);
        /*if (ratioFrom.utcOffset() != ratioTo.utcOffset()) {
            ratioTo = ratioTo.clone().utcOffset(ratioFrom.utcOffset(), true);
        }*/


        if (applyNw) {
            let nwTime = ratioTo.diff(ratioFrom, 'minutes')

            if (actualShiftFlag && actualShiftBreakMap[shift.id] && actualShiftBreakMap[shift.id].length > 0) {
                let breaks = actualShiftBreakMap[shift.id];
                breaks.forEach(abreak => {
                    let check = this.CheckActualBreakFromToInActualShift(abreak, actualShiftFrom, actualShiftTo);
                    if (check.isNonZeroDiff) {
                        let breakFrom = check.from;
                        let breakTo = check.to;
                        if (breakFrom < ratioTo && breakTo > ratioFrom) {
                            let nwBreakFrom = breakFrom < ratioFrom ? ratioFrom : (breakFrom > ratioTo ? ratioTo : breakFrom);
                            let nwBreakTo = breakTo > ratioTo ? ratioTo : (breakTo < ratioFrom ? ratioFrom : breakTo);
                            if (nwBreakFrom.utcOffset() != nwBreakTo.utcOffset()) {
                                //nwBreakTo = nwBreakTo.clone().utcOffset(nwBreakFrom.utcOffset(), true);
                            }
                            nwTime -= Math.max(0, nwBreakTo.diff(nwBreakFrom, 'minutes'));
                        }
                    }
                });
            }

            if (!actualShiftFlag && shift.breakValue > 0) {
                if (shift.breakFrom != null) {
                    let breakFrom = this.getMomentFromStringTZ(shift.breakFrom);
                    let breakTo = breakFrom.clone().add(shift.breakValue, 'minutes');
                    if (breakFrom < ratioTo && breakTo > ratioFrom) {
                        let nwBreakFrom = breakFrom < ratioFrom ? ratioFrom : (breakFrom > ratioTo ? ratioTo : breakFrom);
                        let nwBreakTo = breakTo > ratioTo ? ratioTo : (breakTo < ratioFrom ? ratioFrom : breakTo);
                        if (nwBreakFrom.utcOffset() != nwBreakTo.utcOffset()) {
                            //nwBreakTo = nwBreakTo.clone().utcOffset(nwBreakFrom.utcOffset(), true);
                        }
                        nwTime -= Math.max(0, nwBreakTo.diff(nwBreakFrom, 'minutes'));
                    }
                } else {
                    nwTime = Math.max(0, nwTime - Math.round(shift.breakValue * checkRatio));
                }

            }

            if (mainContract.nightWorkMode == 1) {
                if ((checkRatio > mainContract.nightWorkCutoff / 100) && shiftFrom.month() == actualShiftFrom.month()) {
                    result.count += 1;
                    result.countBonus += mainContract.nightWorkBonusShift;
                } else if ((checkRatio <= mainContract.nightWorkCutoff / 100)) {
                    result.time += nwTime;
                    result.timeBonus += result.time / 60 * mainContract.nightWorkBonusHour;
                }
            } else if ((mainContract.nightWorkMode == 2) && shiftFrom.month() == actualShiftFrom.month()) {
                result.count += 1;
                result.countBonus += mainContract.nightWorkBonusShift;
            } else if (mainContract.nightWorkMode == 3) {
                result.time += nwTime;
                result.timeBonus += result.time / 60 * mainContract.nightWorkBonusHour;
            } else if ((mainContract.nightWorkMode == 4) && shiftFrom.month() == actualShiftFrom.month() && (checkRatio > mainContract.nightWorkCutoff / 100)) {
                result.count += 1;
                result.countBonus += mainContract.nightWorkBonusShift;
            } else if (mainContract.nightWorkMode == 5 && (checkRatio > mainContract.nightWorkCutoff / 100)) {
                result.time += nwTime;
                result.timeBonus += result.time / 60 * mainContract.nightWorkBonusHour;
            }
        }

        return result;
    }

    CalculateOvertimeForShift(shiftFrom, workValue, mainContract, overtimeMap, month, year) {
        let weekStart = shiftFrom.clone().startOf('week');
        let weekEnd = shiftFrom.clone().endOf('week');
        let weekEndKey = weekEnd.format("DD-MM-YYYY");
        let dayKey = shiftFrom.clone().startOf('day').format("DD-MM-YYYY");
        if (!overtimeMap[weekEndKey]) {
            overtimeMap[weekEndKey] = {
                dailyOvertimeSum: 0,
                dailyOvertimeCount: 0,
                dailyMoreTimeSum: 0,
                dailyMoreTimeCount: 0,
                weeklySum: 0,
                nimWeeklySum: 0,
                nimDailyOvertimeSum: 0,
                nimDailyMoreTimeSum: 0,
                nextMonth: false,
                prevMonth: false,
                workDayOvertimeSum: 0,
                nimWorkDayOvertimeSum: 0,
                dayMap: {},
            }
        }
        let mapEntry = overtimeMap[weekEndKey];
        if(!mapEntry.dayMap[dayKey]){
            mapEntry.dayMap[dayKey] = {dailyOverTime: 0, nimDailyOverTime: 0}
        }
        let dailyOverTimeCutoff = mainContract.overtimeCutoff;

        let dailyOverTime = Math.max(0, workValue - dailyOverTimeCutoff);
        //moreTime is 0 if theres overTime already, since it is subsumed in overtime
        let dailyMoreTime = dailyOverTime > 0 ? 0 : Math.max(0, workValue - Math.round(mainContract.weekTimeRegular / mainContract.weekWorkDaysRegular));
        if (shiftFrom.month() == month && shiftFrom.year() == year) {
            mapEntry.weeklySum += workValue;
            mapEntry.dailyOvertimeSum += dailyOverTime;
            mapEntry.dayMap[dayKey].dailyOverTime += dailyOverTime;

            if (dailyOverTime > 0) {
                mapEntry.dailyOvertimeCount += 1;
            }
            mapEntry.dailyMoreTimeSum += dailyMoreTime;
            if (dailyMoreTime > 0) {
                mapEntry.dailyMoreTimeCount += 1;
            }

        } else {
            mapEntry.nimWeeklySum += workValue;
            mapEntry.nimDailyOvertimeSum += dailyOverTime;
            mapEntry.nimDailyMoreTimeSum += dailyMoreTime;
            mapEntry.dayMap[dayKey].nimDailyOverTime += dailyOverTime;
        }

        if (((weekStart.month() < month && weekStart.year() == year) || weekStart.year() < year) && weekEnd.month() == month && weekEnd.year() == year) {
            //week starts in previous month and ends in current month => flag it for calculating prevmonth
            mapEntry.prevMonth = true;
        } else if (((weekEnd.month() > month && weekEnd.year() == year) || weekEnd.year() > year) && weekStart.month() == month && weekStart.year() == year) {
            //week starts in current month and ends in next month => flag it for calculating nextmonth
            mapEntry.nextMonth = true;
        } else if (weekStart.month() == month && weekStart.year() == year && weekEnd.month() == month && weekEnd.year() == year) {
            //week is entirely in current month
            mapEntry.prevMonth = false;
            mapEntry.nextMonth = false;
        } else {
            //week is not in month at all => delete map entry
            delete overtimeMap[weekEndKey];
        }



    }

    CalculateOvertimeForMap(overtimeMap, mainContract) {

        let overTime = 0;
        let overTimeCount = 0;
        let weeklyOverTimeSum = 0;
        let dailyOverTimeSum = 0;
        let workDayOverTimeSum = 0;
        let dayMap = {};
        /*
         * TODO: Ignore moreTime calculation for now, since it is not clear wether dailyMoreTime should actually be calculated
         */
        let moreTime = 0;
        let moreTimeCount = 0;

        let weeklyOvertimeCutoff = mainContract.weeklyOvertimeCutoff

        for (const key in overtimeMap) {
            let entry = overtimeMap[key];
            Object.keys(entry.dayMap).forEach(key => {
                dayMap[key] = entry.dayMap[key];
            })
            if (entry.prevMonth) {
                //entry has overtime from previous month, check if the week overtime is bigger than daily overtime of prev month + current month, if yes then add the difference
                //if no then just add the daily overtime of current month
                let weeklyOvertime = Math.max(0, (entry.weeklySum + entry.nimWeeklySum) - weeklyOvertimeCutoff);
                weeklyOverTimeSum += weeklyOvertime;
                dailyOverTimeSum += entry.dailyOvertimeSum;
                workDayOverTimeSum += entry.workDayOvertimeSum;

                let dailySum = entry.dailyOvertimeSum + entry.nimDailyOvertimeSum + entry.workDayOvertimeSum + entry.nimWorkDayOvertimeSum;
                if (weeklyOvertime > dailySum) {
                    overTime += Math.max(0, weeklyOvertime - entry.nimDailyOvertimeSum - entry.nimWorkDayOvertimeSum);
                } else {
                    overTime += (entry.dailyOvertimeSum + entry.workDayOvertimeSum);
                }

                //moreTime Calc below, only for non full time employees
                if(mainContract.contractType == 2 || mainContract.contractType == 3){
                    //if weektime sum is bigger than overtime cutoff, use overtimecutoff since time above cutoff is overtime and not moretime
                    let moreTimeValue = Math.min(weeklyOvertimeCutoff, entry.weeklySum + entry.nimWeeklySum)
                    let weeklyMoreTime = Math.max(0, moreTimeValue - mainContract.weekTimeRegular);

                    if(weeklyMoreTime > 0){
                        moreTime += weeklyMoreTime;
                        moreTimeCount +=1;
                    }
                }

            } else if (entry.nextMonth) {
                //week entry is for next month => can't check weekly overtime yet, so we just add the daily overtime
                dailyOverTimeSum += entry.dailyOvertimeSum;
                workDayOverTimeSum += entry.workDayOvertimeSum;
                overTime += (entry.dailyOvertimeSum + entry.workDayOvertimeSum);
            } else {
                //entry is in current month, check daily and weekly overtime, take the max of the two
                let weeklyOvertime = Math.max(0, entry.weeklySum - weeklyOvertimeCutoff);
                weeklyOverTimeSum += weeklyOvertime;
                dailyOverTimeSum += entry.dailyOvertimeSum;
                workDayOverTimeSum += entry.workDayOvertimeSum;
                overTime += Math.max(weeklyOvertime, entry.dailyOvertimeSum + entry.workDayOvertimeSum);

                //moreTime Calc below, only for non full time employees
                if(mainContract.contractType == 2 || mainContract.contractType == 3){
                    //if weektime sum is bigger than overtime cutoff, use overtimecutoff since time above cutoff is overtime and not moretime
                    let moreTimeValue = Math.min(weeklyOvertimeCutoff, entry.weeklySum + entry.nimWeeklySum)
                    let weeklyMoreTime = Math.max(0, moreTimeValue - mainContract.weekTimeRegular);
                    if(weeklyMoreTime > 0){
                        moreTime += weeklyMoreTime;
                        moreTimeCount +=1;
                    }
                }
            }
            overTimeCount += entry.dailyOvertimeCount;
        }


        return {
            overTime: overTime,
            overTimeBonus: Math.round(mainContract.overtimeBonusHour * overTime / 60.0),
            overTimeCount: overTimeCount,
            overTimeCountBonus: Math.round(mainContract.overtimeBonusShift * overTimeCount),
            weeklyOverTimeSum: weeklyOverTimeSum,
            dailyOverTimeSum: dailyOverTimeSum,
            workDayOverTimeSum: workDayOverTimeSum,
            moreTime: moreTime,
            moreTimeCount: moreTimeCount,
            dayMap: dayMap
        };
    }

    CalculateHourlyWage(mainContract){
        let hourlyWage = 0;
        if(mainContract && mainContract.payment != null){
            let weekTimeRegular = mainContract.weekTimeRegular
            if(mainContract.wageType == 4 || mainContract.paymentType == 1) {// Monatslohn
                hourlyWage = weekTimeRegular > 0 ? Math.round((mainContract.payment+mainContract.extraPayment) /(weekTimeRegular*4.325/60.0)) : 0;
            } else if(mainContract.wageType == 3) { //Wochenlohn
                hourlyWage = weekTimeRegular > 0 ? Math.round((mainContract.payment+mainContract.extraPayment)  /(weekTimeRegular/60.0)) : 0;
            } else if(mainContract.wageType == 2) { //Tageslohn
                hourlyWage = weekTimeRegular > 0 ? Math.round((mainContract.payment+mainContract.extraPayment)  /(weekTimeRegular/mainContract.weekWorkDaysRegular/60.0)) : 0;
            } else if(mainContract.wageType == 1) { //Stundenlohn
                hourlyWage = (mainContract.payment+mainContract.extraPayment) ;
            }
        }
        return hourlyWage;
    }

    CalculateHourlyWageForValues(paymentType, wageType, weekTimeRegular, weekWorkDaysRegular, payment, extraPayment){
        let hourlyWage = 0;
        let totalPayment = (payment ? payment : 0) + (extraPayment ? extraPayment: 0)
        if(wageType == 4 || paymentType == 1) {// Monatslohn
            hourlyWage = weekTimeRegular > 0 ? Math.round(totalPayment /(weekTimeRegular*4.325/60.0)) : 0;
        } else if(wageType == 3) { //Wochenlohn
            hourlyWage = weekTimeRegular > 0 ? Math.round(totalPayment  /(weekTimeRegular/60.0)) : 0;
        } else if(wageType == 2) { //Tageslohn
            hourlyWage = weekTimeRegular > 0 ? Math.round(totalPayment  /(weekTimeRegular/weekWorkDaysRegular/60.0)) : 0;
        } else if(wageType == 1) { //Stundenlohn
            hourlyWage = totalPayment ;
        }

        return hourlyWage;
    }

    CalculateBonusPaymentSettingValues(bonusPaymentResultMap, shift, shiftLocationId, shiftSpotId, actualShiftFlag, actualShiftFrom, actualShiftTo, shiftFrom, shiftTo, employee,
                                       mainContract, bonusPaymentSettingsMap, spotMap, actualShiftBreakMap,
                                       isUnderage, allowedContractMap, currentMonthToTZ, holidayMap = {}) {

        let hourlyWage = this.CalculateHourlyWage(mainContract);

        let exclusiveResultMap = {};
        Object.values(bonusPaymentSettingsMap).forEach(setting => {
            let employeeCheck = false;
            //first check if setting should be applied to employee
            let contractTypeFlag = false;
            let useContractTypeFlag = (setting.contractTypes && setting.contractTypes.length > 0);
            let employeeCategoryFlag = false;
            let useEmployeeCategoryFlag = setting.employeeCategories && setting.employeeCategories.length > 0;
            let employeeLevelFlag = false;
            let useEmployeeLevelFlag =   setting.employeeLevels && setting.employeeLevels.length > 0;
            let employmentTypeFlag = false;
            let useEmploymentTypeFlag =   setting.employmentTypes && setting.employmentTypes.length > 0;
            let spotFlag = false;
            let useSpotFlag = setting.spotId != null;
            let shiftSpotFlag = false;
            let useShiftSpotFlag = setting.shiftSpotId != null;
            let collectiveContractFlag = false;
            let useCollectiveContractFlag = setting.collectiveContractId != null;
            let locationFlag = false;
            let useLocationFlag = setting.fromLocationId != null;

            if(mainContract){
                let collectiveContract = allowedContractMap[mainContract.collectiveContractId]
                if(collectiveContract != null && collectiveContract.collectiveContractId == setting.collectiveContractId){
                    collectiveContractFlag = true;
                }

                if (setting.contractTypes && setting.contractTypes.includes(mainContract.contractType)) {
                    contractTypeFlag = true;
                }

                if (setting.employeeCategories && setting.employeeCategories.includes(mainContract.employeeCategory)) {
                    employeeCategoryFlag = true;
                }

                if (setting.employmentTypes && setting.employmentTypes.includes(mainContract.employmentType)) {
                    employmentTypeFlag = true;
                }
            }

            let employeeLevel = spotMap[employee.spotId] ? spotMap[employee.spotId].employeeLevel : null;
            if (employeeLevel && setting.employeeLevels && setting.employeeLevels.includes(employeeLevel)) {
                employeeLevelFlag = true;
            }
            if(employee.spotId == setting.spotId){
                spotFlag = true;
            }
            if(setting.shiftSpotId != null && setting.shiftSpotId == shiftSpotId){
                shiftSpotFlag = true;
            }
            if(setting.fromLocationId != null && setting.fromLocationId == shiftLocationId){
                locationFlag = true;
            }


            //check whether to use logical and or logical OR for application check
            if(setting.conditionJoin && (useContractTypeFlag || useEmployeeCategoryFlag || useEmployeeLevelFlag || useEmploymentTypeFlag || useSpotFlag || useCollectiveContractFlag || useShiftSpotFlag || useLocationFlag)){
                let flag = true;
                if(useContractTypeFlag){
                    flag = flag && contractTypeFlag;
                }
                if(useEmployeeCategoryFlag){
                    flag = flag && employeeCategoryFlag;
                }
                if(useEmployeeLevelFlag){
                    flag = flag && employeeLevelFlag;
                }
                if(useEmploymentTypeFlag){
                    flag = flag && employmentTypeFlag;
                }
                if(useSpotFlag){
                    flag = flag && spotFlag;
                }
                if(useCollectiveContractFlag){
                    flag = flag && collectiveContractFlag;
                }
                if(useShiftSpotFlag){
                    flag = flag && shiftSpotFlag;
                }
                if(useLocationFlag){
                    flag = flag && locationFlag;
                }
                employeeCheck = flag;
            } else {
                employeeCheck = contractTypeFlag || employeeCategoryFlag || employeeLevelFlag || employmentTypeFlag || spotFlag || collectiveContractFlag || shiftSpotFlag || locationFlag;
            }

            if(setting.applyToUnderage != null && (setting.applyToUnderage == false && isUnderage)){
                employeeCheck = false;
            }


            if(employeeCheck){
                //next check whether the setting should be applied to the shift
                let shiftCheck = true;

                if(!((setting.from == null || this.getMomentFromStringTZ(setting.from) < actualShiftTo)
                    && (setting.to == null || this.getMomentFromStringTZ(setting.to) > actualShiftFrom))){
                    shiftCheck = false;

                }

                let holidayFound = false;
                let holidayFrom = null;
                let holidayTo = null;
                if(setting.onlyHoliday){
                    //apply setting only on holidays -> check if shift starts on same day as holiday start
                    let hd = Object.values(holidayMap)
                        .find(holiday => {
                            let holidayStart = holiday.fromMoment ? holiday.fromMoment : this.getMomentFromStringTZ(holiday.from);
                            let holidayEnd = holiday.toMoment ? holiday.toMoment : this.getMomentFromStringTZ(holiday.to);
                            let holidayTypes = this.getHolidayTypesForStoreEvent(holiday);
                            let matchingTypes = setting.holidayTypes.filter(type => holidayTypes.includes(type));
                            let hf = matchingTypes.length > 0 && actualShiftFrom < holidayEnd && actualShiftTo > holidayStart;
                            if(hf){
                                holidayFrom = holidayStart;
                                holidayTo = holidayEnd;
                            }
                            return hf
                        });
                    holidayFound = hd != null;
                    shiftCheck = hd != null;
                }


                if(shiftCheck){
                    //do the actual Calculation
                    let foundResult = false;
                    let result = {
                        id: setting.id,
                        name: setting.name,
                        from: actualShiftFrom,
                        to: actualShiftTo,
                        count: 0,
                        countBonus: 0,
                        time: 0,
                        timeBonus: 0,
                        settingTime: 0,
                        priority: setting.priority,
                        ewbWorkTime: 0,
                    };
                    let overMidnight = false;
                    let bonusFrom = this.getMomentFromStringUTC(setting.bonusFrom, 'HH:mm');
                    let bonusTo = this.getMomentFromStringUTC(setting.bonusTo, 'HH:mm');
                    if (bonusTo <= bonusFrom) {
                        overMidnight = true;
                    }
                    let minMaxCheckFrom = null;
                    let minMaxCheckTo = null;
                    if (setting.checkFrom != null && setting.checkTo != null) {
                        minMaxCheckFrom = this.getMomentFromStringUTC(setting.checkFrom, 'HH:mm');
                        minMaxCheckTo = this.getMomentFromStringUTC(setting.checkTo, 'HH:mm');
                    }

                    if(holidayFound){
                        let hStart = holidayFrom.clone();

                        //loop through holiday interval daily and check bonus interval match
                        while(hStart < holidayTo){
                            let hbonusFrom = hStart.clone().hours(bonusFrom.hours()).minutes(bonusFrom.minutes());
                            let hbonusTo = hStart.clone().hours(bonusTo.hours()).minutes(bonusTo.minutes());
                            if(hbonusTo <= hbonusFrom){
                                hbonusTo = hbonusTo.add(1, 'days');
                            }
                            if(hbonusTo > holidayTo){
                                hbonusTo = holidayTo;
                            }
                            if(hbonusFrom < holidayFrom){
                                hbonusFrom = holidayFrom;
                            }

                            let hMinMaxCheckFrom = null;
                            let hMinMaxCheckTo = null;
                            if(minMaxCheckFrom != null && minMaxCheckTo != null){
                                hMinMaxCheckFrom = hStart.clone().hours(minMaxCheckFrom.hours()).minutes(minMaxCheckFrom.minutes());
                                hMinMaxCheckTo = hStart.clone().hours(minMaxCheckTo.hours()).minutes(minMaxCheckTo.minutes());
                                if(hMinMaxCheckTo <= hMinMaxCheckFrom){
                                    hMinMaxCheckTo = hMinMaxCheckTo.add(1, 'days');
                                }
                                if(!(hMinMaxCheckTo > hbonusFrom && hMinMaxCheckFrom < hbonusTo)){
                                    //the check intervals don't overlap -> subtract a day to make them overlap (e.g. interval is 00:00 - 06:00 and check is 17:00 - 07:00)
                                    hMinMaxCheckFrom = hMinMaxCheckFrom.add(-1, 'days');
                                    hMinMaxCheckTo = hMinMaxCheckTo.add(-1, 'days');
                                }
                            }

                            if(actualShiftFrom < hbonusTo && actualShiftTo > hbonusFrom && (setting.weekDays != null && setting.weekDays.includes(hbonusFrom.isoWeekday()))){
                                let entryResult = this.calculateBonusPaymentEntry(shift, actualShiftFlag, actualShiftFrom, actualShiftTo, shiftFrom, shiftTo, hbonusFrom, hbonusTo, hMinMaxCheckFrom, hMinMaxCheckTo, hourlyWage, setting, actualShiftBreakMap, holidayFrom, holidayTo);
                                if(entryResult.count > 0 || entryResult.time > 0){
                                    foundResult = true;
                                    result.count += entryResult.count;
                                    result.countBonus += entryResult.countBonus;
                                    result.time += entryResult.time;
                                    result.timeBonus += entryResult.timeBonus;
                                    result.settingTime += entryResult.settingTime;
                                }
                            }


                            hStart = hStart.add(1, 'days').startOf('day');
                        }

                    } else {

                        bonusFrom = shiftFrom.clone().hours(bonusFrom.hours()).minutes(bonusFrom.minutes());
                        bonusTo = shiftFrom.clone().hours(bonusTo.hours()).minutes(bonusTo.minutes());

                        if (minMaxCheckFrom != null && minMaxCheckTo != null) {
                            minMaxCheckFrom = shiftFrom.clone().hours(minMaxCheckFrom.hours()).minutes(minMaxCheckFrom.minutes());
                            minMaxCheckTo = shiftFrom.clone().hours(minMaxCheckTo.hours()).minutes(minMaxCheckTo.minutes());
                        }



                        if(bonusFrom.format() == bonusTo.format()){
                            //unbroken interval => find longest timeframe

                            let t = actualShiftFrom.clone().startOf('day');
                            let bFrom = null;
                            while (t < actualShiftTo){
                                if(setting.weekDays != null && setting.weekDays.includes(t.isoWeekday())){

                                    bFrom = t;
                                    break;
                                }
                                t = t.add(1, 'days');
                            }
                            if(bFrom != null){
                                bFrom = bFrom.hours(bonusFrom.hours()).minutes(bonusFrom.minutes());
                                t = bFrom.clone();
                                while(t < actualShiftTo && (setting.weekDays != null && setting.weekDays.includes(t.isoWeekday()))){
                                    t.add(1, 'days');
                                }
                                let bTo = t;
                                t = bFrom.clone().add(-1, 'days')
                                if(setting.weekDays != null && setting.weekDays.includes(t.isoWeekday())){
                                    bFrom = t;
                                }


                                if(actualShiftFrom < bTo && actualShiftTo > bFrom){
                                    if(minMaxCheckFrom != null && minMaxCheckTo != null){
                                        minMaxCheckFrom = bFrom.clone().hours(minMaxCheckFrom.hours()).minutes(minMaxCheckFrom.minutes());
                                        minMaxCheckTo = bTo.clone().hours(minMaxCheckTo.hours()).minutes(minMaxCheckTo.minutes());
                                        if(minMaxCheckTo <= minMaxCheckFrom){
                                            minMaxCheckTo = minMaxCheckTo.add(1, 'days');
                                        }
                                        if(!(minMaxCheckTo > bFrom && minMaxCheckFrom < bTo)){
                                            //the check intervals don't overlap -> subtract a day to make them overlap (e.g. interval is 00:00 - 06:00 and check is 17:00 - 07:00)
                                            minMaxCheckFrom = minMaxCheckFrom.add(-1, 'days');
                                            minMaxCheckTo = minMaxCheckTo.add(-1, 'days');
                                        }
                                    }

                                    let entryResult = this.calculateBonusPaymentEntry(shift, actualShiftFlag, actualShiftFrom, actualShiftTo, shiftFrom, shiftTo, bFrom, bTo, minMaxCheckFrom, minMaxCheckTo, hourlyWage, setting, actualShiftBreakMap);
                                    if(entryResult.count > 0 || entryResult.time > 0){
                                        foundResult = true;
                                        result.count += entryResult.count;
                                        result.countBonus += entryResult.countBonus;
                                        result.time += entryResult.time;
                                        result.timeBonus += entryResult.timeBonus;
                                        result.settingTime += entryResult.settingTime;
                                    }
                                }

                            }


                        } else {

                            if (bonusTo <= bonusFrom) {
                                bonusTo.add(1, 'days');
                            }

                            if(minMaxCheckFrom != null && minMaxCheckTo != null){
                                if(minMaxCheckTo <= minMaxCheckFrom){
                                    minMaxCheckTo = minMaxCheckTo.add(1, 'days');
                                }
                                if(!(minMaxCheckTo > bonusFrom && minMaxCheckFrom < bonusTo)){
                                    //the check intervals don't overlap -> subtract a day to make them overlap (e.g. interval is 00:00 - 06:00 and check is 17:00 - 07:00)
                                    minMaxCheckFrom = minMaxCheckFrom.add(-1, 'days');
                                    minMaxCheckTo = minMaxCheckTo.add(-1, 'days');
                                }
                            }

                            if(setting.weekDays != null && setting.weekDays.includes(bonusFrom.isoWeekday())){
                                foundResult = true;
                                let entryResult = this.calculateBonusPaymentEntry(shift, actualShiftFlag, actualShiftFrom, actualShiftTo, shiftFrom, shiftTo, bonusFrom, bonusTo, minMaxCheckFrom, minMaxCheckTo, hourlyWage, setting, actualShiftBreakMap);

                                result.count += entryResult.count;
                                result.countBonus += entryResult.countBonus;
                                result.time += entryResult.time;
                                result.timeBonus += entryResult.timeBonus;
                                result.settingTime += entryResult.settingTime;
                            }


                            if (overMidnight) {
                                //nightwork goes over midnight => WE NEED TO CHECK IF THE SHIFT MATCHES WITH BONUSWORK OF 'PREVIOUS' DAY
                                let bFrom = bonusFrom.clone().add(-1, 'days');
                                let bTo = bonusTo.clone().add(-1, 'days');

                                let mmCFrom = null;
                                let mmCTo = null;

                                if(minMaxCheckFrom != null && minMaxCheckTo != null){
                                    mmCFrom = minMaxCheckFrom.clone().add(-1, 'days');
                                    mmCTo = minMaxCheckTo.clone().add(-1, 'days');
                                    
                                }

                                if(setting.weekDays != null && setting.weekDays.includes(bFrom.isoWeekday())){

                                    let entryResult = this.calculateBonusPaymentEntry(shift, actualShiftFlag, actualShiftFrom, actualShiftTo, shiftFrom, shiftTo, bFrom, bTo, mmCFrom, mmCTo, hourlyWage, setting, actualShiftBreakMap);

                                    if(entryResult.count > 0 || entryResult.time > 0){
                                        foundResult = true;
                                        result.count += entryResult.count;
                                        result.countBonus += entryResult.countBonus;
                                        result.time += entryResult.time;
                                        result.timeBonus += entryResult.timeBonus;
                                        result.settingTime += entryResult.settingTime;
                                    }

                                }

                            }
                            if (actualShiftTo.date() != actualShiftFrom.date() /* && shiftTo < currentMonthToTZ */) {
                                //shift goes over midnight => WE NEED TO CHECK IF SHIFT MATCHES WITH BONUSWORK OF NEXT DAY

                                let bFrom = bonusFrom.clone().add(1, 'days');
                                let bTo = bonusTo.clone().add(1, 'days');

                                let mmCFrom = null;
                                let mmCTo = null;

                                if(minMaxCheckFrom != null && minMaxCheckTo != null){
                                    mmCFrom = minMaxCheckFrom.clone().add(1, 'days');
                                    mmCTo = minMaxCheckTo.clone().add(1, 'days');
                                    
                                }

                                if(setting.weekDays != null && setting.weekDays.includes(bFrom.isoWeekday())){

                                    let entryResult = this.calculateBonusPaymentEntry(shift, actualShiftFlag, actualShiftFrom, actualShiftTo, shiftFrom, shiftTo, bFrom, bTo, mmCFrom, mmCTo, hourlyWage, setting, actualShiftBreakMap);

                                    if(entryResult.count > 0 || entryResult.time > 0){
                                        foundResult = true;
                                        result.count += entryResult.count;
                                        result.countBonus += entryResult.countBonus;
                                        result.time += entryResult.time;
                                        result.timeBonus += entryResult.timeBonus;
                                        result.settingTime += entryResult.settingTime;
                                    }

                                }
                            }
                        }
                    }

                    if(setting.ewbWorkTimePercentage > 0){
                        result.ewbWorkTime = Math.round(result.settingTime * setting.ewbWorkTimePercentage/100.0);

                    }

                    if(foundResult && result.settingTime > 0){
                        if(setting.exclusiveGroup == null){
                            if(!bonusPaymentResultMap[setting.id]){
                                bonusPaymentResultMap[setting.id] = {
                                    name: setting.name,
                                    count: 0,
                                    countBonus: 0,
                                    time: 0,
                                    timeBonus: 0,
                                    entries: [],
                                    equalizeMonthly: setting.equalizeMonthly,
                                    ewbWorkTime: 0
                                };
                            }
                            bonusPaymentResultMap[setting.id].count += result.count;
                            bonusPaymentResultMap[setting.id].countBonus += result.countBonus;
                            bonusPaymentResultMap[setting.id].time += result.time;
                            bonusPaymentResultMap[setting.id].timeBonus += result.timeBonus;
                            bonusPaymentResultMap[setting.id].ewbWorkTime += result.ewbWorkTime;
                            bonusPaymentResultMap[setting.id].entries.push(result);
                        } else {
                            //setting belongs to exclusive group for which we will only take the max value of group into account;
                            let key = ""+setting.exclusiveGroup;
                            if(!exclusiveResultMap[key]){
                                exclusiveResultMap[key] = result;
                            } else {
                                let oldResult = exclusiveResultMap[key];

                                if(result.priority > oldResult.priority){
                                    exclusiveResultMap[key] = result;
                                } else if(result.priority == oldResult.priority){
                                    if(result.settingTime > oldResult.settingTime){
                                        exclusiveResultMap[key] = result;
                                    } else if(result.settingTime == oldResult.settingTime ){
                                        if(Math.max(result.timeBonus, result.countBonus) > Math.max(oldResult.timeBonus, oldResult.countBonus)){
                                            exclusiveResultMap[key] = result;
                                        }
                                    }
                                }

                            }
                        }
                    }

                }
            }

        });
        //iterate through exclusiveResultMap and apply result to bonusPaymentResultMap
        Object.values(exclusiveResultMap).forEach(result => {
            if(!bonusPaymentResultMap[result.id]){
                bonusPaymentResultMap[result.id] = {
                    name: result.name,
                    count: 0,
                    countBonus: 0,
                    time: 0,
                    timeBonus: 0,
                    entries: [],
                    equalizeMonthly: bonusPaymentSettingsMap[result.id].equalizeMonthly,
                    ewbWorkTime: 0
                };
            }
            bonusPaymentResultMap[result.id].count += result.count;
            bonusPaymentResultMap[result.id].countBonus += result.countBonus;
            bonusPaymentResultMap[result.id].time += result.time;
            bonusPaymentResultMap[result.id].timeBonus += result.timeBonus;
            bonusPaymentResultMap[result.id].ewbWorkTime += result.ewbWorkTime;
            bonusPaymentResultMap[result.id].entries.push(result);
        })

    }


    calculateBonusPaymentEntry(shift, actualShiftFlag, actualShiftFrom, actualShiftTo, shiftFrom, shiftTo, bonusFrom, bonusTo, minMaxCheckFrom, minMaxCheckTo, hourlyWage, setting, actualShiftBreakMap, withinFrom = null, withinTo = null) {
        let result = {
            count: 0,
            countBonus: 0,
            time: 0,
            timeBonus: 0,
            settingTime: 0,
        };
        //check full shift
        let checkRatioFrom = actualShiftFrom < bonusFrom ? bonusFrom : (actualShiftFrom > bonusTo ? bonusTo : actualShiftFrom);
        let checkRatioTo = actualShiftTo > bonusTo ? bonusTo : (actualShiftTo < bonusFrom ? bonusFrom : actualShiftTo);
        
        let minMaxCheckRatioFrom = null;
        if(minMaxCheckFrom != null){
            minMaxCheckRatioFrom = actualShiftFrom < minMaxCheckFrom ? minMaxCheckFrom : (actualShiftFrom > minMaxCheckTo ? minMaxCheckTo : actualShiftFrom);
        } else {
            minMaxCheckRatioFrom = checkRatioFrom;
        }

        let minMaxCheckRatioTo = null;
        if(minMaxCheckTo != null){  
            minMaxCheckRatioTo = actualShiftTo > minMaxCheckTo ? minMaxCheckTo : (actualShiftTo < minMaxCheckFrom ? minMaxCheckFrom : actualShiftTo);
        } else {
            minMaxCheckRatioTo = checkRatioTo;
        }
        

        let checkRatio = checkRatioTo.diff(checkRatioFrom) / actualShiftTo.diff(actualShiftFrom);
        let withinCheckFrom = withinFrom ? withinFrom : bonusFrom;
        let withinCheckTo = withinTo ? withinTo : bonusTo;
        let startsWithinCheck = !setting.startsWithin || (setting.startsWithin && actualShiftFrom >= withinCheckFrom && actualShiftFrom < withinCheckTo);

        let ratioFrom = shiftFrom < bonusFrom ? bonusFrom : (shiftFrom > bonusTo ? bonusTo : shiftFrom);
        let ratioTo = shiftTo > bonusTo ? bonusTo : (shiftTo < bonusFrom ? bonusFrom : shiftTo);
        
        let ratio = ratioTo.diff(ratioFrom) / shiftTo.diff(shiftFrom);

        if (checkRatio >= 0.00001 && startsWithinCheck) {
            let nwTime = ratioTo.diff(ratioFrom, 'minutes');
            let checkTime = minMaxCheckRatioTo.diff(minMaxCheckRatioFrom, 'minutes');

            let minFlag = setting.minWorkTime == null || setting.minWorkTime == 0 || checkTime >= setting.minWorkTime;
            let maxFlag = setting.maxWorkTime == null || setting.maxWorkTime > checkTime;
            if(minFlag && maxFlag){

                if (actualShiftFlag && actualShiftBreakMap[shift.id] && actualShiftBreakMap[shift.id].length > 0) {
                    let breaks = actualShiftBreakMap[shift.id];
                    breaks.forEach(abreak => {
                        let check = this.CheckActualBreakFromToInActualShift(abreak, actualShiftFrom, actualShiftTo);
                        if (check.isNonZeroDiff) {
                            let breakFrom = check.from;
                            let breakTo = check.to;
                            if (breakFrom < ratioTo && breakTo > ratioFrom) {
                                let nwBreakFrom = breakFrom < ratioFrom ? ratioFrom : (breakFrom > ratioTo ? ratioTo : breakFrom);
                                let nwBreakTo = breakTo > ratioTo ? ratioTo : (breakTo < ratioFrom ? ratioFrom : breakTo);
                                if (nwBreakFrom.utcOffset() != nwBreakTo.utcOffset()) {
                                    //nwBreakTo = nwBreakTo.clone().utcOffset(nwBreakFrom.utcOffset(), true);
                                }
                                nwTime -= Math.max(0, nwBreakTo.diff(nwBreakFrom, 'minutes'));
                            }
                        }
                    });
                }
                if (!actualShiftFlag && shift.breakValue > 0) {
                    if (shift.breakFrom != null) {
                        let breakFrom = this.getMomentFromStringTZ(shift.breakFrom);
                        let breakTo = breakFrom.clone().add(shift.breakValue, 'minutes');
                        if (breakFrom < ratioTo && breakTo > ratioFrom) {
                            let nwBreakFrom = breakFrom < ratioFrom ? ratioFrom : (breakFrom > ratioTo ? ratioTo : breakFrom);
                            let nwBreakTo = breakTo > ratioTo ? ratioTo : (breakTo < ratioFrom ? ratioFrom : breakTo);
                            if (nwBreakFrom.utcOffset() != nwBreakTo.utcOffset()) {
                                //nwBreakTo = nwBreakTo.clone().utcOffset(nwBreakFrom.utcOffset(), true);
                            }
                            nwTime -= Math.max(0, nwBreakTo.diff(nwBreakFrom, 'minutes'));
                        }
                    } else {
                        nwTime = Math.max(0, nwTime - Math.round(shift.breakValue * ratio));
                    }
                }

                let hourlyBonus = setting.useHourlyWage ? (hourlyWage * setting.hourlyWagePercentage/100.0) : setting.bonusHour;

                if (setting.bonusMode == 1) {
                    if ((checkRatio > setting.bonusCutoff / 100.0) && shiftFrom.month() == actualShiftFrom.month()) {
                        result.settingTime = checkTime;
                        result.count += 1;
                        result.countBonus += setting.bonusShift;
                    } else if ((checkRatio <= setting.bonusCutoff / 100.0)) {
                        result.settingTime = nwTime;
                        result.time += nwTime;
                        result.timeBonus += (result.time / 60) * hourlyBonus;
                    }
                } else if ((setting.bonusMode == 2) && shiftFrom.month() == actualShiftFrom.month()) {
                    result.settingTime = checkTime;
                    result.count += 1;
                    result.countBonus += setting.bonusShift;
                } else if (setting.bonusMode == 3) {
                    result.settingTime = nwTime;
                    result.time += nwTime;
                    result.timeBonus += (result.time / 60) * hourlyBonus;
                } else if ((setting.bonusMode == 4) && shiftFrom.month() == actualShiftFrom.month() && (checkRatio > setting.bonusCutoff / 100.0)) {
                    result.settingTime = checkTime;
                    result.count += 1;
                    result.countBonus += setting.bonusShift;
                } else if (setting.bonusMode == 5 && (checkRatio > setting.bonusCutoff / 100.0)) {
                    result.settingTime = nwTime;
                    result.time += nwTime;
                    result.timeBonus += (result.time / 60) * hourlyBonus;
                }
            }

        }

        return result;
    }

    GetMomentDayNumberFromUnixEpoch(moment) {
        return Math.floor((moment.clone().startOf('day')._d.getTime() - (moment.utcOffset() * 60 * 1000)) / (24 * 60 * 60 * 1000));
    }


    //example

    //this.$helpers.OpenColorSelection(
    //  (color) => {
    //      store.color = color;
    //      view.$forceUpdate();
    //  },
    //  {
    //      header: 'Wahl-Farben',
    //      colorSelection: this.spotsStructured.map(s => { return s.color}),
    //      colorSelected: store.color,
    //      colorBlacklist: this.spotsStructured.map(s => { return {color: s.color, label: s.name}})
    //  }
    //);
    //
    //or just for default values
    //this.$helpers.OpenColorSelection((color) => { store.color = color; }},

    OpenColorSelection(callback, options = {}) {
        this.OpenPopup({
            expanded: true,
            noScroll: true,
            header: options.header ? options.header : i18n.t('global.ui.selectColors'),
            components: [{
                type: 'colorselection',
                customEvents: {
                    'ApplyColor': callback
                },
                propContainer: {
                    color: options.colorSelected,
                    colorSelection: options.colorSelection,
                    colorBlacklist: options.colorBlacklist
                },
            }],
        });
    }

    CalculateRosterFromTo(date){
        let fixedDate = this.getMomentTZ().year(date.year()).month(date.month()).date(date.date()).startOf('day');

        let from = fixedDate.clone().startOf('isoWeek');
        let to = fixedDate.clone().endOf('month');
        if(from.format() == fixedDate.format()){
            from = from.add(-1, 'weeks').startOf('isoWeek')
        }
        if(to.isoWeekday() == 7){
            to = to.endOf('isoWeek').add(2,'weeks').startOf('isoWeek');
        } else {
            to = to.endOf('isoWeek').add(1,'weeks').startOf('isoWeek');
        }
        let rosterFromTo = {
            year: fixedDate.year(),
            month: fixedDate.month(),
            from: from.format(),
            to: to.format(),
        };
        return rosterFromTo;
    }

    GetAccountingPeriodSettingState(setting, month, priority = null, availableMonths, contractTypes, employeeCategories, employmentTypes, employeeLevels, storeSettings, presentSaveOption = false, employees = null, callback){
        let state = {

        }
        let conditionJoinModes = [{label: i18n.t('global.ui.and'), value: true}, {label: i18n.t('global.ui.or'), value: false}]
        let overTimeModes = [{label: i18n.t('workBalance.accounting.noAdjustment'), value: 0}, {label: i18n.t('workBalance.accounting.balanceOvertime'), value: 1}, {label: i18n.t('workBalance.accounting.addOvertimeUpgradeToBalance'), value: 2}, {label: i18n.t('workBalance.accounting.addReconciledOvertimeToBalance'), value: 3}]

        let selectedOverTimeMode = setting != null ? overTimeModes.find(m => m.value == setting.overTimeMode) : overTimeModes[0];

        let entries = [];
        if(setting != null){
            entries.push({label: 'Id', key: 'id', hidden: true, type: 'text', value: setting.id});
            entries.push({label: i18n.t('global.ui.prio'), key: 'priority', hidden: false, disabled: true, type: 'numeric', value: setting.priority })
            entries.push(
                {label: i18n.tc('global.general.month', 1), key: 'month', hidden: true, value: setting.month}
            )
        } else {

            if(month != null){
                entries.push({label: i18n.t('global.ui.prio'), key: 'priority', hidden: false, disabled: true, type: 'numeric', value: 1 })
                entries.push(
                    {label: i18n.tc('global.general.month', 1), key: 'month', hidden: true, value: month}
                )
            } else if(priority != null) {
                entries.push({label: i18n.t('global.ui.prio'), key: 'priority', hidden: false, disabled: true, type: 'numeric', value: priority })
                entries.push(
                    {label: i18n.tc('global.general.month', 2), key: 'months', hidden: false, type: 'dropdownsearch', value: null,
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: availableMonths[""+priority],
                            selectMultiple: true,
                            selectedItems: [],
                            selectFirst: false,
                            styleLight: true,
                        }
                    }
                )
            } else {
                entries.push({label: 'Id', key: 'id', hidden: true, type: 'text', value: null});

                let prevPrio = 1;
                entries.push(
                    {label: i18n.t('global.ui.prio'), key: 'priority', hidden: false, type: 'slider', value: 1,
                        slider: {min: 1, max: 3, value: 1, step: 1, inputControl: true, sliderInput: (x) => {return x}},
                        computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let months = datafill.entries.find(i => i.key == 'months');
                            if(prevPrio != lastVal){
                                months.value = null;

                                months.dropdownSearchState = {
                                    toggled: false,
                                    displayedItems: [],
                                    input: '',
                                    items: availableMonths[""+lastVal],
                                    selectMultiple: true,
                                    selectedItems: [],
                                    selectFirst: false,
                                    styleLight: true,
                                }


                            }

                            prevPrio = lastVal;

                            return entryBeforeUpdate;
                        }
                    }
                )
                entries.push(
                    {label: i18n.tc('global.general.month', 2), key: 'months', hidden: false, type: 'dropdownsearch', value: null,
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: availableMonths["1"],
                            selectMultiple: true,
                            selectedItems: [],
                            selectFirst: false,
                            styleLight: true,
                        }
                    }
                )

            }
        }
        if(employees != null && employees.length > 0){
            entries.push({label: i18n.t('global.ui.selectEmployee'), key: 'employeeFlag', hidden: true, type: 'bool', value: true});
            entries.push({label: i18n.tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: false,
                dropdownSearchState: {
                    selectMultiple: true, styleLight: true,
                    items: employees.map(e => {
                        return {
                            label: e.label,
                            value: e.value,
                            selected: false
                        }
                    }),
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag').value;
                    if(employeeFlag){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.dropdownSearchState.selectedItems = [];
                        entryBeforeUpdate.value = [];
                        entryBeforeUpdate.hidden = true;
                    }

                    return entryBeforeUpdate;
                }
            });
            entries.push({label: i18n.t('workBalance.accounting.applyToUnderage'), key: 'applyToUnderage', hidden: true, type: 'bool', value: true});
        } else {
            entries = entries.concat([

                {label: i18n.t('workBalance.accounting.useContractTypes'), key: 'useContractTypes', hidden: false, type: 'bool', value: setting != null ? setting.useContractTypes : true, computed: (datafill, lastVal, entryBeforeUpdate) => {

                        let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag');
                        employeeFlag = employeeFlag != null ? employeeFlag.value : false;

                        if(!employeeFlag){

                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.value = true;
                            entryBeforeUpdate.hidden = true;
                        }

                        return entryBeforeUpdate;
                    }},
                {label: i18n.tc('pages.employeeContract.contractType', 2), key: 'contractTypes', hidden: setting != null ? !setting.useContractTypes: false, type: 'dropdownsearch', value: setting != null ? setting.contractTypes: null, dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: setting != null ? contractTypes.map(c => {
                            return {
                                label: c.label,
                                value: c.value,
                                selected: setting.contractTypes.find(v => v == c.value)
                            }
                        }) :contractTypes,
                        selectMultiple: true,
                        selectedItems: [],
                        selectFirst: false,
                        styleLight: true,
                    }, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let useContractTypes = datafill.entries.find(i => i.key == 'useContractTypes').value;
                        let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag');
                        employeeFlag = employeeFlag != null ? employeeFlag.value : false;

                        if(useContractTypes && !employeeFlag){

                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.dropdownSearchState.selectedItems = [];
                            entryBeforeUpdate.value = [];
                            entryBeforeUpdate.hidden = true;
                        }
                        return entryBeforeUpdate;
                    }
                },
                {label: i18n.t('store.settings.minWeekHours'), key: 'minWeekTimeRegular', hidden: setting != null ? setting.useContractTypes : true,
                    type: 'slider', value: setting != null ? setting.minWeekTimeRegular : 0*60, min: 0*60, max: 60*60,
                    slider: {min: 0*60, max: 60*60, value: setting != null ? setting.minWeekTimeRegular : 0*60, step: 15,
                        DisplayLabel: (val) => {return (val/60).toFixed(2);}, inputControl: true, sliderInput: (x) => { return x * 60}
                    }, computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let useContractTypes = datafill.entries.find(i => i.key == 'useContractTypes').value;
                        let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag');
                        employeeFlag = employeeFlag != null ? employeeFlag.value : false;

                        if(useContractTypes || employeeFlag){

                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = 0;
                        } else {
                            entryBeforeUpdate.hidden = false;
                        }

                    return entryBeforeUpdate;
                }},
                {label: i18n.t('store.settings.maxWeekHours'), key: 'maxWeekTimeRegular', hidden: setting != null ? setting.useContractTypes : true,
                    type: 'slider', value: setting != null ? setting.maxWeekTimeRegular :40*60, min: 0*60, max: 60*60,
                    slider: {min: 0*60, max: 60*60, value: setting != null ? setting.maxWeekTimeRegular : 40*60, step: 15,
                        DisplayLabel: (val) => {return (val/60).toFixed(2);}, inputControl: true, sliderInput: (x) => { return x * 60}},
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let useContractTypes = datafill.entries.find(i => i.key == 'useContractTypes').value;
                        let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag');
                        employeeFlag = employeeFlag != null ? employeeFlag.value : false;

                        if(useContractTypes || employeeFlag){
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = 40*60;
                        } else {
                            entryBeforeUpdate.hidden = false;
                        }
                        return entryBeforeUpdate;
                    }},
                {label: i18n.t('workBalance.accounting.employeeCategories'), key: 'employeeCategories', hidden: false, type: 'dropdownsearch', value: setting != null ? setting.employeeCategories : null, dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: setting != null ?  employeeCategories.map(c => {
                            return {
                                label: c.label,
                                value: c.value,
                                selected: setting.employeeCategories.find(v => v == c.value)
                            }
                        }) : employeeCategories,
                        selectMultiple: true,
                        selectFirst: false,
                        styleLight: true,
                    }, computed: (datafill, lastVal, entryBeforeUpdate) => {

                        let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag');
                        employeeFlag = employeeFlag != null ? employeeFlag.value : false;

                        if(!employeeFlag){

                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.dropdownSearchState.selectedItems = [];
                            entryBeforeUpdate.value = [];
                            entryBeforeUpdate.hidden = true;
                        }
                        return entryBeforeUpdate;
                    }
                },
                {label: i18n.t('pages.employeeContract.employmentType'), key: 'employmentTypes', hidden: false, type: 'dropdownsearch', value: setting != null ? setting.employmentTypes : null, dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: setting != null ?  employmentTypes.map(c => {
                            return {
                                label: c.label,
                                value: c.value,
                                selected: setting.employmentTypes.find(v => v == c.value)
                            }
                        }) : employmentTypes,
                        selectMultiple: true,
                        selectFirst: false,
                        styleLight: true,
                    }, computed: (datafill, lastVal, entryBeforeUpdate) => {

                        let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag');
                        employeeFlag = employeeFlag != null ? employeeFlag.value : false;

                        if(!employeeFlag){

                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.dropdownSearchState.selectedItems = [];
                            entryBeforeUpdate.value = [];
                            entryBeforeUpdate.hidden = true;
                        }
                        return entryBeforeUpdate;
                    }
                },
                {label: i18n.tc('store.structure.employeeLevel', 2), key: 'employeeLevels', hidden: false, type: 'dropdownsearch', value: setting != null ? setting.employeeLevels : null, dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: setting != null ? employeeLevels.map(c => {
                            return {
                                label: c.label,
                                value: c.value,
                                selected: setting.employeeLevels.find(v => v == c.value)
                            }
                        }) : employeeLevels,
                        selectMultiple: true,
                        selectFirst: false,
                        styleLight: true,
                    }, computed: (datafill, lastVal, entryBeforeUpdate) => {

                        let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag');
                        employeeFlag = employeeFlag != null ? employeeFlag.value : false;

                        if(!employeeFlag){

                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.dropdownSearchState.selectedItems = [];
                            entryBeforeUpdate.value = [];
                            entryBeforeUpdate.hidden = true;
                        }
                        return entryBeforeUpdate;
                    }
                },
                {label: i18n.t('workBalance.accounting.linkCondition'), key: 'conditionJoin', hidden: false, type: 'dropdownsearch', value: setting != null ? setting.conditionJoin: false, dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: conditionJoinModes,
                        selectMultiple: false,
                        selectedItem: setting != null ? conditionJoinModes.find(c => c.value == setting.conditionJoin) : conditionJoinModes[1],
                        selectFirst: false,
                        styleLight: true,
                    }, computed: (datafill, lastVal, entryBeforeUpdate) => {

                        let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag');
                        employeeFlag = employeeFlag != null ? employeeFlag.value : false;

                        if(!employeeFlag){

                            entryBeforeUpdate.hidden = false;
                        } else {

                            entryBeforeUpdate.hidden = true;
                        }
                        return entryBeforeUpdate;
                    }
                },
                {label: i18n.t('workBalance.accounting.applyToUnderage'), key: 'applyToUnderage', hidden: false, type: 'bool', value: setting != null ? setting.applyToUnderage : true},
            ]);
        }

        entries = entries.concat([
            {label: i18n.t('workBalance.accounting.useMultiplier'), key: 'useWorkTimeFactor', hidden: !storeSettings.enableWorkBalanceMultiplier && ( setting != null ? !setting.useWorkTimeFactor : true), type: 'bool', value: setting != null ? setting.useWorkTimeFactor : false},
            {label: i18n.t('workBalance.accounting.workTimeFactor'), key: 'workTimeFactor', hidden: !storeSettings.enableWorkBalanceMultiplier && ( setting != null ? !setting.useWorkTimeFactor : true), type: 'slider', value: setting != null ? setting.workTimeFactor : storeSettings.workBalanceMultiplier,
                slider: {
                    min: 0, max: 200, value: setting != null ? setting.workTimeFactor : storeSettings.workBalanceMultiplier, step: 5,
                    inputControl: true,
                    sliderInput: (x) => {return Math.round(x*100.0)},
                    labelToInt: (x) => {return x.slice(0, -1)},
                    DisplayLabel: (val) => {return (val/100.0).toFixed(2)},
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                    if(useWorkTimeFactor){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = storeSettings.workBalanceMultiplier;
                        entryBeforeUpdate.slider.value = entryBeforeUpdate.value;
                        entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                    }
                    return entryBeforeUpdate;
                }
            },
            {label: i18n.t('workBalance.accounting.useMoreTimeMultiplier'), key: 'useMoreTimeFactor', hidden: !storeSettings.enableWorkBalanceMultiplier && ( setting != null ? !setting.useWorkTimeFactor : true), type: 'bool', value: setting != null ? setting.moreTimeFactor > 0 : false,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                    if(!useWorkTimeFactor || storeSettings.country != 1){
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false;

                    } else {
                        entryBeforeUpdate.hidden = false;
                    }
                    return entryBeforeUpdate;
                }
            },
            {label: i18n.t('workBalance.accounting.moreTimeFactor'), key: 'moreTimeFactor', hidden: (!storeSettings.enableWorkBalanceMultiplier && ( setting != null ? !setting.useWorkTimeFactor : true)) || (setting != null ? setting.moreTimeFactor == 0 : false), type: 'slider', value: setting != null ? setting.moreTimeFactor : 0,
                slider: {
                    min: 0, max: 200, value: setting != null ? setting.moreTimeFactor : 0, step: 5,
                    inputControl: true,
                    sliderInput: (x) => {return Math.round(x*100.0)},
                    labelToInt: (x) => {return x.slice(0, -1)},
                    DisplayLabel: (val) => {return (val/100.0).toFixed(2)},
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useMoreTimeFactor = datafill.entries.find(i => i.key == 'useMoreTimeFactor').value;

                    if(useMoreTimeFactor){
                        entryBeforeUpdate.hidden = false;
                        if(entryBeforeUpdate.value == 0){
                            entryBeforeUpdate.value = 125;
                            entryBeforeUpdate.slider.value = entryBeforeUpdate.value;
                            entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                        }
                    } else {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = 0;
                        entryBeforeUpdate.slider.value = entryBeforeUpdate.value;
                        entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                    }
                    return entryBeforeUpdate;
                }
            },
            {label: i18n.t('workBalance.accounting.contractTypeFactorExemption1'), key: 'contractTypeFactorExemption1', hidden: !storeSettings.enableWorkBalanceMultiplier && ( setting != null ? !setting.useWorkTimeFactor : true), type: 'slider', value: setting != null ? setting.contractTypeFactorExemption1 : 0,
                slider: {
                    min: 0, max: 100*60, value: setting != null ? setting.contractTypeFactorExemption1 : 0, step: 15,
                    inputControl: true,
                    sliderInput: (x) => {return Math.round(x*60.0)},
                    labelToInt: (x) => {return x.slice(0, -1)},
                    DisplayLabel: (val) => {return (val/60.0).toFixed(2)},
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                    if(useWorkTimeFactor){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = 0;
                        entryBeforeUpdate.slider.value = entryBeforeUpdate.value;
                        entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                    }
                    return entryBeforeUpdate;
                }
            },
            {label: i18n.t('workBalance.accounting.contractTypeFactorExemption2'), key: 'contractTypeFactorExemption2', hidden: !storeSettings.enableWorkBalanceMultiplier && ( setting != null ? !setting.useWorkTimeFactor : true), type: 'slider', value: setting != null ? setting.contractTypeFactorExemption2 : 0,
                slider: {
                    min: 0, max: 100*60, value: setting != null ? setting.contractTypeFactorExemption2 : 0, step: 15,
                    inputControl: true,
                    sliderInput: (x) => {return Math.round(x*60.0)},
                    labelToInt: (x) => {return x.slice(0, -1)},
                    DisplayLabel: (val) => {return (val/60.0).toFixed(2)},
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                    if(useWorkTimeFactor){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = 0;
                        entryBeforeUpdate.slider.value = entryBeforeUpdate.value;
                        entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                    }
                    return entryBeforeUpdate;
                }
            },
            {label: i18n.t('workBalance.accounting.contractTypeFactorExemption3'), key: 'contractTypeFactorExemption3', hidden: !storeSettings.enableWorkBalanceMultiplier && ( setting != null ? !setting.useWorkTimeFactor : true), type: 'slider', value: setting != null ? setting.contractTypeFactorExemption3 : 0,
                slider: {
                    min: 0, max: 100*60, value: setting != null ? setting.contractTypeFactorExemption3 : 0, step: 15,
                    inputControl: true,
                    sliderInput: (x) => {return Math.round(x*60.0)},
                    labelToInt: (x) => {return x.slice(0, -1)},
                    DisplayLabel: (val) => {return (val/60.0).toFixed(2)},
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                    if(useWorkTimeFactor){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = 0;
                        entryBeforeUpdate.slider.value = entryBeforeUpdate.value;
                        entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                    }
                    return entryBeforeUpdate;
                }
            },


            {label: i18n.t('workBalance.accounting.reconcilePositive'), key: 'compensatePositiveWorkTime', hidden: setting != null ? setting.useWorkTimeFactor : false, type: 'bool', value: setting != null ? setting.compensatePositiveWorkTime : true, computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                    if(useWorkTimeFactor){
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false;
                    } else {
                        entryBeforeUpdate.hidden = false;
                    }
                    return entryBeforeUpdate;
                }},
            {label: i18n.t('workBalance.accounting.reconcileNegative'), key: 'compensateNegativeWorkTime', hidden: false, type: 'bool', value: setting != null ? setting.compensateNegativeWorkTime : true},
            {label: 'Nur Vertrags Soll ausgleichen', key: 'compensateToContract', hidden: true, type: 'bool', value: setting != null ? setting.compensateToContract: false, computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useWorkTimeFactor = datafill.entries.find(i => i.key == 'useWorkTimeFactor').value;

                    if(useWorkTimeFactor){
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false;
                    } else {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false;
                    }
                    return entryBeforeUpdate;
                }},
            {label: i18n.t('workBalance.accounting.addHolidayHoursToWorkTimeBalance'), key: 'useHolidayFactor', hidden: !storeSettings.separateOvertimeHolidayTime, type: 'bool', value: setting != null ? setting.useHolidayFactor : false, computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let compensatePositiveHolidays = datafill.entries.find(i => i.key == 'compensatePositiveHolidays').value;
                    let compensateNegativeHolidays = datafill.entries.find(i => i.key == 'compensateNegativeHolidays').value;

                    if( compensatePositiveHolidays || compensateNegativeHolidays){
                        entryBeforeUpdate.value = false;

                    }
                    return entryBeforeUpdate;
                }},
            {label: i18n.t('workBalance.accounting.addHolidayHoursToPositiveBalance'), key: 'useHolidayFactorForPositive', hidden: setting != null ? !setting.useHolidayFactor : true, type: 'bool', value: setting != null ? setting.useHolidayFactorForPositive : false, computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useHolidayFactor = datafill.entries.find(i => i.key == 'useHolidayFactor').value;

                    if(useHolidayFactor){
                        entryBeforeUpdate.hidden = false;

                    } else {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false;
                    }
                    return entryBeforeUpdate;
                }},
            {label: 'Feiertagsstunden auf negatives Arbeitszeitsaldo', key: 'useHolidayFactorForNegative', hidden: setting != null ? !setting.useHolidayFactor : true, type: 'bool', value: setting != null ? setting.useHolidayFactorForNegative : false, computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useHolidayFactor = datafill.entries.find(i => i.key == 'useHolidayFactor').value;

                    if(useHolidayFactor){
                        entryBeforeUpdate.hidden = false;

                    } else {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false;
                    }
                    return entryBeforeUpdate;
                }},
            {label: i18n.t('workBalance.accounting.reconcilePositiveHolidays'), key: 'compensatePositiveHolidays', hidden: setting != null ? setting.useHolidayFactor : false, type: 'bool', value: setting != null ? setting.compensatePositiveHolidays : true, computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useHolidayFactor = datafill.entries.find(i => i.key == 'useHolidayFactor').value;

                    if(useHolidayFactor){
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false;

                    } else {
                        entryBeforeUpdate.hidden = false;
                    }
                    return entryBeforeUpdate;
                }},
            {label: i18n.t('workBalance.accounting.reconcileNegativeHolidays'), key: 'compensateNegativeHolidays', hidden: setting != null ? setting.useHolidayFactor : false, type: 'bool', value: setting != null ? setting.compensateNegativeHolidays : true, computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useHolidayFactor = datafill.entries.find(i => i.key == 'useHolidayFactor').value;

                    if(useHolidayFactor){
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false;

                    } else {
                        entryBeforeUpdate.hidden = false;
                    }
                    return entryBeforeUpdate;
                }},
            {label: i18n.t('workBalance.payroll.reconcileNightWorkBalance'), key: 'compensateNightWorkTime', hidden: false, type: 'bool', value: setting != null ? setting.compensateNightWorkTime : true},
            {label: i18n.t('workBalance.accounting.addOvertimeToWorkTimeBalance'), key: 'overTimeMode', hidden: !storeSettings.separateOvertimeHolidayTime, type: 'dropdownsearch', value: selectedOverTimeMode.value, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: overTimeModes,
                    selectMultiple: false,
                    selectedItems: [selectedOverTimeMode],
                    selectedItem: selectedOverTimeMode,
                    selectFirst: false,
                    styleLight: true,
                }
            },


            {label: i18n.t('workBalance.accounting.addOvertimeToPositiveBalance'), key: 'useOvertimeFactorForPositive', hidden: setting != null ? !(setting.overTimeMode == 2) : true, type: 'bool', value: setting != null ? setting.useOvertimeFactorForPositive : false, computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let matchingMode = datafill.entries.find(i => i.key == 'overTimeMode').value == 2;

                    if(matchingMode){
                        entryBeforeUpdate.hidden = false;

                    } else {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false;
                    }
                    return entryBeforeUpdate;
                }},
            {label: i18n.t('workBalance.accounting.addOvertimeToNegativeBalance'), key: 'useOvertimeFactorForNegative', hidden: setting != null ? !(setting.overTimeMode == 2) : true, type: 'bool', value: setting != null ? setting.useOvertimeFactorForNegative : false, computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let matchingMode = datafill.entries.find(i => i.key == 'overTimeMode').value == 2;

                    if(matchingMode){
                        entryBeforeUpdate.hidden = false;

                    } else {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false;
                    }
                    return entryBeforeUpdate;
                }},
            {label: i18n.t('workBalance.payroll.useDeltaOverTimeFactor'), key: 'useDeltaOvertimeFactor', hidden: setting != null ? !(setting.overTimeMode == 2) : true, type: 'bool', value: setting != null ? setting.useDeltaOvertimeFactor : false, computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let matchingMode = datafill.entries.find(i => i.key == 'overTimeMode').value == 2;

                    if(matchingMode){
                        entryBeforeUpdate.hidden = false;

                    } else {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false;
                    }
                    return entryBeforeUpdate;
                }},

            {label: i18n.t('workBalance.payroll.overtimePositiveWorkTime'), key: 'compensateWorkTimeWithOvertime', hidden: setting != null ? !(setting.overTimeMode == 1) : true, type: 'bool', value: setting != null ? setting.compensateWorkTimeWithOvertime : false, computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let matchingMode = datafill.entries.find(i => i.key == 'overTimeMode').value == 1;

                    if(!matchingMode){
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false;

                    } else {
                        entryBeforeUpdate.hidden = false;
                    }
                    return entryBeforeUpdate;
                }},
            {label: i18n.t('workBalance.payroll.overtimeNegativeWorkTime'), key: 'compensateNegativeWorkTimeWithOvertime', hidden: setting != null ? !(setting.overTimeMode == 1) : true, type: 'bool', value: setting != null ? setting.compensateNegativeWorkTimeWithOvertime : false, computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let matchingMode = datafill.entries.find(i => i.key == 'overTimeMode').value == 1;

                    if(!matchingMode){
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false;

                    } else {
                        entryBeforeUpdate.hidden = false;
                    }
                    return entryBeforeUpdate;
                }},
            {label: i18n.t('workBalance.payroll.reconcileMoreTimeBalance'), key: 'compensateMoreTime', hidden: false, type: 'bool', value: setting != null ? setting.compensateMoreTime : true},
            {label: i18n.t('workBalance.payroll.reconcileBonusHoursBalance'), key: 'compensateBonusTime', hidden: false, type: 'bool', value: setting != null ? setting.compensateBonusTime : true},
            {label: i18n.t('workBalance.balances.roundUpVacationTime'), key: 'roundUpVacationTime', hidden: false, type: 'bool', value: setting != null ? setting.roundUpVacationTime : false},
            {label: i18n.t('workBalance.balances.compensateVacationTime'), key: 'compensateVacationTime', hidden: false, type: 'bool', value: setting != null ? setting.compensateVacationTime : false},
            {label: i18n.t('workBalance.accounting.endsAccountingPeriod'), key: 'endsAccountingPeriod', hidden: false, type: 'bool', value: setting != null ? setting.endsAccountingPeriod : true},


        ])
        if(presentSaveOption){
            entries.push({label: i18n.t('workBalance.balances.saveSettings'), key: 'saveSetting', hidden: false, type: 'bool', value: false, computed: (datafill, lastVal, entryBeforeUpdate) => {

                    let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag');
                    employeeFlag = employeeFlag != null ? employeeFlag.value : false;

                    if(!employeeFlag){

                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.value = false;
                        entryBeforeUpdate.hidden = true;
                    }
                    return entryBeforeUpdate;
                }})
        }
        state.entries = entries;
        state.selectCallback = callback;

        return state;
    }

    GetBonusPaymentSettingState(setting, uiData, collectiveContracts, spots, locations,
                                contractTypes, employeeCategories, employeeLevels, employmentTypes, storeSettings, presentSaveOption = false, employees = null, callback){
        let state = {

        }
        let conditionJoinModes = [{label: i18n.t('global.ui.and'), value: true}, {label: i18n.t('global.ui.or'), value: false}];

        let ccItems = collectiveContracts.filter(i=> i.country == storeSettings.country).map(i => {return {label: i.name, value: i.id, data: i}});
        ccItems.sort((a,b) => {
            return (a.label == "Systemgastronomie")? -1 : (b.label == "Systemgastronomie")? 1 : (a.label > b.label)? -1 : (b.label > a.label)? 1 : 0;
        });
        ccItems.push({label: i18n.tc('roster.comp.noContractModel'), value: null});
        let selectedCC = null;
        if(setting && setting.collectiveContractId){
            selectedCC = ccItems.find(i => i.value == setting.collectiveContractId);
        }

        let spotItems = spots.map(i => {return {label: i.name, value: i.id, data: i}});
        spotItems.sort((a,b) => {
            return  (a.label > b.label)? 1 : (b.label > a.label)? -1 : 0;
        });
        spotItems.push({label: i18n.t('store.settings.noPositions'), value: null});
        let selectedSpot = null;
        if(setting && setting.spotId){
            selectedSpot = spotItems.find(i => i.value == setting.spotId);
        }

        let shiftSpotItems = spots.map(i => {return {label: i.name, value: i.id, data: i}});
        shiftSpotItems.sort((a,b) => {
            return  (a.label > b.label)? 1 : (b.label > a.label)? -1 : 0;
        });
        shiftSpotItems.push({label: i18n.t('store.settings.noPositions'), value: null});
        let selectedShiftSpot = null;
        if(setting && setting.shiftSpotId){
            selectedShiftSpot = shiftSpotItems.find(i => i.value == setting.shiftSpotId);
        }

        let locationItems = locations.map(i => {return {label: i.name, value: i.id, data: i}});
        locationItems.sort((a,b) => {
            return  (a.label > b.label)? 1 : (b.label > a.label)? -1 : 0;
        });
        locationItems.push({label: i18n.t('store.settings.noLocation'), value: null});
        let selectedLocation = null;
        if(setting && setting.fromLocationId){
            selectedLocation = locationItems.find(i => i.value == setting.fromLocationId);
        }

        let bonusModeItems = uiData.nightWorkModes.map(i => {return {label: i.label_de, value: i.id, data: i}});
        let selectedMode = bonusModeItems[0];
        if(setting && setting.bonusMode){
            selectedMode = bonusModeItems.find(i => i.value == setting.bonusMode);
        }

        let holidayTypes = uiData.holidayTypes.map(i => {return {label: i.label_de, value: i.id, data: i}});
        let selectedHolidayTypes = [holidayTypes[0]];
        if(setting && setting.holidayTypes && setting.holidayTypes.length > 0){
            selectedHolidayTypes = holidayTypes.filter(i => setting.holidayTypes.find(j => j == i.value) != null);
        }
        selectedHolidayTypes.forEach(i => {
            i.selected = true;
        });


        let tValidFrom = setting && setting.from ? this.getMomentFromStringTZ(setting.from) : this.getMomentTZ().add(-1, 'weeks').startOf('day');
        let tValidTo = setting && setting.to ? this.getMomentFromStringTZ(setting.to).add(-1, 'days') : this.getMomentTZ().add(1, 'weeks').startOf('day');
        let bonusFrom = setting && setting.bonusFrom ? this.getMomentFromStringTZ(setting.bonusFrom, 'HH:mm') : this.getMomentTZ().hours(22).minutes(0);
        let bonusTo = setting && setting.bonusTo ? this.getMomentFromStringTZ(setting.bonusTo, 'HH:mm') : this.getMomentTZ().hours(6).minutes(0);

        let checkFrom = setting && setting.checkFrom ? this.getMomentFromStringTZ(setting.checkFrom, 'HH:mm') : bonusFrom.clone();
        let checkTo = setting && setting.checkTo ? this.getMomentFromStringTZ(setting.checkTo, 'HH:mm') : bonusTo.clone();
        let enableCheckTime = setting && (setting.checkFrom != null || setting.checkTo != null) && (setting.minWorkTime > 0 || setting.maxWorkTime > 0) ? true : false;


        let entries = [];
        if(setting != null){
            entries.push({label: 'Id', key: 'id', hidden: true, type: 'text', value: setting.id});

        }
        entries.push(
            {label: i18n.t('pages.employeeData.name'), key: 'name', hidden: false, value: setting ? setting.name : '', type: 'text'}
        )
        if(employees != null && employees.length > 0){
            entries.push({label: i18n.t('global.ui.selectEmployee'), key: 'employeeFlag', hidden: false, type: 'bool', value: false});
            entries.push({label: i18n.tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: true,
                dropdownSearchState: {
                    selectMultiple: true, styleLight: true,
                    items: employees.map(e => {
                        return {
                            label: e.label,
                            value: e.value,
                            selected: false
                        }
                    }),
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag').value;
                    if(employeeFlag){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.dropdownSearchState.selectedItems = [];
                        entryBeforeUpdate.value = [];
                        entryBeforeUpdate.hidden = true;
                    }

                    return entryBeforeUpdate;
                }
            });
        }

        entries = entries.concat([
            {divider: true},
            {label: i18n.t('workBalance.bonus.useHourlyWage'), key: 'useHourlyWage', hidden: false, type: 'bool', value: setting != null ? setting.useHourlyWage : false,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let mode = datafill.entries.find(i => i.key == 'bonusMode').value;
                    if(mode == 2 || mode == 4){
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false;
                    } else {

                        entryBeforeUpdate.hidden = false;
                    }

                    return entryBeforeUpdate;
                } },
            {label: i18n.t('store.settings.hourlyWageBonus'), key: 'hourlyWagePercentage', hidden: false, type: 'slider', value: setting != null ? setting.hourlyWagePercentage : 100,
                slider: {hideMin: true, hideMax: true, min: 0, max: 400, value: setting != null ? setting.hourlyWagePercentage : 100,
                    step: 1, inputControl: true, sliderInput: (x) => {return x}, labelToInt: (x) => {return x.slice(0, -1)},
                    DisplayLabel: (x) => {return x + '%'}, shorterDisplayLabel: (x) => {return x}},
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useHourlyWage = datafill.entries.find(i => i.key == 'useHourlyWage').value;
                    let mode = datafill.entries.find(i => i.key == 'bonusMode').value;
                    if(!useHourlyWage || mode == 2 || mode == 4){

                        entryBeforeUpdate.slider.value = 100;
                        entryBeforeUpdate.value = 100;
                        entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                        entryBeforeUpdate.hidden = true;

                    } else {
                        entryBeforeUpdate.hidden = false;
                    }

                    return entryBeforeUpdate;
                }
            },
            {label: i18n.t('workBalance.bonus.hourBonus'), key: 'bonusHour', hidden: false, type: 'slider', value: setting != null ? setting.bonusHour : 0,
                slider: {hideMin: true, hideMax: true, min: 0, max: 100*100, value: setting != null ? setting.bonusHour : 0,
                    step: 1, DisplayLabel: (val) => { return (val/100.0).toFixed(2)+"€";}, inputControl: true,
                    sliderInput: (x) => {return x * 100}},
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useHourlyWage = datafill.entries.find(i => i.key == 'useHourlyWage').value;
                    let mode = datafill.entries.find(i => i.key == 'bonusMode').value;
                    if(useHourlyWage || mode == 2 || mode == 4){

                        entryBeforeUpdate.slider.value = 0;
                        entryBeforeUpdate.value = 0;
                        entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                        entryBeforeUpdate.hidden = true;

                    } else {
                        entryBeforeUpdate.hidden = false;
                    }
                    return entryBeforeUpdate;
                }
            },
            {label: i18n.t('workBalance.bonus.lumpSumBonus'), key: 'bonusShift', hidden: false, type: 'slider', value: setting != null ? setting.bonusShift : 0,
                slider: {hideMin: true, hideMax: true, min: 0, max: 100*100, value: setting != null ? setting.bonusShift : 0,
                    step: 1, DisplayLabel: (val) => { return (val/100.0).toFixed(2)+"€";}, inputControl: true,
                    sliderInput: (x) => {return x * 100}},
                computed: (datafill, lastVal, entryBeforeUpdate) => {

                    let mode = datafill.entries.find(i => i.key == 'bonusMode').value;
                    if(mode == 3 || mode == 5){

                        entryBeforeUpdate.slider.value = 0;
                        entryBeforeUpdate.value = 0;
                        entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                        entryBeforeUpdate.hidden = true;

                    } else {
                        entryBeforeUpdate.hidden = false;
                    }
                    return entryBeforeUpdate;
                }
            },
            {label: i18n.t('workBalance.bonus.from'), key: 'bonusFrom', hidden: false, flexGroup: false, type: 'timeframe', value: bonusFrom, timeBig: false},
            {label: i18n.t('workBalance.bonus.till'), key: 'bonusTo', hidden: false, flexGroup: false, type: 'timeframe', value: bonusTo, timeBig: false},
            {label: i18n.t('workBalance.bonus.calculationMode'), key: 'bonusMode', hidden: false, type: 'dropdownsearch', value: selectedMode.value, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: bonusModeItems,
                    selectMultiple: false,
                    selectedItem: selectedMode,
                    selectFirst: false,
                    styleLight: true,
                }},
            {label: i18n.t('workBalance.bonus.lumpSumThreshold'), key: 'bonusCutoff', hidden: selectedMode.value == 2 || selectedMode.value == 3, type: 'slider', value: setting != null ? setting.bonusCutoff : 50,
                slider: {hideMin: true, hideMax: true, min: 0, max: 100, value: setting != null ? setting.bonusCutoff : 50,
                    step: 1, inputControl: true, sliderInput: (x) => {return x}, labelToInt: (x) => {return x.slice(0, -1)},
                    DisplayLabel: (x) => {return x + '%'}, shorterDisplayLabel: (x) => {return x}},
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let bonusMode = datafill.entries.find(i => i.key == 'bonusMode').value;

                    if(bonusMode == 2 || bonusMode == 3){

                        entryBeforeUpdate.slider.value = 50;
                        entryBeforeUpdate.value = 50;
                        entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                        entryBeforeUpdate.hidden = true;

                    } else {
                        entryBeforeUpdate.hidden = false;
                    }
                    return entryBeforeUpdate;
                }
            },
            {label: i18n.t('workBalance.bonus.minWorkTime'), key: 'minWorkTime', hidden: false, type: 'slider', value: setting != null ? setting.minWorkTime : 0,
                slider: {hideMin: true, hideMax: true, min: 0, max: 12 *60, value: setting != null ? setting.minWorkTime : 0,
                    step: 15, DisplayLabel: (val) => { return (val/60).toFixed(2)+"h";}, inputControl: true,
                    sliderInput: (x) => {return x * 60}, labelToInt: (x) => {return x.slice(0, -1)},
                    shorterDisplayLabel: (x) => {return (x / 60.0).toFixed(2)+'h'}}},
            {label: i18n.t('workBalance.bonus.applyMaxWorkTime'), key: 'useMaxWorkTime', hidden: false, type: 'bool', value: setting != null ? setting.maxWorkTime != null : false},
            {label: i18n.t('workBalance.bonus.maxWorkTime'), key: 'maxWorkTime', hidden: setting != null ? setting.maxWorkTime == null : true, type: 'slider', value: setting != null ? (setting.maxWorkTime != null ?  setting.maxWorkTime : 0): 0,
                slider: {hideMin: true, hideMax: true, min: 0, max: 24 *60, value: setting != null ? (setting.maxWorkTime != null ?  setting.maxWorkTime : 0) : 0,
                    step: 15, DisplayLabel: (val) => { return (val/60).toFixed(2)+"h";}, inputControl: true,
                    sliderInput: (x) => {return x * 60}, labelToInt: (x) => {return x.slice(0, -1)},
                    shorterDisplayLabel: (x) => {return (x / 60.0).toFixed(2)+'h'}},
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useMaxWorkTime = datafill.entries.find(i => i.key == 'useMaxWorkTime').value;

                    if(useMaxWorkTime){

                        entryBeforeUpdate.hidden = false;

                    } else {
                        entryBeforeUpdate.slider.value = 0;
                        entryBeforeUpdate.value = 0;
                        entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                        entryBeforeUpdate.hidden = true;

                    }
                    return entryBeforeUpdate;
                }},
            {label: i18n.t('workBalance.bonus.applyCheckTime'), key: 'useCheckTime', hidden: setting ? (setting.maxWorkTime > 0 || setting.minWorkTime > 0) : true, type: 'bool', value: enableCheckTime,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let minWorkTime = datafill.entries.find(i => i.key == 'minWorkTime').value;
                    let maxWorkTime = datafill.entries.find(i => i.key == 'maxWorkTime').value;

                    if(minWorkTime > 0 || maxWorkTime > 0){
                        entryBeforeUpdate.hidden = false;
                        
                    } else {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false;
                    }
                    return entryBeforeUpdate;
                }
            },
            {label: i18n.t('workBalance.bonus.checkFrom'), key: 'checkFrom', hidden: !enableCheckTime, flexGroup: false, type: 'timeframe', value: checkFrom, timeBig: false, 
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useCheckTime = datafill.entries.find(i => i.key == 'useCheckTime').value;

                    if(useCheckTime){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;
                    }
                    return entryBeforeUpdate;
                }
            },
            {label: i18n.t('workBalance.bonus.checkTo'), key: 'checkTo', hidden: !enableCheckTime, flexGroup: false, type: 'timeframe', value: checkTo, timeBig: false,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useCheckTime = datafill.entries.find(i => i.key == 'useCheckTime').value;

                    if(useCheckTime){
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;
                    }
                    return entryBeforeUpdate;
                }
            },
            
            {label: i18n.t('workBalance.bonus.shiftsStartsInterval'), key: 'startsWithin', hidden: false, flexGroup: false, type: 'bool', value: setting != null ? setting.startsWithin : false},

            {divider: true},
            {label: i18n.t('workBalance.bonus.applyExclusiveGroup'), key: 'useExclusiveGroup', hidden: false, type: 'bool', value: setting != null ? setting.exclusiveGroup != null : false},
            {label: i18n.t('workBalance.bonus.exclusiveGroup'), key: 'exclusiveGroup', hidden: setting != null ? setting.exclusiveGroup == null : true, type: 'slider', value: setting != null ? (setting.exclusiveGroup != null ?  setting.exclusiveGroup : 1): 1,
                slider: {hideMin: true, hideMax: true, min: 1, max: 10, value: setting != null ? (setting.exclusiveGroup != null ?  setting.exclusiveGroup : 1) : 1,
                    step: 1, DisplayLabel: (val) => { return val;}, inputControl: true, sliderInput:(x) => {return x}},
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useExclusiveGroup = datafill.entries.find(i => i.key == 'useExclusiveGroup').value;

                    if(useExclusiveGroup){

                        entryBeforeUpdate.hidden = false;

                    } else {
                        entryBeforeUpdate.slider.value = 1;
                        entryBeforeUpdate.value = 1;
                        entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                        entryBeforeUpdate.hidden = true;

                    }
                    return entryBeforeUpdate;
                }},
            {label: i18n.t('workBalance.bonus.prioInGroup'), key: 'priority', hidden: setting != null ? setting.exclusiveGroup == null : true, type: 'slider', value: setting != null ? (setting.exclusiveGroup != null ?  setting.priority : 1): 1,
                slider: {hideMin: true, hideMax: true, min: 1, max: 10, value: setting != null ? (setting.exclusiveGroup != null ?  setting.priority : 1) : 1,
                    step: 1, DisplayLabel: (val) => {return val;}, inputControl: true, sliderInput:(x) => {return x}},
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let useExclusiveGroup = datafill.entries.find(i => i.key == 'useExclusiveGroup').value;

                    if(useExclusiveGroup){

                        entryBeforeUpdate.hidden = false;

                    } else {
                        entryBeforeUpdate.slider.value = 1;
                        entryBeforeUpdate.value = 1;
                        entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                        entryBeforeUpdate.hidden = true;

                    }
                    return entryBeforeUpdate;
                }},
            {divider: true},
            {label: i18n.t('workBalance.bonus.recursIndefinitely'), key: 'noValidFrom', hidden: false, disabled: false, type: 'bool', value: setting ? setting.from == null : true},
            {label: i18n.t('pages.employeeContract.validFrom'), key: 'from', hidden: this.CheckDatafillKeysForHiddenInverted('noValidFrom'), type: 'date', value: tValidFrom, flexGroup: false},
            {label: i18n.t('workBalance.bonus.ongoingIndefinitely'), key: 'noValidTo', hidden: false, disabled: false, type: 'bool', value: setting ? setting.to == null : true},
            {label: i18n.t('pages.employeeContract.validUntil'), key: 'to', hidden: this.CheckDatafillKeysForHiddenInverted('noValidTo') , type: 'date', value: tValidTo, flexGroup: false},
            {label: i18n.tc('store.settings.weekdays', 2), key: 'weekDays', hidden: false, flexGroup: false, type: 'togglelist', toggleEntries: [
                    {label: i18n.t('store.openingHours.weekDay1Short'), value: 1, selected: setting ? setting.weekDays.includes(1) : true},
                    {label: i18n.t('store.openingHours.weekDay2Short'), value: 2, selected: setting ? setting.weekDays.includes(2) : true},
                    {label: i18n.t('store.openingHours.weekDay3Short'), value: 3, selected: setting ? setting.weekDays.includes(3) : true},
                    {label: i18n.t('store.openingHours.weekDay4Short'), value: 4, selected: setting ? setting.weekDays.includes(4) : true},
                    {label: i18n.t('store.openingHours.weekDay5Short'), value: 5, selected: setting ? setting.weekDays.includes(5) : true},
                    {label: i18n.t('store.openingHours.weekDay6Short'), value: 6, selected: setting ? setting.weekDays.includes(6) : true},
                    {label: i18n.t('store.openingHours.weekDay7Short'), value: 7, selected: setting ? setting.weekDays.includes(7) : true},
                ],
            },
            {label: i18n.t('workBalance.bonus.holidaysOnly'), key: 'onlyHoliday', hidden: false, type: 'bool', value: setting != null ? setting.onlyHoliday != null? setting.onlyHoliday : false : false},
            {label: i18n.t('workBalance.bonus.holidayType'), key: 'holidayTypes', hidden: setting != null ? setting.onlyHoliday == null : true, type: 'dropdownsearch', value: setting != null ? setting.holidayTypes : null,
                dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: holidayTypes,
                    selectMultiple: true,
                    selectedItems: selectedHolidayTypes,
                    selectFirst: false,
                    styleLight: true,
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    entryBeforeUpdate.hidden = !datafill.entries.find(i => i.key == 'onlyHoliday').value;
                    return entryBeforeUpdate;
                }
            },

            {divider: true},
            {label: i18n.t('pages.employeeContract.contractModel'), key: 'collectiveContractId', hidden: false, type: 'dropdownsearch', value: setting ? setting.collectiveContractId : null, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: ccItems,
                    selectMultiple: false,
                    selectedItem: selectedCC,
                    selectFirst: false,
                    styleLight: true,
                }},
            {label: i18n.t('workBalance.bonus.employeePosition'), key: 'spotId', hidden: false, type: 'dropdownsearch', value: setting ? setting.spotId : null, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: spotItems,
                    selectMultiple: false,
                    selectedItem: selectedSpot,
                    selectFirst: false,
                    styleLight: true,
                }},
            {label: i18n.t('workBalance.bonus.shiftPosition'), key: 'shiftSpotId', hidden: false, type: 'dropdownsearch', value: setting ? setting.shiftSpotId : null, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: shiftSpotItems,
                    selectMultiple: false,
                    selectedItem: selectedShiftSpot,
                    selectFirst: false,
                    styleLight: true,
                }},
            {label: i18n.t('workBalance.bonus.shiftLocation'), key: 'fromLocationId', hidden: false, type: 'dropdownsearch', value: setting ? setting.fromLocationId : null, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: locationItems,
                    selectMultiple: false,
                    selectedItem: selectedLocation,
                    selectFirst: false,
                    styleLight: true,
                }},
            {label: i18n.tc('pages.employeeContract.contractType', 2), key: 'contractTypes', hidden: false, type: 'dropdownsearch', value: setting != null ? setting.contractTypes: null, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: setting != null ? contractTypes.map(c => {
                        return {
                            label: c.label,
                            value: c.value,
                            selected: setting.contractTypes.find(v => v == c.value)
                        }
                    }) :contractTypes,
                    selectMultiple: true,
                    selectedItems: [],
                    selectFirst: false,
                    styleLight: true,
                }, computed: (datafill, lastVal, entryBeforeUpdate) => {

                    let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag');
                    employeeFlag = employeeFlag != null ? employeeFlag.value : false;

                    if(!employeeFlag){

                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.dropdownSearchState.selectedItems = [];
                        entryBeforeUpdate.value = [];
                        entryBeforeUpdate.hidden = true;
                    }
                    return entryBeforeUpdate;
                }
            },
            {label: i18n.t('workBalance.accounting.employeeCategories'), key: 'employeeCategories', hidden: false, type: 'dropdownsearch', value: setting != null ? setting.employeeCategories : null, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: setting != null ?  employeeCategories.map(c => {
                        return {
                            label: c.label,
                            value: c.value,
                            selected: setting.employeeCategories.find(v => v == c.value)
                        }
                    }) : employeeCategories,
                    selectMultiple: true,
                    selectFirst: false,
                    styleLight: true,
                }, computed: (datafill, lastVal, entryBeforeUpdate) => {

                    let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag');
                    employeeFlag = employeeFlag != null ? employeeFlag.value : false;

                    if(!employeeFlag){

                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.dropdownSearchState.selectedItems = [];
                        entryBeforeUpdate.value = [];
                        entryBeforeUpdate.hidden = true;
                    }
                    return entryBeforeUpdate;
                }
            },
            {label: i18n.tc('store.structure.employeeLevel', 2), key: 'employeeLevels', hidden: false, type: 'dropdownsearch', value: setting != null ? setting.employeeLevels : null, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: setting != null ? employeeLevels.map(c => {
                        return {
                            label: c.label,
                            value: c.value,
                            selected: setting.employeeLevels.find(v => v == c.value)
                        }
                    }) : employeeLevels,
                    selectMultiple: true,
                    selectFirst: false,
                    styleLight: true,
                }, computed: (datafill, lastVal, entryBeforeUpdate) => {

                    let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag');
                    employeeFlag = employeeFlag != null ? employeeFlag.value : false;

                    if(!employeeFlag){

                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.dropdownSearchState.selectedItems = [];
                        entryBeforeUpdate.value = [];
                        entryBeforeUpdate.hidden = true;
                    }
                    return entryBeforeUpdate;
                }
            },
            {label: i18n.t('pages.employeeContract.employmentType'), key: 'employmentTypes', hidden: false, type: 'dropdownsearch', value: setting != null ? setting.employmentTypes : null, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: setting != null ? employmentTypes.map(c => {
                        return {
                            label: c.label,
                            value: c.value,
                            selected: setting.employmentTypes.find(v => v == c.value)
                        }
                    }) : employmentTypes,
                    selectMultiple: true,
                    selectFirst: false,
                    styleLight: true,
                }, computed: (datafill, lastVal, entryBeforeUpdate) => {

                    let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag');
                    employeeFlag = employeeFlag != null ? employeeFlag.value : false;

                    if(!employeeFlag){

                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.dropdownSearchState.selectedItems = [];
                        entryBeforeUpdate.value = [];
                        entryBeforeUpdate.hidden = true;
                    }
                    return entryBeforeUpdate;
                }
            },
            {label: i18n.t('workBalance.accounting.linkCondition'), key: 'conditionJoin', hidden: false, type: 'dropdownsearch', value: setting != null ? setting.conditionJoin: false, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: conditionJoinModes,
                    selectMultiple: false,
                    selectedItem: setting != null ? conditionJoinModes.find(c => c.value == setting.conditionJoin) : conditionJoinModes[1],
                    selectFirst: false,
                    styleLight: true,
                }, computed: (datafill, lastVal, entryBeforeUpdate) => {

                    let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag');
                    employeeFlag = employeeFlag != null ? employeeFlag.value : false;

                    if(!employeeFlag){

                        entryBeforeUpdate.hidden = false;
                    } else {

                        entryBeforeUpdate.hidden = true;
                    }
                    return entryBeforeUpdate;
                }
            },
            {label: i18n.t('workBalance.accounting.applyToUnderage'), key: 'applyToUnderage', hidden: false, type: 'bool', value: setting != null ? setting.applyToUnderage : true},
            {label: i18n.t('workBalance.bonus.reconcileMonthly'), key: 'equalizeMonthly', hidden: false, type: 'bool', value: setting != null ? setting.equalizeMonthly : false},
            {label: i18n.t('workBalance.bonus.applyToWorkTimeBalance'), key: 'applyToEwbWorktime', hidden: false, type: 'bool', value: setting != null ? setting.ewbWorkTimePercentage > 0 : false},
            {label: i18n.t('workBalance.bonus.workTimeBalanceBonus'), key: 'ewbWorkTimePercentage', hidden: setting != null ? setting.ewbWorkTimePercentage <= 0 : true, type: 'slider', value: setting != null ? setting.ewbWorkTimePercentage : 0,
                slider: {hideMin: true, hideMax: true, min: 0, max: 200, value: setting != null ? setting.ewbWorkTimePercentage : 0,
                    step: 1, inputControl: true, sliderInput: (x) => {return x}, labelToInt: (x) => {return x.slice(0, -1)},
                    DisplayLabel: (x) => {return x + '%'}, shorterDisplayLabel: (x) => {return x}},
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let applyToEwbWorktime = datafill.entries.find(i => i.key == 'applyToEwbWorktime').value;

                    if(!applyToEwbWorktime){

                        entryBeforeUpdate.slider.value = 0;
                        entryBeforeUpdate.value = 0;
                        entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                        entryBeforeUpdate.hidden = true;

                    } else {
                        entryBeforeUpdate.hidden = false;
                    }
                    return entryBeforeUpdate;
                }
            },
        ])
        if(presentSaveOption){
            entries.push({label: i18n.t('workBalance.balances.saveSettings'), key: 'saveSetting', hidden: false, type: 'bool', value: false, computed: (datafill, lastVal, entryBeforeUpdate) => {

                    let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag');
                    employeeFlag = employeeFlag != null ? employeeFlag.value : false;

                    if(!employeeFlag){

                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.value = false;
                        entryBeforeUpdate.hidden = true;
                    }
                    return entryBeforeUpdate;
                }})
        }
        state.entries = entries;
        state.errorCheck= [
            (entries) => {

                if(!entries['weekDays'] || entries['weekDays'].length < 1){
                    return {key: 'weekDays', type: 'error', label: i18n.tc('store.settings.weekdays', 2), text: i18n.t('shift.template.selectWeekdayError')}
                } else {
                    return null
                }
            },
            (entries) => {

                if(!entries['name'] || entries['name'].length < 1){
                    return {key: 'name', type: 'error', label: i18n.t('pages.employeeData.name'), text: i18n.t('global.notifications.enterName')}
                } else {
                    return null
                }
            },
            (entries) => {

                if(entries['useMaxWorkTime'] && entries['maxWorkTime'] <= entries['minWorkTime']){
                    return {key: 'maxWorkTime', type: 'error', label: i18n.t('workBalance.bonus.maxWorkTime'), text: i18n.t('workBalance.bonus.maxWorkTimeLarger')}
                } else {
                    return null
                }
            },
            (entries) => {
                if(entries.useCheckTime) {
                    //check if intervalls overlap
                    let bFrom = entries.bonusFrom.clone();
                    let bTo = entries.bonusTo.clone();
                    if(bTo <= bFrom){
                        bTo = bTo.add(1, 'days');
                    }
                    let cFrom = entries.checkFrom.clone();
                    let cTo = entries.checkTo.clone();
                    if(cTo <= cFrom){
                        cTo = cTo.add(1, 'days');
                    }
                    if(!(cTo > bFrom && cFrom < bTo)){
                        //no overlap, try checking if there is an overlap if 1 day is subtracted, e.g. in case of 00:00 - 06:00 but check is 19:00 - 07:00
                        cFrom = cFrom.add(-1, 'days');
                        cTo = cTo.add(-1, 'days');
                    }
                    if(!(cTo > bFrom && cFrom < bTo)){
                        //still no overlap (e.g. 00:00 - 06:00 and 07:00 - 14:00) => error
                        return {key: 'checkFrom', type: 'error', label: i18n.t('workBalance.bonus.checkFrom'), text: i18n.t('workBalance.bonus.checkTimeOverlapError')}
                    } else {
                        return null;
                    }


                } else {
                    return null;
                }
                
            },

        ];
        state.selectCallback = callback;

        return state;
    }

    hasAutomaticVacationEntitlement(storeSettings){
        return storeSettings.autoVacCalc && storeSettings.country != 8;
    }

    calculateContractVacationEntitlement(storeSettings, startDate, currentDate, additionalYears, subtractedYears, weekWorkDaysRegular, collectiveContractId){
        let entitlement = 25;
        if(storeSettings.country == 8){
            entitlement = 26;
        }

        if(startDate != null){
            let mcdCCs = ['75ac14f4-9260-40f1-9b26-ff005b0d8309', 'f6c66725-f229-44ce-9458-418da16def58', '964f479d-0045-4eb7-a621-aac699ee9585']
            if(storeSettings.country == 1 && (storeSettings.marketType == 1 || mcdCCs.includes(collectiveContractId))){
                entitlement = 5 * weekWorkDaysRegular;

                let startMonth = startDate.clone().startOf('month');
                let totalYears = Math.max(currentDate.diff(startMonth, 'months')/12.0, 0) + additionalYears - subtractedYears;
                

                if(currentDate.year() > 2025 || (currentDate.year() == 2025 && currentDate.month() >= startDate.month())){
                    let addition = 0;
                    
                    if(totalYears >= 15){
                        addition = 5
                    } else if(totalYears >= 12){
                        addition = 3
                    } else if(totalYears >= 9){
                        addition = 2
                    } else if(totalYears >= 6){
                        addition = 1
                    }
                    if(addition > 0){
                        entitlement += ((addition*weekWorkDaysRegular)/5)
                    }
                }
                if(totalYears >= 25){
                    let swentitlement = 6 * weekWorkDaysRegular;
                    entitlement = Math.max(entitlement, swentitlement);
                }
                

            } else if(storeSettings.country == 2 && storeSettings.marketType == 1){
                let startYear = startDate.year();
                let startMonth = startDate.month()+1;
                let startDay = startDate.date();
                if(startMonth > 6){
                    startYear++;
                }
                let totalYears = Math.max(currentDate.year() - startYear, 0) + 1 + additionalYears - subtractedYears;

                if(totalYears >= 7){
                    entitlement = 30;
                } else if(totalYears >= 5){
                    entitlement = 29;
                } else if(totalYears >= 3){
                    entitlement = 27;
                }

            } else if(storeSettings.country == 1 && storeSettings.marketType == 2){
                let startMonth = startDate.clone().startOf('month');
                let totalYears = Math.max(currentDate.diff(startMonth, 'months')/12.0, 0) + additionalYears - subtractedYears;
                
                if(totalYears >= 20){
                    entitlement = 31;
                } else if(totalYears >= 15){
                    entitlement = 30;
                } else if(totalYears >= 10){
                    entitlement = 28;
                } else if(totalYears >= 5){
                    entitlement = 27;
                } else if(totalYears >= 1){
                    entitlement = 26;
                }
            }
        }


        return entitlement;
    }

    getEmployeeEntryDate(employee, employeeContracts, date = null){
        let earliest = null;

        if(date == null){
            if(employee.workEntryDate != null){
                earliest = this.getMomentFromStringTZ(employee.workEntryDate);
            } else {

                employeeContracts.forEach(c => {
                    if(c.employeeId == employee.id){

                        let from = this.getMomentFromStringTZ(c.from);
                        if(earliest == null || from.isBefore(earliest)){
                            earliest = from;
                        }
                    }
                });

            }
        } else {
            //first check if there's contract overlapping date
            let overlapping = employeeContracts.find(c => c.employeeId == employee.id && this.getMomentFromStringTZ(c.from) <= date && (c.to == null || this.getMomentFromStringTZ(c.to) > date));
            if(overlapping != null){
                //find earliest date of overlapping series
                let earliest = this.getMomentFromStringTZ(overlapping.from);
                let preceeding = employeeContracts.find(c => c.employeeId == employee.id && c.to != null && this.getMomentFromStringTZ(c.to).isSame(earliest));
                while(preceeding != null){
                    earliest = this.$helpers.getMomentFromStringTZ(preceeding.from);
                    preceeding = employeeContracts.find(c => c.employeeId == employee.id && c.to != null && this.getMomentFromStringTZ(c.to).isSame(earliest));

                }

            } else {
                //check if there's a series of contracts in the future of date
                let future = employeeContracts.find(c => c.employeeId == employee.id && this.getMomentFromStringTZ(c.from) > date);
                if(future != null){
                    //find earliest date of future series
                    let earliest = this.getMomentFromStringTZ(future.from);
                    let preceeding = employeeContracts.find(c => c.employeeId == employee.id && c.to != null && this.getMomentFromStringTZ(c.to).isSame(earliest));
                    while(preceeding != null){
                        earliest = this.$helpers.getMomentFromStringTZ(preceeding.from);
                        preceeding = employeeContracts.find(c => c.employeeId == employee.id && c.to != null && this.getMomentFromStringTZ(c.to).isSame(earliest));

                    }

                } else {
                    //check if there's a series of contracts in the past of date
                    let past = employeeContracts.find(c => c.employeeId == employee.id && this.getMomentFromStringTZ(c.from) < date);
                    if(past != null){
                        //find earliest date of past series
                        let earliest = this.getMomentFromStringTZ(past.from);
                        let preceeding = employeeContracts.find(c => c.employeeId == employee.id && c.to != null && this.getMomentFromStringTZ(c.to).isSame(earliest));
                        while(preceeding != null){
                            earliest = this.$helpers.getMomentFromStringTZ(preceeding.from);
                            preceeding = employeeContracts.find(c => c.employeeId == employee.id && c.to != null && this.getMomentFromStringTZ(c.to).isSame(earliest));
                        }
                    }

                }
            }
        }

        return earliest;
    }

    OpenButtonContainer(buttons, dropdownOptions = { }){
        /*
        used like this
            OpenButtonArray([
                { color: 'blue', icon: 'fa-eye', label: 'test test', click: () => { console.log('test') } },
            ], { elRelative: elementVariable })
         if there's no second parameter with elRelative it will just put the dropdown in the center
         by default it will pin the dropdowncontainer to the right of elRelative but you can override it { elRelative: elementVariable, pinTopRight: false, pinTopLeft: true }
         you can put any of the button state options/props in the array and any of the dropdowncontainer state options/props in dropdownOptions to extend the functionality how you want

         extra dropdownOptions parameters
             closeOnSelect: makes the dropdown close when you click the button
             elementsPerRow: how many buttons you want before it breaks line

         dropdownOptions.maxWidth has to be in pixels
         */

        dropdownOptions = {maxWidth: '450px', closeOnSelect: false, elementsPerRow: 4, ...dropdownOptions};

        const buttonMargin = 20;
        const dropdownPadding = 20;

        if(!buttons) buttons = [];
        let defaultState = {
            components: buttons.map(b => {
                return {
                    type: 'buttonc',
                    propContainer: {
                        type: 'expanded no-hover',
                        styleButton: { color: b.color },
                        ...b,
                        style: { width: ((+dropdownOptions.maxWidth.replace('px', '') - (buttonMargin * dropdownOptions.elementsPerRow) - dropdownPadding) / dropdownOptions.elementsPerRow) + 'px', ...b.style },
                        click: null,
                    },

                    customEvents: {
                        click: dropdownOptions && dropdownOptions.closeOnSelect ? (event) => {  event.target.closest('.c-dropdown').__vue__.Close(); b.click(event);} : b.click,
                    }
                }
            }),
            //expanded: true,
            ...(dropdownOptions && dropdownOptions.elRelative ? {pinTopRight: true} : {centered: true}),
            noScroll: true,
            buttonContainer: true,
            disableCloseIcon: true,
            ...dropdownOptions,
        };

        this.OpenPopup(defaultState);
    }

    b64toBlob = (b64Data, contentType='', sliceSize=512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

    previewPdf(doc, filename, type="Report"){


        let description  = "<p>" + i18n.t('pages.employeeData.messages.pdfCreated', { type: type }) + "</p>";




        this.OpenPopup({
            type: 'datafill',
            componentState: {
                entries: [],
                description: description,
                positiveButtonLabel: i18n.t('global.ui.openInNewTab'),
                positiveButtonLabel2: i18n.t('global.ui.save'),
                selectCallback: function (data) {
                    let objectURL = URL.createObjectURL(doc.output("blob"));
                    window.open(objectURL, "_blank");

                    //doc.output('dataurlnewwindow');
                },
                selectCallback2: function (data) {
                    doc.save(filename);

                }
            },
            header: type+' ' + i18n.t('global.general.created'),
            expanded: true,
            width: "700px",
            centered: true,
            disableCloseIcon: true,
            locked: false
        });

    }

    buildHeaderMapLabel(headerMap, val, text) {
        return this.buildHeaderMapLabelStyle(headerMap, val, text, styleLabel)
    }

    buildHeaderMapLabelStyle(headerMap, val, text, styleLabel) {
        headerMap[val].stylesEntrySum = {color: 'black'};
        headerMap[val].sort = false;
        headerMap[val].componentStateBuilders = [(data) => {
            let textValue = data[val];
            if (text === 'min') {
                textValue = textValue / 60 + ' Min.'
            }
            return {
                componentType: 'labelc',
                state: {
                    text: textValue,
                },
                styleLabel: styleLabel,
            }
        }];
    }

    putPreference(preference, successCallback, action) {
        let url = '/api/sec/employeepreference/' + action;

        let payload = {id: preference.id, certain: (preference.state == 1 || preference.state == 2) ? true : false, factor: preference.factor};

        this.EditCall(url, payload, successCallback, {
                title: i18n.t('global.notifications.updateMessage'),
                message: i18n.t('global.ui.editedX', [i18n.tc('global.general.absence')]),
            }, (error) => {
                console.log(error);
            }, { title: i18n.t('global.notifications.updateFailed'), message: i18n.t('global.ui.editedErrorX', [i18n.tc('global.general.absence')]) },
        );
    }

    approvePreference(preference, successCallback) {
        if (!preference || preference.approved) return;

        this.putPreference(preference, successCallback, 'approve');
    }

    denyPreference(preference, successCallback) {
        if (!preference || preference.denied) return;

        this.putPreference(preference, successCallback, 'deny');
    }

    translateDayShort(val) {
        return daysShort[val] || val;
    }

    translateWeekday(val) {
        return weekdays[val] || val;
    }

    translateMonth(val) {
        return monthsShort[val] || val;
    }

    formatHolidayArray(array){
        let result = "";
        if(array){
            array.forEach(e => {
                if (e === 1) {
                    result += holidayType[e] + "";
                }
                else if (e === 2) {
                    if (result !== "") {
                        result += "; ";
                    }
                    result += holidayType[e] + "";
                }
            })
        }

        return result;
    }

    getHolidayTypesForStoreEvent(e){
        let types = [];
        if(e.federalHoliday){
            types.push(1);
        }
        if(e.contractHoliday){
            types.push(2);
        }
        if(e.bankHoliday){
            types.push(3);
        }
        return types;
    }

}

const styleLabel = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    background: '',
    height: 'calc(100% - 10px)'
}

const daysShort = {
    'Mo': i18n.t('store.openingHours.weekDay1Short'),
    'Di': i18n.t('store.openingHours.weekDay2Short'),
    'Tu': i18n.t('store.openingHours.weekDay2Short'),
    'Mi': i18n.t('store.openingHours.weekDay3Short'),
    'We': i18n.t('store.openingHours.weekDay3Short'),
    'Do': i18n.t('store.openingHours.weekDay4Short'),
    'Th': i18n.t('store.openingHours.weekDay4Short'),
    'Fr': i18n.t('store.openingHours.weekDay5Short'),
    'Sa': i18n.t('store.openingHours.weekDay6Short'),
    'So': i18n.t('store.openingHours.weekDay7Short'),
    'Su': i18n.t('store.openingHours.weekDay7Short'),
}

const weekdays = {
    'Montag': i18n.t('global.general.week1'),
    'Monday': i18n.t('global.general.week1'),
    'Dienstag': i18n.t('global.general.week2'),
    'Tuesday': i18n.t('global.general.week2'),
    'Mittwoch': i18n.t('global.general.week3'),
    'Wednesday': i18n.t('global.general.week3'),
    'Donnerstag': i18n.t('global.general.week4'),
    'Thursday': i18n.t('global.general.week4'),
    'Freitag': i18n.t('global.general.week5'),
    'Friday': i18n.t('global.general.week5'),
    'Samstag': i18n.t('global.general.week6'),
    'Saturday': i18n.t('global.general.week6'),
    'Sonntag': i18n.t('global.general.week7'),
    'Sunday': i18n.t('global.general.week7'),
}

const monthsShort = {
    'Januar': i18n.t('global.general.month1'),
    'January': i18n.t('global.general.month1'),
    'Februar': i18n.t('global.general.month2'),
    'February': i18n.t('global.general.month2'),
    'März': i18n.t('global.general.month3'),
    'March': i18n.t('global.general.month3'),
    'April': i18n.t('global.general.month4'),
    'Mai': i18n.t('global.general.month5'),
    'May': i18n.t('global.general.month5'),
    'Juni': i18n.t('global.general.month6'),
    'June': i18n.t('global.general.month6'),
    'Juli': i18n.t('global.general.month7'),
    'July': i18n.t('global.general.month7'),
    'August': i18n.t('global.general.month8'),
    'September': i18n.t('global.general.month9'),
    'Oktober': i18n.t('global.general.month10'),
    'October': i18n.t('global.general.month10'),
    'November': i18n.t('global.general.month11'),
    'Dezember': i18n.t('global.general.month12'),
}

const holidayType = {
    1: i18n.t('store.events.nationalHoliday'),
    2: i18n.t('store.events.contractHoliday'),
    3: i18n.t('store.events.bankHoliday'),
}
